/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dashboard = __webpack_require__(1);
	
	var dashboard = _interopRequireWildcard(_dashboard);
	
	var _admin = __webpack_require__(3);
	
	var admin = _interopRequireWildcard(_admin);
	
	var _bootstrapSlider = __webpack_require__(4);
	
	var bootstrapSlider = _interopRequireWildcard(_bootstrapSlider);
	
	var _pathUtils = __webpack_require__(5);
	
	var pathUtils = _interopRequireWildcard(_pathUtils);
	
	var _jquery = __webpack_require__(6);
	
	var mask = _interopRequireWildcard(_jquery);
	
	var _scripts = __webpack_require__(7);
	
	var scripts = _interopRequireWildcard(_scripts);
	
	var _fourth = __webpack_require__(8);
	
	var fourth = _interopRequireWildcard(_fourth);
	
	var _forms = __webpack_require__(9);
	
	var forms = _interopRequireWildcard(_forms);
	
	var _browserCheck = __webpack_require__(11);
	
	var browsercheck = _interopRequireWildcard(_browserCheck);
	
	var _menuMobile = __webpack_require__(12);
	
	var menuMobile = _interopRequireWildcard(_menuMobile);
	
	var _popUp = __webpack_require__(13);
	
	var popUp = _interopRequireWildcard(_popUp);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	$(document).ready(function () {
	  var sidebar = $('.p__dashboard--sidebar');
	  if ($(sidebar).length) {
	    $('#hamburger').on('click', function () {
	      $(this).toggleClass('open');
	      $(sidebar).toggleClass('open');
	    });
	  }
	
	  $('button[action="openChildForm"]').on('click', function () {
	    var $this = $(this);
	    $this.fadeOut(300);
	    setTimeout(function () {
	      $this.next('.form--data').fadeIn(300);
	    }, 400);
	  });
	});
	
	$('.checkMobile').on('click', function () {
	  $(this).toggleClass('active');
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v2.2.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-05-20T17:23Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//"use strict";
	var arr = [];
	
	var document = window.document;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "2.2.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			var realStringObj = obj && obj.toString();
			return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			// Not own constructor property must be Object
			if ( obj.constructor &&
					!hasOwn.call( obj, "constructor" ) &&
					!hasOwn.call( obj.constructor.prototype || {}, "isPrototypeOf" ) ) {
				return false;
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
	
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf( "use strict" ) === 1 ) {
					script = document.createElement( "script" );
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
	
					// Otherwise, avoid the DOM node creation, insertion
					// and removal by using an indirect global eval
	
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	// JSHint would error on this code due to the Symbol not being defined in ES5.
	// Defining this global in .jshintrc would create a danger of using the global
	// unguarded in another place, it seems safer to just disable JSHint for these
	// three lines.
	/* jshint ignore: start */
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	/* jshint ignore: end */
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.1
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-10-17
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, nidselect, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rescape, "\\$&" );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
						while ( i-- ) {
							groups[i] = nidselect + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( (parent = document.defaultView) && parent.top !== parent ) {
			// Support: IE 11
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( document.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( (oldCache = uniqueCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
	
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[ 0 ] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
					// Always skip document fragments
					if ( cur.nodeType < 11 && ( pos ?
						pos.index( cur ) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this === promise ? newDefer.promise() : this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add( function() {
	
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 ||
					( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.progress( updateFunc( i, progressContexts, progressValues ) )
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	} );
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
	
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	} );
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE9-10 only
			// Older IE sometimes signals "interactive" too soon
			if ( document.readyState === "complete" ||
				( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		register: function( owner, initial ) {
			var value = initial || {};
	
			// If it is a node unlikely to be stringify-ed or looped over
			// use plain assignment
			if ( owner.nodeType ) {
				owner[ this.expando ] = value;
	
			// Otherwise secure it in a non-enumerable, non-writable property
			// configurability must be true to allow the property to be
			// deleted with the delete operator
			} else {
				Object.defineProperty( owner, this.expando, {
					value: value,
					writable: true,
					configurable: true
				} );
			}
			return owner[ this.expando ];
		},
		cache: function( owner ) {
	
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( !acceptData( owner ) ) {
				return {};
			}
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
				owner[ this.expando ] && owner[ this.expando ][ key ];
		},
		access: function( owner, key, value ) {
			var stored;
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase( key ) );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key === undefined ) {
				this.register( owner );
	
			} else {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
	
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
	
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
	
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <= 35-45+
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://code.google.com/p/chromium/issues/detail?id=378607
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data, camelKey;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// with the key as-is
					data = dataUser.get( elem, key ) ||
	
						// Try to find dashed key if it exists (gh-2779)
						// This is for 2.2.x only
						dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );
	
					if ( data !== undefined ) {
						return data;
					}
	
					camelKey = jQuery.camelCase( key );
	
					// Attempt to get data from the cache
					// with the key camelized
					data = dataUser.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				camelKey = jQuery.camelCase( key );
				this.each( function() {
	
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = dataUser.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					dataUser.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
						dataUser.set( this, key, value );
					}
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" ||
				!jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() { return tween.cur(); } :
				function() { return jQuery.css( elem, prop, "" ); },
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([\w:-]+)/ );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE9-11+
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0-4.3, Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE9
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support (at least): Chrome, IE9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox<=42+
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
			"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split( " " ),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
				"screenX screenY toElement" ).split( " " ),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX +
						( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
						( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY +
						( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
						( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://code.google.com/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName( "tbody" )[ 0 ] ||
				elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android<4.1, PhantomJS<2
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
	
		// Keep domManip exposed until 3.0 (gh-2225)
		domManip: domManip,
	
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	
	var iframe,
		elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			display = jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
					.appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var documentElement = document.documentElement;
	
	
	
	( function() {
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
			div.style.cssText =
	
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
		}
	
		jQuery.extend( support, {
			pixelPosition: function() {
	
				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
	
				// Support: Android 4.0-4.3
				// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
				// since that compresses better and they're computed together anyway.
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
	
				// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return reliableMarginLeftVal;
			},
			reliableMarginRight: function() {
	
				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;box-sizing:content-box;" +
					"display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				documentElement.appendChild( container );
	
				ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );
	
				documentElement.removeChild( container );
				div.removeChild( marginDiv );
	
				return ret;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
		// Support: Opera 12.1x only
		// Fall back to style even without computed
		// computed is undefined for elems on document fragments
		if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// http://dev.w3.org/csswg/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE9-11+
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = dataPriv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
	
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = dataPriv.access(
						elem,
						"olddisplay",
						defaultDisplay( elem.nodeName )
					);
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					dataPriv.set(
						elem,
						"olddisplay",
						hidden ? display : jQuery.css( elem, "display" )
					);
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
						elem.offsetWidth === 0 ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show
					// and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done( function() {
					jQuery( elem ).hide();
				} );
			}
			anim.done( function() {
				var prop;
	
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
			opt.duration : opt.duration in jQuery.fx.speeds ?
				jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		window.clearInterval( timerId );
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
	
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// Handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ?
									!option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome, Safari
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// The jqXHR state
				state = 0,
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE8-11+
				// IE throws exception if url is malformed, e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE8-11+
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( state === 2 ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
	
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapAll( html.call( this, i ) );
				} );
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function() {
			return this.parent().each( function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			} ).end();
		}
	} );
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		return !jQuery.expr.filters.visible( elem );
	};
	jQuery.expr.filters.visible = function( elem ) {
	
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		// Use OR instead of AND as the element is not visible if either is true
		// See tickets #10406 and #13132
		return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE9
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE9
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			box = elem.getBoundingClientRect();
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari<7-8+, Chrome<37-44+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
		size: function() {
			return this.length;
		}
	} );
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	return jQuery;
	}));


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var admin = $('section[data-admin]').length;
	
	if (admin) {
	  $('footer').addClass('footer__admin');
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*! =========================================================
	 * bootstrap-slider.js
	 *
	 * Maintainers:
	 *		Kyle Kemp
	 *			- Twitter: @seiyria
	 *			- Github:  seiyria
	 *		Rohit Kalkur
	 *			- Twitter: @Rovolutionary
	 *			- Github:  rovolution
	 *
	 * =========================================================
	 *
	 * bootstrap-slider is released under the MIT License
	 * Copyright (c) 2017 Kyle Kemp, Rohit Kalkur, and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person
	 * obtaining a copy of this software and associated documentation
	 * files (the "Software"), to deal in the Software without
	 * restriction, including without limitation the rights to use,
	 * copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the
	 * Software is furnished to do so, subject to the following
	 * conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
	 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
	 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
	 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	 * OTHER DEALINGS IN THE SOFTWARE.
	 *
	 * ========================================================= */
	
	/**
	 * Bridget makes jQuery widgets
	 * v1.0.1
	 * MIT license
	 */
	var windowIsDefined = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object";
	
	(function (factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
			var jQuery;
			try {
				jQuery = require("jquery");
			} catch (err) {
				jQuery = null;
			}
			module.exports = factory(jQuery);
		} else if (window) {
			window.Slider = factory(window.jQuery);
		}
	})(function ($) {
		// Constants
		var NAMESPACE_MAIN = 'slider';
		var NAMESPACE_ALTERNATE = 'bootstrapSlider';
	
		// Polyfill console methods
		if (windowIsDefined && !window.console) {
			window.console = {};
		}
		if (windowIsDefined && !window.console.log) {
			window.console.log = function () {};
		}
		if (windowIsDefined && !window.console.warn) {
			window.console.warn = function () {};
		}
	
		// Reference to Slider constructor
		var Slider;
	
		(function ($) {
	
			'use strict';
	
			// -------------------------- utils -------------------------- //
	
			var slice = Array.prototype.slice;
	
			function noop() {}
	
			// -------------------------- definition -------------------------- //
	
			function defineBridget($) {
	
				// bail if no jQuery
				if (!$) {
					return;
				}
	
				// -------------------------- addOptionMethod -------------------------- //
	
				/**
	    * adds option method -> $().plugin('option', {...})
	    * @param {Function} PluginClass - constructor class
	    */
				function addOptionMethod(PluginClass) {
					// don't overwrite original option method
					if (PluginClass.prototype.option) {
						return;
					}
	
					// option setter
					PluginClass.prototype.option = function (opts) {
						// bail out if not an object
						if (!$.isPlainObject(opts)) {
							return;
						}
						this.options = $.extend(true, this.options, opts);
					};
				}
	
				// -------------------------- plugin bridge -------------------------- //
	
				// helper function for logging errors
				// $.error breaks jQuery chaining
				var logError = typeof console === 'undefined' ? noop : function (message) {
					console.error(message);
				};
	
				/**
	    * jQuery plugin bridge, access methods like $elem.plugin('method')
	    * @param {String} namespace - plugin name
	    * @param {Function} PluginClass - constructor class
	    */
				function bridge(namespace, PluginClass) {
					// add to jQuery fn namespace
					$.fn[namespace] = function (options) {
						if (typeof options === 'string') {
							// call plugin method when first argument is a string
							// get arguments for method
							var args = slice.call(arguments, 1);
	
							for (var i = 0, len = this.length; i < len; i++) {
								var elem = this[i];
								var instance = $.data(elem, namespace);
								if (!instance) {
									logError("cannot call methods on " + namespace + " prior to initialization; " + "attempted to call '" + options + "'");
									continue;
								}
								if (!$.isFunction(instance[options]) || options.charAt(0) === '_') {
									logError("no such method '" + options + "' for " + namespace + " instance");
									continue;
								}
	
								// trigger method with arguments
								var returnValue = instance[options].apply(instance, args);
	
								// break look and return first value if provided
								if (returnValue !== undefined && returnValue !== instance) {
									return returnValue;
								}
							}
							// return this if no return value
							return this;
						} else {
							var objects = this.map(function () {
								var instance = $.data(this, namespace);
								if (instance) {
									// apply options & init
									instance.option(options);
									instance._init();
								} else {
									// initialize new instance
									instance = new PluginClass(this, options);
									$.data(this, namespace, instance);
								}
								return $(this);
							});
	
							if (!objects || objects.length > 1) {
								return objects;
							} else {
								return objects[0];
							}
						}
					};
				}
	
				// -------------------------- bridget -------------------------- //
	
				/**
	    * converts a Prototypical class into a proper jQuery plugin
	    *   the class must have a ._init method
	    * @param {String} namespace - plugin name, used in $().pluginName
	    * @param {Function} PluginClass - constructor class
	    */
				$.bridget = function (namespace, PluginClass) {
					addOptionMethod(PluginClass);
					bridge(namespace, PluginClass);
				};
	
				return $.bridget;
			}
	
			// get jquery from browser global
			defineBridget($);
		})($);
	
		/*************************************************
	 			BOOTSTRAP-SLIDER SOURCE CODE
	 	**************************************************/
	
		(function ($) {
	
			var ErrorMsgs = {
				formatInvalidInputErrorMsg: function formatInvalidInputErrorMsg(input) {
					return "Invalid input value '" + input + "' passed in";
				},
				callingContextNotSliderInstance: "Calling context element does not have instance of Slider bound to it. Check your code to make sure the JQuery object returned from the call to the slider() initializer is calling the method"
			};
	
			var SliderScale = {
				linear: {
					toValue: function toValue(percentage) {
						var rawValue = percentage / 100 * (this.options.max - this.options.min);
						var shouldAdjustWithBase = true;
						if (this.options.ticks_positions.length > 0) {
							var minv,
							    maxv,
							    minp,
							    maxp = 0;
							for (var i = 1; i < this.options.ticks_positions.length; i++) {
								if (percentage <= this.options.ticks_positions[i]) {
									minv = this.options.ticks[i - 1];
									minp = this.options.ticks_positions[i - 1];
									maxv = this.options.ticks[i];
									maxp = this.options.ticks_positions[i];
	
									break;
								}
							}
							var partialPercentage = (percentage - minp) / (maxp - minp);
							rawValue = minv + partialPercentage * (maxv - minv);
							shouldAdjustWithBase = false;
						}
	
						var adjustment = shouldAdjustWithBase ? this.options.min : 0;
						var value = adjustment + Math.round(rawValue / this.options.step) * this.options.step;
						if (value < this.options.min) {
							return this.options.min;
						} else if (value > this.options.max) {
							return this.options.max;
						} else {
							return value;
						}
					},
					toPercentage: function toPercentage(value) {
						if (this.options.max === this.options.min) {
							return 0;
						}
	
						if (this.options.ticks_positions.length > 0) {
							var minv,
							    maxv,
							    minp,
							    maxp = 0;
							for (var i = 0; i < this.options.ticks.length; i++) {
								if (value <= this.options.ticks[i]) {
									minv = i > 0 ? this.options.ticks[i - 1] : 0;
									minp = i > 0 ? this.options.ticks_positions[i - 1] : 0;
									maxv = this.options.ticks[i];
									maxp = this.options.ticks_positions[i];
	
									break;
								}
							}
							if (i > 0) {
								var partialPercentage = (value - minv) / (maxv - minv);
								return minp + partialPercentage * (maxp - minp);
							}
						}
	
						return 100 * (value - this.options.min) / (this.options.max - this.options.min);
					}
				},
	
				logarithmic: {
					/* Based on http://stackoverflow.com/questions/846221/logarithmic-slider */
					toValue: function toValue(percentage) {
						var min = this.options.min === 0 ? 0 : Math.log(this.options.min);
						var max = Math.log(this.options.max);
						var value = Math.exp(min + (max - min) * percentage / 100);
						value = this.options.min + Math.round((value - this.options.min) / this.options.step) * this.options.step;
						/* Rounding to the nearest step could exceed the min or
	      * max, so clip to those values. */
						if (value < this.options.min) {
							return this.options.min;
						} else if (value > this.options.max) {
							return this.options.max;
						} else {
							return value;
						}
					},
					toPercentage: function toPercentage(value) {
						if (this.options.max === this.options.min) {
							return 0;
						} else {
							var max = Math.log(this.options.max);
							var min = this.options.min === 0 ? 0 : Math.log(this.options.min);
							var v = value === 0 ? 0 : Math.log(value);
							return 100 * (v - min) / (max - min);
						}
					}
				}
			};
	
			/*************************************************
	  						CONSTRUCTOR
	  	**************************************************/
			Slider = function Slider(element, options) {
				createNewSlider.call(this, element, options);
				return this;
			};
	
			function createNewSlider(element, options) {
	
				/*
	   	The internal state object is used to store data about the current 'state' of slider.
	   	This includes values such as the `value`, `enabled`, etc...
	   */
				this._state = {
					value: null,
					enabled: null,
					offset: null,
					size: null,
					percentage: null,
					inDrag: false,
					over: false
				};
	
				// The objects used to store the reference to the tick methods if ticks_tooltip is on
				this.ticksCallbackMap = {};
				this.handleCallbackMap = {};
	
				if (typeof element === "string") {
					this.element = document.querySelector(element);
				} else if (element instanceof HTMLElement) {
					this.element = element;
				}
	
				/*************************************************
	   					Process Options
	   	**************************************************/
				options = options ? options : {};
				var optionTypes = Object.keys(this.defaultOptions);
	
				for (var i = 0; i < optionTypes.length; i++) {
					var optName = optionTypes[i];
	
					// First check if an option was passed in via the constructor
					var val = options[optName];
					// If no data attrib, then check data atrributes
					val = typeof val !== 'undefined' ? val : getDataAttrib(this.element, optName);
					// Finally, if nothing was specified, use the defaults
					val = val !== null ? val : this.defaultOptions[optName];
	
					// Set all options on the instance of the Slider
					if (!this.options) {
						this.options = {};
					}
					this.options[optName] = val;
				}
	
				// Check options.rtl
				if (this.options.rtl === 'auto') {
					this.options.rtl = window.getComputedStyle(this.element).direction === 'rtl';
				}
	
				/*
	   	Validate `tooltip_position` against 'orientation`
	   	- if `tooltip_position` is incompatible with orientation, swith it to a default compatible with specified `orientation`
	   		-- default for "vertical" -> "right", "left" if rtl
	   		-- default for "horizontal" -> "top"
	   */
				if (this.options.orientation === "vertical" && (this.options.tooltip_position === "top" || this.options.tooltip_position === "bottom")) {
					if (this.options.rtl) {
						this.options.tooltip_position = "left";
					} else {
						this.options.tooltip_position = "right";
					}
				} else if (this.options.orientation === "horizontal" && (this.options.tooltip_position === "left" || this.options.tooltip_position === "right")) {
	
					this.options.tooltip_position = "top";
				}
	
				function getDataAttrib(element, optName) {
					var dataName = "data-slider-" + optName.replace(/_/g, '-');
					var dataValString = element.getAttribute(dataName);
	
					try {
						return JSON.parse(dataValString);
					} catch (err) {
						return dataValString;
					}
				}
	
				/*************************************************
	   					Create Markup
	   	**************************************************/
	
				var origWidth = this.element.style.width;
				var updateSlider = false;
				var parent = this.element.parentNode;
				var sliderTrackSelection;
				var sliderTrackLow, sliderTrackHigh;
				var sliderMinHandle;
				var sliderMaxHandle;
	
				if (this.sliderElem) {
					updateSlider = true;
				} else {
					/* Create elements needed for slider */
					this.sliderElem = document.createElement("div");
					this.sliderElem.className = "slider";
	
					/* Create slider track elements */
					var sliderTrack = document.createElement("div");
					sliderTrack.className = "slider-track";
	
					sliderTrackLow = document.createElement("div");
					sliderTrackLow.className = "slider-track-low";
	
					sliderTrackSelection = document.createElement("div");
					sliderTrackSelection.className = "slider-selection";
	
					sliderTrackHigh = document.createElement("div");
					sliderTrackHigh.className = "slider-track-high";
	
					sliderMinHandle = document.createElement("div");
					sliderMinHandle.className = "slider-handle min-slider-handle";
					sliderMinHandle.setAttribute('role', 'slider');
					sliderMinHandle.setAttribute('aria-valuemin', this.options.min);
					sliderMinHandle.setAttribute('aria-valuemax', this.options.max);
	
					sliderMaxHandle = document.createElement("div");
					sliderMaxHandle.className = "slider-handle max-slider-handle";
					sliderMaxHandle.setAttribute('role', 'slider');
					sliderMaxHandle.setAttribute('aria-valuemin', this.options.min);
					sliderMaxHandle.setAttribute('aria-valuemax', this.options.max);
	
					sliderTrack.appendChild(sliderTrackLow);
					sliderTrack.appendChild(sliderTrackSelection);
					sliderTrack.appendChild(sliderTrackHigh);
	
					/* Create highlight range elements */
					this.rangeHighlightElements = [];
					var rangeHighlightsOpts = this.options.rangeHighlights;
					if (Array.isArray(rangeHighlightsOpts) && rangeHighlightsOpts.length > 0) {
						for (var j = 0; j < rangeHighlightsOpts.length; j++) {
							var rangeHighlightElement = document.createElement("div");
							var customClassString = rangeHighlightsOpts[j].class || "";
							rangeHighlightElement.className = "slider-rangeHighlight slider-selection " + customClassString;
							this.rangeHighlightElements.push(rangeHighlightElement);
							sliderTrack.appendChild(rangeHighlightElement);
						}
					}
	
					/* Add aria-labelledby to handle's */
					var isLabelledbyArray = Array.isArray(this.options.labelledby);
					if (isLabelledbyArray && this.options.labelledby[0]) {
						sliderMinHandle.setAttribute('aria-labelledby', this.options.labelledby[0]);
					}
					if (isLabelledbyArray && this.options.labelledby[1]) {
						sliderMaxHandle.setAttribute('aria-labelledby', this.options.labelledby[1]);
					}
					if (!isLabelledbyArray && this.options.labelledby) {
						sliderMinHandle.setAttribute('aria-labelledby', this.options.labelledby);
						sliderMaxHandle.setAttribute('aria-labelledby', this.options.labelledby);
					}
	
					/* Create ticks */
					this.ticks = [];
					if (Array.isArray(this.options.ticks) && this.options.ticks.length > 0) {
						this.ticksContainer = document.createElement('div');
						this.ticksContainer.className = 'slider-tick-container';
	
						for (i = 0; i < this.options.ticks.length; i++) {
							var tick = document.createElement('div');
							tick.className = 'slider-tick';
							if (this.options.ticks_tooltip) {
								var tickListenerReference = this._addTickListener();
								var enterCallback = tickListenerReference.addMouseEnter(this, tick, i);
								var leaveCallback = tickListenerReference.addMouseLeave(this, tick);
	
								this.ticksCallbackMap[i] = {
									mouseEnter: enterCallback,
									mouseLeave: leaveCallback
								};
							}
							this.ticks.push(tick);
							this.ticksContainer.appendChild(tick);
						}
	
						sliderTrackSelection.className += " tick-slider-selection";
					}
	
					this.tickLabels = [];
					if (Array.isArray(this.options.ticks_labels) && this.options.ticks_labels.length > 0) {
						this.tickLabelContainer = document.createElement('div');
						this.tickLabelContainer.className = 'slider-tick-label-container';
	
						for (i = 0; i < this.options.ticks_labels.length; i++) {
							var label = document.createElement('div');
							var noTickPositionsSpecified = this.options.ticks_positions.length === 0;
							var tickLabelsIndex = this.options.reversed && noTickPositionsSpecified ? this.options.ticks_labels.length - (i + 1) : i;
							label.className = 'slider-tick-label';
							label.innerHTML = this.options.ticks_labels[tickLabelsIndex];
	
							this.tickLabels.push(label);
							this.tickLabelContainer.appendChild(label);
						}
					}
	
					var createAndAppendTooltipSubElements = function createAndAppendTooltipSubElements(tooltipElem) {
						var arrow = document.createElement("div");
						arrow.className = "tooltip-arrow";
	
						var inner = document.createElement("div");
						inner.className = "tooltip-inner";
	
						tooltipElem.appendChild(arrow);
						tooltipElem.appendChild(inner);
					};
	
					/* Create tooltip elements */
					var sliderTooltip = document.createElement("div");
					sliderTooltip.className = "tooltip tooltip-main";
					sliderTooltip.setAttribute('role', 'presentation');
					createAndAppendTooltipSubElements(sliderTooltip);
	
					var sliderTooltipMin = document.createElement("div");
					sliderTooltipMin.className = "tooltip tooltip-min";
					sliderTooltipMin.setAttribute('role', 'presentation');
					createAndAppendTooltipSubElements(sliderTooltipMin);
	
					var sliderTooltipMax = document.createElement("div");
					sliderTooltipMax.className = "tooltip tooltip-max";
					sliderTooltipMax.setAttribute('role', 'presentation');
					createAndAppendTooltipSubElements(sliderTooltipMax);
	
					/* Append components to sliderElem */
					this.sliderElem.appendChild(sliderTrack);
					this.sliderElem.appendChild(sliderTooltip);
					this.sliderElem.appendChild(sliderTooltipMin);
					this.sliderElem.appendChild(sliderTooltipMax);
	
					if (this.tickLabelContainer) {
						this.sliderElem.appendChild(this.tickLabelContainer);
					}
					if (this.ticksContainer) {
						this.sliderElem.appendChild(this.ticksContainer);
					}
	
					this.sliderElem.appendChild(sliderMinHandle);
					this.sliderElem.appendChild(sliderMaxHandle);
	
					/* Append slider element to parent container, right before the original <input> element */
					parent.insertBefore(this.sliderElem, this.element);
	
					/* Hide original <input> element */
					this.element.style.display = "none";
				}
				/* If JQuery exists, cache JQ references */
				if ($) {
					this.$element = $(this.element);
					this.$sliderElem = $(this.sliderElem);
				}
	
				/*************************************************
	   						Setup
	   	**************************************************/
				this.eventToCallbackMap = {};
				this.sliderElem.id = this.options.id;
	
				this.touchCapable = 'ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch;
	
				this.touchX = 0;
				this.touchY = 0;
	
				this.tooltip = this.sliderElem.querySelector('.tooltip-main');
				this.tooltipInner = this.tooltip.querySelector('.tooltip-inner');
	
				this.tooltip_min = this.sliderElem.querySelector('.tooltip-min');
				this.tooltipInner_min = this.tooltip_min.querySelector('.tooltip-inner');
	
				this.tooltip_max = this.sliderElem.querySelector('.tooltip-max');
				this.tooltipInner_max = this.tooltip_max.querySelector('.tooltip-inner');
	
				if (SliderScale[this.options.scale]) {
					this.options.scale = SliderScale[this.options.scale];
				}
	
				if (updateSlider === true) {
					// Reset classes
					this._removeClass(this.sliderElem, 'slider-horizontal');
					this._removeClass(this.sliderElem, 'slider-vertical');
					this._removeClass(this.sliderElem, 'slider-rtl');
					this._removeClass(this.tooltip, 'hide');
					this._removeClass(this.tooltip_min, 'hide');
					this._removeClass(this.tooltip_max, 'hide');
	
					// Undo existing inline styles for track
					["left", "right", "top", "width", "height"].forEach(function (prop) {
						this._removeProperty(this.trackLow, prop);
						this._removeProperty(this.trackSelection, prop);
						this._removeProperty(this.trackHigh, prop);
					}, this);
	
					// Undo inline styles on handles
					[this.handle1, this.handle2].forEach(function (handle) {
						this._removeProperty(handle, 'left');
						this._removeProperty(handle, 'right');
						this._removeProperty(handle, 'top');
					}, this);
	
					// Undo inline styles and classes on tooltips
					[this.tooltip, this.tooltip_min, this.tooltip_max].forEach(function (tooltip) {
						this._removeProperty(tooltip, 'left');
						this._removeProperty(tooltip, 'right');
						this._removeProperty(tooltip, 'top');
						this._removeProperty(tooltip, 'margin-left');
						this._removeProperty(tooltip, 'margin-right');
						this._removeProperty(tooltip, 'margin-top');
	
						this._removeClass(tooltip, 'right');
						this._removeClass(tooltip, 'left');
						this._removeClass(tooltip, 'top');
					}, this);
				}
	
				if (this.options.orientation === 'vertical') {
					this._addClass(this.sliderElem, 'slider-vertical');
					this.stylePos = 'top';
					this.mousePos = 'pageY';
					this.sizePos = 'offsetHeight';
				} else {
					this._addClass(this.sliderElem, 'slider-horizontal');
					this.sliderElem.style.width = origWidth;
					this.options.orientation = 'horizontal';
					if (this.options.rtl) {
						this.stylePos = 'right';
					} else {
						this.stylePos = 'left';
					}
					this.mousePos = 'pageX';
					this.sizePos = 'offsetWidth';
				}
				// specific rtl class
				if (this.options.rtl) {
					this._addClass(this.sliderElem, 'slider-rtl');
				}
				this._setTooltipPosition();
				/* In case ticks are specified, overwrite the min and max bounds */
				if (Array.isArray(this.options.ticks) && this.options.ticks.length > 0) {
					this.options.max = Math.max.apply(Math, this.options.ticks);
					this.options.min = Math.min.apply(Math, this.options.ticks);
				}
	
				if (Array.isArray(this.options.value)) {
					this.options.range = true;
					this._state.value = this.options.value;
				} else if (this.options.range) {
					// User wants a range, but value is not an array
					this._state.value = [this.options.value, this.options.max];
				} else {
					this._state.value = this.options.value;
				}
	
				this.trackLow = sliderTrackLow || this.trackLow;
				this.trackSelection = sliderTrackSelection || this.trackSelection;
				this.trackHigh = sliderTrackHigh || this.trackHigh;
	
				if (this.options.selection === 'none') {
					this._addClass(this.trackLow, 'hide');
					this._addClass(this.trackSelection, 'hide');
					this._addClass(this.trackHigh, 'hide');
				} else if (this.options.selection === 'after' || this.options.selection === 'before') {
					this._removeClass(this.trackLow, 'hide');
					this._removeClass(this.trackSelection, 'hide');
					this._removeClass(this.trackHigh, 'hide');
				}
	
				this.handle1 = sliderMinHandle || this.handle1;
				this.handle2 = sliderMaxHandle || this.handle2;
	
				if (updateSlider === true) {
					// Reset classes
					this._removeClass(this.handle1, 'round triangle');
					this._removeClass(this.handle2, 'round triangle hide');
	
					for (i = 0; i < this.ticks.length; i++) {
						this._removeClass(this.ticks[i], 'round triangle hide');
					}
				}
	
				var availableHandleModifiers = ['round', 'triangle', 'custom'];
				var isValidHandleType = availableHandleModifiers.indexOf(this.options.handle) !== -1;
				if (isValidHandleType) {
					this._addClass(this.handle1, this.options.handle);
					this._addClass(this.handle2, this.options.handle);
	
					for (i = 0; i < this.ticks.length; i++) {
						this._addClass(this.ticks[i], this.options.handle);
					}
				}
	
				this._state.offset = this._offset(this.sliderElem);
				this._state.size = this.sliderElem[this.sizePos];
				this.setValue(this._state.value);
	
				/******************************************
	   				Bind Event Listeners
	   	******************************************/
	
				// Bind keyboard handlers
				this.handle1Keydown = this._keydown.bind(this, 0);
				this.handle1.addEventListener("keydown", this.handle1Keydown, false);
	
				this.handle2Keydown = this._keydown.bind(this, 1);
				this.handle2.addEventListener("keydown", this.handle2Keydown, false);
	
				this.mousedown = this._mousedown.bind(this);
				this.touchstart = this._touchstart.bind(this);
				this.touchmove = this._touchmove.bind(this);
	
				if (this.touchCapable) {
					// Test for passive event support
					var supportsPassive = false;
					try {
						var opts = Object.defineProperty({}, 'passive', {
							get: function get() {
								supportsPassive = true;
							}
						});
						window.addEventListener("test", null, opts);
					} catch (e) {}
					// Use our detect's results. passive applied if supported, capture will be false either way.
					var eventOptions = supportsPassive ? { passive: true } : false;
					// Bind touch handlers
					this.sliderElem.addEventListener("touchstart", this.touchstart, eventOptions);
					this.sliderElem.addEventListener("touchmove", this.touchmove, eventOptions);
				}
				this.sliderElem.addEventListener("mousedown", this.mousedown, false);
	
				// Bind window handlers
				this.resize = this._resize.bind(this);
				window.addEventListener("resize", this.resize, false);
	
				// Bind tooltip-related handlers
				if (this.options.tooltip === 'hide') {
					this._addClass(this.tooltip, 'hide');
					this._addClass(this.tooltip_min, 'hide');
					this._addClass(this.tooltip_max, 'hide');
				} else if (this.options.tooltip === 'always') {
					this._showTooltip();
					this._alwaysShowTooltip = true;
				} else {
					this.showTooltip = this._showTooltip.bind(this);
					this.hideTooltip = this._hideTooltip.bind(this);
	
					if (this.options.ticks_tooltip) {
						var callbackHandle = this._addTickListener();
						//create handle1 listeners and store references in map
						var mouseEnter = callbackHandle.addMouseEnter(this, this.handle1);
						var mouseLeave = callbackHandle.addMouseLeave(this, this.handle1);
						this.handleCallbackMap.handle1 = {
							mouseEnter: mouseEnter,
							mouseLeave: mouseLeave
						};
						//create handle2 listeners and store references in map
						mouseEnter = callbackHandle.addMouseEnter(this, this.handle2);
						mouseLeave = callbackHandle.addMouseLeave(this, this.handle2);
						this.handleCallbackMap.handle2 = {
							mouseEnter: mouseEnter,
							mouseLeave: mouseLeave
						};
					} else {
						this.sliderElem.addEventListener("mouseenter", this.showTooltip, false);
						this.sliderElem.addEventListener("mouseleave", this.hideTooltip, false);
					}
	
					this.handle1.addEventListener("focus", this.showTooltip, false);
					this.handle1.addEventListener("blur", this.hideTooltip, false);
	
					this.handle2.addEventListener("focus", this.showTooltip, false);
					this.handle2.addEventListener("blur", this.hideTooltip, false);
				}
	
				if (this.options.enabled) {
					this.enable();
				} else {
					this.disable();
				}
			}
	
			/*************************************************
	  				INSTANCE PROPERTIES/METHODS
	  	- Any methods bound to the prototype are considered
	  part of the plugin's `public` interface
	  	**************************************************/
			Slider.prototype = {
				_init: function _init() {}, // NOTE: Must exist to support bridget
	
				constructor: Slider,
	
				defaultOptions: {
					id: "",
					min: 0,
					max: 10,
					step: 1,
					precision: 0,
					orientation: 'horizontal',
					value: 5,
					range: false,
					selection: 'before',
					tooltip: 'show',
					tooltip_split: false,
					handle: 'round',
					reversed: false,
					rtl: 'auto',
					enabled: true,
					formatter: function formatter(val) {
						if (Array.isArray(val)) {
							return val[0] + " : " + val[1];
						} else {
							return val;
						}
					},
					natural_arrow_keys: false,
					ticks: [],
					ticks_positions: [],
					ticks_labels: [],
					ticks_snap_bounds: 0,
					ticks_tooltip: false,
					scale: 'linear',
					focus: false,
					tooltip_position: null,
					labelledby: null,
					rangeHighlights: []
				},
	
				getElement: function getElement() {
					return this.sliderElem;
				},
	
				getValue: function getValue() {
					if (this.options.range) {
						return this._state.value;
					} else {
						return this._state.value[0];
					}
				},
	
				setValue: function setValue(val, triggerSlideEvent, triggerChangeEvent) {
					if (!val) {
						val = 0;
					}
					var oldValue = this.getValue();
					this._state.value = this._validateInputValue(val);
					var applyPrecision = this._applyPrecision.bind(this);
	
					if (this.options.range) {
						this._state.value[0] = applyPrecision(this._state.value[0]);
						this._state.value[1] = applyPrecision(this._state.value[1]);
	
						this._state.value[0] = Math.max(this.options.min, Math.min(this.options.max, this._state.value[0]));
						this._state.value[1] = Math.max(this.options.min, Math.min(this.options.max, this._state.value[1]));
					} else {
						this._state.value = applyPrecision(this._state.value);
						this._state.value = [Math.max(this.options.min, Math.min(this.options.max, this._state.value))];
						this._addClass(this.handle2, 'hide');
						if (this.options.selection === 'after') {
							this._state.value[1] = this.options.max;
						} else {
							this._state.value[1] = this.options.min;
						}
					}
	
					if (this.options.max > this.options.min) {
						this._state.percentage = [this._toPercentage(this._state.value[0]), this._toPercentage(this._state.value[1]), this.options.step * 100 / (this.options.max - this.options.min)];
					} else {
						this._state.percentage = [0, 0, 100];
					}
	
					this._layout();
					var newValue = this.options.range ? this._state.value : this._state.value[0];
	
					this._setDataVal(newValue);
					if (triggerSlideEvent === true) {
						this._trigger('slide', newValue);
					}
					if (oldValue !== newValue && triggerChangeEvent === true) {
						this._trigger('change', {
							oldValue: oldValue,
							newValue: newValue
						});
					}
	
					return this;
				},
	
				destroy: function destroy() {
					// Remove event handlers on slider elements
					this._removeSliderEventHandlers();
	
					// Remove the slider from the DOM
					this.sliderElem.parentNode.removeChild(this.sliderElem);
					/* Show original <input> element */
					this.element.style.display = "";
	
					// Clear out custom event bindings
					this._cleanUpEventCallbacksMap();
	
					// Remove data values
					this.element.removeAttribute("data");
	
					// Remove JQuery handlers/data
					if ($) {
						this._unbindJQueryEventHandlers();
						this.$element.removeData('slider');
					}
				},
	
				disable: function disable() {
					this._state.enabled = false;
					this.handle1.removeAttribute("tabindex");
					this.handle2.removeAttribute("tabindex");
					this._addClass(this.sliderElem, 'slider-disabled');
					this._trigger('slideDisabled');
	
					return this;
				},
	
				enable: function enable() {
					this._state.enabled = true;
					this.handle1.setAttribute("tabindex", 0);
					this.handle2.setAttribute("tabindex", 0);
					this._removeClass(this.sliderElem, 'slider-disabled');
					this._trigger('slideEnabled');
	
					return this;
				},
	
				toggle: function toggle() {
					if (this._state.enabled) {
						this.disable();
					} else {
						this.enable();
					}
					return this;
				},
	
				isEnabled: function isEnabled() {
					return this._state.enabled;
				},
	
				on: function on(evt, callback) {
					this._bindNonQueryEventHandler(evt, callback);
					return this;
				},
	
				off: function off(evt, callback) {
					if ($) {
						this.$element.off(evt, callback);
						this.$sliderElem.off(evt, callback);
					} else {
						this._unbindNonQueryEventHandler(evt, callback);
					}
				},
	
				getAttribute: function getAttribute(attribute) {
					if (attribute) {
						return this.options[attribute];
					} else {
						return this.options;
					}
				},
	
				setAttribute: function setAttribute(attribute, value) {
					this.options[attribute] = value;
					return this;
				},
	
				refresh: function refresh() {
					this._removeSliderEventHandlers();
					createNewSlider.call(this, this.element, this.options);
					if ($) {
						// Bind new instance of slider to the element
						$.data(this.element, 'slider', this);
					}
					return this;
				},
	
				relayout: function relayout() {
					this._resize();
					this._layout();
					return this;
				},
	
				/******************************+
	   				HELPERS
	   	- Any method that is not part of the public interface.
	   - Place it underneath this comment block and write its signature like so:
	   		_fnName : function() {...}
	   	********************************/
				_removeSliderEventHandlers: function _removeSliderEventHandlers() {
					// Remove keydown event listeners
					this.handle1.removeEventListener("keydown", this.handle1Keydown, false);
					this.handle2.removeEventListener("keydown", this.handle2Keydown, false);
	
					//remove the listeners from the ticks and handles if they had their own listeners
					if (this.options.ticks_tooltip) {
						var ticks = this.ticksContainer.getElementsByClassName('slider-tick');
						for (var i = 0; i < ticks.length; i++) {
							ticks[i].removeEventListener('mouseenter', this.ticksCallbackMap[i].mouseEnter, false);
							ticks[i].removeEventListener('mouseleave', this.ticksCallbackMap[i].mouseLeave, false);
						}
						this.handle1.removeEventListener('mouseenter', this.handleCallbackMap.handle1.mouseEnter, false);
						this.handle2.removeEventListener('mouseenter', this.handleCallbackMap.handle2.mouseEnter, false);
						this.handle1.removeEventListener('mouseleave', this.handleCallbackMap.handle1.mouseLeave, false);
						this.handle2.removeEventListener('mouseleave', this.handleCallbackMap.handle2.mouseLeave, false);
					}
	
					this.handleCallbackMap = null;
					this.ticksCallbackMap = null;
	
					if (this.showTooltip) {
						this.handle1.removeEventListener("focus", this.showTooltip, false);
						this.handle2.removeEventListener("focus", this.showTooltip, false);
					}
					if (this.hideTooltip) {
						this.handle1.removeEventListener("blur", this.hideTooltip, false);
						this.handle2.removeEventListener("blur", this.hideTooltip, false);
					}
	
					// Remove event listeners from sliderElem
					if (this.showTooltip) {
						this.sliderElem.removeEventListener("mouseenter", this.showTooltip, false);
					}
					if (this.hideTooltip) {
						this.sliderElem.removeEventListener("mouseleave", this.hideTooltip, false);
					}
					this.sliderElem.removeEventListener("touchstart", this.touchstart, false);
					this.sliderElem.removeEventListener("touchmove", this.touchmove, false);
					this.sliderElem.removeEventListener("mousedown", this.mousedown, false);
	
					// Remove window event listener
					window.removeEventListener("resize", this.resize, false);
				},
				_bindNonQueryEventHandler: function _bindNonQueryEventHandler(evt, callback) {
					if (this.eventToCallbackMap[evt] === undefined) {
						this.eventToCallbackMap[evt] = [];
					}
					this.eventToCallbackMap[evt].push(callback);
				},
				_unbindNonQueryEventHandler: function _unbindNonQueryEventHandler(evt, callback) {
					var callbacks = this.eventToCallbackMap[evt];
					if (callbacks !== undefined) {
						for (var i = 0; i < callbacks.length; i++) {
							if (callbacks[i] === callback) {
								callbacks.splice(i, 1);
								break;
							}
						}
					}
				},
				_cleanUpEventCallbacksMap: function _cleanUpEventCallbacksMap() {
					var eventNames = Object.keys(this.eventToCallbackMap);
					for (var i = 0; i < eventNames.length; i++) {
						var eventName = eventNames[i];
						delete this.eventToCallbackMap[eventName];
					}
				},
				_showTooltip: function _showTooltip() {
					if (this.options.tooltip_split === false) {
						this._addClass(this.tooltip, 'in');
						this.tooltip_min.style.display = 'none';
						this.tooltip_max.style.display = 'none';
					} else {
						this._addClass(this.tooltip_min, 'in');
						this._addClass(this.tooltip_max, 'in');
						this.tooltip.style.display = 'none';
					}
					this._state.over = true;
				},
				_hideTooltip: function _hideTooltip() {
					if (this._state.inDrag === false && this.alwaysShowTooltip !== true) {
						this._removeClass(this.tooltip, 'in');
						this._removeClass(this.tooltip_min, 'in');
						this._removeClass(this.tooltip_max, 'in');
					}
					this._state.over = false;
				},
				_setToolTipOnMouseOver: function _setToolTipOnMouseOver(tempState) {
					var formattedTooltipVal = this.options.formatter(!tempState ? this._state.value[0] : tempState.value[0]);
					var positionPercentages = !tempState ? getPositionPercentages(this._state, this.options.reversed) : getPositionPercentages(tempState, this.options.reversed);
					this._setText(this.tooltipInner, formattedTooltipVal);
	
					this.tooltip.style[this.stylePos] = positionPercentages[0] + "%";
					if (this.options.orientation === 'vertical') {
						this._css(this.tooltip, "margin-" + this.stylePos, -this.tooltip.offsetHeight / 2 + "px");
					} else {
						this._css(this.tooltip, "margin-" + this.stylePos, -this.tooltip.offsetWidth / 2 + "px");
					}
	
					function getPositionPercentages(state, reversed) {
						if (reversed) {
							return [100 - state.percentage[0], this.options.range ? 100 - state.percentage[1] : state.percentage[1]];
						}
						return [state.percentage[0], state.percentage[1]];
					}
				},
				_addTickListener: function _addTickListener() {
					return {
						addMouseEnter: function addMouseEnter(reference, tick, index) {
							var enter = function enter() {
								var tempState = reference._state;
								var idString = index >= 0 ? index : this.attributes['aria-valuenow'].value;
								var hoverIndex = parseInt(idString, 10);
								tempState.value[0] = hoverIndex;
								tempState.percentage[0] = reference.options.ticks_positions[hoverIndex];
								reference._setToolTipOnMouseOver(tempState);
								reference._showTooltip();
							};
							tick.addEventListener("mouseenter", enter, false);
							return enter;
						},
						addMouseLeave: function addMouseLeave(reference, tick) {
							var leave = function leave() {
								reference._hideTooltip();
							};
							tick.addEventListener("mouseleave", leave, false);
							return leave;
						}
					};
				},
				_layout: function _layout() {
					var positionPercentages;
	
					if (this.options.reversed) {
						positionPercentages = [100 - this._state.percentage[0], this.options.range ? 100 - this._state.percentage[1] : this._state.percentage[1]];
					} else {
						positionPercentages = [this._state.percentage[0], this._state.percentage[1]];
					}
	
					this.handle1.style[this.stylePos] = positionPercentages[0] + "%";
					this.handle1.setAttribute('aria-valuenow', this._state.value[0]);
					if (isNaN(this.options.formatter(this._state.value[0]))) {
						this.handle1.setAttribute('aria-valuetext', this.options.formatter(this._state.value[0]));
					}
	
					this.handle2.style[this.stylePos] = positionPercentages[1] + "%";
					this.handle2.setAttribute('aria-valuenow', this._state.value[1]);
					if (isNaN(this.options.formatter(this._state.value[1]))) {
						this.handle2.setAttribute('aria-valuetext', this.options.formatter(this._state.value[1]));
					}
	
					/* Position highlight range elements */
					if (this.rangeHighlightElements.length > 0 && Array.isArray(this.options.rangeHighlights) && this.options.rangeHighlights.length > 0) {
						for (var _i = 0; _i < this.options.rangeHighlights.length; _i++) {
							var startPercent = this._toPercentage(this.options.rangeHighlights[_i].start);
							var endPercent = this._toPercentage(this.options.rangeHighlights[_i].end);
	
							if (this.options.reversed) {
								var sp = 100 - endPercent;
								endPercent = 100 - startPercent;
								startPercent = sp;
							}
	
							var currentRange = this._createHighlightRange(startPercent, endPercent);
	
							if (currentRange) {
								if (this.options.orientation === 'vertical') {
									this.rangeHighlightElements[_i].style.top = currentRange.start + "%";
									this.rangeHighlightElements[_i].style.height = currentRange.size + "%";
								} else {
									if (this.options.rtl) {
										this.rangeHighlightElements[_i].style.right = currentRange.start + "%";
									} else {
										this.rangeHighlightElements[_i].style.left = currentRange.start + "%";
									}
									this.rangeHighlightElements[_i].style.width = currentRange.size + "%";
								}
							} else {
								this.rangeHighlightElements[_i].style.display = "none";
							}
						}
					}
	
					/* Position ticks and labels */
					if (Array.isArray(this.options.ticks) && this.options.ticks.length > 0) {
	
						var styleSize = this.options.orientation === 'vertical' ? 'height' : 'width';
						var styleMargin;
						if (this.options.orientation === 'vertical') {
							styleMargin = 'marginTop';
						} else {
							if (this.options.rtl) {
								styleMargin = 'marginRight';
							} else {
								styleMargin = 'marginLeft';
							}
						}
						var labelSize = this._state.size / (this.options.ticks.length - 1);
	
						if (this.tickLabelContainer) {
							var extraMargin = 0;
							if (this.options.ticks_positions.length === 0) {
								if (this.options.orientation !== 'vertical') {
									this.tickLabelContainer.style[styleMargin] = -labelSize / 2 + "px";
								}
	
								extraMargin = this.tickLabelContainer.offsetHeight;
							} else {
								/* Chidren are position absolute, calculate height by finding the max offsetHeight of a child */
								for (i = 0; i < this.tickLabelContainer.childNodes.length; i++) {
									if (this.tickLabelContainer.childNodes[i].offsetHeight > extraMargin) {
										extraMargin = this.tickLabelContainer.childNodes[i].offsetHeight;
									}
								}
							}
							if (this.options.orientation === 'horizontal') {
								this.sliderElem.style.marginBottom = extraMargin + "px";
							}
						}
						for (var i = 0; i < this.options.ticks.length; i++) {
	
							var percentage = this.options.ticks_positions[i] || this._toPercentage(this.options.ticks[i]);
	
							if (this.options.reversed) {
								percentage = 100 - percentage;
							}
	
							this.ticks[i].style[this.stylePos] = percentage + "%";
	
							/* Set class labels to denote whether ticks are in the selection */
							this._removeClass(this.ticks[i], 'in-selection');
							if (!this.options.range) {
								if (this.options.selection === 'after' && percentage >= positionPercentages[0]) {
									this._addClass(this.ticks[i], 'in-selection');
								} else if (this.options.selection === 'before' && percentage <= positionPercentages[0]) {
									this._addClass(this.ticks[i], 'in-selection');
								}
							} else if (percentage >= positionPercentages[0] && percentage <= positionPercentages[1]) {
								this._addClass(this.ticks[i], 'in-selection');
							}
	
							if (this.tickLabels[i]) {
								this.tickLabels[i].style[styleSize] = labelSize + "px";
	
								if (this.options.orientation !== 'vertical' && this.options.ticks_positions[i] !== undefined) {
									this.tickLabels[i].style.position = 'absolute';
									this.tickLabels[i].style[this.stylePos] = percentage + "%";
									this.tickLabels[i].style[styleMargin] = -labelSize / 2 + 'px';
								} else if (this.options.orientation === 'vertical') {
									if (this.options.rtl) {
										this.tickLabels[i].style['marginRight'] = this.sliderElem.offsetWidth + "px";
									} else {
										this.tickLabels[i].style['marginLeft'] = this.sliderElem.offsetWidth + "px";
									}
									this.tickLabelContainer.style[styleMargin] = this.sliderElem.offsetWidth / 2 * -1 + 'px';
								}
							}
						}
					}
	
					var formattedTooltipVal;
	
					if (this.options.range) {
						formattedTooltipVal = this.options.formatter(this._state.value);
						this._setText(this.tooltipInner, formattedTooltipVal);
						this.tooltip.style[this.stylePos] = (positionPercentages[1] + positionPercentages[0]) / 2 + "%";
	
						if (this.options.orientation === 'vertical') {
							this._css(this.tooltip, "margin-" + this.stylePos, -this.tooltip.offsetHeight / 2 + "px");
						} else {
							this._css(this.tooltip, "margin-" + this.stylePos, -this.tooltip.offsetWidth / 2 + "px");
						}
	
						var innerTooltipMinText = this.options.formatter(this._state.value[0]);
						this._setText(this.tooltipInner_min, innerTooltipMinText);
	
						var innerTooltipMaxText = this.options.formatter(this._state.value[1]);
						this._setText(this.tooltipInner_max, innerTooltipMaxText);
	
						this.tooltip_min.style[this.stylePos] = positionPercentages[0] + "%";
	
						if (this.options.orientation === 'vertical') {
							this._css(this.tooltip_min, "margin-" + this.stylePos, -this.tooltip_min.offsetHeight / 2 + "px");
						} else {
							this._css(this.tooltip_min, "margin-" + this.stylePos, -this.tooltip_min.offsetWidth / 2 + "px");
						}
	
						this.tooltip_max.style[this.stylePos] = positionPercentages[1] + "%";
	
						if (this.options.orientation === 'vertical') {
							this._css(this.tooltip_max, "margin-" + this.stylePos, -this.tooltip_max.offsetHeight / 2 + "px");
						} else {
							this._css(this.tooltip_max, "margin-" + this.stylePos, -this.tooltip_max.offsetWidth / 2 + "px");
						}
					} else {
						formattedTooltipVal = this.options.formatter(this._state.value[0]);
						this._setText(this.tooltipInner, formattedTooltipVal);
	
						this.tooltip.style[this.stylePos] = positionPercentages[0] + "%";
						if (this.options.orientation === 'vertical') {
							this._css(this.tooltip, "margin-" + this.stylePos, -this.tooltip.offsetHeight / 2 + "px");
						} else {
							this._css(this.tooltip, "margin-" + this.stylePos, -this.tooltip.offsetWidth / 2 + "px");
						}
					}
	
					if (this.options.orientation === 'vertical') {
						this.trackLow.style.top = '0';
						this.trackLow.style.height = Math.min(positionPercentages[0], positionPercentages[1]) + '%';
	
						this.trackSelection.style.top = Math.min(positionPercentages[0], positionPercentages[1]) + '%';
						this.trackSelection.style.height = Math.abs(positionPercentages[0] - positionPercentages[1]) + '%';
	
						this.trackHigh.style.bottom = '0';
						this.trackHigh.style.height = 100 - Math.min(positionPercentages[0], positionPercentages[1]) - Math.abs(positionPercentages[0] - positionPercentages[1]) + '%';
					} else {
						if (this.stylePos === 'right') {
							this.trackLow.style.right = '0';
						} else {
							this.trackLow.style.left = '0';
						}
						this.trackLow.style.width = Math.min(positionPercentages[0], positionPercentages[1]) + '%';
	
						if (this.stylePos === 'right') {
							this.trackSelection.style.right = Math.min(positionPercentages[0], positionPercentages[1]) + '%';
						} else {
							this.trackSelection.style.left = Math.min(positionPercentages[0], positionPercentages[1]) + '%';
						}
						this.trackSelection.style.width = Math.abs(positionPercentages[0] - positionPercentages[1]) + '%';
	
						if (this.stylePos === 'right') {
							this.trackHigh.style.left = '0';
						} else {
							this.trackHigh.style.right = '0';
						}
						this.trackHigh.style.width = 100 - Math.min(positionPercentages[0], positionPercentages[1]) - Math.abs(positionPercentages[0] - positionPercentages[1]) + '%';
	
						var offset_min = this.tooltip_min.getBoundingClientRect();
						var offset_max = this.tooltip_max.getBoundingClientRect();
	
						if (this.options.tooltip_position === 'bottom') {
							if (offset_min.right > offset_max.left) {
								this._removeClass(this.tooltip_max, 'bottom');
								this._addClass(this.tooltip_max, 'top');
								this.tooltip_max.style.top = '';
								this.tooltip_max.style.bottom = 22 + 'px';
							} else {
								this._removeClass(this.tooltip_max, 'top');
								this._addClass(this.tooltip_max, 'bottom');
								this.tooltip_max.style.top = this.tooltip_min.style.top;
								this.tooltip_max.style.bottom = '';
							}
						} else {
							if (offset_min.right > offset_max.left) {
								this._removeClass(this.tooltip_max, 'top');
								this._addClass(this.tooltip_max, 'bottom');
								this.tooltip_max.style.top = 18 + 'px';
							} else {
								this._removeClass(this.tooltip_max, 'bottom');
								this._addClass(this.tooltip_max, 'top');
								this.tooltip_max.style.top = this.tooltip_min.style.top;
							}
						}
					}
				},
				_createHighlightRange: function _createHighlightRange(start, end) {
					if (this._isHighlightRange(start, end)) {
						if (start > end) {
							return { 'start': end, 'size': start - end };
						}
						return { 'start': start, 'size': end - start };
					}
					return null;
				},
				_isHighlightRange: function _isHighlightRange(start, end) {
					if (0 <= start && start <= 100 && 0 <= end && end <= 100) {
						return true;
					} else {
						return false;
					}
				},
				_resize: function _resize(ev) {
					/*jshint unused:false*/
					this._state.offset = this._offset(this.sliderElem);
					this._state.size = this.sliderElem[this.sizePos];
					this._layout();
				},
				_removeProperty: function _removeProperty(element, prop) {
					if (element.style.removeProperty) {
						element.style.removeProperty(prop);
					} else {
						element.style.removeAttribute(prop);
					}
				},
				_mousedown: function _mousedown(ev) {
					if (!this._state.enabled) {
						return false;
					}
	
					this._state.offset = this._offset(this.sliderElem);
					this._state.size = this.sliderElem[this.sizePos];
	
					var percentage = this._getPercentage(ev);
	
					if (this.options.range) {
						var diff1 = Math.abs(this._state.percentage[0] - percentage);
						var diff2 = Math.abs(this._state.percentage[1] - percentage);
						this._state.dragged = diff1 < diff2 ? 0 : 1;
						this._adjustPercentageForRangeSliders(percentage);
					} else {
						this._state.dragged = 0;
					}
	
					this._state.percentage[this._state.dragged] = percentage;
					this._layout();
	
					if (this.touchCapable) {
						document.removeEventListener("touchmove", this.mousemove, false);
						document.removeEventListener("touchend", this.mouseup, false);
					}
	
					if (this.mousemove) {
						document.removeEventListener("mousemove", this.mousemove, false);
					}
					if (this.mouseup) {
						document.removeEventListener("mouseup", this.mouseup, false);
					}
	
					this.mousemove = this._mousemove.bind(this);
					this.mouseup = this._mouseup.bind(this);
	
					if (this.touchCapable) {
						// Touch: Bind touch events:
						document.addEventListener("touchmove", this.mousemove, false);
						document.addEventListener("touchend", this.mouseup, false);
					}
					// Bind mouse events:
					document.addEventListener("mousemove", this.mousemove, false);
					document.addEventListener("mouseup", this.mouseup, false);
	
					this._state.inDrag = true;
					var newValue = this._calculateValue();
	
					this._trigger('slideStart', newValue);
	
					this._setDataVal(newValue);
					this.setValue(newValue, false, true);
	
					ev.returnValue = false;
	
					if (this.options.focus) {
						this._triggerFocusOnHandle(this._state.dragged);
					}
	
					return true;
				},
				_touchstart: function _touchstart(ev) {
					if (ev.changedTouches === undefined) {
						this._mousedown(ev);
						return;
					}
	
					var touch = ev.changedTouches[0];
					this.touchX = touch.pageX;
					this.touchY = touch.pageY;
				},
				_triggerFocusOnHandle: function _triggerFocusOnHandle(handleIdx) {
					if (handleIdx === 0) {
						this.handle1.focus();
					}
					if (handleIdx === 1) {
						this.handle2.focus();
					}
				},
				_keydown: function _keydown(handleIdx, ev) {
					if (!this._state.enabled) {
						return false;
					}
	
					var dir;
					switch (ev.keyCode) {
						case 37: // left
						case 40:
							// down
							dir = -1;
							break;
						case 39: // right
						case 38:
							// up
							dir = 1;
							break;
					}
					if (!dir) {
						return;
					}
	
					// use natural arrow keys instead of from min to max
					if (this.options.natural_arrow_keys) {
						var ifVerticalAndNotReversed = this.options.orientation === 'vertical' && !this.options.reversed;
						var ifHorizontalAndReversed = this.options.orientation === 'horizontal' && this.options.reversed; // @todo control with rtl
	
						if (ifVerticalAndNotReversed || ifHorizontalAndReversed) {
							dir = -dir;
						}
					}
	
					var val = this._state.value[handleIdx] + dir * this.options.step;
					var percentage = val / this.options.max * 100;
					this._state.keyCtrl = handleIdx;
					if (this.options.range) {
						this._adjustPercentageForRangeSliders(percentage);
						var val1 = !this._state.keyCtrl ? val : this._state.value[0];
						var val2 = this._state.keyCtrl ? val : this._state.value[1];
						val = [val1, val2];
					}
	
					this._trigger('slideStart', val);
					this._setDataVal(val);
					this.setValue(val, true, true);
	
					this._setDataVal(val);
					this._trigger('slideStop', val);
					this._layout();
	
					this._pauseEvent(ev);
					delete this._state.keyCtrl;
	
					return false;
				},
				_pauseEvent: function _pauseEvent(ev) {
					if (ev.stopPropagation) {
						ev.stopPropagation();
					}
					if (ev.preventDefault) {
						ev.preventDefault();
					}
					ev.cancelBubble = true;
					ev.returnValue = false;
				},
				_mousemove: function _mousemove(ev) {
					if (!this._state.enabled) {
						return false;
					}
	
					var percentage = this._getPercentage(ev);
					this._adjustPercentageForRangeSliders(percentage);
					this._state.percentage[this._state.dragged] = percentage;
					this._layout();
	
					var val = this._calculateValue(true);
					this.setValue(val, true, true);
	
					return false;
				},
				_touchmove: function _touchmove(ev) {
					if (ev.changedTouches === undefined) {
						return;
					}
	
					var touch = ev.changedTouches[0];
	
					var xDiff = touch.pageX - this.touchX;
					var yDiff = touch.pageY - this.touchY;
	
					if (!this._state.inDrag) {
						// Vertical Slider
						if (this.options.orientation === 'vertical' && xDiff <= 5 && xDiff >= -5 && (yDiff >= 15 || yDiff <= -15)) {
							this._mousedown(ev);
						}
						// Horizontal slider.
						else if (yDiff <= 5 && yDiff >= -5 && (xDiff >= 15 || xDiff <= -15)) {
								this._mousedown(ev);
							}
					}
				},
				_adjustPercentageForRangeSliders: function _adjustPercentageForRangeSliders(percentage) {
					if (this.options.range) {
						var precision = this._getNumDigitsAfterDecimalPlace(percentage);
						precision = precision ? precision - 1 : 0;
						var percentageWithAdjustedPrecision = this._applyToFixedAndParseFloat(percentage, precision);
						if (this._state.dragged === 0 && this._applyToFixedAndParseFloat(this._state.percentage[1], precision) < percentageWithAdjustedPrecision) {
							this._state.percentage[0] = this._state.percentage[1];
							this._state.dragged = 1;
						} else if (this._state.dragged === 1 && this._applyToFixedAndParseFloat(this._state.percentage[0], precision) > percentageWithAdjustedPrecision) {
							this._state.percentage[1] = this._state.percentage[0];
							this._state.dragged = 0;
						} else if (this._state.keyCtrl === 0 && this._state.value[1] / this.options.max * 100 < percentage) {
							this._state.percentage[0] = this._state.percentage[1];
							this._state.keyCtrl = 1;
							this.handle2.focus();
						} else if (this._state.keyCtrl === 1 && this._state.value[0] / this.options.max * 100 > percentage) {
							this._state.percentage[1] = this._state.percentage[0];
							this._state.keyCtrl = 0;
							this.handle1.focus();
						}
					}
				},
				_mouseup: function _mouseup() {
					if (!this._state.enabled) {
						return false;
					}
					if (this.touchCapable) {
						// Touch: Unbind touch event handlers:
						document.removeEventListener("touchmove", this.mousemove, false);
						document.removeEventListener("touchend", this.mouseup, false);
					}
					// Unbind mouse event handlers:
					document.removeEventListener("mousemove", this.mousemove, false);
					document.removeEventListener("mouseup", this.mouseup, false);
	
					this._state.inDrag = false;
					if (this._state.over === false) {
						this._hideTooltip();
					}
					var val = this._calculateValue(true);
	
					this._layout();
					this._setDataVal(val);
					this._trigger('slideStop', val);
	
					return false;
				},
				_calculateValue: function _calculateValue(snapToClosestTick) {
					var val;
					if (this.options.range) {
						val = [this.options.min, this.options.max];
						if (this._state.percentage[0] !== 0) {
							val[0] = this._toValue(this._state.percentage[0]);
							val[0] = this._applyPrecision(val[0]);
						}
						if (this._state.percentage[1] !== 100) {
							val[1] = this._toValue(this._state.percentage[1]);
							val[1] = this._applyPrecision(val[1]);
						}
					} else {
						val = this._toValue(this._state.percentage[0]);
						val = parseFloat(val);
						val = this._applyPrecision(val);
					}
	
					if (snapToClosestTick) {
						var min = [val, Infinity];
						for (var i = 0; i < this.options.ticks.length; i++) {
							var diff = Math.abs(this.options.ticks[i] - val);
							if (diff <= min[1]) {
								min = [this.options.ticks[i], diff];
							}
						}
						if (min[1] <= this.options.ticks_snap_bounds) {
							return min[0];
						}
					}
	
					return val;
				},
				_applyPrecision: function _applyPrecision(val) {
					var precision = this.options.precision || this._getNumDigitsAfterDecimalPlace(this.options.step);
					return this._applyToFixedAndParseFloat(val, precision);
				},
				_getNumDigitsAfterDecimalPlace: function _getNumDigitsAfterDecimalPlace(num) {
					var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
					if (!match) {
						return 0;
					}
					return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
				},
				_applyToFixedAndParseFloat: function _applyToFixedAndParseFloat(num, toFixedInput) {
					var truncatedNum = num.toFixed(toFixedInput);
					return parseFloat(truncatedNum);
				},
				/*
	   	Credits to Mike Samuel for the following method!
	   	Source: http://stackoverflow.com/questions/10454518/javascript-how-to-retrieve-the-number-of-decimals-of-a-string-number
	   */
				_getPercentage: function _getPercentage(ev) {
					if (this.touchCapable && (ev.type === 'touchstart' || ev.type === 'touchmove')) {
						ev = ev.touches[0];
					}
	
					var eventPosition = ev[this.mousePos];
					var sliderOffset = this._state.offset[this.stylePos];
					var distanceToSlide = eventPosition - sliderOffset;
					if (this.stylePos === 'right') {
						distanceToSlide = -distanceToSlide;
					}
					// Calculate what percent of the length the slider handle has slid
					var percentage = distanceToSlide / this._state.size * 100;
					percentage = Math.round(percentage / this._state.percentage[2]) * this._state.percentage[2];
					if (this.options.reversed) {
						percentage = 100 - percentage;
					}
	
					// Make sure the percent is within the bounds of the slider.
					// 0% corresponds to the 'min' value of the slide
					// 100% corresponds to the 'max' value of the slide
					return Math.max(0, Math.min(100, percentage));
				},
				_validateInputValue: function _validateInputValue(val) {
					if (!isNaN(+val)) {
						return +val;
					} else if (Array.isArray(val)) {
						this._validateArray(val);
						return val;
					} else {
						throw new Error(ErrorMsgs.formatInvalidInputErrorMsg(val));
					}
				},
				_validateArray: function _validateArray(val) {
					for (var i = 0; i < val.length; i++) {
						var input = val[i];
						if (typeof input !== 'number') {
							throw new Error(ErrorMsgs.formatInvalidInputErrorMsg(input));
						}
					}
				},
				_setDataVal: function _setDataVal(val) {
					this.element.setAttribute('data-value', val);
					this.element.setAttribute('value', val);
					this.element.value = val;
				},
				_trigger: function _trigger(evt, val) {
					val = val || val === 0 ? val : undefined;
	
					var callbackFnArray = this.eventToCallbackMap[evt];
					if (callbackFnArray && callbackFnArray.length) {
						for (var i = 0; i < callbackFnArray.length; i++) {
							var callbackFn = callbackFnArray[i];
							callbackFn(val);
						}
					}
	
					/* If JQuery exists, trigger JQuery events */
					if ($) {
						this._triggerJQueryEvent(evt, val);
					}
				},
				_triggerJQueryEvent: function _triggerJQueryEvent(evt, val) {
					var eventData = {
						type: evt,
						value: val
					};
					this.$element.trigger(eventData);
					this.$sliderElem.trigger(eventData);
				},
				_unbindJQueryEventHandlers: function _unbindJQueryEventHandlers() {
					this.$element.off();
					this.$sliderElem.off();
				},
				_setText: function _setText(element, text) {
					if (typeof element.textContent !== "undefined") {
						element.textContent = text;
					} else if (typeof element.innerText !== "undefined") {
						element.innerText = text;
					}
				},
				_removeClass: function _removeClass(element, classString) {
					var classes = classString.split(" ");
					var newClasses = element.className;
	
					for (var i = 0; i < classes.length; i++) {
						var classTag = classes[i];
						var regex = new RegExp("(?:\\s|^)" + classTag + "(?:\\s|$)");
						newClasses = newClasses.replace(regex, " ");
					}
	
					element.className = newClasses.trim();
				},
				_addClass: function _addClass(element, classString) {
					var classes = classString.split(" ");
					var newClasses = element.className;
	
					for (var i = 0; i < classes.length; i++) {
						var classTag = classes[i];
						var regex = new RegExp("(?:\\s|^)" + classTag + "(?:\\s|$)");
						var ifClassExists = regex.test(newClasses);
	
						if (!ifClassExists) {
							newClasses += " " + classTag;
						}
					}
	
					element.className = newClasses.trim();
				},
				_offsetLeft: function _offsetLeft(obj) {
					return obj.getBoundingClientRect().left;
				},
				_offsetRight: function _offsetRight(obj) {
					return obj.getBoundingClientRect().right;
				},
				_offsetTop: function _offsetTop(obj) {
					var offsetTop = obj.offsetTop;
					while ((obj = obj.offsetParent) && !isNaN(obj.offsetTop)) {
						offsetTop += obj.offsetTop;
						if (obj.tagName !== 'BODY') {
							offsetTop -= obj.scrollTop;
						}
					}
					return offsetTop;
				},
				_offset: function _offset(obj) {
					return {
						left: this._offsetLeft(obj),
						right: this._offsetRight(obj),
						top: this._offsetTop(obj)
					};
				},
				_css: function _css(elementRef, styleName, value) {
					if ($) {
						$.style(elementRef, styleName, value);
					} else {
						var style = styleName.replace(/^-ms-/, "ms-").replace(/-([\da-z])/gi, function (all, letter) {
							return letter.toUpperCase();
						});
						elementRef.style[style] = value;
					}
				},
				_toValue: function _toValue(percentage) {
					return this.options.scale.toValue.apply(this, [percentage]);
				},
				_toPercentage: function _toPercentage(value) {
					return this.options.scale.toPercentage.apply(this, [value]);
				},
				_setTooltipPosition: function _setTooltipPosition() {
					var tooltips = [this.tooltip, this.tooltip_min, this.tooltip_max];
					if (this.options.orientation === 'vertical') {
						var tooltipPos;
						if (this.options.tooltip_position) {
							tooltipPos = this.options.tooltip_position;
						} else {
							if (this.options.rtl) {
								tooltipPos = 'left';
							} else {
								tooltipPos = 'right';
							}
						}
						var oppositeSide = tooltipPos === 'left' ? 'right' : 'left';
						tooltips.forEach(function (tooltip) {
							this._addClass(tooltip, tooltipPos);
							tooltip.style[oppositeSide] = '100%';
						}.bind(this));
					} else if (this.options.tooltip_position === 'bottom') {
						tooltips.forEach(function (tooltip) {
							this._addClass(tooltip, 'bottom');
							tooltip.style.top = 22 + 'px';
						}.bind(this));
					} else {
						tooltips.forEach(function (tooltip) {
							this._addClass(tooltip, 'top');
							tooltip.style.top = -this.tooltip.outerHeight - 14 + 'px';
						}.bind(this));
					}
				}
			};
	
			/*********************************
	  		Attach to global namespace
	  	*********************************/
			if ($ && $.fn) {
				var autoRegisterNamespace = void 0;
	
				if (!$.fn.slider) {
					$.bridget(NAMESPACE_MAIN, Slider);
					autoRegisterNamespace = NAMESPACE_MAIN;
				} else {
					if (windowIsDefined) {
						window.console.warn("bootstrap-slider.js - WARNING: $.fn.slider namespace is already bound. Use the $.fn.bootstrapSlider namespace instead.");
					}
					autoRegisterNamespace = NAMESPACE_ALTERNATE;
				}
				$.bridget(NAMESPACE_ALTERNATE, Slider);
	
				// Auto-Register data-provide="slider" Elements
				$(function () {
					$("input[data-provide=slider]")[autoRegisterNamespace]();
				});
			}
		})($);
	
		return Slider;
	});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var disableFields = $('[disable-fields]'),
	    otherAddressRadio = $('input[type="radio"]'),
	    closeLightbox = $('.lightbox-close'),
	    statements = $('.approval-statements'),
	    select = $('.select'),
	    childbirthSchoolCheckbox = $('input[childbirth-school-checkbox]'),
	    installment = $('.leftLink'),
	    promoCode = $('.rightLink');
	
	var activeSwitcher = function activeSwitcher($this) {
	    $this.siblings('.switch').addClass('y');
	    $this.siblings('span[data-answer="no"]').removeClass('active');
	    $this.siblings('span[data-answer="yes"]').addClass('active');
	
	    $this.prop('checked', true);
	    $this.closest('.form--data').children('.hidden').slideDown().children('.textareaCounter').fadeIn(500);
	};
	
	var inactiveSwitcher = function inactiveSwitcher($this) {
	    $this.siblings('.switch').removeClass('y');
	    $this.siblings('span[data-answer="no"]').addClass('active');
	    $this.siblings('span[data-answer="yes"]').removeClass('active');
	
	    $this.prop('checked', false);
	    $this.closest('.form--data').children('.hidden').slideUp().children('.textareaCounter').fadeOut(100);
	};
	
	var showHiddenFields = function showHiddenFields(checked) {
	    var isChecked = checked.is(':checked');
	
	    if (isChecked) {
	        checked.closest('fieldset').next().slideDown();
	    } else {
	        checked.closest('fieldset').next().slideUp();
	    }
	};
	
	var activeDisableFields = function activeDisableFields($this) {
	    var isChecked = $this.is(':checked'),
	        inputs = $this.closest('.form--data').find('input[field-to-disable]');
	
	    if (isChecked) {
	        inputs.attr('disabled', 'disabled').val('');
	        inputs.prev().removeClass('error');
	
	        if (inputs.next('.errorBar')) {
	            inputs.next('.errorBar').remove();
	        }
	    } else {
	        inputs.removeAttr('disabled', 'disabled');
	    }
	};
	
	var showHiddenFieldsCustom = function showHiddenFieldsCustom(checked) {
	    var isChecked = checked.is(':checked');
	    if (isChecked) {
	        checked.closest('fieldset').parent().next().find('fieldset').slideDown();
	    } else {
	        checked.closest('fieldset').parent().next().find('fieldset').slideUp();
	    }
	};
	
	var activeDisableFieldsCustom = function activeDisableFieldsCustom($this) {
	    var isChecked = $this.is(':checked'),
	        inputs = $this.closest('.form--data').find('input[field-to-disable]');
	
	    if (isChecked) {
	        inputs.attr('disabled', 'disabled').val('');
	        inputs.prev().removeClass('error');
	
	        if (inputs.next('.errorBar')) {
	            inputs.next('.errorBar').remove();
	        }
	    } else {
	        inputs.removeAttr('disabled', 'disabled');
	    }
	};
	
	var switcher = function switcher($this, bool, type) {
	    if (type === 'switch') {
	        if (bool) {
	            inactiveSwitcher($this);
	        } else {
	            activeSwitcher($this);
	        }
	    } else if (type === 'yes' && bool === false) {
	        activeSwitcher($this);
	    } else if (type === 'no' && bool === true) {
	        inactiveSwitcher($this);
	    }
	};
	
	/* sprawdzenie, czy inputy wyłączające pola byly zaznaczone */
	
	if (disableFields.length) {
	    var type = disableFields.map(function () {
	        return $(this).attr('disable-fields');
	    }).get();
	
	    for (var i = 0; i < type.length; i++) {
	        activeDisableFields($('[disable-fields=\'' + type[i] + '\']'));
	        showHiddenFields($('[disable-fields=\'' + type[i] + '\']'));
	    }
	}
	
	if ($('.p__path--second').length) {
	    var checkAboYear = function checkAboYear() {
	        if ($('#app_conversion_path_second_step_years').val() == 1) {
	            $('.tooltip-inner').addClass('first');
	            $('.tooltip-inner').removeClass('other');
	        } else {
	            $('.tooltip-inner').addClass('other');
	            $('.tooltip-inner').removeClass('first');
	        }
	    };
	
	    // BG zaznaczonych pol po odswiezeniu/powrocie
	
	
	    // Summary mobile
	    var sumCol = $('.summaryColumn');
	    var closeCol = $('.closeSummary');
	    $(closeCol).on('click', function () {
	        if ($(this).hasClass('active')) {
	            $(this).removeClass('active');
	            $(sumCol).removeClass('active');
	            $('body').removeClass('unscroll');
	        } else {
	            $(this).addClass('active');
	            $(sumCol).addClass('active');
	            $('body').addClass('unscroll');
	        }
	    });
	
	    var red = $('div.red');
	    var blue = $('div.blue');
	    var navy = $('div.navy');
	    var gold = $('div.gold');
	    var variant = $('label.variant_label');
	
	    // Zaznaczanie zaznaczonych danych
	
	    if ($('[data-var="service"]:checked')) {
	        $('[data-var="service"]:checked').closest(variant).addClass('active').removeClass('inactive').siblings().removeClass('active').addClass('inactive');
	    } else {}
	    $(variant).on('click', function () {
	        $(this).addClass('active').removeClass('inactive').siblings().removeClass('active').addClass('inactive');
	        var attr = $(this).attr('for');
	        $("#" + attr).prop("checked", true).trigger("change");
	    });
	
	    $(document).on('click', '.save', function () {
	        $(this).fadeOut(300);
	        $('.hiddenAbonament').addClass('active');
	    });
	
	    $(document).on('click', '#labs-link', function () {
	        $('#labs-list').toggleClass('active');
	        $('#labs-link').toggleClass('active');
	    });
	
	    $(document).on('click', '.open_icon', function () {
	        if ($(this).closest('.option').next('.info').hasClass('active')) {
	            $(this).removeClass('active');
	            $(this).closest('.option').next('.info').removeClass('active');
	        } else {
	            $('.open_icon').removeClass('active');
	            $('.info').removeClass('active');
	            $(this).addClass('active');
	            $(this).closest('.option').next('.info').addClass('active');
	        }
	    });
	
	    $(document).on('click', '.info p', function () {
	        $('.open_icon').removeClass('active');
	        $('.info').removeClass('active');
	    });
	
	    $(document).on('click', '.open_ktg', function () {
	        if ($('.info_ktg').hasClass('active')) {
	            $(this).removeClass('active');
	            $('.info_ktg').removeClass('active');
	        } else {
	            $(this).addClass('active');
	            $('.info_ktg').addClass('active');
	        }
	    });
	
	    $(document).on('click', '.info_ktg .roll', function () {
	        $('.open_ktg').removeClass('active');
	        $('.info_ktg').removeClass('active');
	    });
	
	    $('<div class="quantity-button quantity-up"><i class="fa fa-plus-circle" aria-hidden="true"></i></div><div class="quantity-button quantity-down"><i class="fa fa-minus-circle" aria-hidden="true"></i></div>').insertAfter('.quantity input');
	    $('.quantity').each(function () {
	        var spinner = $(this),
	            input = spinner.find('input[type="number"]'),
	            btnUp = spinner.find('.quantity-up'),
	            btnDown = spinner.find('.quantity-down'),
	            min = input.attr('min'),
	            max = input.attr('max');
	
	        btnUp.click(function () {
	            var oldValue = parseFloat(input.val());
	            if (oldValue >= max) {
	                var newVal = oldValue;
	            } else {
	                var newVal = oldValue + 1;
	                spinner.find("input").val(newVal);
	                spinner.find("input").trigger("change");
	            }
	        });
	
	        btnDown.click(function () {
	            var oldValue = parseFloat(input.val());
	            if (oldValue <= min) {
	                var newVal = oldValue;
	            } else {
	                var newVal = oldValue - 1;
	                spinner.find("input").val(newVal);
	                spinner.find("input").trigger("change");
	            }
	        });
	    });
	
	    checkAboYear();
	    $('#app_conversion_path_second_step_years').on('change', function () {
	        checkAboYear();
	    });
	
	    if ($('[name="app_conversion_path_second_step[_package]"]:checked').length) {
	        var val = $('[name="app_conversion_path_second_step[_package]"]:checked').val();
	        var current = "app_conversion_path_second_step__package_" + val;
	        $("label[for='" + current + "']").addClass('active');
	    }
	
	    $(document).on('click', '.btn--change', function () {
	        $('.ktg_lightbox').fadeIn();
	        $('body').addClass('unscroll');
	    });
	
	    $('.p__path--variant_ktg').find('.data').removeClass('push-sm-1').removeClass('col-sm-4').addClass('col-sm-5');
	    $('.p__path--variant_ktg').find('.variants').removeClass('push-sm-1');
	
	    $(document).ready(function () {
	        var storageYearsPaidChecked = $('[name="app_conversion_path_second_step[storageYearsPaid]"]:checked');
	
	        if ($('#labs-list').find('input[type="radio"]:not(".default-transfer-country"):checked').length > 0) {
	            $('a.resignation').addClass('active');
	        }
	
	        if (storageYearsPaidChecked.length > 0 && storageYearsPaidChecked.val() === '-1') {
	            storageYearsPaidChecked.parent().addClass('active');
	        }
	
	        $(document).on('click', 'input[data-disabled="data-disabled"]', function (event) {
	            event.preventDefault();
	        });
	    });
	}
	
	if ($(document).find('.p__path--variant_ktg').length || $(document).find('.ktg_lightbox').length) {
	
	    if ($('[name="app_ktg_path_first_step[_ktgPackage]"]:checked').length) {
	        var val = $('[name="app_ktg_path_first_step[_ktgPackage]"]:checked').val();
	        var current = "app_ktg_path_first_step__ktgPackage_" + val;
	        $("label[for='" + current + "']").addClass('active');
	    }
	
	    $(document).on('click', 'label.variant', function () {
	        $(this).addClass('active').siblings().removeClass('active');
	        var attr = $(this).attr('for');
	        $("#" + attr).prop("checked", true).trigger("change");
	    });
	    $(document).on('click', '.returnForm, .ktg_lightbox .lightbox-close', function () {
	        var ktgVariants = $('.flex, .basic, .elite');
	        $('.lightbox_wrapper').fadeOut(500);
	        $('body').removeClass('unscroll');
	        $('#app_conversion_path_second_step_isKtg').prop("checked", false).trigger('change');
	        ktgVariants.removeClass('error');
	    });
	    $(document).on('ktgPriceChange', function () {
	        var val = $('[name="app_conversion_path_second_step[_ktgPackage]"]:checked').attr('data');
	        var valPrice = $('[name="app_conversion_path_second_step[_ktgPackage]"]:checked').attr('dataPrice') + ' euro';
	        $('#variantKtg').text(val);
	        $('#ktgPrice').text(valPrice);
	    });
	    $(document).on('click', '.ktgSubmit', function () {
	        var ktgVariants = $('.flex, .basic, .elite');
	        if ($('[name="app_conversion_path_second_step[_ktgPackage]"]:checked').length) {
	            ktgVariants.removeClass('error');
	            $('.option_ktg > input').prop("checked", true).trigger("change");
	
	            var val = $('[name="app_conversion_path_second_step[_ktgPackage]"]:checked').attr('data');
	            var valPrice = $('[name="app_conversion_path_second_step[_ktgPackage]"]:checked').attr('dataPrice') + ' euro';
	            $('#variantKtg').text(val);
	            $('.chooseVar').fadeOut();
	            $('#ktgPrice').text(valPrice).fadeIn();
	            setTimeout(function () {
	                $('.lightbox_wrapper').fadeOut(500);
	                $('body').removeClass('unscroll');
	            }, 250);
	        } else {
	            ktgVariants.addClass('error');
	        }
	    });
	
	    // Zabezpieczenie podstawowych i plus Transplant Assistance
	    $(document).on('change', 'input[data-code="optional.transplant"]', function () {
	        var $basic = $('input[data-code="optional.transplant"]');
	        var $extended = $('input[data-code="optional.transplant_plus"]');
	        if ($extended.is(':checked')) {
	            $extended.prop('checked', false);
	        }
	    });
	
	    $(document).on('change', 'input[data-code="optional.transplant_plus"]', function () {
	        var $basic = $('input[data-code="optional.transplant"]');
	        var $extended = $('input[data-code="optional.transplant_plus"]');
	        if ($basic.is(':checked')) {
	            $basic.prop('checked', false);
	        }
	    });
	
	    // Zabezpieczenie podstawowych i rzoszerzonych sznur
	    $(document).on('change', 'input[data-code="optional.cord_tissue_isolation"]', function () {
	        var $basic = $('input[data-code="optional.cord_tissue_isolation"]');
	        var $extended = $('input[data-code="optional.cord_tissue_isolation_extended"]');
	        if ($extended.is(':checked')) {
	            $extended.prop('checked', false);
	        }
	    });
	
	    $(document).on('change', 'input[data-code="optional.cord_tissue_isolation_extended"]', function () {
	        var $basic = $('input[data-code="optional.cord_tissue_isolation"]');
	        var $extended = $('input[data-code="optional.cord_tissue_isolation_extended"]');
	        if ($basic.is(':checked')) {
	            $basic.prop('checked', false);
	        }
	    });
	
	    // Wywolanie home_ktg po zaznaczeniu checkboxa bez wybranego pakietu
	    $(document).on("click", 'label[for="app_conversion_path_second_step_isKtg"]', function () {
	        if ($('#app_conversion_path_second_step_isKtg').is(':checked')) {} else {
	            $('.ktg_lightbox').css("display", "block").hide().fadeIn();
	            $('body').addClass('unscroll');
	        }
	    });
	}
	
	if ($('.p__path-ktg--second')) {
	    $(document).on('click', '#copyAddressMotherKtgSite', function () {
	        function copyAddress(path_step, fromWho, type) {
	            var street = $('#app_ktg_path_second_step_' + fromWho + '_address').val();
	            var houseNr = $('#app_ktg_path_second_step_' + fromWho + '_houseNumber').val();
	            var localNr = $('#app_ktg_path_second_step_' + fromWho + '_placeNumber').val();
	            var postalCode = $('#app_ktg_path_second_step_' + fromWho + '_postalCode').val();
	            var city = $('#app_ktg_path_second_step_' + fromWho + '_city').val();
	            var country = $('#app_ktg_path_second_step_' + fromWho + '_country').val();
	            var field = ['address', 'houseNumber', 'placeNumber', 'postalCode', 'city', 'country'];
	            var valueField = [street, houseNr, localNr, postalCode, city, country];
	            for (var i = 0; i < field.length; i++) {
	                if (valueField[i] != '') {
	                    if ($('#' + path_step + '_' + type + '_' + field[i]).attr('readonly') == 'readonly') {} else {
	                        $('#' + path_step + '_' + type + '_' + field[i]).val(valueField[i]).trigger('change');
	                    }
	                }
	            }
	        }
	
	        if ($(this).attr('id') == 'copyAddressMotherKtgSite') {
	            copyAddress('app_ktg_path_second_step', 'mother', 'ktgAddress');
	        }
	    });
	}
	
	if ($('.p__path--third').length) {
	    $('#submit').on('click', function () {
	        $('label').filter(function () {
	            if ($(this).next().val() == "") {
	                return true;
	            }
	        }).addClass('error');
	    });
	
	    $('.select--custom select').on('change', function (e) {
	        $(e.target).parent().prev('label').removeClass('error');
	    });
	
	    $(document).on('click', '#copyAddressMotherKit, #copyAddressFatherKit, #copyAddressKoreKit, #copyAddress, #copyAddressMotherToChild, #copyAddressFatherToChild, #copyAddressChildToMother, #copyAddressChildToFather', function () {
	        function copyAddress(path_step, fromWho, type) {
	            var street = $('#app_conversion_path_third_step_' + fromWho + '_address').val();
	            var houseNr = $('#app_conversion_path_third_step_' + fromWho + '_houseNumber').val();
	            var localNr = $('#app_conversion_path_third_step_' + fromWho + '_placeNumber').val();
	            var postalCode = $('#app_conversion_path_third_step_' + fromWho + '_postalCode').val();
	            var city = $('#app_conversion_path_third_step_' + fromWho + '_city').val();
	            var country = $('#app_conversion_path_third_step_' + fromWho + '_country').val();
	            var field = ['address', 'houseNumber', 'placeNumber', 'postalCode', 'city', 'country'];
	            var valueField = [street, houseNr, localNr, postalCode, city, country];
	            for (var i = 0; i < field.length; i++) {
	                if (valueField[i] != '') {
	                    $('#' + path_step + '_' + type + '_' + field[i]).val(valueField[i]).trigger('change');
	                }
	            }
	        }
	
	        if ($(this).attr('id') == 'copyAddressMotherToChild') {
	            copyAddress('app_conversion_path_third_step', 'mother', 'child');
	        }
	
	        if ($(this).attr('id') == 'copyAddressFatherToChild') {
	            copyAddress('app_conversion_path_third_step', 'father', 'child');
	        }
	
	        if ($(this).attr('id') == 'copyAddressChildToMother') {
	            copyAddress('app_conversion_path_third_step', 'child', 'mother');
	        }
	
	        if ($(this).attr('id') == 'copyAddressChildToFather') {
	            copyAddress('app_conversion_path_third_step', 'child', 'father');
	        }
	
	        if ($(this).attr('id') == 'copyAddress') {
	            copyAddress('app_conversion_path_third_step', 'mother', 'father');
	        }
	        if ($(this).attr('id') == 'copyAddressMotherKit') {
	            copyAddress('app_conversion_path_third_step', 'mother', 'kitAddress');
	        }
	        if ($(this).attr('id') == 'copyAddressFatherKit') {
	            copyAddress('app_conversion_path_third_step', 'father', 'kitAddress');
	        }
	        if ($(this).attr('id') == 'copyAddressKoreKit') {
	            copyAddress('app_conversion_path_third_step', 'addressForCorrespondence', 'kitAddress');
	        }
	    });
	
	    $(document).on('click', '#copyAddressMotherKtg, #copyAddressMotherKtgSite, #copyAddressFatherKtg, #copyAddressKoreKtg', function () {
	        function copyAddress(path_step, fromWho, type) {
	            var street = $('#app_conversion_path_third_step_' + fromWho + '_address').val();
	            var houseNr = $('#app_conversion_path_third_step_' + fromWho + '_houseNumber').val();
	            var localNr = $('#app_conversion_path_third_step_' + fromWho + '_placeNumber').val();
	            var postalCode = $('#app_conversion_path_third_step_' + fromWho + '_postalCode').val();
	            var city = $('#app_conversion_path_third_step_' + fromWho + '_city').val();
	            var country = $('#app_conversion_path_third_step_' + fromWho + '_country').val();
	            var field = ['address', 'houseNumber', 'placeNumber', 'postalCode', 'city', 'country'];
	            var valueField = [street, houseNr, localNr, postalCode, city, country];
	            for (var i = 0; i < field.length; i++) {
	                if (valueField[i] != '') {
	                    if ($('#' + path_step + '_' + type + '_' + field[i]).attr('readonly') == 'readonly') {} else {
	                        $('#' + path_step + '_' + type + '_' + field[i]).val(valueField[i]).trigger('change');
	                    }
	                }
	            }
	        }
	
	        if ($(this).attr('id') == 'copyAddressMotherKtg') {
	            copyAddress('app_conversion_path_third_step', 'mother', 'ktgAddress');
	        }
	        if ($(this).attr('id') == 'copyAddressMotherKtgSite') {
	            copyAddress('app_ktg_path_second_step', 'mother', 'ktgAddress');
	        }
	        if ($(this).attr('id') == 'copyAddressFatherKtg') {
	            copyAddress('app_conversion_path_third_step', 'father', 'ktgAddress');
	        }
	        if ($(this).attr('id') == 'copyAddressKoreKtg') {
	            copyAddress('app_conversion_path_third_step', 'addressForCorrespondence', 'ktgAddress');
	        }
	    });
	
	    $('#app_conversion_path_third_step_isMother').on('change', function (e) {
	        $('.motherData .loader').fadeIn(300);
	    });
	    $('#app_conversion_path_third_step_isFather').on('change', function (e) {
	        $('.fatherData .loader').fadeIn(300);
	    });
	
	    // usuwanie errorBara z selectow
	
	    $('select').on("change", function () {
	        $(this).next('.errorBar').remove();
	    });
	}
	
	if ($('.childrenForm').length) {
	    $('select').on("change", function () {
	        $(this).next('.errorBar').remove();
	        $(this).parent().prev().removeClass('error');
	    });
	}
	
	// sprawdzanie czy zgody zostaly juz zaznaczone
	if (statements.length) {
	    (function (checkbox) {
	        checkbox.siblings('.switch').addClass('y');
	        checkbox.siblings('span[data-answer="no"]').removeClass('active');
	        checkbox.siblings('span[data-answer="yes"]').addClass('active');
	    })($('.switch--content input[checked="checked"]'));
	}
	
	$(document).on('change', '[name="app_conversion_path_third_step[addressForCorrespondenceType]"]', function (e) {
	    var value = $(e.target).attr('value');
	
	    if (value !== 'other') {
	        $(e.target).closest('fieldset').parent().next().find('fieldset').slideUp();
	        $('#copyAddressKoreKit').fadeOut(300);
	        $('#copyAddressKoreKtg').fadeOut(300);
	    } else {
	        $('#copyAddressKoreKit').fadeIn(300);
	        $('#copyAddressKoreKtg').fadeIn(300);
	    }
	});
	
	$(document).on('change', 'input[disable-fields]', function (e) {
	    showHiddenFields($(e.target));
	    activeDisableFields($(e.target));
	});
	
	$(document).on('change', 'input[disable-fields-custom]', function (e) {
	    showHiddenFieldsCustom($(e.target));
	    activeDisableFieldsCustom($(e.target));
	});
	
	$(document).on('click', 'span[data-answer], .switch', function (e) {
	    var input = $(e.target).siblings('input'),
	        isChecked = input.is(':checked'),
	        typeAnswer = $(e.target).attr('data-answer'),
	        typeSwitch = $(e.target).attr('data-type');
	
	    switcher(input, isChecked, typeAnswer || typeSwitch);
	    input.trigger('change');
	});
	
	$(document).on('click touchstart', '.lightbox-close, .btn--check', function (e) {
	    if ($(e.target).closest('.lightbox_wrapper').hasClass('second-1')) {
	        $(e.target).closest('.lightbox_wrapper').fadeOut("normal", function () {
	            $(this).remove();
	        });
	    } else {
	        $(e.target).closest('.lightbox_wrapper').fadeOut();
	    }
	
	    if ($(e.target).closest('.lightbox_wrapper[indirect-step]')) {
	        $(e.target).closest('.lightbox_wrapper[indirect-step]').fadeOut("normal", function () {
	            $(this).remove();
	        });
	    }
	
	    $('body').removeClass('unscroll');
	});
	
	select.on('change', function (e) {
	    $(e.target).parent().prev().removeClass('error');
	});
	
	if ($('.p__path--fifth').length) {
	    var isTouchDevice = function isTouchDevice() {
	        return typeof window.ontouchstart !== 'undefined';
	    };
	
	    var fatherCont = $('#fatherCont');
	    var motherCont = $('#motherCont');
	
	    if (isTouchDevice()) {} else {
	        motherCont.remove();
	        fatherCont.remove();
	    }
	}
	
	installment.on('click', function (e) {
	    if ($('input[name="app_conversion_path_second_step[_package]"]').is(':checked')) {
	        $(e.target).toggleClass('active');
	        $(e.target).next().removeClass('active');
	        $(e.target).closest('.cost--summary').children('.promo-code').removeClass('active');
	        $(e.target).closest('.cost--summary').children('.installment').toggleClass('active');
	    } else {
	        toastr.error(jsTranslations['messages']['choose_variant']);
	    }
	});
	
	$('#closeInstallment').on('click', function (e) {
	    installment.toggleClass('active');
	    $(e.target).parent().parent('.installment').removeClass('active');
	});
	
	if (!$('.promo-code-activation').hasClass('active')) {
	    promoCode.on('click', function (e) {
	        if ($('input[name="app_conversion_path_second_step[_package]"]').is(':checked')) {
	            $(e.target).toggleClass('active');
	            $(e.target).prev().removeClass('active');
	            $(e.target).closest('.cost--summary').children('.promo-code').toggleClass('active');
	            $(e.target).closest('.cost--summary').children('.installment').removeClass('active');
	        } else {
	            toastr.error(jsTranslations['messages']['choose_variant']);
	        }
	    });
	} else if ($('.promo-code-activation').hasClass('active')) {
	    $('.promo-code').removeClass('active');
	    promoCode.removeClass('active');
	}
	
	$(document).on('click', '[close-lightbox]', function (e) {
	    $(e.target).closest('.lightbox_wrapper').fadeOut();
	});
	
	$(document).on('change', 'label + input', function (e) {
	    $(e.target).prev('label').removeClass('error').next().next('.errorBar').remove();
	});
	
	if ($('body.mobile').length) {
	    $(document).on("change", 'input[name="app_ktg_path_first_step[_ktgPackage]"]', function () {
	        var data = $(this).attr('data');
	        $('.' + data).addClass('active');
	        if (data == 'flex') {
	            $('.basic').removeClass('active');
	            $('.elite').removeClass('active');
	            $('.medical').removeClass('active');
	        } else if (data == 'basic') {
	            $('.flex').removeClass('active');
	            $('.elite').removeClass('active');
	            $('.medical').removeClass('active');
	        } else if (data == 'elite') {
	            $('.basic').removeClass('active');
	            $('.flex').removeClass('active');
	            $('.medical').removeClass('active');
	        } else if (data == 'medical') {
	            $('.basic').removeClass('active');
	            $('.flex').removeClass('active');
	            $('.elite').removeClass('active');
	        }
	    });
	    $(document).on("change", 'input[name="app_conversion_path_second_step[_ktgPackage]"]', function () {
	        var data = $(this).attr('data');
	        $('.' + data).addClass('active');
	        if (data == 'flex') {
	            $('.basic').removeClass('active');
	            $('.elite').removeClass('active');
	        } else if (data == 'basic') {
	            $('.flex').removeClass('active');
	            $('.elite').removeClass('active');
	        } else if (data == 'elite') {
	            $('.basic').removeClass('active');
	            $('.flex').removeClass('active');
	        }
	    });
	
	    if ($('[name="app_ktg_path_first_step[_ktgPackage]"]:checked').length) {
	        var val = $('[name="app_ktg_path_first_step[_ktgPackage]"]:checked').attr('data');
	        $('.' + val).addClass('active');
	    }
	}
	
	$(document).on('click', 'a[data-check-all="true"]', function (e) {
	    e.preventDefault();
	    var group = $(this).attr('data-group');
	    var subgroup = $(this).attr('data-subgroup');
	
	    $(document).find('#agreements_' + group + '_' + subgroup).find('.switch--content').each(function (index, switchContentElement) {
	        var input = $(switchContentElement).find('input'),
	            isChecked = false,
	            typeSwitch = 'switch';
	
	        switcher(input, isChecked, typeSwitch);
	        input.trigger('change');
	    });
	});
	
	$(document).on('click', '.step-second-2 .nav-link', function (e) {
	    e.preventDefault();
	
	    if (!$(this).hasClass('active')) {
	        $(this).closest('.lightbox_content').find('.nav-item a.active').removeClass('active');
	        $(this).addClass('active');
	        var $target = $($(this).attr('href'));
	
	        $target.parent().find('.show').removeClass('in active show');
	        $target.addClass('in active show');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/**
	 * jquery.mask.js
	 * @version: v1.14.11
	 * @author: Igor Escobar
	 *
	 * Created by Igor Escobar on 2012-03-10. Please report any bug at http://blog.igorescobar.com
	 *
	 * Copyright (c) 2012 Igor Escobar http://blog.igorescobar.com
	 *
	 * The MIT License (http://www.opensource.org/licenses/mit-license.php)
	 *
	 * Permission is hereby granted, free of charge, to any person
	 * obtaining a copy of this software and associated documentation
	 * files (the "Software"), to deal in the Software without
	 * restriction, including without limitation the rights to use,
	 * copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the
	 * Software is furnished to do so, subject to the following
	 * conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
	 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
	 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
	 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	 * OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	/* jshint laxbreak: true */
	/* jshint maxcomplexity:17 */
	/* global define */
	
	'use strict';
	
	// UMD (Universal Module Definition) patterns for JavaScript modules that work everywhere.
	// https://github.com/umdjs/umd/blob/master/jqueryPluginCommonjs.js
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (factory, jQuery, Zepto) {
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	        module.exports = factory(require('jquery'));
	    } else {
	        factory(jQuery || Zepto);
	    }
	})(function ($) {
	
	    var Mask = function Mask(el, mask, options) {
	
	        var p = {
	            invalid: [],
	            getCaret: function getCaret() {
	                try {
	                    var sel,
	                        pos = 0,
	                        ctrl = el.get(0),
	                        dSel = document.selection,
	                        cSelStart = ctrl.selectionStart;
	
	                    // IE Support
	                    if (dSel && navigator.appVersion.indexOf('MSIE 10') === -1) {
	                        sel = dSel.createRange();
	                        sel.moveStart('character', -p.val().length);
	                        pos = sel.text.length;
	                    }
	                    // Firefox support
	                    else if (cSelStart || cSelStart === '0') {
	                            pos = cSelStart;
	                        }
	
	                    return pos;
	                } catch (e) {}
	            },
	            setCaret: function setCaret(pos) {
	                try {
	                    if (el.is(':focus')) {
	                        var range,
	                            ctrl = el.get(0);
	
	                        // Firefox, WebKit, etc..
	                        if (ctrl.setSelectionRange) {
	                            ctrl.setSelectionRange(pos, pos);
	                        } else {
	                            // IE
	                            range = ctrl.createTextRange();
	                            range.collapse(true);
	                            range.moveEnd('character', pos);
	                            range.moveStart('character', pos);
	                            range.select();
	                        }
	                    }
	                } catch (e) {}
	            },
	            events: function events() {
	                el.on('keydown.mask', function (e) {
	                    el.data('mask-keycode', e.keyCode || e.which);
	                    el.data('mask-previus-value', el.val());
	                    el.data('mask-previus-caret-pos', p.getCaret());
	                    p.maskDigitPosMapOld = p.maskDigitPosMap;
	                }).on($.jMaskGlobals.useInput ? 'input.mask' : 'keyup.mask', p.behaviour).on('paste.mask drop.mask', function () {
	                    setTimeout(function () {
	                        el.keydown().keyup();
	                    }, 100);
	                }).on('change.mask', function () {
	                    el.data('changed', true);
	                }).on('blur.mask', function () {
	                    if (oldValue !== p.val() && !el.data('changed')) {
	                        el.trigger('change');
	                    }
	                    el.data('changed', false);
	                })
	                // it's very important that this callback remains in this position
	                // otherwhise oldValue it's going to work buggy
	                .on('blur.mask', function () {
	                    oldValue = p.val();
	                })
	                // select all text on focus
	                .on('focus.mask', function (e) {
	                    if (options.selectOnFocus === true) {
	                        $(e.target).select();
	                    }
	                })
	                // clear the value if it not complete the mask
	                .on('focusout.mask', function () {
	                    if (options.clearIfNotMatch && !regexMask.test(p.val())) {
	                        p.val('');
	                    }
	                });
	            },
	            getRegexMask: function getRegexMask() {
	                var maskChunks = [],
	                    translation,
	                    pattern,
	                    optional,
	                    recursive,
	                    oRecursive,
	                    r;
	
	                for (var i = 0; i < mask.length; i++) {
	                    translation = jMask.translation[mask.charAt(i)];
	
	                    if (translation) {
	
	                        pattern = translation.pattern.toString().replace(/.{1}$|^.{1}/g, '');
	                        optional = translation.optional;
	                        recursive = translation.recursive;
	
	                        if (recursive) {
	                            maskChunks.push(mask.charAt(i));
	                            oRecursive = { digit: mask.charAt(i), pattern: pattern };
	                        } else {
	                            maskChunks.push(!optional && !recursive ? pattern : pattern + '?');
	                        }
	                    } else {
	                        maskChunks.push(mask.charAt(i).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
	                    }
	                }
	
	                r = maskChunks.join('');
	
	                if (oRecursive) {
	                    r = r.replace(new RegExp('(' + oRecursive.digit + '(.*' + oRecursive.digit + ')?)'), '($1)?').replace(new RegExp(oRecursive.digit, 'g'), oRecursive.pattern);
	                }
	
	                return new RegExp(r);
	            },
	            destroyEvents: function destroyEvents() {
	                el.off(['input', 'keydown', 'keyup', 'paste', 'drop', 'blur', 'focusout', ''].join('.mask '));
	            },
	            val: function val(v) {
	                var isInput = el.is('input'),
	                    method = isInput ? 'val' : 'text',
	                    r;
	
	                if (arguments.length > 0) {
	                    if (el[method]() !== v) {
	                        el[method](v);
	                    }
	                    r = el;
	                } else {
	                    r = el[method]();
	                }
	
	                return r;
	            },
	            calculateCaretPosition: function calculateCaretPosition() {
	                var oldVal = el.data('mask-previus-value') || '',
	                    newVal = p.getMasked(),
	                    caretPosNew = p.getCaret();
	                if (oldVal !== newVal) {
	                    var caretPosOld = el.data('mask-previus-caret-pos') || 0,
	                        newValL = newVal.length,
	                        oldValL = oldVal.length,
	                        maskDigitsBeforeCaret = 0,
	                        maskDigitsAfterCaret = 0,
	                        maskDigitsBeforeCaretAll = 0,
	                        maskDigitsBeforeCaretAllOld = 0,
	                        i = 0;
	
	                    for (i = caretPosNew; i < newValL; i++) {
	                        if (!p.maskDigitPosMap[i]) {
	                            break;
	                        }
	                        maskDigitsAfterCaret++;
	                    }
	
	                    for (i = caretPosNew - 1; i >= 0; i--) {
	                        if (!p.maskDigitPosMap[i]) {
	                            break;
	                        }
	                        maskDigitsBeforeCaret++;
	                    }
	
	                    for (i = caretPosNew - 1; i >= 0; i--) {
	                        if (p.maskDigitPosMap[i]) {
	                            maskDigitsBeforeCaretAll++;
	                        }
	                    }
	
	                    for (i = caretPosOld - 1; i >= 0; i--) {
	                        if (p.maskDigitPosMapOld[i]) {
	                            maskDigitsBeforeCaretAllOld++;
	                        }
	                    }
	
	                    if (caretPosNew > oldValL) {
	                        // if the cursor is at the end keep it there
	                        caretPosNew = newValL;
	                    } else if (caretPosOld >= caretPosNew && caretPosOld !== oldValL) {
	                        if (!p.maskDigitPosMapOld[caretPosNew]) {
	                            var caretPos = caretPosNew;
	                            caretPosNew -= maskDigitsBeforeCaretAllOld - maskDigitsBeforeCaretAll;
	                            caretPosNew -= maskDigitsBeforeCaret;
	                            if (p.maskDigitPosMap[caretPosNew]) {
	                                caretPosNew = caretPos;
	                            }
	                        }
	                    } else if (caretPosNew > caretPosOld) {
	                        caretPosNew += maskDigitsBeforeCaretAll - maskDigitsBeforeCaretAllOld;
	                        caretPosNew += maskDigitsAfterCaret;
	                    }
	                }
	                return caretPosNew;
	            },
	            behaviour: function behaviour(e) {
	                e = e || window.event;
	                p.invalid = [];
	
	                var keyCode = el.data('mask-keycode');
	
	                if ($.inArray(keyCode, jMask.byPassKeys) === -1) {
	                    var newVal = p.getMasked(),
	                        caretPos = p.getCaret();
	
	                    setTimeout(function () {
	                        p.setCaret(p.calculateCaretPosition());
	                    }, 10);
	
	                    p.val(newVal);
	                    p.setCaret(caretPos);
	                    return p.callbacks(e);
	                }
	            },
	            getMasked: function getMasked(skipMaskChars, val) {
	                var buf = [],
	                    value = val === undefined ? p.val() : val + '',
	                    m = 0,
	                    maskLen = mask.length,
	                    v = 0,
	                    valLen = value.length,
	                    offset = 1,
	                    addMethod = 'push',
	                    resetPos = -1,
	                    maskDigitCount = 0,
	                    maskDigitPosArr = [],
	                    lastMaskChar,
	                    check;
	
	                if (options.reverse) {
	                    addMethod = 'unshift';
	                    offset = -1;
	                    lastMaskChar = 0;
	                    m = maskLen - 1;
	                    v = valLen - 1;
	                    check = function check() {
	                        return m > -1 && v > -1;
	                    };
	                } else {
	                    lastMaskChar = maskLen - 1;
	                    check = function check() {
	                        return m < maskLen && v < valLen;
	                    };
	                }
	
	                var lastUntranslatedMaskChar;
	                while (check()) {
	                    var maskDigit = mask.charAt(m),
	                        valDigit = value.charAt(v),
	                        translation = jMask.translation[maskDigit];
	
	                    if (translation) {
	                        if (valDigit.match(translation.pattern)) {
	                            buf[addMethod](valDigit);
	                            if (translation.recursive) {
	                                if (resetPos === -1) {
	                                    resetPos = m;
	                                } else if (m === lastMaskChar) {
	                                    m = resetPos - offset;
	                                }
	
	                                if (lastMaskChar === resetPos) {
	                                    m -= offset;
	                                }
	                            }
	                            m += offset;
	                        } else if (valDigit === lastUntranslatedMaskChar) {
	                            // matched the last untranslated (raw) mask character that we encountered
	                            // likely an insert offset the mask character from the last entry; fall
	                            // through and only increment v
	                            maskDigitCount--;
	                            lastUntranslatedMaskChar = undefined;
	                        } else if (translation.optional) {
	                            m += offset;
	                            v -= offset;
	                        } else if (translation.fallback) {
	                            buf[addMethod](translation.fallback);
	                            m += offset;
	                            v -= offset;
	                        } else {
	                            p.invalid.push({ p: v, v: valDigit, e: translation.pattern });
	                        }
	                        v += offset;
	                    } else {
	                        if (!skipMaskChars) {
	                            buf[addMethod](maskDigit);
	                        }
	
	                        if (valDigit === maskDigit) {
	                            maskDigitPosArr.push(v);
	                            v += offset;
	                        } else {
	                            lastUntranslatedMaskChar = maskDigit;
	                            maskDigitPosArr.push(v + maskDigitCount);
	                            maskDigitCount++;
	                        }
	
	                        m += offset;
	                    }
	                }
	
	                var lastMaskCharDigit = mask.charAt(lastMaskChar);
	                if (maskLen === valLen + 1 && !jMask.translation[lastMaskCharDigit]) {
	                    buf.push(lastMaskCharDigit);
	                }
	
	                var newVal = buf.join('');
	                p.mapMaskdigitPositions(newVal, maskDigitPosArr, valLen);
	                return newVal;
	            },
	            mapMaskdigitPositions: function mapMaskdigitPositions(newVal, maskDigitPosArr, valLen) {
	                var maskDiff = options.reverse ? newVal.length - valLen : 0;
	                p.maskDigitPosMap = {};
	                for (var i = 0; i < maskDigitPosArr.length; i++) {
	                    p.maskDigitPosMap[maskDigitPosArr[i] + maskDiff] = 1;
	                }
	            },
	            callbacks: function callbacks(e) {
	                var val = p.val(),
	                    changed = val !== oldValue,
	                    defaultArgs = [val, e, el, options],
	                    callback = function callback(name, criteria, args) {
	                    if (typeof options[name] === 'function' && criteria) {
	                        options[name].apply(this, args);
	                    }
	                };
	
	                callback('onChange', changed === true, defaultArgs);
	                callback('onKeyPress', changed === true, defaultArgs);
	                callback('onComplete', val.length === mask.length, defaultArgs);
	                callback('onInvalid', p.invalid.length > 0, [val, e, el, p.invalid, options]);
	            }
	        };
	
	        el = $(el);
	        var jMask = this,
	            oldValue = p.val(),
	            regexMask;
	
	        mask = typeof mask === 'function' ? mask(p.val(), undefined, el, options) : mask;
	
	        // public methods
	        jMask.mask = mask;
	        jMask.options = options;
	        jMask.remove = function () {
	            var caret = p.getCaret();
	            p.destroyEvents();
	            p.val(jMask.getCleanVal());
	            p.setCaret(caret);
	            return el;
	        };
	
	        // get value without mask
	        jMask.getCleanVal = function () {
	            return p.getMasked(true);
	        };
	
	        // get masked value without the value being in the input or element
	        jMask.getMaskedVal = function (val) {
	            return p.getMasked(false, val);
	        };
	
	        jMask.init = function (onlyMask) {
	            onlyMask = onlyMask || false;
	            options = options || {};
	
	            jMask.clearIfNotMatch = $.jMaskGlobals.clearIfNotMatch;
	            jMask.byPassKeys = $.jMaskGlobals.byPassKeys;
	            jMask.translation = $.extend({}, $.jMaskGlobals.translation, options.translation);
	
	            jMask = $.extend(true, {}, jMask, options);
	
	            regexMask = p.getRegexMask();
	
	            if (onlyMask) {
	                p.events();
	                p.val(p.getMasked());
	            } else {
	                if (options.placeholder) {
	                    el.attr('placeholder', options.placeholder);
	                }
	
	                // this is necessary, otherwise if the user submit the form
	                // and then press the "back" button, the autocomplete will erase
	                // the data. Works fine on IE9+, FF, Opera, Safari.
	                if (el.data('mask')) {
	                    el.attr('autocomplete', 'off');
	                }
	
	                // detect if is necessary let the user type freely.
	                // for is a lot faster than forEach.
	                for (var i = 0, maxlength = true; i < mask.length; i++) {
	                    var translation = jMask.translation[mask.charAt(i)];
	                    if (translation && translation.recursive) {
	                        maxlength = false;
	                        break;
	                    }
	                }
	
	                if (maxlength) {
	                    el.attr('maxlength', mask.length);
	                }
	
	                p.destroyEvents();
	                p.events();
	
	                var caret = p.getCaret();
	                p.val(p.getMasked());
	                p.setCaret(caret);
	            }
	        };
	
	        jMask.init(!el.is('input'));
	    };
	
	    $.maskWatchers = {};
	    var HTMLAttributes = function HTMLAttributes() {
	        var input = $(this),
	            options = {},
	            prefix = 'data-mask-',
	            mask = input.attr('data-mask');
	
	        if (input.attr(prefix + 'reverse')) {
	            options.reverse = true;
	        }
	
	        if (input.attr(prefix + 'clearifnotmatch')) {
	            options.clearIfNotMatch = true;
	        }
	
	        if (input.attr(prefix + 'selectonfocus') === 'true') {
	            options.selectOnFocus = true;
	        }
	
	        if (notSameMaskObject(input, mask, options)) {
	            return input.data('mask', new Mask(this, mask, options));
	        }
	    },
	        notSameMaskObject = function notSameMaskObject(field, mask, options) {
	        options = options || {};
	        var maskObject = $(field).data('mask'),
	            stringify = JSON.stringify,
	            value = $(field).val() || $(field).text();
	        try {
	            if (typeof mask === 'function') {
	                mask = mask(value);
	            }
	            return (typeof maskObject === 'undefined' ? 'undefined' : _typeof(maskObject)) !== 'object' || stringify(maskObject.options) !== stringify(options) || maskObject.mask !== mask;
	        } catch (e) {}
	    },
	        eventSupported = function eventSupported(eventName) {
	        var el = document.createElement('div'),
	            isSupported;
	
	        eventName = 'on' + eventName;
	        isSupported = eventName in el;
	
	        if (!isSupported) {
	            el.setAttribute(eventName, 'return;');
	            isSupported = typeof el[eventName] === 'function';
	        }
	        el = null;
	
	        return isSupported;
	    };
	
	    $.fn.mask = function (mask, options) {
	        options = options || {};
	        var selector = this.selector,
	            globals = $.jMaskGlobals,
	            interval = globals.watchInterval,
	            watchInputs = options.watchInputs || globals.watchInputs,
	            maskFunction = function maskFunction() {
	            if (notSameMaskObject(this, mask, options)) {
	                return $(this).data('mask', new Mask(this, mask, options));
	            }
	        };
	
	        $(this).each(maskFunction);
	
	        if (selector && selector !== '' && watchInputs) {
	            clearInterval($.maskWatchers[selector]);
	            $.maskWatchers[selector] = setInterval(function () {
	                $(document).find(selector).each(maskFunction);
	            }, interval);
	        }
	        return this;
	    };
	
	    $.fn.masked = function (val) {
	        return this.data('mask').getMaskedVal(val);
	    };
	
	    $.fn.unmask = function () {
	        clearInterval($.maskWatchers[this.selector]);
	        delete $.maskWatchers[this.selector];
	        return this.each(function () {
	            var dataMask = $(this).data('mask');
	            if (dataMask) {
	                dataMask.remove().removeData('mask');
	            }
	            $(this).removeAttr('maxlength');
	        });
	    };
	
	    $.fn.cleanVal = function () {
	        return this.data('mask').getCleanVal();
	    };
	
	    $.applyDataMask = function (selector) {
	        selector = selector || $.jMaskGlobals.maskElements;
	        var $selector = selector instanceof $ ? selector : $(selector);
	        $selector.filter($.jMaskGlobals.dataMaskAttr).each(HTMLAttributes);
	    };
	
	    var globals = {
	        maskElements: 'input,td,span,div',
	        dataMaskAttr: '*[data-mask]',
	        dataMask: true,
	        watchInterval: 300,
	        watchInputs: true,
	        // old versions of chrome dont work great with input event
	        useInput: !/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent) && eventSupported('input'),
	        watchDataMask: false,
	        byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
	        translation: {
	            '0': { pattern: /\d/ },
	            '9': { pattern: /\d/, optional: true },
	            '#': { pattern: /\d/, recursive: true },
	            'A': { pattern: /[a-zA-Z0-9]/ },
	            'S': { pattern: /[a-zA-Z]/ }
	        }
	    };
	
	    $.jMaskGlobals = $.jMaskGlobals || {};
	    globals = $.jMaskGlobals = $.extend(true, {}, globals, $.jMaskGlobals);
	
	    // looking for inputs with data-mask attribute
	    if (globals.dataMask) {
	        $.applyDataMask();
	    }
	
	    setInterval(function () {
	        if ($.jMaskGlobals.watchDataMask) {
	            $.applyDataMask();
	        }
	    }, globals.watchInterval);
	}, __webpack_provided_window_dot_jQuery, window.Zepto);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	// Sentry.init({
	//     dsn: "https://d5a67fe532d8400f83b5c500d87c520c@o1299664.ingest.sentry.io/6557161",
	//     integrations: [new BrowserTracing()],
	//     tracesSampleRate: 1.0,
	// });
	
	var scrollTop = $('.scroll-top'),
	    customSelect = $('.select');
	
	$(document).ready(function () {
	    $('#language-choice').on('change', function () {
	        window.location.href = Routing.generate('interactivo_language_change', {
	            '_locale': $(this).val(),
	            'locale': $(this).val()
	        });
	    });
	
	    $('.countrySelect').each(function () {
	        if ($(this).hasClass('no-search-bar')) {
	            $(this).select2({
	                minimumResultsForSearch: Infinity
	            });
	        } else {
	            $(this).select2();
	        }
	    });
	
	    $('.select-2').each(function () {
	        if ($(this).hasClass('no-search-bar')) {
	            $(this).select2({
	                minimumResultsForSearch: Infinity
	            });
	        } else {
	            $(this).select2();
	        }
	    });
	
	    var $seSpan = $('#sessionTime');
	
	    function component(x, v) {
	        return Math.floor(x / v);
	    }
	
	    var $div = $seSpan;
	});
	
	if ($('.path').length) {
	    scrollTop.on('click', function (e) {
	        $('body, html').animate({ scrollTop: 0 }, "slow");
	    });
	
	    var width = $(window).width();
	
	    $(window).scroll(function () {
	        if (width > 992) {
	            if ($(document).scrollTop() > 600) {
	                scrollTop.fadeIn("slow");
	            } else {
	                scrollTop.fadeOut(300);
	            }
	        } else {
	            if ($(document).scrollTop() > 10) {
	                scrollTop.fadeIn("slow");
	            } else {
	                scrollTop.fadeOut(300);
	            }
	        }
	    });
	}
	
	$(document).ready(function () {
	    var $loader = $('.siteLoader');
	
	    $loader.fadeOut(500, function () {
	        $(this).remove();
	    });
	});
	
	// FORM MASK
	$(document).ready(function () {
	    if ($('select.countrySelect').val() == 'PL') {
	        $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
	    } else {
	        $(this).closest('.row').find('input[data-input="phoneInput"]').unmask();
	    }
	});
	
	$(document).on('change', 'select.countrySelect', function () {
	    if ($(this).val() == 'PL') {
	        $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
	    } else {
	        $(this).closest('.row').find('input[data-input="phoneInput"]').unmask();
	    }
	});
	$('.validate-postal-code').mask('00-000');
	$('.validate-phone').mask('000-000-000');
	// $('.validate-pesel').mask('00000000000');
	$('.validate-quantity').mask('00');
	$('.validate-local-number').mask('AAAAA');
	$('.validate-house-number').mask('AAAAA');
	$('.validate-one-number').mask('0');
	$('.validate-sms').mask('000000');
	$('.cryo-safe-number-mask').mask('000/00/00000');
	
	$('#app_conversion_path_third_step_child_dateOfBirth').mask('9999-99-99');
	$('#app_conversion_path_third_step_mother_dateOfBirth').mask('9999-99-99');
	$('#app_conversion_path_third_step_father_dateOfBirth').mask('9999-99-99');
	
	function isNumber(n) {
	    return !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	$(".validate-number-type").on("keypress", function (evt) {
	    if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57) {
	        evt.preventDefault();
	    }
	});
	
	$(".validate-number-type-second").on("keypress", function (evt) {
	    if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57) {
	        evt.preventDefault();
	    }
	});
	
	// Dokumenty rozliczeniowy
	
	if ($('.documentTile').length || $('.tile').length) {
	    $('.open-info').on('click', function () {
	        if ($(this).next('.infoPanel').hasClass('active')) {
	            $(this).removeClass('active');
	            $('.infoPanel .nr').removeClass('active');
	            $(this).next('.infoPanel').removeClass('active');
	        } else {
	            $('.open-info').removeClass('active');
	            $('.infoPanel').removeClass('active');
	            $('.infoPanel .nr').removeClass('active');
	            $(this).addClass('active');
	            $(this).next('.infoPanel').addClass('active');
	        }
	    });
	    $('.info .roll').on('click', function () {
	        $('.open-info').removeClass('active');
	        $('.infoPanel').removeClass('active');
	        $('.infoPanel .nr').removeClass('active');
	    });
	}
	
	$(document).on("change", 'input[name="app_conversion_path_second_step_decision[kind]"]', function (e) {
	    if ($('input#app_conversion_path_second_step_decision_kind_1').is(":checked")) {
	        $('.comeback').fadeIn(300);
	        $('#second-step-decision-btn').html(jsTranslations['messages']['next'] + '<i class="fa fa-angle-right" aria-hidden="true"></i>');
	        $('input#app_conversion_path_second_step_decision_account').prop("checked", "checked");
	    } else {
	        $('.comeback').fadeOut(0);
	        $('#second-step-decision-btn').html(jsTranslations['messages']['next'] + '<i class="fa fa-angle-right" aria-hidden="true"></i>');
	    }
	});
	
	$(document).on("change", 'input[name="app_conversion_path_second_step_decision[account]"]', function (e) {
	    if ($('input#app_conversion_path_second_step_decision_account').is(":checked")) {
	        $('#second-step-decision-btn').html(jsTranslations['messages']['next'] + '<i class="fa fa-angle-right" aria-hidden="true"></i>');
	    } else {
	        $('#second-step-decision-btn').html(jsTranslations['messages']['exit'] + '<i class="fa fa-angle-right" aria-hidden="true"></i>');
	    }
	});
	
	customSelect.on('click', function (e) {
	    $(e.target).next().slideToggle();
	});
	
	if (customSelect.length) {
	    $(document).on('click', function (e) {
	        var target = $(e.target).attr('class'),
	            list = $(e.target).closest('.select__list').attr('class');
	
	        if (target !== 'select' && list !== 'select__list') {
	            customSelect.next().slideUp();
	        }
	    });
	}
	
	$(document).on('click', '[type="closeReset"]', function () {
	
	    var dataSectionExist = $(document).find('[data-section]').length,
	        dataSection = $(this).closest('[data-section]'),
	        dataSectionIsClosest = dataSection.length,
	        lightboxOffer = $(this).closest('[data-type="offer"]').length,
	        dataType = dataSection.attr('data-section');
	
	    if (dataSectionIsClosest) {
	        $('.lightbox_wrapper[data-section="' + dataType + '"]').fadeOut();
	    } else if (dataSectionExist) {
	        $(this).closest('.lightbox_wrapper.second-1').remove();
	    } else if (lightboxOffer) {
	        $('.lightbox_wrapper').fadeOut();
	    } else {
	        $('.lightbox_wrapper').fadeOut("normal", function () {
	            $(this).remove();
	        });
	    }
	
	    $('body').removeClass('unscroll');
	});
	
	$('[data-delete="offer_link"]').on('click', function (e) {
	    var token = $(e.target).attr('data-token'),
	        $element = $('input[name="token"][value="' + token + '"]');
	
	    if (typeof $element === 'undefined') {
	        return;
	    }
	
	    var $form = $element.closest('form');
	    $form.submit();
	});
	
	$('[data-delete="offer"]').on('click', function (e) {
	    var token = $(e.target).attr('data-token');
	
	    $('.lightbox_wrapper').fadeIn();
	    $('[data-delete="offer_link"]').attr({
	        'href': 'javascript: void(0);',
	        'data-token': token
	    });
	
	    return false;
	});
	//Pass tip
	$(document).ready(function () {
	    $('[data="passTip"]').on('click', function () {
	        var $wrapp = $('.pass_info_wrapp');
	        if ($wrapp.hasClass('full')) {
	            $wrapp.animate({
	                height: "0px"
	            }, 500).removeClass('full');
	        } else {
	            $wrapp.animate({
	                height: $wrapp.get(0).scrollHeight
	            }, 500).addClass('full');
	        }
	        ;
	    });
	});
	
	$(document).on('click', '#iact_core_mfa_resend', function () {
	    $.ajax({
	        url: Routing.generate('interactivo_core_mfa_resend_sms', { _locale: currentLocale }),
	        type: 'GET',
	        success: function success(data, textStatus, jqXHR) {
	            if (data.status === 200) {
	                toastr.info(data.message);
	            } else {
	                toastr.error(data.message);
	            }
	        }
	    });
	});
	
	$(document).on('click', '#iact_core_mfa_resend_email', function () {
	    $.ajax({
	        url: Routing.generate('interactivo_core_mfa_resend_email', { _locale: currentLocale }),
	        type: 'GET',
	        success: function success(data, textStatus, jqXHR) {
	            if (data.status === 200) {
	                toastr.info(data.message);
	            } else {
	                toastr.error(data.message);
	            }
	        }
	    });
	});
	
	// Prowizoryczna validacja formularza przejsciowego logowania
	$(document).on('input', 'form#second-step-login-form #username, form#first-step-login-form #username', function () {
	    if ($('#username_error').length) {
	        $('#username_error').remove();
	    }
	});
	
	$(document).on('input', 'form#second-step-login-form #password, form#first-step-login-form #password', function () {
	    if ($('#password_error').length) {
	        $('#password_error').remove();
	    }
	});
	
	$(document).on('input', '#iact_user_resetting_password_plainPassword_first', function () {
	    if ($('#iact_user_resetting_password_plainPassword_first_error').length) {
	        $('#iact_user_resetting_password_plainPassword_first_error').remove();
	    }
	});
	
	$(document).on('input', '#iact_partner_resetting_password_plainPassword_first', function () {
	    if ($('#iact_partner_resetting_password_plainPassword_first_error').length) {
	        $('#iact_partner_resetting_password_plainPassword_first_error').remove();
	    }
	});
	
	$(document).on('input', '#iact_user_registration_password_plainPassword_first', function () {
	    if ($('#iact_user_registration_password_plainPassword_first_error').length) {
	        $('#iact_user_registration_password_plainPassword_first_error').remove();
	    }
	});
	
	$(document).on('input', '#iact_partner_registration_password_plainPassword_first', function () {
	    if ($('#iact_partner_registration_password_plainPassword_first_error').length) {
	        $('#iact_partner_registration_password_plainPassword_first_error').remove();
	    }
	});
	
	$(document).ready(function () {
	    sidebarLinksCheck();
	    $(window).resize(function () {
	        sidebarLinksCheck();
	    });
	
	    function sidebarLinksCheck() {
	        if ($('.p__dashboard').length) {
	            var width = $(window).width();
	            var $sidebarLink = $('.sidebarLink');
	            if (width < 768 && width > 575) {
	                $sidebarLink.fadeOut(0);
	            } else {
	                $sidebarLink.fadeIn(0);
	            }
	        }
	    }
	});
	
	$(document).on('change', '[name="app_conversion_path_second_step[_storage]"]', function (event) {
	    if ($(this).attr('id') === 'app_conversion_path_second_step__storage_1') {
	        $('.abonament .inputs .choose.other-options').removeClass('active');
	        $('.abonament .storage-other-options').removeClass('active');
	    }
	    if ($(this).attr('id') === 'app_conversion_path_second_step__storage_2') {
	        $('.abonament .inputs .choose.other-options').addClass('active');
	        $('.abonament .storage-other-options').addClass('active');
	    }
	    if ($(this).attr('id') === 'app_conversion_path_second_step__storage_3') {
	        $('.abonament .inputs .choose.other-options').addClass('active');
	        $('.abonament .storage-other-options').addClass('active');
	    }
	});
	
	$(document).on('click', '.abonament .inputs .choose.other-options', function (event) {
	    if ($(this).hasClass('active')) {
	        $(this).removeClass('active');
	        $('.abonament .storage-other-options').removeClass('active');
	    } else {
	        $(this).addClass('active');
	        $('.abonament .storage-other-options').addClass('active');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	/* Funkcje zaznaczające checki w sekcjach, zliczajace wszystkie pytania itp z czwartego kroku km */
	
	$(document).ready(function () {
	    if ($('.p__path--fourth').length) {
	        var addCheck = function addCheck(target) {
	            var name = $(target).attr('name');
	            var dataCount = $(target).attr('data-count');
	            // Znajdujemy pozycje tego name'a w tablicy
	            if (dataCount == 'misc') {
	                var position = $.inArray(name, arr_misc);
	                if (arr_checked_misc[position] == null) {
	                    counterMisc++;
	                    arr_checked_misc[position] = 1;
	                } else {}
	                ;
	            } else if (dataCount == 'lyme') {
	                var position = $.inArray(name, arr_lyme);
	                if (arr_checked_lyme[position] == null) {
	                    counterLyme++;
	                    arr_checked_lyme[position] = 1;
	                } else {}
	                ;
	            } else {
	                var position = $.inArray(name, arr);
	                // Sprawdzmy czy pozycja w arr_checked ma wartosc null czy nie
	                if (arr_checked[position] == null) {
	                    // Podbijamy counter i wstrzykujemy go do CurrentCounter'a i ustawiamy arr_checked o danej pozycji na 1
	                    counter++;
	                    currentCounter.html(counter);
	                    arr_checked[position] = 1;
	                } else {}
	                ;
	            }
	
	            if ($('#' + divNameStr + '_bbe80691_0').is(':checked') || $('#' + divNameStr + '_c228a33a_0').is(':checked')) {
	                overallCount = arr.length;
	
	                if ($('#' + divNameStr + '_bbe80691_0').is(':checked')) {
	                    overallCount += arr_misc.length;
	                }
	                if ($('#' + divNameStr + '_c228a33a_0').is(':checked')) {
	                    overallCount += arr_lyme.length;
	                }
	            } else overallCount = arr.length;
	
	            counterAll = counter + counterMisc + counterLyme;
	            currentCounter.html(counterAll);
	
	            if (counterAll >= overallCount) {
	                counterAll = overallCount;
	                currentCounter.html(counterAll);
	                $('.counterFourth').addClass('finished');
	            } else {
	                $('.counterFourth').removeClass('finished');
	            }
	        };
	
	        var removeCheck = function removeCheck(target) {
	            var name = $(target).attr('name');
	            var dataCount = $(target).attr('data-count');
	            if (dataCount == 'misc') {
	                var position = $.inArray(name, arr_misc);
	                if (arr_checked_misc[position] == 1) {
	                    counterMisc--;
	                    arr_checked_misc[position] = null;
	                } else {}
	                ;
	            }
	
	            if (dataCount == 'lyme') {
	                var position = $.inArray(name, arr_lyme);
	                if (arr_checked_lyme[position] == 1) {
	                    counterLyme--;
	                    arr_checked_lyme[position] = null;
	                } else {}
	                ;
	            }
	
	            counterAll = counter + counterMisc + counterLyme;
	            currentCounter.html(counterAll);
	
	            overallCount = arr.length;
	
	            if ($('#' + divNameStr + '_bbe80691_0').is(':checked')) {
	                overallCount += arr_misc.length;
	            }
	            if ($('#' + divNameStr + '_c228a33a_0').is(':checked')) {
	                overallCount += arr_lyme.length;
	            }
	
	            if (counterAll >= overallCount) {
	                counterAll = overallCount;
	                currentCounter.html(counterAll);
	                $('.counterFourth').addClass('finished');
	            } else {
	                $('.counterFourth').removeClass('finished');
	            }
	        };
	
	        // Tworzymy tablice z unikalnych name'ow inputow radio
	
	
	        var prepareOverall = function prepareOverall() {
	            // Bierzemy liczbe unikalnych name'ow i wstrzykujemy w overallCounter
	            // Jesli poronienie lub borelioza jest zaznaczone, to dodajemy takze tablice z tymi pytaniami
	            if ($('#' + divNameStr + '_bbe80691_0').is(':checked') || $('#' + divNameStr + '_c228a33a_0').is(':checked')) {
	                var _overallCount = arr.length;
	
	                if ($('#' + divNameStr + '_bbe80691_0').is(':checked')) {
	                    _overallCount += arr_misc.length;
	                }
	                if ($('#' + divNameStr + '_c228a33a_0').is(':checked')) {
	                    _overallCount += arr_lyme.length;
	                }
	                overallCounter.html(_overallCount);
	
	                for (var i = 0; i <= arr.length; i++) {
	                    var nameCheck = arr[i];
	                    if ($('input[name="' + nameCheck + '"]').is(':checked')) {
	                        addCheck('input[name="' + nameCheck + '"]');
	                    }
	                }
	
	                if ($('#' + divNameStr + '_bbe80691_0').is(':checked')) {
	                    for (var i = 0; i <= arr_misc.length; i++) {
	                        var nameCheck = arr_misc[i];
	                        if ($('input[name="' + nameCheck + '"]').is(':checked')) {
	                            addCheck('input[name="' + nameCheck + '"]');
	                        }
	                    }
	                }
	                if ($('#' + divNameStr + '_c228a33a_0').is(':checked')) {
	                    for (var i = 0; i <= arr_lyme.length; i++) {
	                        var nameCheck = arr_lyme[i];
	                        if ($('input[name="' + nameCheck + '"]').is(':checked')) {
	                            addCheck('input[name="' + nameCheck + '"]');
	                        }
	                    }
	                }
	            } else {
	                overallCounter.html(arr.length);
	                for (var i = 0; i <= arr.length; i++) {
	                    var nameCheck = arr[i];
	                    if ($('input[name="' + nameCheck + '"]').is(':checked')) {
	                        addCheck('input[name="' + nameCheck + '"]');
	                    }
	                }
	            }
	        };
	
	        // wywolanie na starcie
	
	
	        var divNameStr = 'app_conversion_path_fourth_step';
	        var healthDataUrl = 'app_conversion_path_health_conf';
	
	        if ($('.p__path--second').length) {
	            divNameStr = 'app_conversion_path_second_step_haquestionnaire';
	            healthDataUrl = 'interactivo_partner_conversion_path_health_conf';
	        }
	
	        var healthData = void 0;
	        // Zaciaganie configa /komunikaty/
	        $.get(Routing.generate(healthDataUrl, { _locale: currentLocale })).done(function (data) {
	            healthData = data;
	
	            for (var name in healthData) {
	                if (healthData.hasOwnProperty(name)) {
	                    var $divName = $('#' + divNameStr + '_' + name);
	
	                    if ($divName.children('input:radio:checked').length > 0) {
	                        var healthConf = healthData[name];
	                        var healthVal = parseInt($divName.children('input:radio:checked').val());
	
	                        if (healthConf.hasOwnProperty('status') && healthConf.hasOwnProperty('restrictions') && healthConf.hasOwnProperty('modal_section') && healthConf.hasOwnProperty('messages')) {
	                            if (Object.keys(healthConf['messages']).length > 0) {
	                                $divName.find('.infoBar').remove();
	
	                                if (healthConf['restrictions'].length > 0) {
	                                    if (healthConf['messages'].hasOwnProperty(healthVal)) {
	                                        (function () {
	                                            var showMessage = false;
	                                            healthConf['restrictions'].forEach(function (item) {
	                                                if (showMessage === false) {
	                                                    if (parseInt($('.p__path--fourth').attr('data-' + item)) === 1) {
	                                                        showMessage = true;
	                                                    }
	                                                }
	                                            });
	                                            if (showMessage) {
	                                                $divName.after('<div class="infoBar"><p>' + jsTranslations['messages'][healthConf['messages'][healthVal]] + '</p></div>');
	                                            }
	                                        })();
	                                    }
	                                } else {
	                                    if (healthConf['messages'].hasOwnProperty(healthVal)) {
	                                        $divName.after('<div class="infoBar"><p>' + jsTranslations['messages'][healthConf['messages'][healthVal]] + '</p></div>');
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	
	            $('.siteLoaderFourth').fadeOut(500, function () {
	                $(this).remove();
	            });
	        });
	
	        // Understand lightbox
	
	        $('.understandCheck').on('change', function () {
	            var $that = $(this);
	            $that.closest('.lightbox_wrapper').fadeOut(300, function () {
	                $that.prop('checked', false);
	            });
	        });
	
	        /* Licznik */
	        var counter = 0;
	        var counterMisc = 0;
	        var counterLyme = 0;
	        var counterAll = 0;
	        var overallCount = 0;
	        var currentCounter = $('#currentCounter');
	        var overallCounter = $('#overallCounter');
	        var arr = [];
	        var arr_checked = [];
	        var arr_checked_misc = [];
	        var arr_checked_lyme = [];
	        var arr_misc = [];
	        var arr_lyme = [];
	        arr_checked[-1] = 1;
	
	        $.each($('input[name*=' + divNameStr + ']:radio'), function () {
	            if ($(this).attr('data-count') == 'misc') {
	                var mynameMisc = this.name;
	                if ($.inArray(mynameMisc, arr_misc) < 0) {
	                    arr_misc.push(mynameMisc);
	                }
	            } else if ($(this).attr('data-count') == 'lyme') {
	                var mynameLyme = this.name;
	                if ($.inArray(mynameLyme, arr_lyme) < 0) {
	                    arr_lyme.push(mynameLyme);
	                }
	            } else {
	                var myname = this.name;
	                if ($.inArray(myname, arr) < 0) {
	                    arr.push(myname);
	                }
	            }
	        });
	
	        prepareOverall();
	
	        // Na zmiane wartosci konkretnego inputa
	        $('input[id*=' + divNameStr + ']:radio').on("change", function () {
	            addCheck(this);
	            prepareOverall();
	
	            // sprawdzanie komunikatu z konfiga
	            var name = '';
	            if (divNameStr === 'app_conversion_path_second_step_haquestionnaire') {
	                name = $(this).attr('name').substring($(this).attr('name').indexOf('[') + 18, $(this).attr('name').indexOf('[') + 26);
	            } else {
	                name = $(this).attr('name').substring($(this).attr('name').indexOf('[') + 1, $(this).attr('name').indexOf('[') + 9);
	            }
	            var that = $(this);
	
	            if (healthData.hasOwnProperty(name)) {
	                var healthConf = healthData[name];
	                var healthVal = parseInt(that.val());
	
	                if (healthConf.hasOwnProperty('status') && healthConf.hasOwnProperty('restrictions') && healthConf.hasOwnProperty('modal_section') && healthConf.hasOwnProperty('messages')) {
	                    if (healthConf['modal_section'] !== false) {
	                        var modals = [];
	
	                        $.each(healthConf['modal_section'], function (key, value) {
	                            if (value.hasOwnProperty(healthVal)) {
	                                if (key === 'all') {
	                                    if (!modals.includes(value[healthVal])) {
	                                        modals.push(value[healthVal]);
	                                    }
	                                } else {
	                                    if (parseInt($('.p__path--fourth').attr('data-' + key)) === 1) {
	                                        if (!modals.includes(value[healthVal])) {
	                                            modals.push(value[healthVal]);
	                                        }
	                                    }
	                                }
	                            }
	                        });
	
	                        modals.forEach(function (item) {
	                            $('.lightbox_wrapper[data-section="' + item + '"]').fadeIn(300);
	                        });
	                    }
	
	                    if (Object.keys(healthConf['messages']).length > 0) {
	                        that.parent().parent().find('.infoBar').remove();
	
	                        if (healthConf['restrictions'].length > 0) {
	                            if (healthConf['messages'].hasOwnProperty(healthVal)) {
	                                var showMessage = false;
	                                healthConf['restrictions'].forEach(function (item) {
	                                    if (showMessage === false) {
	                                        if (parseInt($('.p__path--fourth').attr('data-' + item)) === 1) {
	                                            showMessage = true;
	                                        }
	                                    }
	                                });
	                                if (showMessage) {
	                                    that.parent().after('<div class="infoBar"><p>' + jsTranslations['messages'][healthConf['messages'][healthVal]] + '</p></div>');
	                                }
	                            }
	                        } else {
	                            if (healthConf['messages'].hasOwnProperty(healthVal)) {
	                                that.parent().after('<div class="infoBar"><p>' + jsTranslations['messages'][healthConf['messages'][healthVal]] + '</p></div>');
	                            }
	                        }
	                    }
	                }
	            }
	        });
	
	        /* Poronienie */
	        $('[name=' + divNameStr + '\\[bbe80691\\]]').on("change", function () {
	            var $yes = $('#' + divNameStr + '_bbe80691_yes');
	            if ($('#' + divNameStr + '_bbe80691_0').is(':checked')) {
	                $yes.slideDown(300);
	            } else {
	                $yes.find('input').each(function (index) {
	                    if (index === 1) {
	                        $(this).prop('checked', true).trigger("change");
	                    }
	                    removeCheck($(this));
	                    $(this).prop('checked', false);
	                });
	                $yes.slideUp(300);
	            }
	        });
	
	        /* Borelioza (choroba z Lyme) */
	        $('[name=' + divNameStr + '\\[c228a33a\\]]').on("change", function () {
	            var $yes = $('#' + divNameStr + '_c228a33a_yes');
	            if ($('#' + divNameStr + '_c228a33a_0').is(':checked')) {
	                $yes.slideDown(300);
	            } else {
	                $yes.find('input').each(function (index) {
	                    if (index === 1) {
	                        $(this).prop('checked', true).trigger("change", [true]);
	                    }
	                    removeCheck($(this));
	                    $(this).prop('checked', false);
	                });
	                $yes.slideUp(300);
	            }
	        });
	
	        /* Czy ciąża jest wynikiem zabiegu zapłodnienia in vitro? */
	        $('[name=' + divNameStr + '\\[fb2cde49\\]]').on("change", function () {
	            var $yes = $('#' + divNameStr + '_fb2cde49_yes');
	            var $no = $('#' + divNameStr + '_a1790811_no');
	            if ($('#' + divNameStr + '_fb2cde49_0').is(':checked')) {
	                $yes.slideDown(300);
	            } else {
	                $yes.find('input').each(function (index) {
	                    if (index === 1) {
	                        $(this).prop('checked', true).trigger("change", [true]);
	                    }
	                    removeCheck($(this));
	                    $(this).prop('checked', false);
	                });
	                $yes.slideUp(300);
	                $no.find('input').each(function (index) {
	                    if (index === 1) {
	                        $(this).prop('checked', true).trigger("change", [true]);
	                    }
	                    removeCheck($(this));
	                    $(this).prop('checked', false);
	                });
	                $no.slideUp(300);
	            }
	        });
	
	        /* Czy ciąża jest wynikiem zabiegu zapłodnienia in vitro komórek pochodzących od rodziców biologicznych? */
	        $('[name=' + divNameStr + '\\[a1790811\\]]').on("change", function () {
	            var $no = $('#' + divNameStr + '_a1790811_no');
	            if ($('#' + divNameStr + '_a1790811_1').is(':checked')) {
	                $no.slideDown(300);
	            } else {
	                $no.find('input').each(function (index) {
	                    if (index === 1) {
	                        $(this).prop('checked', true).trigger("change", [true]);
	                    }
	                    removeCheck($(this));
	                    $(this).prop('checked', false);
	                });
	                $no.slideUp(300);
	            }
	        });
	
	        /* Czy chorowała Pani kiedykolwiek na chorobę nowotworową? */
	        $('[name=' + divNameStr + '\\[cb944f10\\]]').on("change", function () {
	            var $yes = $('#' + divNameStr + '_cb944f10_yes');
	            if ($('#' + divNameStr + '_cb944f10_0').is(':checked')) {
	                $yes.slideDown(300);
	            } else {
	                $yes.find('input').each(function (index) {
	                    if (index === 1) {
	                        $(this).prop('checked', true).trigger("change", [true]);
	                    }
	                    removeCheck($(this));
	                    $(this).prop('checked', false);
	                });
	                $yes.slideUp(300);
	            }
	        });
	
	        /* Czy proces nowotworowy miał charakter ŁAGODNY? */
	        $('[name=' + divNameStr + '\\[a87fa40e\\]]').on("change", function () {
	            var $yes = $('#' + divNameStr + '_a87fa40e_yes');
	            if ($('#' + divNameStr + '_a87fa40e_0').is(':checked')) {
	                $yes.slideDown(300);
	            } else {
	                $yes.find('input').each(function (index) {
	                    if (index === 1) {
	                        $(this).prop('checked', true).trigger("change", [true]);
	                    }
	                    removeCheck($(this));
	                    $(this).prop('checked', false);
	                });
	                $yes.slideUp(300);
	            }
	        });
	
	        /* Czy zmiana miała charakter ZŁOŚLIWY? */
	        $('[name=' + divNameStr + '\\[e634afe1\\]]').on("change", function () {
	            var $yes = $('#' + divNameStr + '_e634afe1_yes');
	            if ($('#' + divNameStr + '_e634afe1_0').is(':checked')) {
	                $yes.slideDown(300);
	            } else {
	                $yes.find('input').each(function (index) {
	                    if (index === 1) {
	                        $(this).prop('checked', true).trigger("change", [true]);
	                    }
	                    removeCheck($(this));
	                    $(this).prop('checked', false);
	                });
	                $yes.slideUp(300);
	            }
	        });
	
	        $('[name=' + divNameStr + '\\[b9f086ea\\]]').on("change", function (e, isJsChange) {
	            if (isJsChange !== true) {
	                if ($('#' + divNameStr + '_b9f086ea_0').is(':checked')) {
	                    $('#' + divNameStr + '_e88246e7_1').prop('checked', true).trigger("change", [true]);
	                }
	                if ($('#' + divNameStr + '_b9f086ea_1').is(':checked')) {
	                    $('#' + divNameStr + '_e88246e7_0').prop('checked', true).trigger("change", [true]);
	                }
	            }
	        });
	        $('[name=' + divNameStr + '\\[e88246e7\\]]').on("change", function (e, isJsChange) {
	            if (isJsChange !== true) {
	                if ($('#' + divNameStr + '_e88246e7_0').is(':checked')) {
	                    $('#' + divNameStr + '_b9f086ea_1').prop('checked', true).trigger("change", [true]);
	                }
	                if ($('#' + divNameStr + '_e88246e7_1').is(':checked')) {
	                    $('#' + divNameStr + '_b9f086ea_0').prop('checked', true).trigger("change", [true]);
	                }
	            }
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _select = __webpack_require__(10);
	
	var select2 = _interopRequireWildcard(_select);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var psshSbsoluteCounter = 0;
	
	var validatePhoneCodeSelector = function validatePhoneCodeSelector(isSubmit) {
	    $('select.phone-code-selector').each(function (i) {
	        var currentSelect = $(this);
	        var currentSelectId = $(this).attr('id');
	        var currentSelectedValue = $(currentSelect).val();
	        var errorMessage = $(currentSelect).data('error-message');
	        var errorMessageElement = $(currentSelect).next('.select2-container');
	
	        if (isSubmit) {
	            $("#" + currentSelectId + "_error").remove();
	
	            if ($(currentSelectedValue).selector.length === 0) {
	                $(errorMessageElement).after('<div id="' + currentSelectId + '_error" class="errorBar" style=" margin-top: 8px;"><p>' + errorMessage + '</p></div>');
	            }
	        }
	
	        if (!isSubmit && $(currentSelectedValue).selector.length > 0) {
	            $("#" + currentSelectId + "_error").remove();
	        }
	    });
	};
	
	var addError = function addError(fieldKey, field, footerBar) {
	    if (fieldKey.indexOf('user-login-form') >= 0) {
	        fieldKey = fieldKey.replace('user-login-form_', '');
	    }
	
	    if (field.hasOwnProperty('errors')) {
	        for (var key in field['errors']) {
	            if (field['errors'].hasOwnProperty(key)) {
	                if (field['errors'][key] === 'Udzielona odpowiedź jest przeciwwskazaniem do realizacji umowy.') {
	                    psshSbsoluteCounter++;
	                }
	
	                if ($('#' + fieldKey + '_error').length === 0) {
	                    if ($('#' + fieldKey).hasClass('countrySelect')) {
	                        $('#' + fieldKey).addClass('error').attr('data-error', 'true').next('span').addClass('error').after('<div id="' + fieldKey + '_error" class="errorBar"><p>' + field['errors'][key] + '</p></div>');
	                    } else {
	                        $('#' + fieldKey).addClass('error').attr('data-error', 'true').after('<div id="' + fieldKey + '_error" class="errorBar"><p>' + field['errors'][key] + '</p></div>');
	                    }
	                    $('label[for="' + fieldKey + '"]').addClass('error');
	                } else {
	                    $('#' + fieldKey).addClass('error').removeAttr('data-error');
	                    $('#' + fieldKey + '_error').html('<p>' + field['errors'][key] + '</p>');
	                    $('label[for="' + fieldKey + '"]').addClass('error');
	                }
	            }
	        }
	    } else {
	        if ($('#' + fieldKey + '_error').html() === '<p>Udzielona odpowiedź jest przeciwwskazaniem do realizacji umowy.</p>') {
	            psshSbsoluteCounter--;
	        }
	
	        if ($('#' + fieldKey).hasClass('countrySelect')) {
	            $('#' + fieldKey).next('span').removeClass('error');
	        }
	        $('#' + fieldKey).removeClass('error').removeAttr('data-error');
	        $('#' + fieldKey + '_error').remove();
	        $('label[for="' + fieldKey + '"]').removeClass('error');
	    }
	
	    if ($(document).find('.p__path--second').length > 0) {
	        if (psshSbsoluteCounter > 0) {
	            $(document).find('#second-step-path').hide();
	            $(document).find('#second-step-partner-error').show();
	        } else {
	            $(document).find('#second-step-path').show();
	            $(document).find('#second-step-partner-error').hide();
	        }
	    }
	};
	
	var formValidation = function formValidation(formName, errorList, fieldId, isSubmit) {
	    if (fieldId !== null && fieldId.indexOf('phoneNumber_number') >= 0) {
	        fieldId = fieldId.replace('phoneNumber_number', 'phoneNumber');
	    }
	
	    var footerBar = $('form[name="' + formName + '"]').attr('footer_bar');
	    var addErrorResult = false;
	    var addErrorFooter = false;
	
	    if (footerBar === undefined) {
	        footerBar = null;
	    }
	
	    var stack = [];
	    var stackKeys = [];
	
	    if (errorList.hasOwnProperty('children')) {
	        for (var key in errorList['children']) {
	            if (errorList['children'].hasOwnProperty(key)) {
	                stack.push(errorList['children'][key]);
	                stackKeys.push(formName + '_' + key);
	            }
	        }
	    }
	
	    while (stack.length !== 0 && stackKeys.length !== 0) {
	        var field = stack.pop();
	        var fieldKey = stackKeys.pop();
	
	        if (field.hasOwnProperty('children')) {
	            for (var key in field['children']) {
	                if (field['children'].hasOwnProperty(key)) {
	                    stack.push(field['children'][key]);
	                    stackKeys.push(fieldKey + '_' + key);
	                }
	            }
	        }
	
	        if (fieldId === null) {
	            addError(fieldKey, field, footerBar);
	        } else {
	            if (Array.isArray(fieldId)) {
	                if (fieldId.indexOf(fieldKey) > -1) {
	                    addError(fieldKey, field, footerBar);
	                }
	            } else {
	                if (fieldId === fieldKey) {
	                    addError(fieldKey, field, footerBar);
	                }
	            }
	        }
	
	        if (field.hasOwnProperty('errors')) {
	            addErrorResult = true;
	        }
	
	        if (addErrorFooter === false && addErrorResult === true) {
	            addErrorFooter = true;
	        }
	    }
	
	    if (addErrorFooter === true) {
	        if (footerBar !== null && isSubmit === true) {
	            $('.errorFooter').html('<p>' + jsTranslations['messages']['form_fix_errors'] + '</p>');
	        }
	    } else {
	        $('.errorFooter').html('');
	    }
	};
	
	var conversionPathAjax = function conversionPathAjax($form, params, fieldId, isSubmit, motherPeselOrDateOfBirthChanged) {
	    return $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('check_parent_pesel') && data["check_parent_pesel"] === true) {
	                $.ajax({
	                    url: Routing.generate('app_conversion_path_second_step_pesel', { _locale: currentLocale }),
	                    type: "GET",
	                    success: function success(data) {
	                        if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                            if (data["sessionChanged"] === true) {
	                                window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                            }
	                        }
	
	                        $(".p__path--second").append(data);
	                        $('body').addClass('unscroll');
	                    },
	                    error: function error(jqXHR, textStatus, errorThrown) {
	
	                        if (jqXHR.status === 401) {
	                            window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                        }
	                    }
	                });
	            } else if (isSubmit && data.hasOwnProperty('decision') && data["decision"] === true) {
	                $.ajax({
	                    url: $form.attr('data-deci-url'),
	                    type: "GET",
	                    success: function success(data) {
	
	                        if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                            if (data["sessionChanged"] === true) {
	                                window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                            }
	                        }
	
	                        $(".p__path--second").append(data);
	                        $('body').addClass('unscroll');
	                    },
	                    error: function error(jqXHR, textStatus, errorThrown) {
	
	                        if (jqXHR.status === 401) {
	                            window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                        }
	                    }
	                });
	            } else if (isSubmit && data.hasOwnProperty('newAccount') && data["newAccount"] === true) {
	                $.ajax({
	                    url: $form.attr('data-acco-url'),
	                    type: "GET",
	                    success: function success(data) {
	
	                        if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                            if (data["sessionChanged"] === true) {
	                                window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                            }
	                        }
	
	                        $(".p__path--second").append(data);
	                        $('body').addClass('unscroll');
	                    },
	                    error: function error(jqXHR, textStatus, errorThrown) {
	
	                        if (jqXHR.status === 401) {
	                            window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                        }
	                    }
	                });
	            } else if (isSubmit && data.hasOwnProperty('existingUser') && data["existingUser"] === true) {
	                $.ajax({
	                    url: $form.attr('data-user-url'),
	                    type: "GET",
	                    success: function success(data) {
	
	                        if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                            if (data["sessionChanged"] === true) {
	                                window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                            }
	                        }
	
	                        $(".p__path--second").append(data);
	                        $('body').addClass('unscroll');
	                    },
	                    error: function error(jqXHR, textStatus, errorThrown) {
	
	                        if (jqXHR.status === 401) {
	                            window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                        }
	                    }
	                });
	            } else if (isSubmit && data.hasOwnProperty('confirmationUrl')) {
	
	                window.location.href = Routing.generate(data['confirmationUrl'], { _locale: currentLocale });
	            } else if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
	
	                auth(data['mfaUrl']);
	            } else {
	
	                if (isSubmit && data["success"]) {
	                    $('.errorBar').html('');
	                    $form.submit();
	                } else {
	                    $('.info-service-not-available').hide();
	                    if (typeof data["additionalPackagesValid"] !== 'undefined') {
	                        if (data["additionalPackagesValid"]["result"] == false) {
	                            $('.info-service-not-available').show();
	                        }
	                    }
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                    validatePhoneCodeSelector(isSubmit);
	
	                    if (motherPeselOrDateOfBirthChanged === true) {
	                        if (data.hasOwnProperty('peselUnderEighteen') && data.hasOwnProperty('dateOfBirthUnderEighteen')) {
	                            if (data["peselUnderEighteen"] === true || data["dateOfBirthUnderEighteen"] === true) {
	                                if ($('[data-partner]').length) {
	                                    var attr = $('[data-partner]').attr('data-partner');
	
	                                    toastr.options = {
	                                        "timeOut": "15000"
	                                    };
	
	                                    if (attr === 'false') {
	                                        toastr.info(jsTranslations['messages']['mother_not_adult']);
	                                    } else {
	                                        toastr.info(jsTranslations['messages']['mother_not_adult_partner']);
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (textStatus === 'error') {
	                window.location.href = Routing.generate('root', { _locale: currentLocale });
	            }
	
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	
	var jqxhr_cpf;
	var conversionPathForm = function conversionPathForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_cpf) {
	        jqxhr_cpf.abort();
	    }
	    jqxhr_cpf = conversionPathAjax($form, params, fieldId, isSubmit);
	};
	
	var conversionPathThirdStepForm = function conversionPathThirdStepForm($form, params, fieldId, isSubmit, motherPeselOrDateOfBirthChanged) {
	    conversionPathAjax($form, params, fieldId, isSubmit, motherPeselOrDateOfBirthChanged);
	};
	
	var conversionPathFourthStepForm = function conversionPathFourthStepForm($form, params, fieldId, isSubmit) {
	    conversionPathAjax($form, params, fieldId, isSubmit);
	};
	
	var jqxhr_af;
	var accountForm = function accountForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_af) {
	        jqxhr_af.abort();
	    }
	    jqxhr_af = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data["success"]) {
	                $form.submit();
	            } else {
	                formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	
	var jqxhr_uf;
	var userForm = function userForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_uf) {
	        jqxhr_uf.abort();
	    }
	    jqxhr_uf = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data["success"]) {
	                $form.submit();
	            } else {
	                formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	
	//Validacja pierwszego kroku
	if ($('.p__path--first').length) {
	    $(document).on("click", "#conversion_path_submit", function (e) {
	        var $form = $(this).closest('form');
	
	        conversionPathForm($form, $form.serializeArray(), null, true);
	    });
	}
	
	var changeMaterialFunc = function changeMaterialFunc($form, callback) {
	    $.ajax({
	        url: $form.attr('action') + '?chanmat=true',
	        type: $form.attr('method'),
	        data: $form.serializeArray(),
	        success: function success(html) {
	            $('.additional').html($(html).find('.additional').html());
	            $('.additional').find('[uncheck=1]').prop('checked', false);
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    }).done(callback);
	
	    conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step_material', false);
	};
	
	var checkedAddonsFunc = function checkedAddonsFunc() {
	    var show = false;
	    $('.additional input:checkbox').each(function () {
	        if ($(this).is(':checked') == true && $(this).parent()[0].id != 'optional-price_guarantee') {
	            var blockingPackage = $(this).data('blocking-package');
	            if (typeof blockingPackage !== "undefined") {
	                if (blockingPackage.length > 0) {
	                    $('#' + blockingPackage).addClass('disabled striked');
	                    $('#' + blockingPackage + ' input').prop('disabled', true);
	                }
	            }
	            show = true;
	        }
	    });
	
	    if ($('#app_conversion_path_second_step_companyCode').val() !== 'BC4') {
	        show = false;
	    }
	
	    if (show == true) {
	        $('#app_conversion_path_second_step__additionalPackagesValidate').show();
	    } else {
	        $('#app_conversion_path_second_step__additionalPackagesValidate').hide();
	    }
	};
	
	var formForceUncheck = function formForceUncheck() {
	    if (!$('form.force-uncheck input[type="checkbox"]:checked').length) {
	        return;
	    }
	
	    var target = $('form.force-uncheck input[type="checkbox"]:checked').first();
	
	    if (target.is(':disabled')) {
	        target.prop('checked', false);
	    } else {
	        target.click();
	    }
	
	    if ($('form.force-uncheck input[type="checkbox"]:checked').length) {
	        setTimeout(function () {
	            formForceUncheck();
	        }, 200);
	    }
	};
	
	var unlockPriceGuarantee = function unlockPriceGuarantee() {
	    var price_guarantee_input = $('#optional-price_guarantee input');
	    var show = false;
	
	    $('#app_conversion_path_second_step__storage_1, #app_conversion_path_second_step__additionalPackages_1, #app_conversion_path_second_step__additionalPackages_2').each(function () {
	        if ($(this).is(':checked') == true) {
	            show = true;
	        }
	    });
	
	    // if for free
	    if (price_guarantee_input.attr('checked') && !price_guarantee_input.attr('disabled')) {
	        $('#optional-price_guarantee input').prop('checked', true);
	    }
	
	    // disable for upsale
	    if (window.location.href.includes('additional-packages')) {
	        show = false;
	    }
	
	    if (show == true) {
	        $('#optional-price_guarantee').removeClass('disabled striked');
	        $('#optional-price_guarantee input').prop('disabled', false);
	    } else {
	        $('#optional-price_guarantee').addClass('disabled striked');
	        $('#optional-price_guarantee input').prop('disabled', true);
	        $('#optional-price_guarantee input').prop('checked', false);
	    }
	};
	
	var changeAddonsFunc = function changeAddonsFunc($target) {
	    $('#app_conversion_path_second_step__additionalPackages_error').remove();
	    var blockingPackage = $($target).data('blocking-package');
	    if (typeof blockingPackage === "undefined") {
	        return;
	    }
	    if (blockingPackage.length <= 0) {
	        return;
	    }
	    var dataDisabled = $('#' + blockingPackage + ' input').data('disabled');
	    if (true === $target.checked) {
	        $('#' + blockingPackage).addClass('disabled striked');
	        $('#' + blockingPackage + ' input').prop('disabled', true);
	    } else {
	        if (typeof dataDisabled === "undefined") {
	            $('#' + blockingPackage).removeClass('disabled striked');
	            $('#' + blockingPackage + ' input').prop('disabled', false);
	        }
	    }
	};
	
	var validateAdditionalPackage = function validateAdditionalPackage() {
	
	    var validate = false;
	    $('.additional input:checkbox').each(function () {
	        if ($(this).is(':checked') == true) {
	            validate = true;
	        }
	    });
	
	    if (false === validate) {
	        $('.info-service-not-available').hide();
	        $('.info-service-available').hide();
	        return;
	    }
	
	    var $form = $("form[name='app_conversion_path_second_step']");
	
	    $('.info-service-not-available').hide();
	    $('.info-service-available').hide();
	    $('.info-service-invalid-cryosave').hide();
	    $('.btn-check-additional-packages').on("click", function () {
	        var selfBtn = $(this);
	        var cryosaveAgreementNumber = $('#app_conversion_path_second_step_cryosaveAgreementNumber').val();
	        if (typeof cryosaveAgreementNumber !== 'undefined' && cryosaveAgreementNumber.length > 0) {
	            selfBtn.html(selfBtn.data('label-checking'));
	            $('.info-service-invalid-cryosave').hide();
	            // let regexp = new RegExp('^[a-zA-Z0-9_]+\\/[a-zA-Z0-9]+(\\/[a-zA-Z0-9]+)?$');
	            // if(cryosaveAgreementNumber.length >= 3 && cryosaveAgreementNumber.length <= 14 && regexp.test(cryosaveAgreementNumber) === true) {
	            if (cryosaveAgreementNumber.length >= 3 && cryosaveAgreementNumber.length <= 14) {
	                jqxhr = $.ajax({
	                    url: $form.attr('data-addons-validate-url'),
	                    type: "POST",
	                    data: $form.serialize(),
	                    success: function success(data) {
	                        if (data.result === false) {
	                            $('.info-service-not-available').show();
	                        } else {
	                            $('.info-service-available').show();
	                        }
	                        selfBtn.html(selfBtn.data('label-default'));
	                    },
	                    error: function error(jqXHR, textStatus, errorThrown) {
	                        if (jqXHR.status === 401) {
	                            window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                        }
	                        selfBtn.html(selfBtn.data('label-default'));
	                    }
	
	                });
	            } else {
	                selfBtn.html(selfBtn.data('label-default'));
	                $('.info-service-invalid-cryosave').show();
	            }
	        }
	        selfBtn.html(selfBtn.data('label-default'));
	    });
	};
	
	if ($('[checked="checked"]', '.storage-years-box .prepayments-row').length) {
	    $('.storage-years-box .prepayments-row').addClass('active');
	}
	
	var changeStorageYearsPaidFunc = function changeStorageYearsPaidFunc($form, callback) {
	    $.ajax({
	        url: $form.attr('action') + '?chansyp=true',
	        type: $form.attr('method'),
	        data: $form.serializeArray(),
	        success: function success(html) {
	            var inputText = $(html).find('input[type="radio"]:checked+label').text();
	            var htmlToInsert = $(html).find('.storageYearsPaidOther').html();
	
	            // if (inputText.indexOf('*') > -1) {
	            //     // $('.storage-years-box .additional-info').css('visibility','visible');
	            //     $('.storage-years-box .additional-info').fadeTo(300,1);
	            // } else {
	            //     // $('.storage-years-box .additional-info').css('visibility','hidden');
	            //     $('.storage-years-box .additional-info').fadeTo(300,0);
	            // }
	
	            $('.storage-years-box .prepayments-row').addClass('active');
	
	            if (htmlToInsert.length < 150) {
	                $('.cryo-years .inputs.other').removeClass('active');
	                $('.storageYearsPaidOther').html(htmlToInsert);
	            } else {
	                $('.storageYearsPaidOther').html(htmlToInsert);
	                $('.cryo-years .inputs.other').addClass('active');
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    }).done(callback);
	
	    conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step_storageYearsPaid', false);
	};
	
	var changeTransferCountryCodeFunc = function changeTransferCountryCodeFunc($form, callback) {
	    $.ajax({
	        url: $form.attr('action') + '?chantcc=true',
	        type: $form.attr('method'),
	        data: $form.serializeArray(),
	        success: function success(html) {
	            $('.additional').html($(html).find('.additional').html());
	
	            if ($(html).find('#labs-list').find('input[type="radio"]:checked').length > 0) {
	                $('a.resignation').addClass('active');
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    }).done(callback);
	
	    conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step_transferCountryCode', false);
	};
	var changePrepaymentFunc = function changePrepaymentFunc($form, callback) {
	    $.ajax({
	        url: $form.attr('action') + '?chanpp=true',
	        type: $form.attr('method'),
	        data: $form.serializeArray(),
	        success: function success(html) {
	            $('.additional').html($(html).find('.additional').html());
	            var $prepayments = $('#app_conversion_path_second_step_prepayment .prepayment');
	            $.each($prepayments, function () {
	                var $this = $(this);
	
	                if ($this.find('input').prop('checked')) {
	                    $this.removeClass('not-checked');
	                } else {
	                    $this.addClass('not-checked');
	                }
	            });
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    }).done(callback);
	
	    conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step_prepayment', false);
	};
	
	var changeStorageFunc = function changeStorageFunc($form, callback) {
	    $.ajax({
	        url: $form.attr('action') + '?chanst=true',
	        type: $form.attr('method'),
	        data: $form.serializeArray(),
	        success: function success(html) {
	            $('.additional').html($(html).find('.additional').html());
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    }).done(callback);
	
	    conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step__storage', false);
	};
	
	var changecountryOfOriginCodeFunc = function changecountryOfOriginCodeFunc($form, callback) {
	    $.ajax({
	        url: $form.attr('action') + '?chancooc=true',
	        type: $form.attr('method'),
	        data: $form.serializeArray(),
	        success: function success(html) {
	            $('.additional').html($(html).find('.additional').html());
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    }).done(callback);
	
	    conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step_countryOfOriginCode', false);
	};
	
	var changelanguageSupportFunc = function changelanguageSupportFunc($form, callback) {
	    $.ajax({
	        url: $form.attr('action') + '?chanls=true',
	        type: $form.attr('method'),
	        data: $form.serializeArray(),
	        success: function success(html) {
	            $('.additional').html($(html).find('.additional').html());
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    }).done(callback);
	
	    conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step_languageSupport', false);
	};
	
	var changePackFunc = function changePackFunc($form, callback) {
	    $('#app_conversion_path_second_step_instalmentBaseVariantAndAddons').prop('checked', false);
	    $('.installHide1').removeClass('active');
	    $('#app_conversion_path_second_step_instalmentStorage').prop('checked', false);
	    $('.installHide2').removeClass('active');
	    $("[id*='app_conversion_path_second_step_instalmentBaseVariantAndAddonsQuantity_']").each(function () {
	        $(this).prop('checked', false);
	        $('#installment-checked').removeClass('active');
	    });
	    $("[id*='app_conversion_path_second_step_instalmentStorageQuantity_']").each(function () {
	        $(this).prop('checked', false);
	        $('#installment-checked').removeClass('active');
	    });
	
	    $.ajax({
	        url: $form.attr('action') + '?chanpack=true',
	        type: $form.attr('method'),
	        data: $form.serializeArray(),
	        success: function success(html) {
	            $('.abonament').html($(html).find('.abonament').html());
	            $('.additional').html($(html).find('.additional').html());
	            $('.insurance').html($(html).find('.insurance').html());
	            $('.number-of-installment').html($(html).find('.number-of-installment').html());
	            $('.charge-type').html($(html).find('.charge-type').html());
	
	            $('.ktg').html($(html).find('.ktg').html());
	            $('.ktg_lightbox').html($(html).find('.ktg_lightbox').html());
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    }).done(callback);
	
	    conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step__package', false);
	};
	
	var changeKtgPackFunc = function changeKtgPackFunc($form) {
	    $.ajax({
	        url: $form.attr('action') + '?chanpack=true',
	        type: $form.attr('method'),
	        data: $form.serializeArray(),
	        success: function success(html) {
	            $('.ktg').html($(html).find('.ktg').html());
	            $('.ktg_lightbox').html($(html).find('.ktg_lightbox').html());
	
	            var elementToReplace = $(html).find('#app_ktg_path_first_step__ktgPackage');
	
	            $('#app_ktg_path_first_step__ktgPackage').replaceWith(elementToReplace);
	
	            if (parseInt(elementToReplace.attr('data-children')) === 4) {
	                if ($('.ktgMobile').length > 0) {
	                    $('.variantWrapper').first().find('input').prop('checked', true).trigger('change');
	                } else {
	                    $('.variant').first().find('input').prop('checked', true).trigger('change');
	                }
	            }
	
	            if ($('[name="app_ktg_path_first_step[_ktgPackage]"]:checked').length) {
	                var val = $('[name="app_ktg_path_first_step[_ktgPackage]"]:checked').attr('data');
	                $('.' + val).addClass('active');
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	
	    ktgPathForm($form, $form.serializeArray(), 'app_ktg_path_first_step__ktgPackage', false);
	};
	
	//Walidacja drugiego kroku
	if ($('.p__path--second').length) {
	
	    $(document).on("click", "#conversion_path_submit", function (e) {
	        var $form = $(this).closest('form');
	        if (!$("input[name='app_conversion_path_second_step[prepayment]']:checked").val()) {
	            $('#app_conversion_path_second_step_prepayment_error').show();
	        }
	        conversionPathForm($form, $form.serializeArray(), null, true);
	    });
	
	    var loader = $('.loader');
	
	    checkedAddonsFunc();
	    unlockPriceGuarantee();
	    validateAdditionalPackage();
	
	    $(document).on("change", "form[name='app_conversion_path_second_step']", function (e) {
	        var $form = $(this);
	        var $target = e.target;
	
	        checkedAddonsFunc();
	        unlockPriceGuarantee();
	        validateAdditionalPackage();
	
	        if ($target.id !== 'app_conversion_path_second_step_promoCode' && e.target.id !== 'app_conversion_path_second_step_promoCodeBirthDays') {
	            if (e.target.id.indexOf('app_conversion_path_second_step__package_') >= 0) {
	                changePackFunc($form, function () {
	                    checkedAddonsFunc();
	                    unlockPriceGuarantee();
	                    calculateAjax($form, validateAjax);
	                });
	            } else if (e.target.id.indexOf('app_conversion_path_second_step_material_') >= 0) {
	                changeMaterialFunc($form, function () {
	                    checkedAddonsFunc();
	                    unlockPriceGuarantee();
	                    calculateAjax($form, validateAjax);
	                });
	            } else if (e.target.id.indexOf('app_conversion_path_second_step_storageYearsPaid_') >= 0) {
	                changeStorageYearsPaidFunc($form, function () {
	                    checkedAddonsFunc();
	                    unlockPriceGuarantee();
	                    calculateAjax($form, validateAjax);
	                });
	            } else if (e.target.id.indexOf('app_conversion_path_second_step_storageYearsPaidOther') >= 0) {
	                conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step_storageYearsPaidOther', false);
	            } else if (e.target.id.indexOf('app_conversion_path_second_step_transferCountryCode_') >= 0) {
	                changeTransferCountryCodeFunc($form, function () {
	                    checkedAddonsFunc();
	                    unlockPriceGuarantee();
	                    calculateAjax($form, validateAjax);
	                });
	            } else if (e.target.id.indexOf('app_conversion_path_second_step_prepayment_') >= 0) {
	                changePrepaymentFunc($form, function () {
	                    checkedAddonsFunc();
	                    unlockPriceGuarantee();
	                    calculateAjax($form, validateAjax);
	                });
	            } else if (e.target.id.indexOf('app_conversion_path_second_step__storage_') >= 0) {
	                changeStorageFunc($form, function () {
	                    checkedAddonsFunc();
	                    unlockPriceGuarantee();
	                    calculateAjax($form, validateAjax);
	                });
	            } else if (e.target.id.indexOf('app_conversion_path_second_step_countryOfOriginCode') >= 0) {
	                changecountryOfOriginCodeFunc($form, function () {
	                    checkedAddonsFunc();
	                    unlockPriceGuarantee();
	                    calculateAjax($form, validateAjax);
	                });
	            } else if (e.target.id.indexOf('app_conversion_path_second_step_languageSupport') >= 0) {
	                changelanguageSupportFunc($form, function () {
	                    checkedAddonsFunc();
	                    unlockPriceGuarantee();
	                    calculateAjax($form, validateAjax);
	                });
	            } else if (e.target.id.indexOf('app_conversion_path_second_step_years_') >= 0) {
	                $('#app_conversion_path_second_step_instalmentStorage').prop('checked', false);
	                $('.installHide2').removeClass('active');
	                $("[id*='app_conversion_path_second_step_instalmentStorageQuantity_']").each(function () {
	                    $(this).prop('checked', false);
	                });
	
	                $.ajax({
	                    url: $form.attr('action') + '?chanyear=true',
	                    type: $form.attr('method'),
	                    data: $form.serializeArray(),
	                    success: function success(html) {
	                        $('.number-of-installment').html($(html).find('.number-of-installment').html());
	                        $('.charge-type').html($(html).find('.charge-type').html());
	                        $('.additional').html($(html).find('.additional').html());
	
	                        conversionPathForm($form, $form.serializeArray(), 'app_conversion_path_second_step_years', false);
	                    },
	                    error: function error(jqXHR, textStatus, errorThrown) {
	                        if (jqXHR.status === 401) {
	                            window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                        }
	                    }
	                }).done(calculateAjax($form, validateAjax));
	            } else if (e.target.id.indexOf('app_conversion_path_second_step_instalmentBaseVariantAndAddons') >= 0) {
	                $.ajax({
	                    url: $form.attr('action') + '?chaninsqua=true',
	                    type: $form.attr('method'),
	                    data: $form.serializeArray(),
	                    success: function success(html) {
	                        $('.number-of-installment').html($(html).find('.number-of-installment').html());
	                        $('.charge-type').html($(html).find('.charge-type').html());
	                        $('#installment-checked').addClass('active');
	                        if ($('#app_conversion_path_second_step_instalmentBaseVariantAndAddons').is(':checked') || $('#app_conversion_path_second_step_instalmentStorage').is(':checked')) {
	                            $('#installment-checked').addClass('active');
	                            if ($('#app_conversion_path_second_step_instalmentBaseVariantAndAddons').is(':checked')) {
	                                $('.installHide1').addClass('active');
	                            } else {
	                                $('.installHide1').removeClass('active');
	                            }
	                        } else {
	                            $('#installment-checked').removeClass('active');
	                        }
	                    },
	                    error: function error(jqXHR, textStatus, errorThrown) {
	                        if (jqXHR.status === 401) {
	                            window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                        }
	                    }
	                }).done(calculateAjax($form, validateAjax));
	            } else if (e.target.id.indexOf('app_conversion_path_second_step_instalmentStorage') >= 0) {
	                $.ajax({
	                    url: $form.attr('action') + '?chaninsqua=true',
	                    type: $form.attr('method'),
	                    data: $form.serializeArray(),
	                    success: function success(html) {
	                        $('.number-of-installment').html($(html).find('.number-of-installment').html());
	                        $('.charge-type').html($(html).find('.charge-type').html());
	                        if ($('#app_conversion_path_second_step_instalmentBaseVariantAndAddons').is(':checked') || $('#app_conversion_path_second_step_instalmentStorage').is(':checked')) {
	                            $('#installment-checked').addClass('active');
	                            if ($('#app_conversion_path_second_step_instalmentStorage').is(':checked')) {
	                                $('.installHide2').addClass('active');
	                            } else {
	                                $('.installHide2').removeClass('active');
	                            }
	                        } else {
	                            $('#installment-checked').removeClass('active');
	                        }
	                    },
	                    error: function error(jqXHR, textStatus, errorThrown) {
	                        if (jqXHR.status === 401) {
	                            window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                        }
	                    }
	                }).done(calculateAjax($form, validateAjax));
	            } else if (e.target.id.indexOf('app_conversion_path_second_step_haquestionnaire') >= 0) {
	                $.ajax({
	                    url: $form.attr('action') + '?chanhaq=true',
	                    type: $form.attr('method'),
	                    data: $form.serializeArray(),
	                    success: function success(html) {
	                        $('.variants').html($(html).find('.variants').html());
	                        $('.abonament').html($(html).find('.abonament').html());
	                        $('.additional').html($(html).find('.additional').html());
	                        $('.insurance').html($(html).find('.insurance').html());
	                        $('.number-of-installment').html($(html).find('.number-of-installment').html());
	                        $('.charge-type').html($(html).find('.charge-type').html());
	
	                        $('.ktg').html($(html).find('.ktg').html());
	                        $('.ktg_lightbox').html($(html).find('.ktg_lightbox').html());
	                        conversionPathForm($form, $form.serializeArray(), e.target.id.substr(0, e.target.id.lastIndexOf('_')), false);
	                    },
	                    error: function error(jqXHR, textStatus, errorThrown) {
	                        if (jqXHR.status === 401) {
	                            window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                        }
	                    }
	                }).done(calculateAjax($form, validateAjax));
	            } else {
	                changeAddonsFunc($target);
	                unlockPriceGuarantee();
	                calculateAjax($form, validateAjax);
	            }
	        }
	    });
	
	    $(document).on('click', ".resignation", function (e) {
	        if ($(e.target).hasClass('active')) {
	            $('input[name="app_conversion_path_second_step[transferCountryCode]"][value!="PL"]').prop('checked', false).trigger("change");
	            $('[data-code="optional.transplant"]').prop('checked', false);
	            $('input[name="app_conversion_path_second_step[transferCountryCode]"][value="PL"]').prop('checked', true).trigger("change");
	            calculateAjax($(this).closest('form'), validateAjax);
	            $(e.target).removeClass('active');
	        }
	    });
	
	    $(document).on("click", "#second-step-pesel-show", function (e) {
	        e.preventDefault();
	        $.ajax({
	            url: $(this).data('href'),
	            type: "GET",
	            success: function success(data) {
	                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                    if (data["sessionChanged"] === true) {
	                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                    }
	                }
	
	                $(".p__path--second").append(data);
	                $('body').addClass('unscroll');
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (jqXHR.status === 401) {
	                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                }
	            }
	        });
	    });
	
	    $(document).on("click", "#second-step-agreement-btn", function (e) {
	        e.preventDefault();
	
	        var $form = $(this).closest('form');
	
	        $('.lightbox_content .loader').show();
	
	        $.ajax({
	            url: $form.attr('action'),
	            type: $form.attr('method'),
	            data: $form.serializeArray(),
	            success: function success(data) {
	                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                    if (data["sessionChanged"] === true) {
	                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                    }
	                }
	
	                if (data.hasOwnProperty('isDiscount') && data['isDiscount'] === true) {
	                    var $formSecond = $(document).find("form[name='app_conversion_path_second_step']");
	                    $('#app_conversion_path_second_step_promoCode').val('');
	
	                    changePackFunc($formSecond, function () {
	                        calculateAjax($formSecond, validateAjax);
	                        unlockPriceGuarantee();
	                    });
	
	                    $(".success__panel").slideDown();
	                    $(".lastattempt__panel").slideUp();
	                    $(".go-further").slideUp();
	                    $(".error__panel").slideUp();
	                    $(".error-time__panel").slideUp();
	                } else {
	                    if (data.hasOwnProperty('isLastAttempt') && data['isLastAttempt'] === true) {
	                        $(".lastattempt__panel").slideDown();
	                        $(".success__panel").slideUp();
	                        $(".go-further").slideUp();
	                        $(".error__panel").slideUp();
	                        $(".error-time__panel").slideUp();
	                    } else if (data.hasOwnProperty('isTimeOut') && data['isTimeOut'] === true) {
	                        $(".error-time__panel").slideDown();
	                        $(".lastattempt__panel").slideUp();
	                        $(".success__panel").slideUp();
	                        $(".go-further").slideUp();
	                        $(".error__panel").slideUp();
	                    } else {
	                        if (data.hasOwnProperty('valid') && data['valid'] === false) {
	                            formValidation($form.attr("name"), $.parseJSON(data["errorList"]), null, false);
	                        } else {
	                            $(".lastattempt__panel").slideUp();
	                            $(".success__panel").slideUp();
	                            $(".error-time__panel").slideUp();
	                            $(".go-further").slideDown();
	                            $(".error__panel").slideDown();
	                        }
	                    }
	                }
	
	                $('.lightbox_content .loader').hide();
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (jqXHR.status === 401) {
	                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                }
	            }
	        });
	    });
	
	    $(document).on("click", "#second-step-back-decision-btn", function (e) {
	        e.preventDefault();
	
	        var $form = $(this).closest('form');
	
	        $.ajax({
	            url: $form.attr('data-deci-url'),
	            type: "GET",
	            success: function success(data) {
	                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                    if (data["sessionChanged"] === true) {
	                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                    }
	                }
	
	                $('.lightbox_wrapper[indirect-step]').remove();
	                $('body').addClass('unscroll');
	                $(".p__path--second").append(data);
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (jqXHR.status === 401) {
	                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                }
	            }
	        });
	    });
	
	    $(document).on("click", "#second-step-back-account-btn", function (e) {
	        e.preventDefault();
	
	        var $form = $(this).closest('form');
	
	        $.ajax({
	            url: $form.attr('data-acc-url'),
	            type: "GET",
	            success: function success(data) {
	                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                    if (data["sessionChanged"] === true) {
	                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                    }
	                }
	
	                $('.lightbox_wrapper[indirect-step]').remove();
	                $('body').addClass('unscroll');
	                $(".p__path--second").append(data);
	                $('.countrySelect').each(function () {
	                    $(this).select2();
	                    if ($(this).val() == 'PL') {
	                        $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
	                    }
	                });
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (jqXHR.status === 401) {
	                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                }
	            }
	        });
	    });
	
	    $(document).on("click", "#second-step-decision-btn", function (e) {
	        e.preventDefault();
	
	        var $form = $(this).closest('form');
	
	        $.ajax({
	            url: $form.attr('action'),
	            type: $form.attr('method'),
	            data: $form.serializeArray(),
	            success: function success(data) {
	                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                    if (data["sessionChanged"] === true) {
	                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                    }
	                }
	
	                if (data.hasOwnProperty('newAccount') && data.hasOwnProperty('existingUser') && data.hasOwnProperty('url') && data.hasOwnProperty('token')) {
	                    if (data['newAccount'] === true && data['existingUser'] === false) {
	                        $.ajax({
	                            url: Routing.generate(data['url'], { _locale: currentLocale, token: data['token'] }),
	                            type: "GET",
	                            success: function success(data) {
	                                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                                    if (data["sessionChanged"] === true) {
	                                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                                    }
	                                }
	
	                                $('.lightbox_wrapper[indirect-step]').remove();
	                                $('body').addClass('unscroll');
	                                $(".p__path--second").append(data);
	                                $('.countrySelect').each(function () {
	                                    $(this).select2();
	                                    if ($(this).val() == 'PL') {
	                                        $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
	                                    }
	                                });
	                            },
	                            error: function error(jqXHR, textStatus, errorThrown) {
	                                if (jqXHR.status === 401) {
	                                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                                }
	                            }
	                        });
	                    } else if (data['newAccount'] === false && data['existingUser'] === true) {
	                        $.ajax({
	                            url: Routing.generate(data['url'], { _locale: currentLocale, token: data['token'] }),
	                            type: "GET",
	                            success: function success(data) {
	                                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                                    if (data["sessionChanged"] === true) {
	                                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                                    }
	                                }
	
	                                $('.lightbox_wrapper[indirect-step]').remove();
	                                $('body').addClass('unscroll');
	                                $(".p__path--second").append(data);
	                                $('.countrySelect').each(function () {
	                                    $(this).select2();
	                                    if ($(this).val() == 'PL') {
	                                        $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
	                                    }
	                                });
	                            },
	                            error: function error(jqXHR, textStatus, errorThrown) {
	                                if (jqXHR.status === 401) {
	                                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                                }
	                            }
	                        });
	                    } else {
	                        window.location.href = Routing.generate(data['url'], {
	                            _locale: currentLocale,
	                            token: data['token']
	                        });
	                    }
	                } else if (data.hasOwnProperty('newAccount') && data.hasOwnProperty('existingUser') && data.hasOwnProperty('url')) {
	                    if (data['newAccount'] === true && data['existingUser'] === false) {
	                        $.ajax({
	                            url: Routing.generate(data['url'], { _locale: currentLocale }),
	                            type: "GET",
	                            success: function success(data) {
	                                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                                    if (data["sessionChanged"] === true) {
	                                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                                    }
	                                }
	
	                                $('.lightbox_wrapper[indirect-step]').remove();
	                                $('body').addClass('unscroll');
	                                $(".p__path--second").append(data);
	                                $('.countrySelect').each(function () {
	                                    $(this).select2();
	                                    if ($(this).val() == 'PL') {
	                                        $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
	                                    }
	                                });
	                            },
	                            error: function error(jqXHR, textStatus, errorThrown) {
	                                if (jqXHR.status === 401) {
	                                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                                }
	                            }
	                        });
	                    } else if (data['newAccount'] === false && data['existingUser'] === true) {
	                        $.ajax({
	                            url: Routing.generate(data['url'], { _locale: currentLocale }),
	                            type: "GET",
	                            success: function success(data) {
	                                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                                    if (data["sessionChanged"] === true) {
	                                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                                    }
	                                }
	
	                                $('.lightbox_wrapper[indirect-step]').remove();
	                                $('body').addClass('unscroll');
	                                $(".p__path--second").append(data);
	                                $('.countrySelect').each(function () {
	                                    $(this).select2();
	                                    if ($(this).val() == 'PL') {
	                                        $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
	                                    }
	                                });
	                            },
	                            error: function error(jqXHR, textStatus, errorThrown) {
	                                if (jqXHR.status === 401) {
	                                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                                }
	                            }
	                        });
	                    } else {
	                        window.location.href = Routing.generate(data['url'], { _locale: currentLocale });
	                    }
	                } else {
	                    if (data.hasOwnProperty('newAccount') && data.hasOwnProperty('url')) {
	                        if (data['newAccount'] === true) {
	                            var url = Routing.generate(data['url'], { _locale: currentLocale });
	
	                            if (data.hasOwnProperty('reflection')) {
	                                url += '?reflection=' + data['reflection'];
	                            }
	
	                            $.ajax({
	                                url: url,
	                                type: "GET",
	                                success: function success(data) {
	                                    if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                                        if (data["sessionChanged"] === true) {
	                                            window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                                        }
	                                    }
	
	                                    $('.lightbox_wrapper[indirect-step]').remove();
	                                    $('body').addClass('unscroll');
	                                    $(".p__path--second").append(data);
	                                    $('.countrySelect').each(function () {
	                                        $(this).select2();
	                                        if ($(this).val() == 'PL') {
	                                            $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
	                                        }
	                                    });
	                                },
	                                error: function error(jqXHR, textStatus, errorThrown) {
	                                    if (jqXHR.status === 401) {
	                                        window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                                    }
	                                }
	                            });
	                        } else {
	                            window.location.href = Routing.generate(data['url'], { _locale: currentLocale });
	                        }
	                    }
	                }
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (jqXHR.status === 401) {
	                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                }
	            }
	        });
	    });
	
	    $(document).on("change", "form[name='app_conversion_path_second_step_account']", function (e) {
	        var $form = $(this);
	        if (e.target.id.indexOf('_phoneNumber_country') >= 0 && e.target.id.indexOf('_phoneNumber_number') >= 0) {
	            accountForm($form, $form.serializeArray(), e.target.id.replace('_phoneNumber_country', '_phoneNumber_number'), false);
	        } else {
	            accountForm($form, $form.serializeArray(), e.target.id, false);
	        }
	    });
	
	    $(document).on("click", "#second-step-account-btn", function (e) {
	        var $form = $(this).closest('form');
	
	        accountForm($form, $form.serializeArray(), null, true);
	    });
	
	    $(document).on("click", "#second-step-user-btn", function (e) {
	        var $form = $(this).closest('form');
	
	        userForm($form, $form.serializeArray(), null, true);
	    });
	
	    $(document).on("click", "#second-step-login-btn", function (e) {
	        var isReflection = '';
	
	        if ($(this).attr('data-reflection') === '1') {
	            isReflection = '?reflection=true';
	        }
	
	        $.ajax({
	            url: Routing.generate('app_conversion_path_second_step_login', { _locale: currentLocale }) + isReflection,
	            type: 'GET',
	            success: function success(data) {
	                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                    if (data["sessionChanged"] === true) {
	                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                    }
	                }
	
	                $('.lightbox_wrapper').remove();
	                $(".p__path--second").append(data);
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (jqXHR.status === 401) {
	                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                }
	            }
	        });
	    });
	
	    var validateAjax = function validateAjax($form) {
	        $.ajax({
	            url: $form.attr('action'),
	            type: $form.attr('method'),
	            data: $form.serialize(),
	            success: function success(data) {
	                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                    if (data["sessionChanged"] === true) {
	                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                    }
	                }
	
	                loader.fadeOut(100);
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (jqXHR.status === 401) {
	                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                }
	            }
	        });
	    };
	    var jqxhr;
	
	    var calculateAjax = function calculateAjax($form, callback) {
	        loader.fadeIn(100);
	        jqxhr = $.ajax({
	            url: $form.attr('data-calc-url'),
	            type: "POST",
	            data: $form.serialize(),
	            success: function success(data) {
	                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                    if (data["sessionChanged"] === true) {
	                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                    }
	                }
	
	                // boczny panel
	                $("#storage_fee").html(data.selected.storage / 100 + ' <span class="currency">&euro;</span>');
	                $("#addons_fee").html(data.selected.addons / 100 + ' <span class="currency">&euro;</span>');
	                $("#transfer_fee").html(data.selected.transfer / 100 + ' <span class="currency">&euro;</span>');
	                $("#after_sign_fee").html(data.summary.after_sign / 100 + ' <span class="currency">&euro;</span>');
	                $("#after_cryo_fee").html(data.summary.after_cryo / 100 + ' <span class="currency">&euro;</span>');
	
	                if (data.selected.storage / 100 !== data.selected_standard.storage / 100) {
	                    $("#storage_fee_standard").html(data.selected_standard.storage / 100 + ' <span class="currency">&euro;</span>');
	                    $("#storage_fee_standard").fadeIn(300);
	                } else {
	                    $("#storage_fee_standard").html('');
	                    $("#storage_fee_standard").removeClass('active');
	                }
	
	                if (data.selected.addons / 100 !== data.selected_standard.addons / 100) {
	                    $("#addons_fee_standard").html(data.selected_standard.addons / 100 + ' <span class="currency">&euro;</span>');
	                    $("#addons_fee_standard").fadeIn(300);
	                } else {
	                    $("#addons_fee_standard").html('');
	                    $("#addons_fee_standard").removeClass('active');
	                }
	
	                if (data.selected.transfer / 100 !== data.selected_standard.transfer / 100) {
	                    $("#transfer_fee_standard").html(data.selected_standard.transfer / 100 + ' <span class="currency">&euro;</span>');
	                    $("#transfer_fee_standard").fadeIn(300);
	                } else {
	                    $("#transfer_fee_standard").html('');
	                    $("#transfer_fee_standard").removeClass('active');
	                }
	                // addons list
	                if (data.selected.addons_list.length !== 0) {
	                    $('.additional-packages-hidden').show();
	                    $('.defaultLastRowLeft').removeClass('roundBottomLeft');
	                    $('.defaultLastRowRight').removeClass('roundBottomRight');
	                    $(".addons-list").remove();
	                    $.each(data.selected.addons_list, function (key, addon) {
	                        var roundBottomLeft = addon.last === true ? 'roundBottomLeft' : '';
	                        var roundBottomRight = addon.last === true ? 'roundBottomRight' : '';
	                        var divTableRow = '<div class="divTableRow addons-list">' + '<div class="divTableCell ' + roundBottomLeft + ' width38 fontSize16 fontColorNavy colorWhite borderDashedTop">' + addon.name + '</div>' + '<div class="divTableCell ' + roundBottomRight + ' width12 fontSize14 fontColorNavy colorWhite borderDashedTop">' + addon.client_price / 100 + '<span class="currency">&nbsp;&euro;' + addon.payment_shortcut + '</span></div>' + '<div class="divTableCell width50 fontSize16 fontColorWhite borderDashedTop">' + addon.payment_info + '</div>' + '</div>';
	                        $('.divTableBody').append(divTableRow);
	                    });
	                } else {
	                    $('.additional-packages-hidden').hide();
	                    $('.defaultLastRowLeft').addClass('roundBottomLeft');
	                    $('.defaultLastRowRight').addClass('roundBottomRight');
	                    $('.addons-list').remove();
	                }
	                loader.fadeOut(100);
	
	                // callback($form);
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (jqXHR.status === 401) {
	                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                }
	            }
	        });
	        return jqxhr;
	    };
	}
	
	if ($('.p__path--second').length) {
	    $(document).on("click", "#discount-km-button-submit", function (e) {
	        var $form = $(this).closest('form');
	
	        $.ajax({
	            url: $form.attr('data-disc-url'),
	            type: 'POST',
	            data: $form.serializeArray(),
	            success: function success(data) {
	                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                    if (data["sessionChanged"] === true) {
	                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                    }
	                }
	
	                if (data.hasOwnProperty('error') && data.hasOwnProperty('success') && data.hasOwnProperty('message')) {
	                    if (data['error'] === true && data['success'] === false) {
	                        if (data['birth_days_check'] === false) {
	                            toastr.error(data['message']);
	
	                            changePackFunc($form, function () {
	                                var $form = $(document).find("form[name='app_conversion_path_second_step']");
	
	                                calculateAjax($form, validateAjax);
	                            });
	                        } else {
	                            toastr.error(data['message']);
	
	                            $.ajax({
	                                url: $form.attr('action') + '?chanpromo=true',
	                                type: 'POST',
	                                data: $form.serializeArray(),
	                                success: function success(html) {
	                                    // $('#promo-code-birth-days').html($(html).find('#promo-code-birth-days').html());
	                                    $('#promo-code-birth-days').fadeIn(0);
	                                    $('#promo-code-birth-days input').prop('disabled', false);
	                                },
	                                error: function error(jqXHR, textStatus, errorThrown) {
	                                    if (jqXHR.status === 401) {
	                                        window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                                    }
	                                }
	                            });
	                        }
	                    } else {
	                        toastr.info(data['message']);
	                        if (data['birth_days_check'] === false) {
	                            // $('#promo-code-birth-days').html('');
	                            $('#promo-code-birth-days').fadeOut(0);
	                            $('#promo-code-birth-days input').prop('disabled', true);
	                        }
	
	                        changePackFunc($form, function () {
	                            var $form = $(document).find("form[name='app_conversion_path_second_step']");
	
	                            calculateAjax($form, validateAjax);
	                        });
	                    }
	                }
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (jqXHR.status === 401) {
	                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                }
	            }
	        });
	    });
	}
	
	if ($('.p__path--variant_ktg').length) {
	    $(document).on("click", "#discount-ktg-button-submit", function (e) {
	        var $form = $(this).closest('form');
	
	        $.ajax({
	            url: $form.attr('data-disc-url'),
	            type: 'POST',
	            data: $form.serializeArray(),
	            success: function success(data) {
	                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                    if (data["sessionChanged"] === true) {
	                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                    }
	                }
	
	                if (data.hasOwnProperty('error') && data.hasOwnProperty('success') && data.hasOwnProperty('message')) {
	                    if (data['error'] === true && data['success'] === false) {
	                        if (data['birth_days_check'] === false) {
	                            toastr.error(data['message']);
	                        } else {
	                            toastr.error(data['message']);
	                            $.ajax({
	                                url: $form.attr('action') + '?chanpromo=true',
	                                type: 'POST',
	                                data: $form.serializeArray(),
	                                success: function success(html) {
	                                    $('#promo-code-birth-days').html($(html).find('#promo-code-birth-days').html());
	                                },
	                                error: function error(jqXHR, textStatus, errorThrown) {
	                                    if (jqXHR.status === 401) {
	                                        window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                                    }
	                                }
	                            });
	                        }
	                    } else {
	                        toastr.info(data['message']);
	                        if (data['birth_days_check'] === false) {
	                            $('#promo-code-birth-days').html('');
	                        }
	
	                        $.when(changeKtgPackFunc($form)).done(function () {
	                            var $form = $(document).find("form[name='app_ktg_path_first_step']");
	
	                            calculateKtgAjax($form, validateAjax);
	                        });
	                    }
	                }
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (jqXHR.status === 401) {
	                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                }
	            }
	        });
	    });
	}
	
	var isLogged = false;
	
	if ($('.p__path--second').length || $('.p--admin').length) {
	    $(document).on("submit", "#second-step-login-form", function (e) {
	        e.preventDefault();
	
	        var $form = $(this).closest('form');
	
	        if (isLogged === false) {
	            $.ajax({
	                url: $form.attr('action'),
	                type: $form.attr('method'),
	                data: $form.serializeArray(),
	                success: function success(data) {
	                    if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                        if (data["sessionChanged"] === true) {
	                            window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                        }
	                    }
	
	                    if (data.hasOwnProperty('success') && data.hasOwnProperty('errors') && data.hasOwnProperty('errorList')) {
	                        if (data['success'] === false) {
	                            isLogged = false;
	
	                            formValidation($form.attr('name'), $.parseJSON(data['errorList']), null, false);
	
	                            $(document).find('#invalid-credentials-error').remove();
	
	                            if (data['errors'] !== '') {
	                                $form.before("<div id='invalid-credentials-error' class='errorBar'>" + "<p>" + data['errors'] + "</p>" + "</div>");
	                            }
	                        } else {
	                            isLogged = true;
	
	                            if (data.hasOwnProperty('url')) {
	                                window.location.href = Routing.generate(data['url'], { _locale: currentLocale });
	                            } else {
	                                window.location.href = Routing.generate('app_conversion_path_third_step', { _locale: currentLocale });
	                            }
	                        }
	                    }
	                },
	                error: function error(jqXHR, textStatus, errorThrown) {
	                    var data = jqXHR.responseJSON;
	
	                    if (jqXHR.status === 401) {
	                        isLogged = false;
	
	                        formValidation($form.attr('name'), $.parseJSON(data['errorList']), null, false);
	
	                        $(document).find('#invalid-credentials-error').remove();
	
	                        if (data['errors'] !== '') {
	                            $form.before("<div id='invalid-credentials-error' class='errorBar'><p>" + data['errors'] + "</p></div>");
	                        }
	
	                        // window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
	                    }
	                },
	                beforeSend: function beforeSend(jqXHR, settings) {
	                    isLogged = true;
	                }
	            });
	        }
	    });
	}
	
	var jqxhr_tsv;
	// Walidacja trzeciego kroku
	if ($('.p__path--third').length) {
	    $(document).on("change", "form[name='app_conversion_path_third_step']", function (e) {
	        var $form = $(this);
	        var $element = $(e.target);
	        var loader = $('.loader');
	
	        if ($element.attr('id') === 'app_conversion_path_third_step_mother_pesel') {
	            conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false, true);
	        } else if ($element.attr('id') === 'app_conversion_path_third_step_mother_dateOfBirth') {
	            conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false, true);
	        } else if (e.target.id.indexOf('_phoneNumber_country') >= 0) {
	            conversionPathThirdStepForm($form, $form.serializeArray(), e.target.id.replace('_phoneNumber_country', '_phoneNumber_number'), false);
	        } else if ($element.attr('id') === 'app_conversion_path_third_step_isMother') {
	            var $loader = $('.approval-statements .loader');
	
	            $.when($.ajax({
	                url: $form.attr('action') + '?chanmothda=true',
	                type: $form.attr('method'),
	                data: $form.serializeArray(),
	                success: function success(html) {
	                    loader.fadeOut(600);
	                    $('#mother-data-firstName').replaceWith($(html).find('#mother-data-firstName'));
	                    $('#mother-data-lastName').replaceWith($(html).find('#mother-data-lastName'));
	                    $('#mother-data-maidenName').replaceWith($(html).find('#mother-data-maidenName'));
	                    $('#mother-data-address').replaceWith($(html).find('#mother-data-address'));
	                    $('#mother-data-houseNumber').replaceWith($(html).find('#mother-data-houseNumber'));
	                    $('#mother-data-placeNumber').replaceWith($(html).find('#mother-data-placeNumber'));
	                    $('#mother-data-postalCode').replaceWith($(html).find('#mother-data-postalCode'));
	                    $('#mother-data-city').replaceWith($(html).find('#mother-data-city'));
	                    $('#mother-data-country').replaceWith($(html).find('#mother-data-country'));
	                    $('#mother-data-dateOfBirth').replaceWith($(html).find('#mother-data-dateOfBirth'));
	                    $('#mother-data-idNationalNumber').replaceWith($(html).find('#mother-data-idNationalNumber'));
	                    $('#app_conversion_path_third_step_mother_country').select2();
	                    $('#mother-data-pesel').replaceWith($(html).find('#mother-data-pesel'));
	                    $('#mother-data-no-pesel').replaceWith($(html).find('#mother-data-no-pesel'));
	                    $('#mother-data-idCard').replaceWith($(html).find('#mother-data-idCard'));
	                    $('#mother-data-other-doc-type').replaceWith($(html).find('#mother-data-other-doc-type'));
	                    $('#mother-data-other-doc-number').replaceWith($(html).find('#mother-data-other-doc-number'));
	                    $('#mother-data-email').replaceWith($(html).find('#mother-data-email'));
	                    $('#mother-data-phoneNumber').replaceWith($(html).find('#mother-data-phoneNumber'));
	                    // $('#copyAddress').replaceWith($(html).find('#copyAddress'));
	                    $('#app_conversion_path_third_step_mother_phoneNumber_country').select2();
	                    if ($('#app_conversion_path_third_step_mother_phoneNumber_country').val() == 'PL') {
	                        $('#app_conversion_path_third_step_mother_phoneNumber_country').closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
	                    }
	                    $('#address-for-correspondence-type').replaceWith($(html).find('#address-for-correspondence-type'));
	
	                    $('.approval-statements').replaceWith($(html).find('.approval-statements'));
	                    $('.approval-statements').find('input[type="checkbox"]:checked').each(function ($element) {
	                        $(this).siblings('.switch').addClass('y');
	                        $(this).siblings('span[data-answer="no"]').removeClass('active');
	                        $(this).siblings('span[data-answer="yes"]').addClass('active');
	                    });
	
	                    if ($element.is(':checked')) {
	                        $('#copyAddressMotherToChild').fadeIn(300);
	                        $element.parent().find('.header-row').find('.checkbox-cancel').fadeIn(300);
	                        initDatePicker();
	                    } else {
	                        $('#copyAddressMotherToChild').fadeOut(300);
	                        $element.parent().find('.header-row').find('.checkbox-cancel').fadeOut(300);
	                    }
	                },
	                error: function error(jqXHR, textStatus, errorThrown) {
	                    if (jqXHR.status === 401) {
	                        window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                    }
	                }
	            })).done(function () {
	                var fieldsIds = ['app_conversion_path_third_step_isMother', 'app_conversion_path_third_step_isFather'];
	                conversionPathThirdStepForm($form, $form.serializeArray(), fieldsIds, false);
	            });
	        } else if ($element.attr('id') === 'app_conversion_path_third_step_isFather') {
	            var $loader = $('.approval-statements .loader');
	
	            $.when($.ajax({
	                url: $form.attr('action') + '?chanfathda=true',
	                type: $form.attr('method'),
	                data: $form.serializeArray(),
	                success: function success(html) {
	                    loader.fadeOut(600);
	                    $('#father-data-firstName').replaceWith($(html).find('#father-data-firstName'));
	                    $('#father-data-lastName').replaceWith($(html).find('#father-data-lastName'));
	                    $('#father-data-maidenName').replaceWith($(html).find('#father-data-maidenName'));
	                    $('#father-data-address').replaceWith($(html).find('#father-data-address'));
	                    $('#father-data-houseNumber').replaceWith($(html).find('#father-data-houseNumber'));
	                    $('#father-data-placeNumber').replaceWith($(html).find('#father-data-placeNumber'));
	                    $('#father-data-postalCode').replaceWith($(html).find('#father-data-postalCode'));
	                    $('#father-data-city').replaceWith($(html).find('#father-data-city'));
	                    $('#father-data-country').replaceWith($(html).find('#father-data-country'));
	                    $('#father-data-dateOfBirth').replaceWith($(html).find('#father-data-dateOfBirth'));
	                    $('#father-data-idNationalNumber').replaceWith($(html).find('#father-data-idNationalNumber'));
	                    $('#app_conversion_path_third_step_father_country').select2();
	                    $('#father-data-pesel').replaceWith($(html).find('#father-data-pesel'));
	                    $('#father-data-no-pesel').replaceWith($(html).find('#father-data-no-pesel'));
	                    $('#father-data-idCard').replaceWith($(html).find('#father-data-idCard'));
	                    $('#father-data-other-doc-type').replaceWith($(html).find('#father-data-other-doc-type'));
	                    $('#father-data-other-doc-number').replaceWith($(html).find('#father-data-other-doc-number'));
	                    $('#father-data-email').replaceWith($(html).find('#father-data-email'));
	                    $('#father-data-phoneNumber').replaceWith($(html).find('#father-data-phoneNumber'));
	                    // $('#copyAddress').replaceWith($(html).find('#copyAddress'));
	                    $('#app_conversion_path_third_step_father_phoneNumber_country').select2();
	                    if ($('#app_conversion_path_third_step_father_phoneNumber_country').val() == 'PL') {
	                        $('#app_conversion_path_third_step_father_phoneNumber_country').closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
	                    }
	                    $('#address-for-correspondence-type').replaceWith($(html).find('#address-for-correspondence-type'));
	
	                    $('.approval-statements').replaceWith($(html).find('.approval-statements'));
	                    $('.approval-statements').find('input[type="checkbox"]:checked').each(function ($element) {
	                        $(this).siblings('.switch').addClass('y');
	                        $(this).siblings('span[data-answer="no"]').removeClass('active');
	                        $(this).siblings('span[data-answer="yes"]').addClass('active');
	                    });
	
	                    if ($element.is(':checked')) {
	                        $('#copyAddressFatherToChild').fadeIn(300);
	                        $element.parent().find('.header-row').find('.checkbox-cancel').fadeIn(300);
	                        initDatePicker();
	                    } else {
	                        $('#copyAddressFatherToChild').fadeOut(300);
	                        $element.parent().find('.header-row').find('.checkbox-cancel').fadeOut(300);
	                    }
	                },
	                error: function error(jqXHR, textStatus, errorThrown) {
	                    if (jqXHR.status === 401) {
	                        window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                    }
	                }
	            })).done(function () {
	                var fieldsIds = ['app_conversion_path_third_step_isMother', 'app_conversion_path_third_step_isFather'];
	                conversionPathThirdStepForm($form, $form.serializeArray(), fieldsIds, false);
	            });
	        } else if ($element.attr('id') === 'app_conversion_path_third_step_child_dateOfBirth') {
	            conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
	        } else if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData_childBirthNumber') {
	            var childBirthNumber = parseInt($element.val());
	            var pregnancyNumber = parseInt($('#app_conversion_path_third_step_childbirthData_pregnancyNumber').val());
	
	            if (childBirthNumber <= pregnancyNumber) {
	                if (pregnancyNumber - childBirthNumber >= 2) {
	                    $('.lightboxAccept').fadeIn(300);
	                    $('[data=closeLightbox]').on('click', function () {
	                        $('.lightboxAccept').fadeOut(300);
	                    });
	                }
	            }
	
	            conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
	        } else if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData_pregnancyNumber') {
	            var childBirthNumber = parseInt($('#app_conversion_path_third_step_childbirthData_childBirthNumber').val());
	            var pregnancyNumber = parseInt($element.val());
	
	            if (childBirthNumber <= pregnancyNumber) {
	                if (pregnancyNumber - childBirthNumber >= 2) {
	                    $('.lightboxAccept').fadeIn(300);
	                    $('[data=closeLightbox]').on('click', function () {
	                        $('.lightboxAccept').fadeOut(300);
	                    });
	                }
	            }
	
	            conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
	        } else if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData__hospital') {
	            $.when(changeOtherHospital($element, 'first', false)).done(function () {
	                conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
	            });
	        } else if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData__secondHospital') {
	            $.when(changeOtherHospital($element, 'second', false)).done(function () {
	                conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
	            });
	        } else if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData_firstOtherHospitalName') {
	            $.when(changeOtherHospital($element, 'first', true)).done(function () {
	                conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
	            });
	        } else if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData_firstOtherHospitalAddress') {
	            $.when(changeOtherHospital($element, 'first', true)).done(function () {
	                conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
	            });
	        } else if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData_secondOtherHospitalName') {
	            $.when(changeOtherHospital($element, 'second', true)).done(function () {
	                conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
	            });
	        } else if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData_secondOtherHospitalAddress') {
	            $.when(changeOtherHospital($element, 'second', true)).done(function () {
	                conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
	            });
	        } else if (e.target.id.indexOf('app_conversion_path_third_step_isKit_') >= 0) {
	            $('.kitCont .loader').fadeIn(300);
	            $.when(changeKit($element)).done(function () {
	                conversionPathThirdStepForm($form, $form.serializeArray(), 'app_conversion_path_third_step_isKit', false);
	            });
	        } else if (e.target.id.indexOf('app_conversion_path_third_step_addressForCorrespondenceType_') >= 0) {
	            conversionPathThirdStepForm($form, $form.serializeArray(), 'app_conversion_path_third_step_addressForCorrespondenceType', false);
	        } else if (e.target.id.indexOf('app_conversion_path_third_step_kitNumbers_') >= 0) {
	            var ids = [];
	
	            $(document).find('input[id^=app_conversion_path_third_step_kitNumbers_]').each(function () {
	                if ($(this).val() !== '') {
	                    ids.push($(this).attr('id'));
	                }
	            });
	            $('.kitCont .loader').fadeIn(300);
	            $.when(conversionPathThirdStepForm($form, $form.serializeArray(), ids, false)).done(function () {
	                $('.kitCont .loader').fadeOut(300);
	            });
	        } else if (e.target.id.indexOf('app_conversion_path_third_step__pregnancyData_authorizedPeople_') >= 0) {
	            var ids = [];
	            var allEmpty = true;
	
	            $(document).find('input[id^=app_conversion_path_third_step__pregnancyData_authorizedPeople_' + $element.attr('loop-index') + ']').each(function () {
	                if ($(this).val() !== '') {
	                    allEmpty = false;
	                }
	            });
	
	            $(document).find('input[id^=app_conversion_path_third_step__pregnancyData_authorizedPeople_' + $element.attr('loop-index') + ']').each(function () {
	                if (allEmpty === true) {
	                    ids.push($(this).attr('id'));
	                } else {
	                    if ($element.attr('id') === $(this).attr('id')) {
	                        ids.push($(this).attr('id'));
	                    } else {
	                        if ($(this).val() !== '') {
	                            ids.push($(this).attr('id'));
	                        }
	                    }
	                }
	            });
	
	            conversionPathThirdStepForm($form, $form.serializeArray(), ids, false);
	        } else if (e.target.id.indexOf('app_conversion_path_third_step__agreements_') >= 0) {
	            if (jqxhr_tsv) {
	                jqxhr_tsv.abort();
	            }
	
	            $.when(jqxhr_tsv = $.ajax({
	                url: $form.attr('action') + '?chanagr=true',
	                type: $form.attr('method'),
	                data: $form.serializeArray(),
	                success: function success(html) {
	                    $('.approval-statements').replaceWith($(html).find('.approval-statements'));
	                    $('.approval-statements').find('input[type="checkbox"]:checked').each(function ($element) {
	                        $(this).siblings('.switch').addClass('y');
	                        $(this).siblings('span[data-answer="no"]').removeClass('active');
	                        $(this).siblings('span[data-answer="yes"]').addClass('active');
	                    });
	                },
	                error: function error(jqXHR, textStatus, errorThrown) {
	                    if (jqXHR.status === 401) {
	                        window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                    }
	                }
	            })).done(function () {
	                conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
	            });
	        } else {
	            conversionPathThirdStepForm($form, $form.serializeArray(), $element.attr('id'), false);
	        }
	
	        if ($element.attr('id') === 'app_conversion_path_third_step_childbirthData_dateOfBirth') {
	            var ktgEnd = new Date('2018-08-31');
	            var isKtgAttr = parseInt($element.attr('data-is-ktg'));
	            var now = new Date();
	            var selected = new Date($element.val());
	
	            var timeDiff = Math.abs(selected.getTime() - now.getTime());
	            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
	
	            if (diffDays <= 5) {
	                toastr.info(jsTranslations['messages']['soon_birthdate_warning']);
	            }
	
	            if (isKtgAttr === 1) {
	                if (selected.getTime() > ktgEnd.getTime()) {
	                    toastr.error(jsTranslations['messages']['birthdate_before_only']);
	                }
	            }
	        }
	    });
	
	    $(document).on("click", "#conversion_path_submit", function (e) {
	        var $form = $(this).closest('form');
	
	        conversionPathThirdStepForm($form, $form.serializeArray(), null, true);
	    });
	
	    var changeOtherHospital = function changeOtherHospital($element, number, onlyAgreements) {
	        var $form = $element.closest('form');
	        var $loader = $('.approval-statements .loader');
	        $loader.fadeIn(300);
	        $.ajax({
	            url: $form.attr('action') + '?chanhosp=true',
	            type: $form.attr('method'),
	            data: $form.serializeArray(),
	            success: function success(html) {
	                if (onlyAgreements === false) {
	                    $('#' + number + '_other_hospital').replaceWith($(html).find('#' + number + '_other_hospital'));
	                }
	
	                $('.approval-statements').replaceWith($(html).find('.approval-statements'));
	                $('.approval-statements').find('input[type="checkbox"]:checked').each(function ($element) {
	                    $(this).siblings('.switch').addClass('y');
	                    $(this).siblings('span[data-answer="no"]').removeClass('active');
	                    $(this).siblings('span[data-answer="yes"]').addClass('active');
	                });
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (jqXHR.status === 401) {
	                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                }
	            }
	        });
	    };
	
	    var changeKit = function changeKit($element) {
	        var $form = $element.closest('form');
	
	        $.ajax({
	            url: $form.attr('action') + '?chankit=true',
	            type: $form.attr('method'),
	            data: $form.serializeArray(),
	            success: function success(html) {
	                $('#kitNumbers').replaceWith($(html).find('#kitNumbers'));
	                $('#kitAddress').replaceWith($(html).find('#kitAddress'));
	                $('#kitAddress .countrySelect').select2();
	                if ($('#kitAddress .countrySelect').val() == 'PL') {
	                    $('#kitAddress .countrySelect').closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
	                }
	                $('.loader').fadeOut(300);
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (jqXHR.status === 401) {
	                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                }
	            }
	        });
	    };
	
	    $(document).on('click', '.checkbox-cancel', function () {
	        $(this).parent().next().click().trigger('change');
	    });
	
	    // $(document).on("change", "#app_conversion_path_third_step__familyData__childbirthData__hospital", function (e) {
	    //     changeOtherHospital($(this), 'first');
	    // });
	    //
	    // $(document).on("change", "#app_conversion_path_third_step__familyData__childbirthData__secondHospital", function (e) {
	    //     changeOtherHospital($(this), 'second');
	    // });
	}
	
	// Walidacja czwartego kroku
	if ($('.p__path--fourth').length) {
	
	    var $inputDisease = $('[data-section] input[data-disease]');
	
	    $inputDisease.on('change', function () {
	        var data = $(this).attr('data-disease');
	        var dataCount = $(this).attr('data-count');
	        var answer = $(this).attr('data-answer');
	        var found = $('form[name=app_conversion_path_fourth_step] input[data-disease="' + data + '"][data-answer="' + answer + '"]');
	        if (dataCount == 'misc') {} else {
	            found.trigger("change");
	        }
	
	        // $(this).prop("checked", true);
	    });
	
	    $(document).on("change", "form[name='app_conversion_path_fourth_step']", function (e) {
	        var $form = $(this);
	        var $element = $(e.target);
	        var elementId = $element.attr('id');
	        var elementAnswerId = '';
	
	        if (typeof elementId !== 'undefined') {
	            if (elementId.indexOf('_answer') === -1) {
	                elementId = elementId.slice(0, -2);
	                elementAnswerId = elementId + '_answer';
	            } else {
	                elementAnswerId = elementId;
	                elementId = elementId.slice(0, -7);
	            }
	
	            var ids = [elementId, elementAnswerId];
	
	            if ($.inArray(elementId, ['app_conversion_path_fourth_step_f5d4fb72', 'app_conversion_path_fourth_step_ea52e2aa', 'app_conversion_path_fourth_step_d34c1686']) !== -1) {
	                ids.push('app_conversion_path_fourth_step_bbe80691');
	            }
	
	            $('#app_conversion_path_fourth_step__timestamp').val(Date.now());
	
	            conversionPathFourthStepForm($form, $form.serializeArray(), ids, false);
	        }
	    });
	
	    $(document).on("click", "#conversion_path_submit", function (e) {
	        var $form = $(this).closest('form');
	
	        $('#app_conversion_path_fourth_step__timestamp').val(Date.now());
	
	        conversionPathFourthStepForm($form, $form.serializeArray(), null, true);
	    });
	}
	
	// Walidacja piątego kroku
	if ($('.p__path--fifth').length) {
	    $(document).on("change", "form[name='app_conversion_path_fifth_step']", function (e) {
	        var $form = $(this);
	        var $element = $(e.target);
	        var $button = $('#conversion_path_submit');
	
	        if ($element[0].id === 'app_conversion_path_fifth_step_paymentMethod_1') {
	            $button.html(jsTranslations['messages']['order_payment_later'] + ' <i class="fa fa-angle-right" aria-hidden="true"></i>');
	        }
	
	        if ($element[0].id === 'app_conversion_path_fifth_step_paymentMethod_0') {
	            $button.html(jsTranslations['messages']['order_payment_now'] + ' <i class="fa fa-angle-right" aria-hidden="true"></i>');
	        }
	
	        conversionPathForm($form, $form.serializeArray(), $element.attr('id'), false);
	    });
	
	    $(document).on("click", "#conversion_path_submit", function (e) {
	        var $form = $(this).closest('form');
	        $('.btn--back').hide();
	
	        conversionPathForm($form, $form.serializeArray(), null, true);
	    });
	}
	
	var jqxhr_kpf;
	var ktgPathForm = function ktgPathForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_kpf) {
	        jqxhr_kpf.abort();
	    }
	    jqxhr_kpf = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('newAccount') && data.hasOwnProperty('url')) {
	                $.ajax({
	                    url: $form.attr('data-acco-url'),
	                    type: "GET",
	                    success: function success(data) {
	                        if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                            if (data["sessionChanged"] === true) {
	                                window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                            }
	                        }
	
	                        $(".p__path--variant_ktg").append(data);
	                        $('body').addClass('unscroll');
	                        $('.countrySelect').each(function () {
	                            $(this).select2();
	                            if ($(this).val() == 'PL') {
	                                $(this).closest('.row').find('input[data-input="phoneInput"]').mask('000-000-000');
	                            }
	                        });
	                    },
	                    error: function error(jqXHR, textStatus, errorThrown) {
	                        if (jqXHR.status === 401) {
	                            window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                        }
	                    }
	                });
	            } else {
	                if (isSubmit && data["success"]) {
	                    $form.submit();
	                } else {
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	
	// Walidacja pierwszego kroku KTG
	if ($('.p__path--variant_ktg').length || $('.p__path--fifth').length) {
	    $(document).on("change", "form[name='app_ktg_path_first_step']", function (e) {
	        if (e.target.id !== 'app_ktg_path_first_step_promoCode') {
	            var $form = $(this);
	            var $element = $(e.target);
	
	            if (e.target.id.indexOf('app_ktg_path_first_step__ktgPackage_') >= 0) {
	                ktgPathForm($form, $form.serializeArray(), 'app_ktg_path_first_step__ktgPackage', false);
	            } else {
	                ktgPathForm($form, $form.serializeArray(), $element.attr('id'), false);
	            }
	        }
	    });
	
	    $(document).on("click", "#ktg_path_submit", function (e) {
	        var $form = $(this).closest('form');
	
	        ktgPathForm($form, $form.serializeArray(), null, true);
	    });
	
	    $(document).on("click", "#first-step-account-btn", function (e) {
	        var $form = $(this).closest('form');
	
	        accountForm($form, $form.serializeArray(), null, true);
	    });
	
	    $(document).on("click", "#first-step-back-account-btn", function (e) {
	        e.preventDefault();
	
	        var $form = $(this).closest('form');
	
	        $.ajax({
	            url: $form.attr('data-acc-url'),
	            type: "GET",
	            success: function success(data) {
	                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                    if (data["sessionChanged"] === true) {
	                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                    }
	                }
	
	                $('.lightbox_wrapper[indirect-step]').remove();
	                $('body').addClass('unscroll');
	                $(".p__path--variant_ktg").append(data);
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (jqXHR.status === 401) {
	                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                }
	            }
	        });
	    });
	
	    $(document).on("click", "#first-step-login-btn", function (e) {
	        $.ajax({
	            url: Routing.generate('app_ktg_path_first_step_login', { _locale: currentLocale }),
	            type: 'GET',
	            success: function success(data) {
	                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                    if (data["sessionChanged"] === true) {
	                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                    }
	                }
	
	                $('.lightbox_wrapper').remove();
	                $(".p__path--variant_ktg").append(data);
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (jqXHR.status === 401) {
	                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                }
	            }
	        });
	    });
	
	    var isLoggedKtg = false;
	
	    $(document).on("submit", "#first-step-login-form", function (e) {
	        e.preventDefault();
	
	        var $form = $(this).closest('form');
	
	        if (isLoggedKtg === false) {
	            $.ajax({
	                url: $form.attr('action'),
	                type: $form.attr('method'),
	                data: $form.serializeArray(),
	                success: function success(data) {
	                    if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                        if (data["sessionChanged"] === true) {
	                            window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                        }
	                    }
	
	                    if (data.hasOwnProperty('success') && data.hasOwnProperty('errors') && data.hasOwnProperty('errorList')) {
	                        if (data['success'] === false) {
	                            isLoggedKtg = false;
	
	                            formValidation($form.attr('name'), $.parseJSON(data['errorList']), null, false);
	
	                            $(document).find('#invalid-credentials-error').remove();
	
	                            if (data['errors'] !== '') {
	                                $form.before("<div id='invalid-credentials-error' class='errorBar'><p>" + data['errors'] + "</p></div>");
	                            }
	                        } else {
	                            isLoggedKtg = true;
	
	                            if (data.hasOwnProperty('url')) {
	                                window.location.href = Routing.generate(data['url'], { _locale: currentLocale });
	                            } else {
	                                window.location.href = Routing.generate('app_ktg_path_second_step', { _locale: currentLocale });
	                            }
	                        }
	                    }
	                },
	                error: function error(jqXHR, textStatus, errorThrown) {
	                    var data = jqXHR.responseJSON;
	
	                    if (jqXHR.status === 401) {
	                        isLoggedKtg = false;
	
	                        formValidation($form.attr('name'), $.parseJSON(data['errorList']), null, false);
	
	                        $(document).find('#invalid-credentials-error').remove();
	
	                        if (data['errors'] !== '') {
	                            $form.before("<div id='invalid-credentials-error' class='errorBar'><p>" + data['errors'] + "</p></div>");
	                        }
	
	                        // window.location.href = Routing.generate('interactivo_user_security_login', {_locale: currentLocale,});
	                    }
	                },
	                beforeSend: function beforeSend(jqXHR, settings) {
	                    isLoggedKtg = true;
	                }
	            });
	        }
	    });
	
	    var loader = $('.loader');
	
	    var calculateKtgAjax = function calculateKtgAjax($form, callback) {
	        if (jqxhr) {
	            jqxhr.abort();
	        }
	        loader.fadeIn(100);
	        jqxhr = $.ajax({
	            url: $form.attr('data-calc-url'),
	            type: "POST",
	            data: $form.serialize(),
	            success: function success(data) {
	                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                    if (data["sessionChanged"] === true) {
	                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                    }
	                }
	
	                // ceny
	                for (var propPackage in data.packages) {
	                    if (propPackage === data.selected) {
	                        if (data.packages[propPackage].fees.hasOwnProperty('base_ktg')) {
	                            for (var propKtg in data.packages[propPackage].fees.base_ktg['client_price']) {
	                                $("#base_ktg_" + propKtg.replace(".", "\\.")).html(data.packages[propPackage].fees.base_ktg['client_price'][propKtg] / 100 + ' euro');
	                                $("[data='" + propKtg.replace(".", "\\.") + "']").attr('dataPrice', data.packages[propPackage].fees.base_ktg['client_price'][propKtg] / 100).trigger("ktgPriceChange");
	                            }
	                        }
	                    }
	                }
	
	                if (data.hasOwnProperty('discounts')) {
	                    if (data['discounts']['type'] === 'code') {
	                        $("#discount-checked").addClass('active').html('Aktywowałeś kod promocyjny');
	                    }
	                }
	
	                if (data.hasOwnProperty('discounts')) {
	                    if (data['discounts']['error'] === false && data['discounts']['success'] === true) {
	                        $(".expire-date").removeClass('active');
	                    } else if (data['discounts']['error'] === true && data['discounts']['success'] === false) {
	                        if (data['discounts'].hasOwnProperty('message')) {
	                            $(".expire-date").html(data['discounts']['message']);
	                        } else {
	                            $(".expire-date").html('Podany kod stracił ważność');
	                        }
	                    } else {
	                        $(".expire-date").removeClass('active');
	                    }
	                } else {
	                    $(".expire-date").removeClass('active');
	                }
	
	                loader.fadeOut(100);
	
	                // callback($form);
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (jqXHR.status === 401) {
	                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                }
	            }
	        });
	        return jqxhr;
	    };
	}
	
	// Walidacja drugiego kroku KTG
	if ($('.p__path-ktg--second').length) {
	    $(document).on("change", "form[name='app_ktg_path_second_step']", function (e) {
	        var $form = $(this);
	        var $element = $(e.target);
	        var ids = [];
	        var allEmpty = true;
	
	        var loader = $('.loader');
	
	        if (e.target.id.indexOf('app_ktg_path_second_step_pregnancyData_authorizedPeople_') >= 0) {
	            $(document).find('input[id^=app_ktg_path_second_step_pregnancyData_authorizedPeople_' + $element.attr('loop-index') + ']').each(function () {
	                if ($(this).val() !== '') {
	                    allEmpty = false;
	                }
	            });
	
	            $(document).find('input[id^=app_ktg_path_second_step_pregnancyData_authorizedPeople_' + $element.attr('loop-index') + ']').each(function () {
	                if (allEmpty === true) {
	                    ids.push($(this).attr('id'));
	                } else {
	                    if ($element.attr('id') === $(this).attr('id')) {
	                        ids.push($(this).attr('id'));
	                    } else {
	                        if ($(this).val() !== '') {
	                            ids.push($(this).attr('id'));
	                        }
	                    }
	                }
	            });
	
	            ktgPathForm($form, $form.serializeArray(), ids, false);
	        } else if ($element.attr('id') === 'app_ktg_path_second_step_isKtgDevice') {
	            $('.ktgCont .loader').fadeIn(300);
	            $.when($.ajax({
	                url: $form.attr('action') + '?chanktgd=true',
	                type: $form.attr('method'),
	                data: $form.serializeArray(),
	                success: function success(html) {
	
	                    $('#ktgAddress').replaceWith($(html).find('#ktgAddress'));
	                    $('#ktgAddress').find('input').each(function () {
	                        $(this).val('');
	                    });
	                    $('#ktgAddress .countrySelect').select2();
	                    $('.ktgCont .loader').fadeOut(300);
	                },
	                error: function error(jqXHR, textStatus, errorThrown) {
	                    if (jqXHR.status === 401) {
	                        window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                    }
	                }
	            })).done(function () {
	                ktgPathForm($form, $form.serializeArray(), $element.attr('id'), false);
	            });
	        } else {
	            ktgPathForm($form, $form.serializeArray(), $element.attr('id'), false);
	        }
	
	        if ($element.attr('id') === 'app_ktg_path_second_step_pregnancyData_dateOfBirth') {
	            var ktgEnd = new Date('2018-08-31');
	            var selected = new Date($element.val());
	            var isKtgAttr = parseInt($element.attr('data-is-ktg'));
	
	            if (isKtgAttr === 1) {
	                if (selected.getTime() > ktgEnd.getTime()) {
	                    toastr.error(jsTranslations['messages']['birthdate_before_only']);
	                }
	            }
	        }
	    });
	
	    $(document).on("click", "#ktg_path_submit", function (e) {
	        var $form = $(this).closest('form');
	
	        ktgPathForm($form, $form.serializeArray(), null, true);
	    });
	}
	
	// Walidacja trzeciego kroku KTG
	if ($('.p__path-ktg--third').length) {
	    $(document).on("change", "form[name='app_ktg_path_third_step']", function (e) {
	        var $form = $(this);
	        var $element = $(e.target);
	
	        if (e.target.id.indexOf('app_ktg_path_third_step_paymentMethod_') >= 0) {
	            ktgPathForm($form, $form.serializeArray(), 'app_ktg_path_third_step_paymentMethod', false);
	        }
	    });
	
	    $(document).on("click", "#ktg_path_submit", function (e) {
	        var $form = $(this).closest('form');
	
	        ktgPathForm($form, $form.serializeArray(), null, true);
	    });
	}
	
	var jqxhr_ucef;
	var iactUserChangeEmailForm = function iactUserChangeEmailForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_ucef) {
	        jqxhr_ucef.abort();
	    }
	    jqxhr_ucef = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
	                auth(data['mfaUrl']);
	            } else {
	                if (isSubmit && data["success"]) {
	                    $form.submit();
	                } else {
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	
	var jqxhr_ucpf;
	var iactUserChangePasswordForm = function iactUserChangePasswordForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_ucpf) {
	        jqxhr_ucpf.abort();
	    }
	    jqxhr_ucpf = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
	                auth(data['mfaUrl']);
	            } else {
	                if (isSubmit && data["success"]) {
	                    $form.submit();
	                } else {
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	
	var jqxhr_ucpnf;
	var iactUserChangePhoneNumberForm = function iactUserChangePhoneNumberForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_ucpnf) {
	        jqxhr_ucpnf.abort();
	    }
	    jqxhr_ucpnf = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
	                auth(data['mfaUrl']);
	            } else {
	                if (isSubmit && data["success"]) {
	                    $form.submit();
	                } else {
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	
	var jqxhr_uccf;
	var iactUserChangeContactForm = function iactUserChangeContactForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_uccf) {
	        jqxhr_uccf.abort();
	    }
	    jqxhr_uccf = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
	                auth(data['mfaUrl']);
	            } else {
	                if (isSubmit && data["success"]) {
	                    $form.submit();
	                } else {
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	
	var jqxhr_iuccf;
	var iactUserContractChildForm = function iactUserContractChildForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_iuccf) {
	        jqxhr_iuccf.abort();
	    }
	    jqxhr_iuccf = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
	                auth(data['mfaUrl']);
	            } else {
	                if (isSubmit && data["success"]) {
	                    $form.submit();
	                } else {
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	
	var jqxhr_iucccf;
	var iactUserContractChildChangeForm = function iactUserContractChildChangeForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_iucccf) {
	        jqxhr_iucccf.abort();
	    }
	    jqxhr_iucccf = $.ajax({
	        url: $form.attr('action') + '?cNoPesel=true',
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            $form.find('div[data-pesel="true"]').replaceWith($(data).find('div[data-pesel="true"]'));
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	
	var jqxhr_iuddf;
	var iactUserDocumentDownloadForm = function iactUserDocumentDownloadForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_iuddf) {
	        jqxhr_iuddf.abort();
	    }
	    jqxhr_iuddf = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
	                auth(data['mfaUrl']);
	            } else {
	                if (isSubmit && data["success"]) {
	                    $form.submit();
	                } else {
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	
	// Walidacja ustawień klienta
	if ($('.tile.settings').length) {
	    // Walidacja zmiany emaila
	    $(document).on("click", "#iact_user_change_email_submit", function (e) {
	        var $form = $(this).closest('form');
	        iactUserChangeEmailForm($form, $form.serializeArray(), null, true);
	    });
	    $(document).find("form[name='iact_user_change_email']").keypress(function (e) {
	        if (e.which == '13') {
	            e.preventDefault();
	
	            var $form = $(document).find("form[name='iact_user_change_email']");
	            iactUserChangeEmailForm($form, $form.serializeArray(), null, true);
	        }
	    });
	
	    // Walidacja zmiany hasła
	    $(document).on("change", "form[name='iact_user_change_password']", function (e) {
	        var $form = $(this);
	        var $element = $(e.target);
	        var ids = [];
	
	        if ($element.attr('id').indexOf('currentPassword') !== -1) {
	            iactUserChangePasswordForm($form, $form.serializeArray(), $element.attr('id'), false);
	        } else {
	            if ($element.attr('id').indexOf('first') === -1) {
	                if ($('#' + $element.attr('id')).val() !== '') {
	                    ids.push($element.attr('id'));
	                }
	
	                if ($('#' + $element.attr('id').slice(0, -6) + 'first').val() !== '') {
	                    ids.push($element.attr('id').slice(0, -6) + 'first');
	                }
	            } else {
	                if ($('#' + $element.attr('id')).val() !== '') {
	                    ids.push($element.attr('id'));
	                }
	
	                if ($('#' + $element.attr('id').slice(0, -5) + 'second').val() !== '') {
	                    ids.push($element.attr('id').slice(0, -5) + 'second');
	                }
	            }
	
	            if (ids.length === 2) {
	                iactUserChangePasswordForm($form, $form.serializeArray(), ids, false);
	            }
	        }
	    });
	    $(document).on("click", "#iact_user_change_password_submit", function (e) {
	        var $form = $(this).closest('form');
	        iactUserChangePasswordForm($form, $form.serializeArray(), null, true);
	    });
	
	    // Walidacja zmiany numeru telefonu
	    $(document).on("click", "#iact_user_change_phone_number_submit", function (e) {
	        var $form = $(this).closest('form');
	        iactUserChangePhoneNumberForm($form, $form.serializeArray(), null, true);
	    });
	    $(document).find("form[name='change_phone_number']").keypress(function (e) {
	        if (e.which == '13') {
	            e.preventDefault();
	
	            var $form = $(document).find("form[name='change_phone_number']");
	            iactUserChangePhoneNumberForm($form, $form.serializeArray(), null, true);
	        }
	    });
	}
	
	if ($('.p__dashboard').length) {
	    // Walidacja zmiany danych kontaktowych
	    $(document).on("change", "form[name='app_account_contact']", function (e) {
	        var $form = $(this);
	        if (e.target.id.indexOf('_phoneNumber_country') >= 0) {
	            iactUserChangeContactForm($form, $form.serializeArray(), e.target.id.replace('_phoneNumber_country', '_phoneNumber_number'), false);
	        } else {
	            iactUserChangeContactForm($form, $form.serializeArray(), e.target.id, false);
	        }
	    });
	    $(document).on("click", "#iact_user_change_contact_submit", function (e) {
	        var $form = $(this).closest('form');
	        iactUserChangeContactForm($form, $form.serializeArray(), null, true);
	    });
	
	    // Walidacja zmiany danych dziecka
	    $(document).on("click", "#iact_user_contract_child_submit", function (e) {
	        var $form = $(this).closest('form');
	        iactUserContractChildForm($form, $form.serializeArray(), null, true);
	    });
	    $(document).on("change", 'form[name="app_account_child"]', function (e) {
	        var $form = $(this).closest('form');
	
	        if (e.target.id === 'app_account_child_noPesel') {
	            iactUserContractChildChangeForm($form, $form.serializeArray(), null, true);
	        }
	    });
	
	    $(document).on("click", "button[data-doc-down-sec='true']", function (e) {
	        var $form = $(this).closest('form');
	        iactUserDocumentDownloadForm($form, $form.serializeArray(), null, true);
	    });
	}
	
	function auth(url) {
	    $.ajax({
	        url: url,
	        type: "GET",
	        success: function success(data, textStatus, jqXHR) {
	            $("#mfa").html(data);
	            $("#mfa").find("form[name='iact_core_mfa']").keypress(function (e) {
	                if (e.which == '13') {
	                    e.preventDefault();
	
	                    var $form = $("#mfa").find("form[name='iact_core_mfa']");
	
	                    iactCoreMfaForm($form, $form.serializeArray(), null, $form.attr('data-form'));
	                }
	            });
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	}
	
	var jqxhr_icmlf;
	var iactCoreMfaLoginForm = function iactCoreMfaLoginForm($form, params, fieldId) {
	    if (jqxhr_icmlf) {
	        jqxhr_icmlf.abort();
	    }
	    jqxhr_icmlf = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (data.hasOwnProperty("success") && data["success"] === true) {
	                $form.submit();
	            } else {
	                formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, false);
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	
	$(document).on("click", "#iact_core_mfa_login_submit", function (event) {
	    var $form = $(this).closest('form');
	
	    iactCoreMfaLoginForm($form, $form.serializeArray(), null);
	});
	
	var jqxhr_icmf;
	var iactCoreMfaForm = function iactCoreMfaForm($form, params, fieldId, formId) {
	    if (jqxhr_icmf) {
	        jqxhr_icmf.abort();
	    }
	    jqxhr_icmf = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (data.hasOwnProperty("success") && data["success"] === true) {
	                if ($(document).find('div[data-results-page="true"]').length > 0) {
	                    $('.lightbox_wrapper').remove();
	                    toastr.info(jsTranslations['messages']['collection_started']);
	                }
	
	                $("#" + formId).submit();
	            } else {
	                formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, false);
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	
	$(document).on("click", "#iact_core_mfa_submit", function (event) {
	    var $form = $(this).closest('form');
	
	    iactCoreMfaForm($form, $form.serializeArray(), null, $form.attr('data-form'));
	});
	
	$(document).find("form[name='iact_core_mfa']").keypress(function (e) {
	    if (e.which == '13') {
	        e.preventDefault();
	
	        var $form = $(this).closest('form');
	
	        iactCoreMfaLoginForm($form, $form.serializeArray(), null);
	    }
	});
	
	var jqxhr_iprpf;
	var iactPartnerRegistrationPasswordForm = function iactPartnerRegistrationPasswordForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_iprpf) {
	        jqxhr_iprpf.abort();
	    }
	    jqxhr_iprpf = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
	                auth(data['mfaUrl']);
	            } else {
	                if (isSubmit && data["success"]) {
	                    $form.submit();
	                } else {
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_partner_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	$(document).on("change", "form[name='iact_partner_registration_password']", function (e) {
	    var $form = $(this);
	    var $element = $(e.target);
	    var ids = [];
	
	    if ($element.attr('id').indexOf('first') === -1) {
	        if ($('#' + $element.attr('id')).val() !== '') {
	            ids.push($element.attr('id'));
	        }
	
	        if ($('#' + $element.attr('id').slice(0, -6) + 'first').val() !== '') {
	            ids.push($element.attr('id').slice(0, -6) + 'first');
	        }
	    } else {
	        if ($('#' + $element.attr('id')).val() !== '') {
	            ids.push($element.attr('id'));
	        }
	
	        if ($('#' + $element.attr('id').slice(0, -5) + 'second').val() !== '') {
	            ids.push($element.attr('id').slice(0, -5) + 'second');
	        }
	    }
	
	    if (ids.length === 2) {
	        iactPartnerRegistrationPasswordForm($form, $form.serializeArray(), ids, false);
	    }
	});
	$(document).on("click", "#iact_partner_registration_password_submit", function (e) {
	    var $form = $(this).closest('form');
	
	    iactPartnerRegistrationPasswordForm($form, $form.serializeArray(), null, true);
	});
	
	var jqxhr_iprrf;
	var iactPartnerResetRequestForm = function iactPartnerResetRequestForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_iprrf) {
	        jqxhr_iprrf.abort();
	    }
	    jqxhr_iprrf = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
	                auth(data['mfaUrl']);
	            } else {
	                if (isSubmit && data["success"]) {
	                    $form.submit();
	                } else {
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_partner_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	$(document).on("change", "form[name='iact_partner_resetting_request']", function (e) {
	    var $form = $(this).closest('form');
	
	    iactPartnerResetRequestForm($form, $form.serializeArray(), e.target.id, false);
	});
	$(document).on("click", "#iact_partner_reset_request_submit", function (e) {
	    var $form = $(this).closest('form');
	
	    iactPartnerResetRequestForm($form, $form.serializeArray(), null, true);
	});
	$(document).find("form[name='iact_partner_resetting_request']").keypress(function (e) {
	    if (e.which == '13') {
	        e.preventDefault();
	
	        var $form = $(this).closest('form');
	
	        iactPartnerResetRequestForm($form, $form.serializeArray(), null, true);
	    }
	});
	
	var jqxhr_iprspf;
	var iactPartnerResetPasswordForm = function iactPartnerResetPasswordForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_iprspf) {
	        jqxhr_iprspf.abort();
	    }
	    jqxhr_iprspf = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
	                auth(data['mfaUrl']);
	            } else {
	                if (isSubmit && data["success"]) {
	                    $form.submit();
	                } else {
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_partner_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	$(document).on("change", "form[name='iact_partner_resetting_password']", function (e) {
	    var $form = $(this).closest('form');
	    var $element = $(e.target);
	    var ids = [];
	
	    if ($element.attr('id').indexOf('first') === -1) {
	        if ($('#' + $element.attr('id')).val() !== '') {
	            ids.push($element.attr('id'));
	        }
	
	        if ($('#' + $element.attr('id').slice(0, -6) + 'first').val() !== '') {
	            ids.push($element.attr('id').slice(0, -6) + 'first');
	        }
	    } else {
	        if ($('#' + $element.attr('id')).val() !== '') {
	            ids.push($element.attr('id'));
	        }
	
	        if ($('#' + $element.attr('id').slice(0, -5) + 'second').val() !== '') {
	            ids.push($element.attr('id').slice(0, -5) + 'second');
	        }
	    }
	
	    if (ids.length === 2) {
	        iactPartnerResetPasswordForm($form, $form.serializeArray(), ids, false);
	    }
	});
	$(document).on("click", "#iact_partner_reset_password_submit", function (e) {
	    var $form = $(this).closest('form');
	
	    iactPartnerResetPasswordForm($form, $form.serializeArray(), null, true);
	});
	
	var jqxhr_iurpf;
	var iactUserRegistrationPasswordForm = function iactUserRegistrationPasswordForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_iurpf) {
	        jqxhr_iurpf.abort();
	    }
	    jqxhr_iurpf = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
	                auth(data['mfaUrl']);
	            } else {
	                if (isSubmit && data["success"]) {
	                    $form.submit();
	                } else {
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	$(document).on("change", "form[name='iact_user_registration_password']", function (e) {
	    var $form = $(this);
	    var $element = $(e.target);
	    var ids = [];
	
	    if ($element.attr('id').indexOf('first') === -1) {
	        if ($('#' + $element.attr('id')).val() !== '') {
	            ids.push($element.attr('id'));
	        }
	
	        if ($('#' + $element.attr('id').slice(0, -6) + 'first').val() !== '') {
	            ids.push($element.attr('id').slice(0, -6) + 'first');
	        }
	    } else {
	        if ($('#' + $element.attr('id')).val() !== '') {
	            ids.push($element.attr('id'));
	        }
	
	        if ($('#' + $element.attr('id').slice(0, -5) + 'second').val() !== '') {
	            ids.push($element.attr('id').slice(0, -5) + 'second');
	        }
	    }
	
	    if (ids.length === 2) {
	        iactUserRegistrationPasswordForm($form, $form.serializeArray(), ids, false);
	    }
	});
	$(document).on("click", "#iact_user_registration_password_submit", function (e) {
	    var $form = $(this).closest('form');
	
	    iactUserRegistrationPasswordForm($form, $form.serializeArray(), null, true);
	});
	
	var jqxhr_iursrf;
	var iactUserResetRequestForm = function iactUserResetRequestForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_iursrf) {
	        jqxhr_iursrf.abort();
	    }
	    jqxhr_iursrf = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
	                auth(data['mfaUrl']);
	            } else {
	                if (isSubmit && data["success"]) {
	                    $form.submit();
	                } else {
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	$(document).on("change", "form[name='iact_user_resetting_request']", function (e) {
	    var $form = $(this);
	
	    iactUserResetRequestForm($form, $form.serializeArray(), e.target.id, false);
	});
	$(document).on("click", "#iact_user_reset_request_submit", function (e) {
	    var $form = $(this).closest('form');
	
	    iactUserResetRequestForm($form, $form.serializeArray(), null, true);
	});
	$(document).find("form[name='iact_user_resetting_request']").keypress(function (e) {
	    if (e.which == '13') {
	        e.preventDefault();
	
	        var $form = $(this).closest('form');
	
	        iactUserResetRequestForm($form, $form.serializeArray(), null, true);
	    }
	});
	
	var jqxhr_iuopof;
	var iactUserOfferPathOrderForm = function iactUserOfferPathOrderForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_iuopof) {
	        jqxhr_iuopof.abort();
	    }
	    jqxhr_iuopof = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
	                auth(data['mfaUrl']);
	            } else {
	                if (isSubmit && data["success"]) {
	                    $form.submit();
	                } else {
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	$(document).on("click", "#iact_user_offer_path_order_submit", function (e) {
	    var $form = $(this).closest('form');
	
	    iactUserOfferPathOrderForm($form, $form.serializeArray(), "interactivo_path_order_pathOrder", true);
	});
	
	var jqxhr_iurspf;
	var iactUserResetPasswordForm = function iactUserResetPasswordForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_iurspf) {
	        jqxhr_iurspf.abort();
	    }
	    jqxhr_iurspf = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
	                auth(data['mfaUrl']);
	            } else {
	                if (isSubmit && data["success"]) {
	                    $form.submit();
	                } else {
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	$(document).on("change", "form[name='iact_user_resetting_password']", function (e) {
	    var $form = $(this);
	    var $element = $(e.target);
	    var ids = [];
	
	    if ($element.attr('id').indexOf('first') === -1) {
	        if ($('#' + $element.attr('id')).val() !== '') {
	            ids.push($element.attr('id'));
	        }
	
	        if ($('#' + $element.attr('id').slice(0, -6) + 'first').val() !== '') {
	            ids.push($element.attr('id').slice(0, -6) + 'first');
	        }
	    } else {
	        if ($('#' + $element.attr('id')).val() !== '') {
	            ids.push($element.attr('id'));
	        }
	
	        if ($('#' + $element.attr('id').slice(0, -5) + 'second').val() !== '') {
	            ids.push($element.attr('id').slice(0, -5) + 'second');
	        }
	    }
	
	    if (ids.length === 2) {
	        iactUserResetPasswordForm($form, $form.serializeArray(), ids, false);
	    }
	});
	$(document).on("click", "#iact_user_reset_password_submit", function (e) {
	    var $form = $(this).closest('form');
	
	    iactUserResetPasswordForm($form, $form.serializeArray(), null, true);
	});
	
	var jqxhr_ipof;
	var iactPartnerOfferForm = function iactPartnerOfferForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_ipof) {
	        jqxhr_ipof.abort();
	    }
	    jqxhr_ipof = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
	                auth(data['mfaUrl']);
	            } else {
	                if (isSubmit && data["success"]) {
	                    $form.submit();
	                } else {
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_partner_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	// Walidacja wyszukiwania ofert w panelu partnera
	if ($('.p__dashboard--tiles').length) {
	    $(document).on("change", "form[name='interactivo_partner_offer']", function (e) {
	        var $form = $(this);
	        var $element = $(e.target);
	
	        iactPartnerOfferForm($form, $form.serializeArray(), $element.attr('id'), false);
	    });
	
	    $(document).on("click", "#iact_partner_offer_list_submit", function (e) {
	        var $form = $(this).closest('form');
	
	        iactPartnerOfferForm($form, $form.serializeArray(), null, true);
	    });
	
	    $(document).find("form[name='interactivo_partner_offer']").keypress(function (e) {
	        if (e.which == '13') {
	            e.preventDefault();
	
	            var $form = $(this).closest('form');
	
	            iactPartnerOfferForm($form, $form.serializeArray(), null, true);
	        }
	    });
	}
	
	var jqxhr_ipopof;
	var iactPartnerOfferPathOrderForm = function iactPartnerOfferPathOrderForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_ipopof) {
	        jqxhr_ipopof.abort();
	    }
	    jqxhr_ipopof = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
	                auth(data['mfaUrl']);
	            } else {
	                if (isSubmit && data["success"]) {
	                    $form.submit();
	                } else {
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_partner_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	if ($('.p__dashboard--tiles').length) {
	    $(document).on("click", "#iact_partner_offer_path_order_submit", function (e) {
	        var $form = $(this).closest('form');
	
	        iactPartnerOfferPathOrderForm($form, $form.serializeArray(), "interactivo_path_order_pathOrder", true);
	    });
	}
	
	if ($('.submit_foot').length) {
	    $(document).on("click", "#clear-conversion-path-order", function (e) {
	        $.ajax({
	            url: Routing.generate('app_conversion_path_clear', { _locale: currentLocale }),
	            type: 'GET',
	            success: function success(data) {
	                if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                    if (data["sessionChanged"] === true) {
	                        window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                    }
	                }
	
	                $('.lightbox_wrapper[indirect-step]').remove();
	                $('body').addClass('unscroll');
	                $("body").append(data);
	            },
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (jqXHR.status === 401) {
	                    window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	                }
	            }
	        });
	    });
	}
	
	var jqxhr_icif;
	var iactClientInvoicesForm = function iactClientInvoicesForm($form, params, fieldId, isSubmit) {
	    if (jqxhr_icif) {
	        jqxhr_icif.abort();
	    }
	    jqxhr_icif = $.ajax({
	        url: $form.attr('action'),
	        type: $form.attr('method'),
	        data: params,
	        success: function success(data) {
	            if (data.hasOwnProperty('success') && data.hasOwnProperty('sessionChanged')) {
	                if (data["sessionChanged"] === true) {
	                    window.location.href = Routing.generate('app_lost_session', { _locale: currentLocale });
	                }
	            }
	
	            if (isSubmit && data.hasOwnProperty('mfaUrl') && data['mfaUrl'] !== null) {
	                auth(data['mfaUrl']);
	            } else {
	                if (isSubmit && data["success"]) {
	                    $form.submit();
	                } else {
	                    formValidation($form.attr("name"), $.parseJSON(data["errorList"]), fieldId, isSubmit);
	                }
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 401) {
	                window.location.href = Routing.generate('interactivo_user_security_login', { _locale: currentLocale });
	            }
	        }
	    });
	};
	if ($('.p__dashboard--documentList').length) {
	    $(document).on("click", "#iact-client-invoices-submit", function (e) {
	        var $form = $(this).closest('form');
	
	        iactClientInvoicesForm($form, $form.serializeArray(), null, true);
	    });
	}
	
	$(document).ready(function () {
	    if ($('form.force-uncheck').length) {
	        formForceUncheck();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * Select2 4.0.6-rc.1
	 * https://select2.github.io
	 *
	 * Released under the MIT license
	 * https://github.com/select2/select2/blob/master/LICENSE.md
	 */
	;(function (factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
	    // Node/CommonJS
	    module.exports = function (root, jQuery) {
	      if (jQuery === undefined) {
	        // require('jQuery') returns a factory that requires window to
	        // build a jQuery instance, we normalize how we use modules
	        // that require this pattern but the window provided is a noop
	        // if it's defined (how jquery works)
	        if (typeof window !== 'undefined') {
	          jQuery = require('jquery');
	        } else {
	          jQuery = require('jquery')(root);
	        }
	      }
	      factory(jQuery);
	      return jQuery;
	    };
	  } else {
	    // Browser globals
	    factory(jQuery);
	  }
	})(function (jQuery) {
	  // This is needed so we can catch the AMD loader configuration and use it
	  // The inner file should be wrapped (by `banner.start.js`) in a function that
	  // returns the AMD loader references.
	  var S2 = function () {
	    // Restore the Select2 AMD loader so it can be used
	    // Needed mostly in the language files, where the loader is not inserted
	    if (jQuery && jQuery.fn && jQuery.fn.select2 && jQuery.fn.select2.amd) {
	      var S2 = jQuery.fn.select2.amd;
	    }
	    var S2;(function () {
	      if (!S2 || !S2.requirejs) {
	        if (!S2) {
	          S2 = {};
	        } else {
	          require = S2;
	        }
	        /**
	         * @license almond 0.3.3 Copyright jQuery Foundation and other contributors.
	         * Released under MIT license, http://github.com/requirejs/almond/LICENSE
	         */
	        //Going sloppy to avoid 'use strict' string cost, but strict practices should
	        //be followed.
	        /*global setTimeout: false */
	
	        var requirejs, require, define;
	        (function (undef) {
	          var main,
	              _req,
	              makeMap,
	              handlers,
	              defined = {},
	              waiting = {},
	              config = {},
	              defining = {},
	              hasOwn = Object.prototype.hasOwnProperty,
	              aps = [].slice,
	              jsSuffixRegExp = /\.js$/;
	
	          function hasProp(obj, prop) {
	            return hasOwn.call(obj, prop);
	          }
	
	          /**
	           * Given a relative module name, like ./something, normalize it to
	           * a real name that can be mapped to a path.
	           * @param {String} name the relative name
	           * @param {String} baseName a real name that the name arg is relative
	           * to.
	           * @returns {String} normalized name
	           */
	          function normalize(name, baseName) {
	            var nameParts,
	                nameSegment,
	                mapValue,
	                foundMap,
	                lastIndex,
	                foundI,
	                foundStarMap,
	                starI,
	                i,
	                j,
	                part,
	                normalizedBaseParts,
	                baseParts = baseName && baseName.split("/"),
	                map = config.map,
	                starMap = map && map['*'] || {};
	
	            //Adjust any relative paths.
	            if (name) {
	              name = name.split('/');
	              lastIndex = name.length - 1;
	
	              // If wanting node ID compatibility, strip .js from end
	              // of IDs. Have to do this here, and not in nameToUrl
	              // because node allows either .js or non .js to map
	              // to same file.
	              if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
	                name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
	              }
	
	              // Starts with a '.' so need the baseName
	              if (name[0].charAt(0) === '.' && baseParts) {
	                //Convert baseName to array, and lop off the last part,
	                //so that . matches that 'directory' and not name of the baseName's
	                //module. For instance, baseName of 'one/two/three', maps to
	                //'one/two/three.js', but we want the directory, 'one/two' for
	                //this normalization.
	                normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
	                name = normalizedBaseParts.concat(name);
	              }
	
	              //start trimDots
	              for (i = 0; i < name.length; i++) {
	                part = name[i];
	                if (part === '.') {
	                  name.splice(i, 1);
	                  i -= 1;
	                } else if (part === '..') {
	                  // If at the start, or previous value is still ..,
	                  // keep them so that when converted to a path it may
	                  // still work when converted to a path, even though
	                  // as an ID it is less than ideal. In larger point
	                  // releases, may be better to just kick out an error.
	                  if (i === 0 || i === 1 && name[2] === '..' || name[i - 1] === '..') {
	                    continue;
	                  } else if (i > 0) {
	                    name.splice(i - 1, 2);
	                    i -= 2;
	                  }
	                }
	              }
	              //end trimDots
	
	              name = name.join('/');
	            }
	
	            //Apply map config if available.
	            if ((baseParts || starMap) && map) {
	              nameParts = name.split('/');
	
	              for (i = nameParts.length; i > 0; i -= 1) {
	                nameSegment = nameParts.slice(0, i).join("/");
	
	                if (baseParts) {
	                  //Find the longest baseName segment match in the config.
	                  //So, do joins on the biggest to smallest lengths of baseParts.
	                  for (j = baseParts.length; j > 0; j -= 1) {
	                    mapValue = map[baseParts.slice(0, j).join('/')];
	
	                    //baseName segment has  config, find if it has one for
	                    //this name.
	                    if (mapValue) {
	                      mapValue = mapValue[nameSegment];
	                      if (mapValue) {
	                        //Match, update name to the new value.
	                        foundMap = mapValue;
	                        foundI = i;
	                        break;
	                      }
	                    }
	                  }
	                }
	
	                if (foundMap) {
	                  break;
	                }
	
	                //Check for a star map match, but just hold on to it,
	                //if there is a shorter segment match later in a matching
	                //config, then favor over this star map.
	                if (!foundStarMap && starMap && starMap[nameSegment]) {
	                  foundStarMap = starMap[nameSegment];
	                  starI = i;
	                }
	              }
	
	              if (!foundMap && foundStarMap) {
	                foundMap = foundStarMap;
	                foundI = starI;
	              }
	
	              if (foundMap) {
	                nameParts.splice(0, foundI, foundMap);
	                name = nameParts.join('/');
	              }
	            }
	
	            return name;
	          }
	
	          function makeRequire(relName, forceSync) {
	            return function () {
	              //A version of a require function that passes a moduleName
	              //value for items that may need to
	              //look up paths relative to the moduleName
	              var args = aps.call(arguments, 0);
	
	              //If first arg is not require('string'), and there is only
	              //one arg, it is the array form without a callback. Insert
	              //a null so that the following concat is correct.
	              if (typeof args[0] !== 'string' && args.length === 1) {
	                args.push(null);
	              }
	              return _req.apply(undef, args.concat([relName, forceSync]));
	            };
	          }
	
	          function makeNormalize(relName) {
	            return function (name) {
	              return normalize(name, relName);
	            };
	          }
	
	          function makeLoad(depName) {
	            return function (value) {
	              defined[depName] = value;
	            };
	          }
	
	          function callDep(name) {
	            if (hasProp(waiting, name)) {
	              var args = waiting[name];
	              delete waiting[name];
	              defining[name] = true;
	              main.apply(undef, args);
	            }
	
	            if (!hasProp(defined, name) && !hasProp(defining, name)) {
	              throw new Error('No ' + name);
	            }
	            return defined[name];
	          }
	
	          //Turns a plugin!resource to [plugin, resource]
	          //with the plugin being undefined if the name
	          //did not have a plugin prefix.
	          function splitPrefix(name) {
	            var prefix,
	                index = name ? name.indexOf('!') : -1;
	            if (index > -1) {
	              prefix = name.substring(0, index);
	              name = name.substring(index + 1, name.length);
	            }
	            return [prefix, name];
	          }
	
	          //Creates a parts array for a relName where first part is plugin ID,
	          //second part is resource ID. Assumes relName has already been normalized.
	          function makeRelParts(relName) {
	            return relName ? splitPrefix(relName) : [];
	          }
	
	          /**
	           * Makes a name map, normalizing the name, and using a plugin
	           * for normalization if necessary. Grabs a ref to plugin
	           * too, as an optimization.
	           */
	          makeMap = function makeMap(name, relParts) {
	            var plugin,
	                parts = splitPrefix(name),
	                prefix = parts[0],
	                relResourceName = relParts[1];
	
	            name = parts[1];
	
	            if (prefix) {
	              prefix = normalize(prefix, relResourceName);
	              plugin = callDep(prefix);
	            }
	
	            //Normalize according
	            if (prefix) {
	              if (plugin && plugin.normalize) {
	                name = plugin.normalize(name, makeNormalize(relResourceName));
	              } else {
	                name = normalize(name, relResourceName);
	              }
	            } else {
	              name = normalize(name, relResourceName);
	              parts = splitPrefix(name);
	              prefix = parts[0];
	              name = parts[1];
	              if (prefix) {
	                plugin = callDep(prefix);
	              }
	            }
	
	            //Using ridiculous property names for space reasons
	            return {
	              f: prefix ? prefix + '!' + name : name, //fullName
	              n: name,
	              pr: prefix,
	              p: plugin
	            };
	          };
	
	          function makeConfig(name) {
	            return function () {
	              return config && config.config && config.config[name] || {};
	            };
	          }
	
	          handlers = {
	            require: function require(name) {
	              return makeRequire(name);
	            },
	            exports: function exports(name) {
	              var e = defined[name];
	              if (typeof e !== 'undefined') {
	                return e;
	              } else {
	                return defined[name] = {};
	              }
	            },
	            module: function module(name) {
	              return {
	                id: name,
	                uri: '',
	                exports: defined[name],
	                config: makeConfig(name)
	              };
	            }
	          };
	
	          main = function main(name, deps, callback, relName) {
	            var cjsModule,
	                depName,
	                ret,
	                map,
	                i,
	                relParts,
	                args = [],
	                callbackType = typeof callback === 'undefined' ? 'undefined' : _typeof(callback),
	                usingExports;
	
	            //Use name if no relName
	            relName = relName || name;
	            relParts = makeRelParts(relName);
	
	            //Call the callback to define the module, if necessary.
	            if (callbackType === 'undefined' || callbackType === 'function') {
	              //Pull out the defined dependencies and pass the ordered
	              //values to the callback.
	              //Default to [require, exports, module] if no deps
	              deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
	              for (i = 0; i < deps.length; i += 1) {
	                map = makeMap(deps[i], relParts);
	                depName = map.f;
	
	                //Fast path CommonJS standard dependencies.
	                if (depName === "require") {
	                  args[i] = handlers.require(name);
	                } else if (depName === "exports") {
	                  //CommonJS module spec 1.1
	                  args[i] = handlers.exports(name);
	                  usingExports = true;
	                } else if (depName === "module") {
	                  //CommonJS module spec 1.1
	                  cjsModule = args[i] = handlers.module(name);
	                } else if (hasProp(defined, depName) || hasProp(waiting, depName) || hasProp(defining, depName)) {
	                  args[i] = callDep(depName);
	                } else if (map.p) {
	                  map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
	                  args[i] = defined[depName];
	                } else {
	                  throw new Error(name + ' missing ' + depName);
	                }
	              }
	
	              ret = callback ? callback.apply(defined[name], args) : undefined;
	
	              if (name) {
	                //If setting exports via "module" is in play,
	                //favor that over return value and exports. After that,
	                //favor a non-undefined return value over exports use.
	                if (cjsModule && cjsModule.exports !== undef && cjsModule.exports !== defined[name]) {
	                  defined[name] = cjsModule.exports;
	                } else if (ret !== undef || !usingExports) {
	                  //Use the return value from the function.
	                  defined[name] = ret;
	                }
	              }
	            } else if (name) {
	              //May just be an object definition for the module. Only
	              //worry about defining if have a module name.
	              defined[name] = callback;
	            }
	          };
	
	          requirejs = require = _req = function req(deps, callback, relName, forceSync, alt) {
	            if (typeof deps === "string") {
	              if (handlers[deps]) {
	                //callback in this case is really relName
	                return handlers[deps](callback);
	              }
	              //Just return the module wanted. In this scenario, the
	              //deps arg is the module name, and second arg (if passed)
	              //is just the relName.
	              //Normalize module name, if it contains . or ..
	              return callDep(makeMap(deps, makeRelParts(callback)).f);
	            } else if (!deps.splice) {
	              //deps is a config object, not an array.
	              config = deps;
	              if (config.deps) {
	                _req(config.deps, config.callback);
	              }
	              if (!callback) {
	                return;
	              }
	
	              if (callback.splice) {
	                //callback is an array, which means it is a dependency list.
	                //Adjust args if there are dependencies
	                deps = callback;
	                callback = relName;
	                relName = null;
	              } else {
	                deps = undef;
	              }
	            }
	
	            //Support require(['a'])
	            callback = callback || function () {};
	
	            //If relName is a function, it is an errback handler,
	            //so remove it.
	            if (typeof relName === 'function') {
	              relName = forceSync;
	              forceSync = alt;
	            }
	
	            //Simulate async callback;
	            if (forceSync) {
	              main(undef, deps, callback, relName);
	            } else {
	              //Using a non-zero value because of concern for what old browsers
	              //do, and latest browsers "upgrade" to 4 if lower value is used:
	              //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
	              //If want a value immediately, use require('id') instead -- something
	              //that works in almond on the global level, but not guaranteed and
	              //unlikely to work in other AMD implementations.
	              setTimeout(function () {
	                main(undef, deps, callback, relName);
	              }, 4);
	            }
	
	            return _req;
	          };
	
	          /**
	           * Just drops the config on the floor, but returns req in case
	           * the config return value is used.
	           */
	          _req.config = function (cfg) {
	            return _req(cfg);
	          };
	
	          /**
	           * Expose module registry for debugging and tooling
	           */
	          requirejs._defined = defined;
	
	          define = function define(name, deps, callback) {
	            if (typeof name !== 'string') {
	              throw new Error('See almond README: incorrect module build, no module name');
	            }
	
	            //This module may not have dependencies
	            if (!deps.splice) {
	              //deps is not an array, so probably means
	              //an object literal or factory function for
	              //the value. Adjust args.
	              callback = deps;
	              deps = [];
	            }
	
	            if (!hasProp(defined, name) && !hasProp(waiting, name)) {
	              waiting[name] = [name, deps, callback];
	            }
	          };
	
	          define.amd = {
	            jQuery: true
	          };
	        })();
	
	        S2.requirejs = requirejs;S2.require = require;S2.define = define;
	      }
	    })();
	    S2.define("almond", function () {});
	
	    /* global jQuery:false, $:false */
	    S2.define('jquery', [], function () {
	      var _$ = jQuery || $;
	
	      if (_$ == null && console && console.error) {
	        console.error('Select2: An instance of jQuery or a jQuery-compatible library was not ' + 'found. Make sure that you are including jQuery before Select2 on your ' + 'web page.');
	      }
	
	      return _$;
	    });
	
	    S2.define('select2/utils', ['jquery'], function ($) {
	      var Utils = {};
	
	      Utils.Extend = function (ChildClass, SuperClass) {
	        var __hasProp = {}.hasOwnProperty;
	
	        function BaseConstructor() {
	          this.constructor = ChildClass;
	        }
	
	        for (var key in SuperClass) {
	          if (__hasProp.call(SuperClass, key)) {
	            ChildClass[key] = SuperClass[key];
	          }
	        }
	
	        BaseConstructor.prototype = SuperClass.prototype;
	        ChildClass.prototype = new BaseConstructor();
	        ChildClass.__super__ = SuperClass.prototype;
	
	        return ChildClass;
	      };
	
	      function getMethods(theClass) {
	        var proto = theClass.prototype;
	
	        var methods = [];
	
	        for (var methodName in proto) {
	          var m = proto[methodName];
	
	          if (typeof m !== 'function') {
	            continue;
	          }
	
	          if (methodName === 'constructor') {
	            continue;
	          }
	
	          methods.push(methodName);
	        }
	
	        return methods;
	      }
	
	      Utils.Decorate = function (SuperClass, DecoratorClass) {
	        var decoratedMethods = getMethods(DecoratorClass);
	        var superMethods = getMethods(SuperClass);
	
	        function DecoratedClass() {
	          var unshift = Array.prototype.unshift;
	
	          var argCount = DecoratorClass.prototype.constructor.length;
	
	          var calledConstructor = SuperClass.prototype.constructor;
	
	          if (argCount > 0) {
	            unshift.call(arguments, SuperClass.prototype.constructor);
	
	            calledConstructor = DecoratorClass.prototype.constructor;
	          }
	
	          calledConstructor.apply(this, arguments);
	        }
	
	        DecoratorClass.displayName = SuperClass.displayName;
	
	        function ctr() {
	          this.constructor = DecoratedClass;
	        }
	
	        DecoratedClass.prototype = new ctr();
	
	        for (var m = 0; m < superMethods.length; m++) {
	          var superMethod = superMethods[m];
	
	          DecoratedClass.prototype[superMethod] = SuperClass.prototype[superMethod];
	        }
	
	        var calledMethod = function calledMethod(methodName) {
	          // Stub out the original method if it's not decorating an actual method
	          var originalMethod = function originalMethod() {};
	
	          if (methodName in DecoratedClass.prototype) {
	            originalMethod = DecoratedClass.prototype[methodName];
	          }
	
	          var decoratedMethod = DecoratorClass.prototype[methodName];
	
	          return function () {
	            var unshift = Array.prototype.unshift;
	
	            unshift.call(arguments, originalMethod);
	
	            return decoratedMethod.apply(this, arguments);
	          };
	        };
	
	        for (var d = 0; d < decoratedMethods.length; d++) {
	          var decoratedMethod = decoratedMethods[d];
	
	          DecoratedClass.prototype[decoratedMethod] = calledMethod(decoratedMethod);
	        }
	
	        return DecoratedClass;
	      };
	
	      var Observable = function Observable() {
	        this.listeners = {};
	      };
	
	      Observable.prototype.on = function (event, callback) {
	        this.listeners = this.listeners || {};
	
	        if (event in this.listeners) {
	          this.listeners[event].push(callback);
	        } else {
	          this.listeners[event] = [callback];
	        }
	      };
	
	      Observable.prototype.trigger = function (event) {
	        var slice = Array.prototype.slice;
	        var params = slice.call(arguments, 1);
	
	        this.listeners = this.listeners || {};
	
	        // Params should always come in as an array
	        if (params == null) {
	          params = [];
	        }
	
	        // If there are no arguments to the event, use a temporary object
	        if (params.length === 0) {
	          params.push({});
	        }
	
	        // Set the `_type` of the first object to the event
	        params[0]._type = event;
	
	        if (event in this.listeners) {
	          this.invoke(this.listeners[event], slice.call(arguments, 1));
	        }
	
	        if ('*' in this.listeners) {
	          this.invoke(this.listeners['*'], arguments);
	        }
	      };
	
	      Observable.prototype.invoke = function (listeners, params) {
	        for (var i = 0, len = listeners.length; i < len; i++) {
	          listeners[i].apply(this, params);
	        }
	      };
	
	      Utils.Observable = Observable;
	
	      Utils.generateChars = function (length) {
	        var chars = '';
	
	        for (var i = 0; i < length; i++) {
	          var randomChar = Math.floor(Math.random() * 36);
	          chars += randomChar.toString(36);
	        }
	
	        return chars;
	      };
	
	      Utils.bind = function (func, context) {
	        return function () {
	          func.apply(context, arguments);
	        };
	      };
	
	      Utils._convertData = function (data) {
	        for (var originalKey in data) {
	          var keys = originalKey.split('-');
	
	          var dataLevel = data;
	
	          if (keys.length === 1) {
	            continue;
	          }
	
	          for (var k = 0; k < keys.length; k++) {
	            var key = keys[k];
	
	            // Lowercase the first letter
	            // By default, dash-separated becomes camelCase
	            key = key.substring(0, 1).toLowerCase() + key.substring(1);
	
	            if (!(key in dataLevel)) {
	              dataLevel[key] = {};
	            }
	
	            if (k == keys.length - 1) {
	              dataLevel[key] = data[originalKey];
	            }
	
	            dataLevel = dataLevel[key];
	          }
	
	          delete data[originalKey];
	        }
	
	        return data;
	      };
	
	      Utils.hasScroll = function (index, el) {
	        // Adapted from the function created by @ShadowScripter
	        // and adapted by @BillBarry on the Stack Exchange Code Review website.
	        // The original code can be found at
	        // http://codereview.stackexchange.com/q/13338
	        // and was designed to be used with the Sizzle selector engine.
	
	        var $el = $(el);
	        var overflowX = el.style.overflowX;
	        var overflowY = el.style.overflowY;
	
	        //Check both x and y declarations
	        if (overflowX === overflowY && (overflowY === 'hidden' || overflowY === 'visible')) {
	          return false;
	        }
	
	        if (overflowX === 'scroll' || overflowY === 'scroll') {
	          return true;
	        }
	
	        return $el.innerHeight() < el.scrollHeight || $el.innerWidth() < el.scrollWidth;
	      };
	
	      Utils.escapeMarkup = function (markup) {
	        var replaceMap = {
	          '\\': '&#92;',
	          '&': '&amp;',
	          '<': '&lt;',
	          '>': '&gt;',
	          '"': '&quot;',
	          '\'': '&#39;',
	          '/': '&#47;'
	        };
	
	        // Do not try to escape the markup if it's not a string
	        if (typeof markup !== 'string') {
	          return markup;
	        }
	
	        return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
	          return replaceMap[match];
	        });
	      };
	
	      // Append an array of jQuery nodes to a given element.
	      Utils.appendMany = function ($element, $nodes) {
	        // jQuery 1.7.x does not support $.fn.append() with an array
	        // Fall back to a jQuery object collection using $.fn.add()
	        if ($.fn.jquery.substr(0, 3) === '1.7') {
	          var $jqNodes = $();
	
	          $.map($nodes, function (node) {
	            $jqNodes = $jqNodes.add(node);
	          });
	
	          $nodes = $jqNodes;
	        }
	
	        $element.append($nodes);
	      };
	
	      // Cache objects in Utils.__cache instead of $.data (see #4346)
	      Utils.__cache = {};
	
	      var id = 0;
	      Utils.GetUniqueElementId = function (element) {
	        // Get a unique element Id. If element has no id,
	        // creates a new unique number, stores it in the id
	        // attribute and returns the new id.
	        // If an id already exists, it simply returns it.
	
	        var select2Id = element.getAttribute('data-select2-id');
	        if (select2Id == null) {
	          // If element has id, use it.
	          if (element.id) {
	            select2Id = element.id;
	            element.setAttribute('data-select2-id', select2Id);
	          } else {
	            element.setAttribute('data-select2-id', ++id);
	            select2Id = id.toString();
	          }
	        }
	        return select2Id;
	      };
	
	      Utils.StoreData = function (element, name, value) {
	        // Stores an item in the cache for a specified element.
	        // name is the cache key.
	        var id = Utils.GetUniqueElementId(element);
	        if (!Utils.__cache[id]) {
	          Utils.__cache[id] = {};
	        }
	
	        Utils.__cache[id][name] = value;
	      };
	
	      Utils.GetData = function (element, name) {
	        // Retrieves a value from the cache by its key (name)
	        // name is optional. If no name specified, return
	        // all cache items for the specified element.
	        // and for a specified element.
	        var id = Utils.GetUniqueElementId(element);
	        if (name) {
	          if (Utils.__cache[id]) {
	            return Utils.__cache[id][name] != null ? Utils.__cache[id][name] : $(element).data(name); // Fallback to HTML5 data attribs.
	          }
	          return $(element).data(name); // Fallback to HTML5 data attribs.
	        } else {
	          return Utils.__cache[id];
	        }
	      };
	
	      Utils.RemoveData = function (element) {
	        // Removes all cached items for a specified element.
	        var id = Utils.GetUniqueElementId(element);
	        if (Utils.__cache[id] != null) {
	          delete Utils.__cache[id];
	        }
	      };
	
	      return Utils;
	    });
	
	    S2.define('select2/results', ['jquery', './utils'], function ($, Utils) {
	      function Results($element, options, dataAdapter) {
	        this.$element = $element;
	        this.data = dataAdapter;
	        this.options = options;
	
	        Results.__super__.constructor.call(this);
	      }
	
	      Utils.Extend(Results, Utils.Observable);
	
	      Results.prototype.render = function () {
	        var $results = $('<ul class="select2-results__options" role="tree"></ul>');
	
	        if (this.options.get('multiple')) {
	          $results.attr('aria-multiselectable', 'true');
	        }
	
	        this.$results = $results;
	
	        return $results;
	      };
	
	      Results.prototype.clear = function () {
	        this.$results.empty();
	      };
	
	      Results.prototype.displayMessage = function (params) {
	        var escapeMarkup = this.options.get('escapeMarkup');
	
	        this.clear();
	        this.hideLoading();
	
	        var $message = $('<li role="treeitem" aria-live="assertive"' + ' class="select2-results__option"></li>');
	
	        var message = this.options.get('translations').get(params.message);
	
	        $message.append(escapeMarkup(message(params.args)));
	
	        $message[0].className += ' select2-results__message';
	
	        this.$results.append($message);
	      };
	
	      Results.prototype.hideMessages = function () {
	        this.$results.find('.select2-results__message').remove();
	      };
	
	      Results.prototype.append = function (data) {
	        this.hideLoading();
	
	        var $options = [];
	
	        if (data.results == null || data.results.length === 0) {
	          if (this.$results.children().length === 0) {
	            this.trigger('results:message', {
	              message: 'noResults'
	            });
	          }
	
	          return;
	        }
	
	        data.results = this.sort(data.results);
	
	        for (var d = 0; d < data.results.length; d++) {
	          var item = data.results[d];
	
	          var $option = this.option(item);
	
	          $options.push($option);
	        }
	
	        this.$results.append($options);
	      };
	
	      Results.prototype.position = function ($results, $dropdown) {
	        var $resultsContainer = $dropdown.find('.select2-results');
	        $resultsContainer.append($results);
	      };
	
	      Results.prototype.sort = function (data) {
	        var sorter = this.options.get('sorter');
	
	        return sorter(data);
	      };
	
	      Results.prototype.highlightFirstItem = function () {
	        var $options = this.$results.find('.select2-results__option[aria-selected]');
	
	        var $selected = $options.filter('[aria-selected=true]');
	
	        // Check if there are any selected options
	        if ($selected.length > 0) {
	          // If there are selected options, highlight the first
	          $selected.first().trigger('mouseenter');
	        } else {
	          // If there are no selected options, highlight the first option
	          // in the dropdown
	          $options.first().trigger('mouseenter');
	        }
	
	        this.ensureHighlightVisible();
	      };
	
	      Results.prototype.setClasses = function () {
	        var self = this;
	
	        this.data.current(function (selected) {
	          var selectedIds = $.map(selected, function (s) {
	            return s.id.toString();
	          });
	
	          var $options = self.$results.find('.select2-results__option[aria-selected]');
	
	          $options.each(function () {
	            var $option = $(this);
	
	            var item = Utils.GetData(this, 'data');
	
	            // id needs to be converted to a string when comparing
	            var id = '' + item.id;
	
	            if (item.element != null && item.element.selected || item.element == null && $.inArray(id, selectedIds) > -1) {
	              $option.attr('aria-selected', 'true');
	            } else {
	              $option.attr('aria-selected', 'false');
	            }
	          });
	        });
	      };
	
	      Results.prototype.showLoading = function (params) {
	        this.hideLoading();
	
	        var loadingMore = this.options.get('translations').get('searching');
	
	        var loading = {
	          disabled: true,
	          loading: true,
	          text: loadingMore(params)
	        };
	        var $loading = this.option(loading);
	        $loading.className += ' loading-results';
	
	        this.$results.prepend($loading);
	      };
	
	      Results.prototype.hideLoading = function () {
	        this.$results.find('.loading-results').remove();
	      };
	
	      Results.prototype.option = function (data) {
	        var option = document.createElement('li');
	        option.className = 'select2-results__option';
	
	        var attrs = {
	          'role': 'treeitem',
	          'aria-selected': 'false'
	        };
	
	        if (data.disabled) {
	          delete attrs['aria-selected'];
	          attrs['aria-disabled'] = 'true';
	        }
	
	        if (data.id == null) {
	          delete attrs['aria-selected'];
	        }
	
	        if (data._resultId != null) {
	          option.id = data._resultId;
	        }
	
	        if (data.title) {
	          option.title = data.title;
	        }
	
	        if (data.children) {
	          attrs.role = 'group';
	          attrs['aria-label'] = data.text;
	          delete attrs['aria-selected'];
	        }
	
	        for (var attr in attrs) {
	          var val = attrs[attr];
	
	          option.setAttribute(attr, val);
	        }
	
	        if (data.children) {
	          var $option = $(option);
	
	          var label = document.createElement('strong');
	          label.className = 'select2-results__group';
	
	          var $label = $(label);
	          this.template(data, label);
	
	          var $children = [];
	
	          for (var c = 0; c < data.children.length; c++) {
	            var child = data.children[c];
	
	            var $child = this.option(child);
	
	            $children.push($child);
	          }
	
	          var $childrenContainer = $('<ul></ul>', {
	            'class': 'select2-results__options select2-results__options--nested'
	          });
	
	          $childrenContainer.append($children);
	
	          $option.append(label);
	          $option.append($childrenContainer);
	        } else {
	          this.template(data, option);
	        }
	
	        Utils.StoreData(option, 'data', data);
	
	        return option;
	      };
	
	      Results.prototype.bind = function (container, $container) {
	        var self = this;
	
	        var id = container.id + '-results';
	
	        this.$results.attr('id', id);
	
	        container.on('results:all', function (params) {
	          self.clear();
	          self.append(params.data);
	
	          if (container.isOpen()) {
	            self.setClasses();
	            self.highlightFirstItem();
	          }
	        });
	
	        container.on('results:append', function (params) {
	          self.append(params.data);
	
	          if (container.isOpen()) {
	            self.setClasses();
	          }
	        });
	
	        container.on('query', function (params) {
	          self.hideMessages();
	          self.showLoading(params);
	        });
	
	        container.on('select', function () {
	          if (!container.isOpen()) {
	            return;
	          }
	
	          self.setClasses();
	          self.highlightFirstItem();
	        });
	
	        container.on('unselect', function () {
	          if (!container.isOpen()) {
	            return;
	          }
	
	          self.setClasses();
	          self.highlightFirstItem();
	        });
	
	        container.on('open', function () {
	          // When the dropdown is open, aria-expended="true"
	          self.$results.attr('aria-expanded', 'true');
	          self.$results.attr('aria-hidden', 'false');
	
	          self.setClasses();
	          self.ensureHighlightVisible();
	        });
	
	        container.on('close', function () {
	          // When the dropdown is closed, aria-expended="false"
	          self.$results.attr('aria-expanded', 'false');
	          self.$results.attr('aria-hidden', 'true');
	          self.$results.removeAttr('aria-activedescendant');
	        });
	
	        container.on('results:toggle', function () {
	          var $highlighted = self.getHighlightedResults();
	
	          if ($highlighted.length === 0) {
	            return;
	          }
	
	          $highlighted.trigger('mouseup');
	        });
	
	        container.on('results:select', function () {
	          var $highlighted = self.getHighlightedResults();
	
	          if ($highlighted.length === 0) {
	            return;
	          }
	
	          var data = Utils.GetData($highlighted[0], 'data');
	
	          if ($highlighted.attr('aria-selected') == 'true') {
	            self.trigger('close', {});
	          } else {
	            self.trigger('select', {
	              data: data
	            });
	          }
	        });
	
	        container.on('results:previous', function () {
	          var $highlighted = self.getHighlightedResults();
	
	          var $options = self.$results.find('[aria-selected]');
	
	          var currentIndex = $options.index($highlighted);
	
	          // If we are already at te top, don't move further
	          // If no options, currentIndex will be -1
	          if (currentIndex <= 0) {
	            return;
	          }
	
	          var nextIndex = currentIndex - 1;
	
	          // If none are highlighted, highlight the first
	          if ($highlighted.length === 0) {
	            nextIndex = 0;
	          }
	
	          var $next = $options.eq(nextIndex);
	
	          $next.trigger('mouseenter');
	
	          var currentOffset = self.$results.offset().top;
	          var nextTop = $next.offset().top;
	          var nextOffset = self.$results.scrollTop() + (nextTop - currentOffset);
	
	          if (nextIndex === 0) {
	            self.$results.scrollTop(0);
	          } else if (nextTop - currentOffset < 0) {
	            self.$results.scrollTop(nextOffset);
	          }
	        });
	
	        container.on('results:next', function () {
	          var $highlighted = self.getHighlightedResults();
	
	          var $options = self.$results.find('[aria-selected]');
	
	          var currentIndex = $options.index($highlighted);
	
	          var nextIndex = currentIndex + 1;
	
	          // If we are at the last option, stay there
	          if (nextIndex >= $options.length) {
	            return;
	          }
	
	          var $next = $options.eq(nextIndex);
	
	          $next.trigger('mouseenter');
	
	          var currentOffset = self.$results.offset().top + self.$results.outerHeight(false);
	          var nextBottom = $next.offset().top + $next.outerHeight(false);
	          var nextOffset = self.$results.scrollTop() + nextBottom - currentOffset;
	
	          if (nextIndex === 0) {
	            self.$results.scrollTop(0);
	          } else if (nextBottom > currentOffset) {
	            self.$results.scrollTop(nextOffset);
	          }
	        });
	
	        container.on('results:focus', function (params) {
	          params.element.addClass('select2-results__option--highlighted');
	        });
	
	        container.on('results:message', function (params) {
	          self.displayMessage(params);
	        });
	
	        if ($.fn.mousewheel) {
	          this.$results.on('mousewheel', function (e) {
	            var top = self.$results.scrollTop();
	
	            var bottom = self.$results.get(0).scrollHeight - top + e.deltaY;
	
	            var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
	            var isAtBottom = e.deltaY < 0 && bottom <= self.$results.height();
	
	            if (isAtTop) {
	              self.$results.scrollTop(0);
	
	              e.preventDefault();
	              e.stopPropagation();
	            } else if (isAtBottom) {
	              self.$results.scrollTop(self.$results.get(0).scrollHeight - self.$results.height());
	
	              e.preventDefault();
	              e.stopPropagation();
	            }
	          });
	        }
	
	        this.$results.on('mouseup', '.select2-results__option[aria-selected]', function (evt) {
	          var $this = $(this);
	
	          var data = Utils.GetData(this, 'data');
	
	          if ($this.attr('aria-selected') === 'true') {
	            if (self.options.get('multiple')) {
	              self.trigger('unselect', {
	                originalEvent: evt,
	                data: data
	              });
	            } else {
	              self.trigger('close', {});
	            }
	
	            return;
	          }
	
	          self.trigger('select', {
	            originalEvent: evt,
	            data: data
	          });
	        });
	
	        this.$results.on('mouseenter', '.select2-results__option[aria-selected]', function (evt) {
	          var data = Utils.GetData(this, 'data');
	
	          self.getHighlightedResults().removeClass('select2-results__option--highlighted');
	
	          self.trigger('results:focus', {
	            data: data,
	            element: $(this)
	          });
	        });
	      };
	
	      Results.prototype.getHighlightedResults = function () {
	        var $highlighted = this.$results.find('.select2-results__option--highlighted');
	
	        return $highlighted;
	      };
	
	      Results.prototype.destroy = function () {
	        this.$results.remove();
	      };
	
	      Results.prototype.ensureHighlightVisible = function () {
	        var $highlighted = this.getHighlightedResults();
	
	        if ($highlighted.length === 0) {
	          return;
	        }
	
	        var $options = this.$results.find('[aria-selected]');
	
	        var currentIndex = $options.index($highlighted);
	
	        var currentOffset = this.$results.offset().top;
	        var nextTop = $highlighted.offset().top;
	        var nextOffset = this.$results.scrollTop() + (nextTop - currentOffset);
	
	        var offsetDelta = nextTop - currentOffset;
	        nextOffset -= $highlighted.outerHeight(false) * 2;
	
	        if (currentIndex <= 2) {
	          this.$results.scrollTop(0);
	        } else if (offsetDelta > this.$results.outerHeight() || offsetDelta < 0) {
	          this.$results.scrollTop(nextOffset);
	        }
	      };
	
	      Results.prototype.template = function (result, container) {
	        var template = this.options.get('templateResult');
	        var escapeMarkup = this.options.get('escapeMarkup');
	
	        var content = template(result, container);
	
	        if (content == null) {
	          container.style.display = 'none';
	        } else if (typeof content === 'string') {
	          container.innerHTML = escapeMarkup(content);
	        } else {
	          $(container).append(content);
	        }
	      };
	
	      return Results;
	    });
	
	    S2.define('select2/keys', [], function () {
	      var KEYS = {
	        BACKSPACE: 8,
	        TAB: 9,
	        ENTER: 13,
	        SHIFT: 16,
	        CTRL: 17,
	        ALT: 18,
	        ESC: 27,
	        SPACE: 32,
	        PAGE_UP: 33,
	        PAGE_DOWN: 34,
	        END: 35,
	        HOME: 36,
	        LEFT: 37,
	        UP: 38,
	        RIGHT: 39,
	        DOWN: 40,
	        DELETE: 46
	      };
	
	      return KEYS;
	    });
	
	    S2.define('select2/selection/base', ['jquery', '../utils', '../keys'], function ($, Utils, KEYS) {
	      function BaseSelection($element, options) {
	        this.$element = $element;
	        this.options = options;
	
	        BaseSelection.__super__.constructor.call(this);
	      }
	
	      Utils.Extend(BaseSelection, Utils.Observable);
	
	      BaseSelection.prototype.render = function () {
	        var $selection = $('<span class="select2-selection" role="combobox" ' + ' aria-haspopup="true" aria-expanded="false">' + '</span>');
	
	        this._tabindex = 0;
	
	        if (Utils.GetData(this.$element[0], 'old-tabindex') != null) {
	          this._tabindex = Utils.GetData(this.$element[0], 'old-tabindex');
	        } else if (this.$element.attr('tabindex') != null) {
	          this._tabindex = this.$element.attr('tabindex');
	        }
	
	        $selection.attr('title', this.$element.attr('title'));
	        $selection.attr('tabindex', this._tabindex);
	
	        this.$selection = $selection;
	
	        return $selection;
	      };
	
	      BaseSelection.prototype.bind = function (container, $container) {
	        var self = this;
	
	        var id = container.id + '-container';
	        var resultsId = container.id + '-results';
	
	        this.container = container;
	
	        this.$selection.on('focus', function (evt) {
	          self.trigger('focus', evt);
	        });
	
	        this.$selection.on('blur', function (evt) {
	          self._handleBlur(evt);
	        });
	
	        this.$selection.on('keydown', function (evt) {
	          self.trigger('keypress', evt);
	
	          if (evt.which === KEYS.SPACE) {
	            evt.preventDefault();
	          }
	        });
	
	        container.on('results:focus', function (params) {
	          self.$selection.attr('aria-activedescendant', params.data._resultId);
	        });
	
	        container.on('selection:update', function (params) {
	          self.update(params.data);
	        });
	
	        container.on('open', function () {
	          // When the dropdown is open, aria-expanded="true"
	          self.$selection.attr('aria-expanded', 'true');
	          self.$selection.attr('aria-owns', resultsId);
	
	          self._attachCloseHandler(container);
	        });
	
	        container.on('close', function () {
	          // When the dropdown is closed, aria-expanded="false"
	          self.$selection.attr('aria-expanded', 'false');
	          self.$selection.removeAttr('aria-activedescendant');
	          self.$selection.removeAttr('aria-owns');
	
	          self.$selection.focus();
	          window.setTimeout(function () {
	            self.$selection.focus();
	          }, 0);
	
	          self._detachCloseHandler(container);
	        });
	
	        container.on('enable', function () {
	          self.$selection.attr('tabindex', self._tabindex);
	        });
	
	        container.on('disable', function () {
	          self.$selection.attr('tabindex', '-1');
	        });
	      };
	
	      BaseSelection.prototype._handleBlur = function (evt) {
	        var self = this;
	
	        // This needs to be delayed as the active element is the body when the tab
	        // key is pressed, possibly along with others.
	        window.setTimeout(function () {
	          // Don't trigger `blur` if the focus is still in the selection
	          if (document.activeElement == self.$selection[0] || $.contains(self.$selection[0], document.activeElement)) {
	            return;
	          }
	
	          self.trigger('blur', evt);
	        }, 1);
	      };
	
	      BaseSelection.prototype._attachCloseHandler = function (container) {
	        var self = this;
	
	        $(document.body).on('mousedown.select2.' + container.id, function (e) {
	          var $target = $(e.target);
	
	          var $select = $target.closest('.select2');
	
	          var $all = $('.select2.select2-container--open');
	
	          $all.each(function () {
	            var $this = $(this);
	
	            if (this == $select[0]) {
	              return;
	            }
	
	            var $element = Utils.GetData(this, 'element');
	
	            $element.select2('close');
	          });
	        });
	      };
	
	      BaseSelection.prototype._detachCloseHandler = function (container) {
	        $(document.body).off('mousedown.select2.' + container.id);
	      };
	
	      BaseSelection.prototype.position = function ($selection, $container) {
	        var $selectionContainer = $container.find('.selection');
	        $selectionContainer.append($selection);
	      };
	
	      BaseSelection.prototype.destroy = function () {
	        this._detachCloseHandler(this.container);
	      };
	
	      BaseSelection.prototype.update = function (data) {
	        throw new Error('The `update` method must be defined in child classes.');
	      };
	
	      return BaseSelection;
	    });
	
	    S2.define('select2/selection/single', ['jquery', './base', '../utils', '../keys'], function ($, BaseSelection, Utils, KEYS) {
	      function SingleSelection() {
	        SingleSelection.__super__.constructor.apply(this, arguments);
	      }
	
	      Utils.Extend(SingleSelection, BaseSelection);
	
	      SingleSelection.prototype.render = function () {
	        var $selection = SingleSelection.__super__.render.call(this);
	
	        $selection.addClass('select2-selection--single');
	
	        $selection.html('<span class="select2-selection__rendered"></span>' + '<span class="select2-selection__arrow" role="presentation">' + '<b role="presentation"></b>' + '</span>');
	
	        return $selection;
	      };
	
	      SingleSelection.prototype.bind = function (container, $container) {
	        var self = this;
	
	        SingleSelection.__super__.bind.apply(this, arguments);
	
	        var id = container.id + '-container';
	
	        this.$selection.find('.select2-selection__rendered').attr('id', id).attr('role', 'textbox').attr('aria-readonly', 'true');
	        this.$selection.attr('aria-labelledby', id);
	
	        this.$selection.on('mousedown', function (evt) {
	          // Only respond to left clicks
	          if (evt.which !== 1) {
	            return;
	          }
	
	          self.trigger('toggle', {
	            originalEvent: evt
	          });
	        });
	
	        this.$selection.on('focus', function (evt) {
	          // User focuses on the container
	        });
	
	        this.$selection.on('blur', function (evt) {
	          // User exits the container
	        });
	
	        container.on('focus', function (evt) {
	          if (!container.isOpen()) {
	            self.$selection.focus();
	          }
	        });
	      };
	
	      SingleSelection.prototype.clear = function () {
	        var $rendered = this.$selection.find('.select2-selection__rendered');
	        $rendered.empty();
	        $rendered.removeAttr('title'); // clear tooltip on empty
	      };
	
	      SingleSelection.prototype.display = function (data, container) {
	        var template = this.options.get('templateSelection');
	        var escapeMarkup = this.options.get('escapeMarkup');
	
	        return escapeMarkup(template(data, container));
	      };
	
	      SingleSelection.prototype.selectionContainer = function () {
	        return $('<span></span>');
	      };
	
	      SingleSelection.prototype.update = function (data) {
	        if (data.length === 0) {
	          this.clear();
	          return;
	        }
	
	        var selection = data[0];
	
	        var $rendered = this.$selection.find('.select2-selection__rendered');
	        var formatted = this.display(selection, $rendered);
	
	        $rendered.empty().append(formatted);
	        $rendered.attr('title', selection.title || selection.text);
	      };
	
	      return SingleSelection;
	    });
	
	    S2.define('select2/selection/multiple', ['jquery', './base', '../utils'], function ($, BaseSelection, Utils) {
	      function MultipleSelection($element, options) {
	        MultipleSelection.__super__.constructor.apply(this, arguments);
	      }
	
	      Utils.Extend(MultipleSelection, BaseSelection);
	
	      MultipleSelection.prototype.render = function () {
	        var $selection = MultipleSelection.__super__.render.call(this);
	
	        $selection.addClass('select2-selection--multiple');
	
	        $selection.html('<ul class="select2-selection__rendered"></ul>');
	
	        return $selection;
	      };
	
	      MultipleSelection.prototype.bind = function (container, $container) {
	        var self = this;
	
	        MultipleSelection.__super__.bind.apply(this, arguments);
	
	        this.$selection.on('click', function (evt) {
	          self.trigger('toggle', {
	            originalEvent: evt
	          });
	        });
	
	        this.$selection.on('click', '.select2-selection__choice__remove', function (evt) {
	          // Ignore the event if it is disabled
	          if (self.options.get('disabled')) {
	            return;
	          }
	
	          var $remove = $(this);
	          var $selection = $remove.parent();
	
	          var data = Utils.GetData($selection[0], 'data');
	
	          self.trigger('unselect', {
	            originalEvent: evt,
	            data: data
	          });
	        });
	      };
	
	      MultipleSelection.prototype.clear = function () {
	        var $rendered = this.$selection.find('.select2-selection__rendered');
	        $rendered.empty();
	        $rendered.removeAttr('title');
	      };
	
	      MultipleSelection.prototype.display = function (data, container) {
	        var template = this.options.get('templateSelection');
	        var escapeMarkup = this.options.get('escapeMarkup');
	
	        return escapeMarkup(template(data, container));
	      };
	
	      MultipleSelection.prototype.selectionContainer = function () {
	        var $container = $('<li class="select2-selection__choice">' + '<span class="select2-selection__choice__remove" role="presentation">' + '&times;' + '</span>' + '</li>');
	
	        return $container;
	      };
	
	      MultipleSelection.prototype.update = function (data) {
	        this.clear();
	
	        if (data.length === 0) {
	          return;
	        }
	
	        var $selections = [];
	
	        for (var d = 0; d < data.length; d++) {
	          var selection = data[d];
	
	          var $selection = this.selectionContainer();
	          var formatted = this.display(selection, $selection);
	
	          $selection.append(formatted);
	          $selection.attr('title', selection.title || selection.text);
	
	          Utils.StoreData($selection[0], 'data', selection);
	
	          $selections.push($selection);
	        }
	
	        var $rendered = this.$selection.find('.select2-selection__rendered');
	
	        Utils.appendMany($rendered, $selections);
	      };
	
	      return MultipleSelection;
	    });
	
	    S2.define('select2/selection/placeholder', ['../utils'], function (Utils) {
	      function Placeholder(decorated, $element, options) {
	        this.placeholder = this.normalizePlaceholder(options.get('placeholder'));
	
	        decorated.call(this, $element, options);
	      }
	
	      Placeholder.prototype.normalizePlaceholder = function (_, placeholder) {
	        if (typeof placeholder === 'string') {
	          placeholder = {
	            id: '',
	            text: placeholder
	          };
	        }
	
	        return placeholder;
	      };
	
	      Placeholder.prototype.createPlaceholder = function (decorated, placeholder) {
	        var $placeholder = this.selectionContainer();
	
	        $placeholder.html(this.display(placeholder));
	        $placeholder.addClass('select2-selection__placeholder').removeClass('select2-selection__choice');
	
	        return $placeholder;
	      };
	
	      Placeholder.prototype.update = function (decorated, data) {
	        var singlePlaceholder = data.length == 1 && data[0].id != this.placeholder.id;
	        var multipleSelections = data.length > 1;
	
	        if (multipleSelections || singlePlaceholder) {
	          return decorated.call(this, data);
	        }
	
	        this.clear();
	
	        var $placeholder = this.createPlaceholder(this.placeholder);
	
	        this.$selection.find('.select2-selection__rendered').append($placeholder);
	      };
	
	      return Placeholder;
	    });
	
	    S2.define('select2/selection/allowClear', ['jquery', '../keys', '../utils'], function ($, KEYS, Utils) {
	      function AllowClear() {}
	
	      AllowClear.prototype.bind = function (decorated, container, $container) {
	        var self = this;
	
	        decorated.call(this, container, $container);
	
	        if (this.placeholder == null) {
	          if (this.options.get('debug') && window.console && console.error) {
	            console.error('Select2: The `allowClear` option should be used in combination ' + 'with the `placeholder` option.');
	          }
	        }
	
	        this.$selection.on('mousedown', '.select2-selection__clear', function (evt) {
	          self._handleClear(evt);
	        });
	
	        container.on('keypress', function (evt) {
	          self._handleKeyboardClear(evt, container);
	        });
	      };
	
	      AllowClear.prototype._handleClear = function (_, evt) {
	        // Ignore the event if it is disabled
	        if (this.options.get('disabled')) {
	          return;
	        }
	
	        var $clear = this.$selection.find('.select2-selection__clear');
	
	        // Ignore the event if nothing has been selected
	        if ($clear.length === 0) {
	          return;
	        }
	
	        evt.stopPropagation();
	
	        var data = Utils.GetData($clear[0], 'data');
	
	        var previousVal = this.$element.val();
	        this.$element.val(this.placeholder.id);
	
	        var unselectData = {
	          data: data
	        };
	        this.trigger('clear', unselectData);
	        if (unselectData.prevented) {
	          this.$element.val(previousVal);
	          return;
	        }
	
	        for (var d = 0; d < data.length; d++) {
	          unselectData = {
	            data: data[d]
	          };
	
	          // Trigger the `unselect` event, so people can prevent it from being
	          // cleared.
	          this.trigger('unselect', unselectData);
	
	          // If the event was prevented, don't clear it out.
	          if (unselectData.prevented) {
	            this.$element.val(previousVal);
	            return;
	          }
	        }
	
	        this.$element.trigger('change');
	
	        this.trigger('toggle', {});
	      };
	
	      AllowClear.prototype._handleKeyboardClear = function (_, evt, container) {
	        if (container.isOpen()) {
	          return;
	        }
	
	        if (evt.which == KEYS.DELETE || evt.which == KEYS.BACKSPACE) {
	          this._handleClear(evt);
	        }
	      };
	
	      AllowClear.prototype.update = function (decorated, data) {
	        decorated.call(this, data);
	
	        if (this.$selection.find('.select2-selection__placeholder').length > 0 || data.length === 0) {
	          return;
	        }
	
	        var $remove = $('<span class="select2-selection__clear">' + '&times;' + '</span>');
	        Utils.StoreData($remove[0], 'data', data);
	
	        this.$selection.find('.select2-selection__rendered').prepend($remove);
	      };
	
	      return AllowClear;
	    });
	
	    S2.define('select2/selection/search', ['jquery', '../utils', '../keys'], function ($, Utils, KEYS) {
	      function Search(decorated, $element, options) {
	        decorated.call(this, $element, options);
	      }
	
	      Search.prototype.render = function (decorated) {
	        var $search = $('<li class="select2-search select2-search--inline">' + '<input class="select2-search__field" type="search" tabindex="-1"' + ' autocomplete="off" autocorrect="off" autocapitalize="none"' + ' spellcheck="false" role="textbox" aria-autocomplete="list" />' + '</li>');
	
	        this.$searchContainer = $search;
	        this.$search = $search.find('input');
	
	        var $rendered = decorated.call(this);
	
	        this._transferTabIndex();
	
	        return $rendered;
	      };
	
	      Search.prototype.bind = function (decorated, container, $container) {
	        var self = this;
	
	        decorated.call(this, container, $container);
	
	        container.on('open', function () {
	          self.$search.trigger('focus');
	        });
	
	        container.on('close', function () {
	          self.$search.val('');
	          self.$search.removeAttr('aria-activedescendant');
	          self.$search.trigger('focus');
	        });
	
	        container.on('enable', function () {
	          self.$search.prop('disabled', false);
	
	          self._transferTabIndex();
	        });
	
	        container.on('disable', function () {
	          self.$search.prop('disabled', true);
	        });
	
	        container.on('focus', function (evt) {
	          self.$search.trigger('focus');
	        });
	
	        container.on('results:focus', function (params) {
	          self.$search.attr('aria-activedescendant', params.id);
	        });
	
	        this.$selection.on('focusin', '.select2-search--inline', function (evt) {
	          self.trigger('focus', evt);
	        });
	
	        this.$selection.on('focusout', '.select2-search--inline', function (evt) {
	          self._handleBlur(evt);
	        });
	
	        this.$selection.on('keydown', '.select2-search--inline', function (evt) {
	          evt.stopPropagation();
	
	          self.trigger('keypress', evt);
	
	          self._keyUpPrevented = evt.isDefaultPrevented();
	
	          var key = evt.which;
	
	          if (key === KEYS.BACKSPACE && self.$search.val() === '') {
	            var $previousChoice = self.$searchContainer.prev('.select2-selection__choice');
	
	            if ($previousChoice.length > 0) {
	              var item = Utils.GetData($previousChoice[0], 'data');
	
	              self.searchRemoveChoice(item);
	
	              evt.preventDefault();
	            }
	          }
	        });
	
	        // Try to detect the IE version should the `documentMode` property that
	        // is stored on the document. This is only implemented in IE and is
	        // slightly cleaner than doing a user agent check.
	        // This property is not available in Edge, but Edge also doesn't have
	        // this bug.
	        var msie = document.documentMode;
	        var disableInputEvents = msie && msie <= 11;
	
	        // Workaround for browsers which do not support the `input` event
	        // This will prevent double-triggering of events for browsers which support
	        // both the `keyup` and `input` events.
	        this.$selection.on('input.searchcheck', '.select2-search--inline', function (evt) {
	          // IE will trigger the `input` event when a placeholder is used on a
	          // search box. To get around this issue, we are forced to ignore all
	          // `input` events in IE and keep using `keyup`.
	          if (disableInputEvents) {
	            self.$selection.off('input.search input.searchcheck');
	            return;
	          }
	
	          // Unbind the duplicated `keyup` event
	          self.$selection.off('keyup.search');
	        });
	
	        this.$selection.on('keyup.search input.search', '.select2-search--inline', function (evt) {
	          // IE will trigger the `input` event when a placeholder is used on a
	          // search box. To get around this issue, we are forced to ignore all
	          // `input` events in IE and keep using `keyup`.
	          if (disableInputEvents && evt.type === 'input') {
	            self.$selection.off('input.search input.searchcheck');
	            return;
	          }
	
	          var key = evt.which;
	
	          // We can freely ignore events from modifier keys
	          if (key == KEYS.SHIFT || key == KEYS.CTRL || key == KEYS.ALT) {
	            return;
	          }
	
	          // Tabbing will be handled during the `keydown` phase
	          if (key == KEYS.TAB) {
	            return;
	          }
	
	          self.handleSearch(evt);
	        });
	      };
	
	      /**
	       * This method will transfer the tabindex attribute from the rendered
	       * selection to the search box. This allows for the search box to be used as
	       * the primary focus instead of the selection container.
	       *
	       * @private
	       */
	      Search.prototype._transferTabIndex = function (decorated) {
	        this.$search.attr('tabindex', this.$selection.attr('tabindex'));
	        this.$selection.attr('tabindex', '-1');
	      };
	
	      Search.prototype.createPlaceholder = function (decorated, placeholder) {
	        this.$search.attr('placeholder', placeholder.text);
	      };
	
	      Search.prototype.update = function (decorated, data) {
	        var searchHadFocus = this.$search[0] == document.activeElement;
	
	        this.$search.attr('placeholder', '');
	
	        decorated.call(this, data);
	
	        this.$selection.find('.select2-selection__rendered').append(this.$searchContainer);
	
	        this.resizeSearch();
	        if (searchHadFocus) {
	          var isTagInput = this.$element.find('[data-select2-tag]').length;
	          if (isTagInput) {
	            // fix IE11 bug where tag input lost focus
	            this.$element.focus();
	          } else {
	            this.$search.focus();
	          }
	        }
	      };
	
	      Search.prototype.handleSearch = function () {
	        this.resizeSearch();
	
	        if (!this._keyUpPrevented) {
	          var input = this.$search.val();
	
	          this.trigger('query', {
	            term: input
	          });
	        }
	
	        this._keyUpPrevented = false;
	      };
	
	      Search.prototype.searchRemoveChoice = function (decorated, item) {
	        this.trigger('unselect', {
	          data: item
	        });
	
	        this.$search.val(item.text);
	        this.handleSearch();
	      };
	
	      Search.prototype.resizeSearch = function () {
	        this.$search.css('width', '25px');
	
	        var width = '';
	
	        if (this.$search.attr('placeholder') !== '') {
	          width = this.$selection.find('.select2-selection__rendered').innerWidth();
	        } else {
	          var minimumWidth = this.$search.val().length + 1;
	
	          width = minimumWidth * 0.75 + 'em';
	        }
	
	        this.$search.css('width', width);
	      };
	
	      return Search;
	    });
	
	    S2.define('select2/selection/eventRelay', ['jquery'], function ($) {
	      function EventRelay() {}
	
	      EventRelay.prototype.bind = function (decorated, container, $container) {
	        var self = this;
	        var relayEvents = ['open', 'opening', 'close', 'closing', 'select', 'selecting', 'unselect', 'unselecting', 'clear', 'clearing'];
	
	        var preventableEvents = ['opening', 'closing', 'selecting', 'unselecting', 'clearing'];
	
	        decorated.call(this, container, $container);
	
	        container.on('*', function (name, params) {
	          // Ignore events that should not be relayed
	          if ($.inArray(name, relayEvents) === -1) {
	            return;
	          }
	
	          // The parameters should always be an object
	          params = params || {};
	
	          // Generate the jQuery event for the Select2 event
	          var evt = $.Event('select2:' + name, {
	            params: params
	          });
	
	          self.$element.trigger(evt);
	
	          // Only handle preventable events if it was one
	          if ($.inArray(name, preventableEvents) === -1) {
	            return;
	          }
	
	          params.prevented = evt.isDefaultPrevented();
	        });
	      };
	
	      return EventRelay;
	    });
	
	    S2.define('select2/translation', ['jquery', 'require'], function ($, require) {
	      function Translation(dict) {
	        this.dict = dict || {};
	      }
	
	      Translation.prototype.all = function () {
	        return this.dict;
	      };
	
	      Translation.prototype.get = function (key) {
	        return this.dict[key];
	      };
	
	      Translation.prototype.extend = function (translation) {
	        this.dict = $.extend({}, translation.all(), this.dict);
	      };
	
	      // Static functions
	
	      Translation._cache = {};
	
	      Translation.loadPath = function (path) {
	        if (!(path in Translation._cache)) {
	          var translations = require(path);
	
	          Translation._cache[path] = translations;
	        }
	
	        return new Translation(Translation._cache[path]);
	      };
	
	      return Translation;
	    });
	
	    S2.define('select2/diacritics', [], function () {
	      var diacritics = {
	        '\u24B6': 'A',
	        '\uFF21': 'A',
	        '\xC0': 'A',
	        '\xC1': 'A',
	        '\xC2': 'A',
	        '\u1EA6': 'A',
	        '\u1EA4': 'A',
	        '\u1EAA': 'A',
	        '\u1EA8': 'A',
	        '\xC3': 'A',
	        '\u0100': 'A',
	        '\u0102': 'A',
	        '\u1EB0': 'A',
	        '\u1EAE': 'A',
	        '\u1EB4': 'A',
	        '\u1EB2': 'A',
	        '\u0226': 'A',
	        '\u01E0': 'A',
	        '\xC4': 'A',
	        '\u01DE': 'A',
	        '\u1EA2': 'A',
	        '\xC5': 'A',
	        '\u01FA': 'A',
	        '\u01CD': 'A',
	        '\u0200': 'A',
	        '\u0202': 'A',
	        '\u1EA0': 'A',
	        '\u1EAC': 'A',
	        '\u1EB6': 'A',
	        '\u1E00': 'A',
	        '\u0104': 'A',
	        '\u023A': 'A',
	        '\u2C6F': 'A',
	        '\uA732': 'AA',
	        '\xC6': 'AE',
	        '\u01FC': 'AE',
	        '\u01E2': 'AE',
	        '\uA734': 'AO',
	        '\uA736': 'AU',
	        '\uA738': 'AV',
	        '\uA73A': 'AV',
	        '\uA73C': 'AY',
	        '\u24B7': 'B',
	        '\uFF22': 'B',
	        '\u1E02': 'B',
	        '\u1E04': 'B',
	        '\u1E06': 'B',
	        '\u0243': 'B',
	        '\u0182': 'B',
	        '\u0181': 'B',
	        '\u24B8': 'C',
	        '\uFF23': 'C',
	        '\u0106': 'C',
	        '\u0108': 'C',
	        '\u010A': 'C',
	        '\u010C': 'C',
	        '\xC7': 'C',
	        '\u1E08': 'C',
	        '\u0187': 'C',
	        '\u023B': 'C',
	        '\uA73E': 'C',
	        '\u24B9': 'D',
	        '\uFF24': 'D',
	        '\u1E0A': 'D',
	        '\u010E': 'D',
	        '\u1E0C': 'D',
	        '\u1E10': 'D',
	        '\u1E12': 'D',
	        '\u1E0E': 'D',
	        '\u0110': 'D',
	        '\u018B': 'D',
	        '\u018A': 'D',
	        '\u0189': 'D',
	        '\uA779': 'D',
	        '\u01F1': 'DZ',
	        '\u01C4': 'DZ',
	        '\u01F2': 'Dz',
	        '\u01C5': 'Dz',
	        '\u24BA': 'E',
	        '\uFF25': 'E',
	        '\xC8': 'E',
	        '\xC9': 'E',
	        '\xCA': 'E',
	        '\u1EC0': 'E',
	        '\u1EBE': 'E',
	        '\u1EC4': 'E',
	        '\u1EC2': 'E',
	        '\u1EBC': 'E',
	        '\u0112': 'E',
	        '\u1E14': 'E',
	        '\u1E16': 'E',
	        '\u0114': 'E',
	        '\u0116': 'E',
	        '\xCB': 'E',
	        '\u1EBA': 'E',
	        '\u011A': 'E',
	        '\u0204': 'E',
	        '\u0206': 'E',
	        '\u1EB8': 'E',
	        '\u1EC6': 'E',
	        '\u0228': 'E',
	        '\u1E1C': 'E',
	        '\u0118': 'E',
	        '\u1E18': 'E',
	        '\u1E1A': 'E',
	        '\u0190': 'E',
	        '\u018E': 'E',
	        '\u24BB': 'F',
	        '\uFF26': 'F',
	        '\u1E1E': 'F',
	        '\u0191': 'F',
	        '\uA77B': 'F',
	        '\u24BC': 'G',
	        '\uFF27': 'G',
	        '\u01F4': 'G',
	        '\u011C': 'G',
	        '\u1E20': 'G',
	        '\u011E': 'G',
	        '\u0120': 'G',
	        '\u01E6': 'G',
	        '\u0122': 'G',
	        '\u01E4': 'G',
	        '\u0193': 'G',
	        '\uA7A0': 'G',
	        '\uA77D': 'G',
	        '\uA77E': 'G',
	        '\u24BD': 'H',
	        '\uFF28': 'H',
	        '\u0124': 'H',
	        '\u1E22': 'H',
	        '\u1E26': 'H',
	        '\u021E': 'H',
	        '\u1E24': 'H',
	        '\u1E28': 'H',
	        '\u1E2A': 'H',
	        '\u0126': 'H',
	        '\u2C67': 'H',
	        '\u2C75': 'H',
	        '\uA78D': 'H',
	        '\u24BE': 'I',
	        '\uFF29': 'I',
	        '\xCC': 'I',
	        '\xCD': 'I',
	        '\xCE': 'I',
	        '\u0128': 'I',
	        '\u012A': 'I',
	        '\u012C': 'I',
	        '\u0130': 'I',
	        '\xCF': 'I',
	        '\u1E2E': 'I',
	        '\u1EC8': 'I',
	        '\u01CF': 'I',
	        '\u0208': 'I',
	        '\u020A': 'I',
	        '\u1ECA': 'I',
	        '\u012E': 'I',
	        '\u1E2C': 'I',
	        '\u0197': 'I',
	        '\u24BF': 'J',
	        '\uFF2A': 'J',
	        '\u0134': 'J',
	        '\u0248': 'J',
	        '\u24C0': 'K',
	        '\uFF2B': 'K',
	        '\u1E30': 'K',
	        '\u01E8': 'K',
	        '\u1E32': 'K',
	        '\u0136': 'K',
	        '\u1E34': 'K',
	        '\u0198': 'K',
	        '\u2C69': 'K',
	        '\uA740': 'K',
	        '\uA742': 'K',
	        '\uA744': 'K',
	        '\uA7A2': 'K',
	        '\u24C1': 'L',
	        '\uFF2C': 'L',
	        '\u013F': 'L',
	        '\u0139': 'L',
	        '\u013D': 'L',
	        '\u1E36': 'L',
	        '\u1E38': 'L',
	        '\u013B': 'L',
	        '\u1E3C': 'L',
	        '\u1E3A': 'L',
	        '\u0141': 'L',
	        '\u023D': 'L',
	        '\u2C62': 'L',
	        '\u2C60': 'L',
	        '\uA748': 'L',
	        '\uA746': 'L',
	        '\uA780': 'L',
	        '\u01C7': 'LJ',
	        '\u01C8': 'Lj',
	        '\u24C2': 'M',
	        '\uFF2D': 'M',
	        '\u1E3E': 'M',
	        '\u1E40': 'M',
	        '\u1E42': 'M',
	        '\u2C6E': 'M',
	        '\u019C': 'M',
	        '\u24C3': 'N',
	        '\uFF2E': 'N',
	        '\u01F8': 'N',
	        '\u0143': 'N',
	        '\xD1': 'N',
	        '\u1E44': 'N',
	        '\u0147': 'N',
	        '\u1E46': 'N',
	        '\u0145': 'N',
	        '\u1E4A': 'N',
	        '\u1E48': 'N',
	        '\u0220': 'N',
	        '\u019D': 'N',
	        '\uA790': 'N',
	        '\uA7A4': 'N',
	        '\u01CA': 'NJ',
	        '\u01CB': 'Nj',
	        '\u24C4': 'O',
	        '\uFF2F': 'O',
	        '\xD2': 'O',
	        '\xD3': 'O',
	        '\xD4': 'O',
	        '\u1ED2': 'O',
	        '\u1ED0': 'O',
	        '\u1ED6': 'O',
	        '\u1ED4': 'O',
	        '\xD5': 'O',
	        '\u1E4C': 'O',
	        '\u022C': 'O',
	        '\u1E4E': 'O',
	        '\u014C': 'O',
	        '\u1E50': 'O',
	        '\u1E52': 'O',
	        '\u014E': 'O',
	        '\u022E': 'O',
	        '\u0230': 'O',
	        '\xD6': 'O',
	        '\u022A': 'O',
	        '\u1ECE': 'O',
	        '\u0150': 'O',
	        '\u01D1': 'O',
	        '\u020C': 'O',
	        '\u020E': 'O',
	        '\u01A0': 'O',
	        '\u1EDC': 'O',
	        '\u1EDA': 'O',
	        '\u1EE0': 'O',
	        '\u1EDE': 'O',
	        '\u1EE2': 'O',
	        '\u1ECC': 'O',
	        '\u1ED8': 'O',
	        '\u01EA': 'O',
	        '\u01EC': 'O',
	        '\xD8': 'O',
	        '\u01FE': 'O',
	        '\u0186': 'O',
	        '\u019F': 'O',
	        '\uA74A': 'O',
	        '\uA74C': 'O',
	        '\u01A2': 'OI',
	        '\uA74E': 'OO',
	        '\u0222': 'OU',
	        '\u24C5': 'P',
	        '\uFF30': 'P',
	        '\u1E54': 'P',
	        '\u1E56': 'P',
	        '\u01A4': 'P',
	        '\u2C63': 'P',
	        '\uA750': 'P',
	        '\uA752': 'P',
	        '\uA754': 'P',
	        '\u24C6': 'Q',
	        '\uFF31': 'Q',
	        '\uA756': 'Q',
	        '\uA758': 'Q',
	        '\u024A': 'Q',
	        '\u24C7': 'R',
	        '\uFF32': 'R',
	        '\u0154': 'R',
	        '\u1E58': 'R',
	        '\u0158': 'R',
	        '\u0210': 'R',
	        '\u0212': 'R',
	        '\u1E5A': 'R',
	        '\u1E5C': 'R',
	        '\u0156': 'R',
	        '\u1E5E': 'R',
	        '\u024C': 'R',
	        '\u2C64': 'R',
	        '\uA75A': 'R',
	        '\uA7A6': 'R',
	        '\uA782': 'R',
	        '\u24C8': 'S',
	        '\uFF33': 'S',
	        '\u1E9E': 'S',
	        '\u015A': 'S',
	        '\u1E64': 'S',
	        '\u015C': 'S',
	        '\u1E60': 'S',
	        '\u0160': 'S',
	        '\u1E66': 'S',
	        '\u1E62': 'S',
	        '\u1E68': 'S',
	        '\u0218': 'S',
	        '\u015E': 'S',
	        '\u2C7E': 'S',
	        '\uA7A8': 'S',
	        '\uA784': 'S',
	        '\u24C9': 'T',
	        '\uFF34': 'T',
	        '\u1E6A': 'T',
	        '\u0164': 'T',
	        '\u1E6C': 'T',
	        '\u021A': 'T',
	        '\u0162': 'T',
	        '\u1E70': 'T',
	        '\u1E6E': 'T',
	        '\u0166': 'T',
	        '\u01AC': 'T',
	        '\u01AE': 'T',
	        '\u023E': 'T',
	        '\uA786': 'T',
	        '\uA728': 'TZ',
	        '\u24CA': 'U',
	        '\uFF35': 'U',
	        '\xD9': 'U',
	        '\xDA': 'U',
	        '\xDB': 'U',
	        '\u0168': 'U',
	        '\u1E78': 'U',
	        '\u016A': 'U',
	        '\u1E7A': 'U',
	        '\u016C': 'U',
	        '\xDC': 'U',
	        '\u01DB': 'U',
	        '\u01D7': 'U',
	        '\u01D5': 'U',
	        '\u01D9': 'U',
	        '\u1EE6': 'U',
	        '\u016E': 'U',
	        '\u0170': 'U',
	        '\u01D3': 'U',
	        '\u0214': 'U',
	        '\u0216': 'U',
	        '\u01AF': 'U',
	        '\u1EEA': 'U',
	        '\u1EE8': 'U',
	        '\u1EEE': 'U',
	        '\u1EEC': 'U',
	        '\u1EF0': 'U',
	        '\u1EE4': 'U',
	        '\u1E72': 'U',
	        '\u0172': 'U',
	        '\u1E76': 'U',
	        '\u1E74': 'U',
	        '\u0244': 'U',
	        '\u24CB': 'V',
	        '\uFF36': 'V',
	        '\u1E7C': 'V',
	        '\u1E7E': 'V',
	        '\u01B2': 'V',
	        '\uA75E': 'V',
	        '\u0245': 'V',
	        '\uA760': 'VY',
	        '\u24CC': 'W',
	        '\uFF37': 'W',
	        '\u1E80': 'W',
	        '\u1E82': 'W',
	        '\u0174': 'W',
	        '\u1E86': 'W',
	        '\u1E84': 'W',
	        '\u1E88': 'W',
	        '\u2C72': 'W',
	        '\u24CD': 'X',
	        '\uFF38': 'X',
	        '\u1E8A': 'X',
	        '\u1E8C': 'X',
	        '\u24CE': 'Y',
	        '\uFF39': 'Y',
	        '\u1EF2': 'Y',
	        '\xDD': 'Y',
	        '\u0176': 'Y',
	        '\u1EF8': 'Y',
	        '\u0232': 'Y',
	        '\u1E8E': 'Y',
	        '\u0178': 'Y',
	        '\u1EF6': 'Y',
	        '\u1EF4': 'Y',
	        '\u01B3': 'Y',
	        '\u024E': 'Y',
	        '\u1EFE': 'Y',
	        '\u24CF': 'Z',
	        '\uFF3A': 'Z',
	        '\u0179': 'Z',
	        '\u1E90': 'Z',
	        '\u017B': 'Z',
	        '\u017D': 'Z',
	        '\u1E92': 'Z',
	        '\u1E94': 'Z',
	        '\u01B5': 'Z',
	        '\u0224': 'Z',
	        '\u2C7F': 'Z',
	        '\u2C6B': 'Z',
	        '\uA762': 'Z',
	        '\u24D0': 'a',
	        '\uFF41': 'a',
	        '\u1E9A': 'a',
	        '\xE0': 'a',
	        '\xE1': 'a',
	        '\xE2': 'a',
	        '\u1EA7': 'a',
	        '\u1EA5': 'a',
	        '\u1EAB': 'a',
	        '\u1EA9': 'a',
	        '\xE3': 'a',
	        '\u0101': 'a',
	        '\u0103': 'a',
	        '\u1EB1': 'a',
	        '\u1EAF': 'a',
	        '\u1EB5': 'a',
	        '\u1EB3': 'a',
	        '\u0227': 'a',
	        '\u01E1': 'a',
	        '\xE4': 'a',
	        '\u01DF': 'a',
	        '\u1EA3': 'a',
	        '\xE5': 'a',
	        '\u01FB': 'a',
	        '\u01CE': 'a',
	        '\u0201': 'a',
	        '\u0203': 'a',
	        '\u1EA1': 'a',
	        '\u1EAD': 'a',
	        '\u1EB7': 'a',
	        '\u1E01': 'a',
	        '\u0105': 'a',
	        '\u2C65': 'a',
	        '\u0250': 'a',
	        '\uA733': 'aa',
	        '\xE6': 'ae',
	        '\u01FD': 'ae',
	        '\u01E3': 'ae',
	        '\uA735': 'ao',
	        '\uA737': 'au',
	        '\uA739': 'av',
	        '\uA73B': 'av',
	        '\uA73D': 'ay',
	        '\u24D1': 'b',
	        '\uFF42': 'b',
	        '\u1E03': 'b',
	        '\u1E05': 'b',
	        '\u1E07': 'b',
	        '\u0180': 'b',
	        '\u0183': 'b',
	        '\u0253': 'b',
	        '\u24D2': 'c',
	        '\uFF43': 'c',
	        '\u0107': 'c',
	        '\u0109': 'c',
	        '\u010B': 'c',
	        '\u010D': 'c',
	        '\xE7': 'c',
	        '\u1E09': 'c',
	        '\u0188': 'c',
	        '\u023C': 'c',
	        '\uA73F': 'c',
	        '\u2184': 'c',
	        '\u24D3': 'd',
	        '\uFF44': 'd',
	        '\u1E0B': 'd',
	        '\u010F': 'd',
	        '\u1E0D': 'd',
	        '\u1E11': 'd',
	        '\u1E13': 'd',
	        '\u1E0F': 'd',
	        '\u0111': 'd',
	        '\u018C': 'd',
	        '\u0256': 'd',
	        '\u0257': 'd',
	        '\uA77A': 'd',
	        '\u01F3': 'dz',
	        '\u01C6': 'dz',
	        '\u24D4': 'e',
	        '\uFF45': 'e',
	        '\xE8': 'e',
	        '\xE9': 'e',
	        '\xEA': 'e',
	        '\u1EC1': 'e',
	        '\u1EBF': 'e',
	        '\u1EC5': 'e',
	        '\u1EC3': 'e',
	        '\u1EBD': 'e',
	        '\u0113': 'e',
	        '\u1E15': 'e',
	        '\u1E17': 'e',
	        '\u0115': 'e',
	        '\u0117': 'e',
	        '\xEB': 'e',
	        '\u1EBB': 'e',
	        '\u011B': 'e',
	        '\u0205': 'e',
	        '\u0207': 'e',
	        '\u1EB9': 'e',
	        '\u1EC7': 'e',
	        '\u0229': 'e',
	        '\u1E1D': 'e',
	        '\u0119': 'e',
	        '\u1E19': 'e',
	        '\u1E1B': 'e',
	        '\u0247': 'e',
	        '\u025B': 'e',
	        '\u01DD': 'e',
	        '\u24D5': 'f',
	        '\uFF46': 'f',
	        '\u1E1F': 'f',
	        '\u0192': 'f',
	        '\uA77C': 'f',
	        '\u24D6': 'g',
	        '\uFF47': 'g',
	        '\u01F5': 'g',
	        '\u011D': 'g',
	        '\u1E21': 'g',
	        '\u011F': 'g',
	        '\u0121': 'g',
	        '\u01E7': 'g',
	        '\u0123': 'g',
	        '\u01E5': 'g',
	        '\u0260': 'g',
	        '\uA7A1': 'g',
	        '\u1D79': 'g',
	        '\uA77F': 'g',
	        '\u24D7': 'h',
	        '\uFF48': 'h',
	        '\u0125': 'h',
	        '\u1E23': 'h',
	        '\u1E27': 'h',
	        '\u021F': 'h',
	        '\u1E25': 'h',
	        '\u1E29': 'h',
	        '\u1E2B': 'h',
	        '\u1E96': 'h',
	        '\u0127': 'h',
	        '\u2C68': 'h',
	        '\u2C76': 'h',
	        '\u0265': 'h',
	        '\u0195': 'hv',
	        '\u24D8': 'i',
	        '\uFF49': 'i',
	        '\xEC': 'i',
	        '\xED': 'i',
	        '\xEE': 'i',
	        '\u0129': 'i',
	        '\u012B': 'i',
	        '\u012D': 'i',
	        '\xEF': 'i',
	        '\u1E2F': 'i',
	        '\u1EC9': 'i',
	        '\u01D0': 'i',
	        '\u0209': 'i',
	        '\u020B': 'i',
	        '\u1ECB': 'i',
	        '\u012F': 'i',
	        '\u1E2D': 'i',
	        '\u0268': 'i',
	        '\u0131': 'i',
	        '\u24D9': 'j',
	        '\uFF4A': 'j',
	        '\u0135': 'j',
	        '\u01F0': 'j',
	        '\u0249': 'j',
	        '\u24DA': 'k',
	        '\uFF4B': 'k',
	        '\u1E31': 'k',
	        '\u01E9': 'k',
	        '\u1E33': 'k',
	        '\u0137': 'k',
	        '\u1E35': 'k',
	        '\u0199': 'k',
	        '\u2C6A': 'k',
	        '\uA741': 'k',
	        '\uA743': 'k',
	        '\uA745': 'k',
	        '\uA7A3': 'k',
	        '\u24DB': 'l',
	        '\uFF4C': 'l',
	        '\u0140': 'l',
	        '\u013A': 'l',
	        '\u013E': 'l',
	        '\u1E37': 'l',
	        '\u1E39': 'l',
	        '\u013C': 'l',
	        '\u1E3D': 'l',
	        '\u1E3B': 'l',
	        '\u017F': 'l',
	        '\u0142': 'l',
	        '\u019A': 'l',
	        '\u026B': 'l',
	        '\u2C61': 'l',
	        '\uA749': 'l',
	        '\uA781': 'l',
	        '\uA747': 'l',
	        '\u01C9': 'lj',
	        '\u24DC': 'm',
	        '\uFF4D': 'm',
	        '\u1E3F': 'm',
	        '\u1E41': 'm',
	        '\u1E43': 'm',
	        '\u0271': 'm',
	        '\u026F': 'm',
	        '\u24DD': 'n',
	        '\uFF4E': 'n',
	        '\u01F9': 'n',
	        '\u0144': 'n',
	        '\xF1': 'n',
	        '\u1E45': 'n',
	        '\u0148': 'n',
	        '\u1E47': 'n',
	        '\u0146': 'n',
	        '\u1E4B': 'n',
	        '\u1E49': 'n',
	        '\u019E': 'n',
	        '\u0272': 'n',
	        '\u0149': 'n',
	        '\uA791': 'n',
	        '\uA7A5': 'n',
	        '\u01CC': 'nj',
	        '\u24DE': 'o',
	        '\uFF4F': 'o',
	        '\xF2': 'o',
	        '\xF3': 'o',
	        '\xF4': 'o',
	        '\u1ED3': 'o',
	        '\u1ED1': 'o',
	        '\u1ED7': 'o',
	        '\u1ED5': 'o',
	        '\xF5': 'o',
	        '\u1E4D': 'o',
	        '\u022D': 'o',
	        '\u1E4F': 'o',
	        '\u014D': 'o',
	        '\u1E51': 'o',
	        '\u1E53': 'o',
	        '\u014F': 'o',
	        '\u022F': 'o',
	        '\u0231': 'o',
	        '\xF6': 'o',
	        '\u022B': 'o',
	        '\u1ECF': 'o',
	        '\u0151': 'o',
	        '\u01D2': 'o',
	        '\u020D': 'o',
	        '\u020F': 'o',
	        '\u01A1': 'o',
	        '\u1EDD': 'o',
	        '\u1EDB': 'o',
	        '\u1EE1': 'o',
	        '\u1EDF': 'o',
	        '\u1EE3': 'o',
	        '\u1ECD': 'o',
	        '\u1ED9': 'o',
	        '\u01EB': 'o',
	        '\u01ED': 'o',
	        '\xF8': 'o',
	        '\u01FF': 'o',
	        '\u0254': 'o',
	        '\uA74B': 'o',
	        '\uA74D': 'o',
	        '\u0275': 'o',
	        '\u01A3': 'oi',
	        '\u0223': 'ou',
	        '\uA74F': 'oo',
	        '\u24DF': 'p',
	        '\uFF50': 'p',
	        '\u1E55': 'p',
	        '\u1E57': 'p',
	        '\u01A5': 'p',
	        '\u1D7D': 'p',
	        '\uA751': 'p',
	        '\uA753': 'p',
	        '\uA755': 'p',
	        '\u24E0': 'q',
	        '\uFF51': 'q',
	        '\u024B': 'q',
	        '\uA757': 'q',
	        '\uA759': 'q',
	        '\u24E1': 'r',
	        '\uFF52': 'r',
	        '\u0155': 'r',
	        '\u1E59': 'r',
	        '\u0159': 'r',
	        '\u0211': 'r',
	        '\u0213': 'r',
	        '\u1E5B': 'r',
	        '\u1E5D': 'r',
	        '\u0157': 'r',
	        '\u1E5F': 'r',
	        '\u024D': 'r',
	        '\u027D': 'r',
	        '\uA75B': 'r',
	        '\uA7A7': 'r',
	        '\uA783': 'r',
	        '\u24E2': 's',
	        '\uFF53': 's',
	        '\xDF': 's',
	        '\u015B': 's',
	        '\u1E65': 's',
	        '\u015D': 's',
	        '\u1E61': 's',
	        '\u0161': 's',
	        '\u1E67': 's',
	        '\u1E63': 's',
	        '\u1E69': 's',
	        '\u0219': 's',
	        '\u015F': 's',
	        '\u023F': 's',
	        '\uA7A9': 's',
	        '\uA785': 's',
	        '\u1E9B': 's',
	        '\u24E3': 't',
	        '\uFF54': 't',
	        '\u1E6B': 't',
	        '\u1E97': 't',
	        '\u0165': 't',
	        '\u1E6D': 't',
	        '\u021B': 't',
	        '\u0163': 't',
	        '\u1E71': 't',
	        '\u1E6F': 't',
	        '\u0167': 't',
	        '\u01AD': 't',
	        '\u0288': 't',
	        '\u2C66': 't',
	        '\uA787': 't',
	        '\uA729': 'tz',
	        '\u24E4': 'u',
	        '\uFF55': 'u',
	        '\xF9': 'u',
	        '\xFA': 'u',
	        '\xFB': 'u',
	        '\u0169': 'u',
	        '\u1E79': 'u',
	        '\u016B': 'u',
	        '\u1E7B': 'u',
	        '\u016D': 'u',
	        '\xFC': 'u',
	        '\u01DC': 'u',
	        '\u01D8': 'u',
	        '\u01D6': 'u',
	        '\u01DA': 'u',
	        '\u1EE7': 'u',
	        '\u016F': 'u',
	        '\u0171': 'u',
	        '\u01D4': 'u',
	        '\u0215': 'u',
	        '\u0217': 'u',
	        '\u01B0': 'u',
	        '\u1EEB': 'u',
	        '\u1EE9': 'u',
	        '\u1EEF': 'u',
	        '\u1EED': 'u',
	        '\u1EF1': 'u',
	        '\u1EE5': 'u',
	        '\u1E73': 'u',
	        '\u0173': 'u',
	        '\u1E77': 'u',
	        '\u1E75': 'u',
	        '\u0289': 'u',
	        '\u24E5': 'v',
	        '\uFF56': 'v',
	        '\u1E7D': 'v',
	        '\u1E7F': 'v',
	        '\u028B': 'v',
	        '\uA75F': 'v',
	        '\u028C': 'v',
	        '\uA761': 'vy',
	        '\u24E6': 'w',
	        '\uFF57': 'w',
	        '\u1E81': 'w',
	        '\u1E83': 'w',
	        '\u0175': 'w',
	        '\u1E87': 'w',
	        '\u1E85': 'w',
	        '\u1E98': 'w',
	        '\u1E89': 'w',
	        '\u2C73': 'w',
	        '\u24E7': 'x',
	        '\uFF58': 'x',
	        '\u1E8B': 'x',
	        '\u1E8D': 'x',
	        '\u24E8': 'y',
	        '\uFF59': 'y',
	        '\u1EF3': 'y',
	        '\xFD': 'y',
	        '\u0177': 'y',
	        '\u1EF9': 'y',
	        '\u0233': 'y',
	        '\u1E8F': 'y',
	        '\xFF': 'y',
	        '\u1EF7': 'y',
	        '\u1E99': 'y',
	        '\u1EF5': 'y',
	        '\u01B4': 'y',
	        '\u024F': 'y',
	        '\u1EFF': 'y',
	        '\u24E9': 'z',
	        '\uFF5A': 'z',
	        '\u017A': 'z',
	        '\u1E91': 'z',
	        '\u017C': 'z',
	        '\u017E': 'z',
	        '\u1E93': 'z',
	        '\u1E95': 'z',
	        '\u01B6': 'z',
	        '\u0225': 'z',
	        '\u0240': 'z',
	        '\u2C6C': 'z',
	        '\uA763': 'z',
	        '\u0386': '\u0391',
	        '\u0388': '\u0395',
	        '\u0389': '\u0397',
	        '\u038A': '\u0399',
	        '\u03AA': '\u0399',
	        '\u038C': '\u039F',
	        '\u038E': '\u03A5',
	        '\u03AB': '\u03A5',
	        '\u038F': '\u03A9',
	        '\u03AC': '\u03B1',
	        '\u03AD': '\u03B5',
	        '\u03AE': '\u03B7',
	        '\u03AF': '\u03B9',
	        '\u03CA': '\u03B9',
	        '\u0390': '\u03B9',
	        '\u03CC': '\u03BF',
	        '\u03CD': '\u03C5',
	        '\u03CB': '\u03C5',
	        '\u03B0': '\u03C5',
	        '\u03C9': '\u03C9',
	        '\u03C2': '\u03C3'
	      };
	
	      return diacritics;
	    });
	
	    S2.define('select2/data/base', ['../utils'], function (Utils) {
	      function BaseAdapter($element, options) {
	        BaseAdapter.__super__.constructor.call(this);
	      }
	
	      Utils.Extend(BaseAdapter, Utils.Observable);
	
	      BaseAdapter.prototype.current = function (callback) {
	        throw new Error('The `current` method must be defined in child classes.');
	      };
	
	      BaseAdapter.prototype.query = function (params, callback) {
	        throw new Error('The `query` method must be defined in child classes.');
	      };
	
	      BaseAdapter.prototype.bind = function (container, $container) {
	        // Can be implemented in subclasses
	      };
	
	      BaseAdapter.prototype.destroy = function () {
	        // Can be implemented in subclasses
	      };
	
	      BaseAdapter.prototype.generateResultId = function (container, data) {
	        var id = container.id + '-result-';
	
	        id += Utils.generateChars(4);
	
	        if (data.id != null) {
	          id += '-' + data.id.toString();
	        } else {
	          id += '-' + Utils.generateChars(4);
	        }
	        return id;
	      };
	
	      return BaseAdapter;
	    });
	
	    S2.define('select2/data/select', ['./base', '../utils', 'jquery'], function (BaseAdapter, Utils, $) {
	      function SelectAdapter($element, options) {
	        this.$element = $element;
	        this.options = options;
	
	        SelectAdapter.__super__.constructor.call(this);
	      }
	
	      Utils.Extend(SelectAdapter, BaseAdapter);
	
	      SelectAdapter.prototype.current = function (callback) {
	        var data = [];
	        var self = this;
	
	        this.$element.find(':selected').each(function () {
	          var $option = $(this);
	
	          var option = self.item($option);
	
	          data.push(option);
	        });
	
	        callback(data);
	      };
	
	      SelectAdapter.prototype.select = function (data) {
	        var self = this;
	
	        data.selected = true;
	
	        // If data.element is a DOM node, use it instead
	        if ($(data.element).is('option')) {
	          data.element.selected = true;
	
	          this.$element.trigger('change');
	
	          return;
	        }
	
	        if (this.$element.prop('multiple')) {
	          this.current(function (currentData) {
	            var val = [];
	
	            data = [data];
	            data.push.apply(data, currentData);
	
	            for (var d = 0; d < data.length; d++) {
	              var id = data[d].id;
	
	              if ($.inArray(id, val) === -1) {
	                val.push(id);
	              }
	            }
	
	            self.$element.val(val);
	            self.$element.trigger('change');
	          });
	        } else {
	          var val = data.id;
	
	          this.$element.val(val);
	          this.$element.trigger('change');
	        }
	      };
	
	      SelectAdapter.prototype.unselect = function (data) {
	        var self = this;
	
	        if (!this.$element.prop('multiple')) {
	          return;
	        }
	
	        data.selected = false;
	
	        if ($(data.element).is('option')) {
	          data.element.selected = false;
	
	          this.$element.trigger('change');
	
	          return;
	        }
	
	        this.current(function (currentData) {
	          var val = [];
	
	          for (var d = 0; d < currentData.length; d++) {
	            var id = currentData[d].id;
	
	            if (id !== data.id && $.inArray(id, val) === -1) {
	              val.push(id);
	            }
	          }
	
	          self.$element.val(val);
	
	          self.$element.trigger('change');
	        });
	      };
	
	      SelectAdapter.prototype.bind = function (container, $container) {
	        var self = this;
	
	        this.container = container;
	
	        container.on('select', function (params) {
	          self.select(params.data);
	        });
	
	        container.on('unselect', function (params) {
	          self.unselect(params.data);
	        });
	      };
	
	      SelectAdapter.prototype.destroy = function () {
	        // Remove anything added to child elements
	        this.$element.find('*').each(function () {
	          // Remove any custom data set by Select2
	          Utils.RemoveData(this);
	        });
	      };
	
	      SelectAdapter.prototype.query = function (params, callback) {
	        var data = [];
	        var self = this;
	
	        var $options = this.$element.children();
	
	        $options.each(function () {
	          var $option = $(this);
	
	          if (!$option.is('option') && !$option.is('optgroup')) {
	            return;
	          }
	
	          var option = self.item($option);
	
	          var matches = self.matches(params, option);
	
	          if (matches !== null) {
	            data.push(matches);
	          }
	        });
	
	        callback({
	          results: data
	        });
	      };
	
	      SelectAdapter.prototype.addOptions = function ($options) {
	        Utils.appendMany(this.$element, $options);
	      };
	
	      SelectAdapter.prototype.option = function (data) {
	        var option;
	
	        if (data.children) {
	          option = document.createElement('optgroup');
	          option.label = data.text;
	        } else {
	          option = document.createElement('option');
	
	          if (option.textContent !== undefined) {
	            option.textContent = data.text;
	          } else {
	            option.innerText = data.text;
	          }
	        }
	
	        if (data.id !== undefined) {
	          option.value = data.id;
	        }
	
	        if (data.disabled) {
	          option.disabled = true;
	        }
	
	        if (data.selected) {
	          option.selected = true;
	        }
	
	        if (data.title) {
	          option.title = data.title;
	        }
	
	        var $option = $(option);
	
	        var normalizedData = this._normalizeItem(data);
	        normalizedData.element = option;
	
	        // Override the option's data with the combined data
	        Utils.StoreData(option, 'data', normalizedData);
	
	        return $option;
	      };
	
	      SelectAdapter.prototype.item = function ($option) {
	        var data = {};
	
	        data = Utils.GetData($option[0], 'data');
	
	        if (data != null) {
	          return data;
	        }
	
	        if ($option.is('option')) {
	          data = {
	            id: $option.val(),
	            text: $option.text(),
	            disabled: $option.prop('disabled'),
	            selected: $option.prop('selected'),
	            title: $option.prop('title')
	          };
	        } else if ($option.is('optgroup')) {
	          data = {
	            text: $option.prop('label'),
	            children: [],
	            title: $option.prop('title')
	          };
	
	          var $children = $option.children('option');
	          var children = [];
	
	          for (var c = 0; c < $children.length; c++) {
	            var $child = $($children[c]);
	
	            var child = this.item($child);
	
	            children.push(child);
	          }
	
	          data.children = children;
	        }
	
	        data = this._normalizeItem(data);
	        data.element = $option[0];
	
	        Utils.StoreData($option[0], 'data', data);
	
	        return data;
	      };
	
	      SelectAdapter.prototype._normalizeItem = function (item) {
	        if (item !== Object(item)) {
	          item = {
	            id: item,
	            text: item
	          };
	        }
	
	        item = $.extend({}, {
	          text: ''
	        }, item);
	
	        var defaults = {
	          selected: false,
	          disabled: false
	        };
	
	        if (item.id != null) {
	          item.id = item.id.toString();
	        }
	
	        if (item.text != null) {
	          item.text = item.text.toString();
	        }
	
	        if (item._resultId == null && item.id && this.container != null) {
	          item._resultId = this.generateResultId(this.container, item);
	        }
	
	        return $.extend({}, defaults, item);
	      };
	
	      SelectAdapter.prototype.matches = function (params, data) {
	        var matcher = this.options.get('matcher');
	
	        return matcher(params, data);
	      };
	
	      return SelectAdapter;
	    });
	
	    S2.define('select2/data/array', ['./select', '../utils', 'jquery'], function (SelectAdapter, Utils, $) {
	      function ArrayAdapter($element, options) {
	        var data = options.get('data') || [];
	
	        ArrayAdapter.__super__.constructor.call(this, $element, options);
	
	        this.addOptions(this.convertToOptions(data));
	      }
	
	      Utils.Extend(ArrayAdapter, SelectAdapter);
	
	      ArrayAdapter.prototype.select = function (data) {
	        var $option = this.$element.find('option').filter(function (i, elm) {
	          return elm.value == data.id.toString();
	        });
	
	        if ($option.length === 0) {
	          $option = this.option(data);
	
	          this.addOptions($option);
	        }
	
	        ArrayAdapter.__super__.select.call(this, data);
	      };
	
	      ArrayAdapter.prototype.convertToOptions = function (data) {
	        var self = this;
	
	        var $existing = this.$element.find('option');
	        var existingIds = $existing.map(function () {
	          return self.item($(this)).id;
	        }).get();
	
	        var $options = [];
	
	        // Filter out all items except for the one passed in the argument
	        function onlyItem(item) {
	          return function () {
	            return $(this).val() == item.id;
	          };
	        }
	
	        for (var d = 0; d < data.length; d++) {
	          var item = this._normalizeItem(data[d]);
	
	          // Skip items which were pre-loaded, only merge the data
	          if ($.inArray(item.id, existingIds) >= 0) {
	            var $existingOption = $existing.filter(onlyItem(item));
	
	            var existingData = this.item($existingOption);
	            var newData = $.extend(true, {}, item, existingData);
	
	            var $newOption = this.option(newData);
	
	            $existingOption.replaceWith($newOption);
	
	            continue;
	          }
	
	          var $option = this.option(item);
	
	          if (item.children) {
	            var $children = this.convertToOptions(item.children);
	
	            Utils.appendMany($option, $children);
	          }
	
	          $options.push($option);
	        }
	
	        return $options;
	      };
	
	      return ArrayAdapter;
	    });
	
	    S2.define('select2/data/ajax', ['./array', '../utils', 'jquery'], function (ArrayAdapter, Utils, $) {
	      function AjaxAdapter($element, options) {
	        this.ajaxOptions = this._applyDefaults(options.get('ajax'));
	
	        if (this.ajaxOptions.processResults != null) {
	          this.processResults = this.ajaxOptions.processResults;
	        }
	
	        AjaxAdapter.__super__.constructor.call(this, $element, options);
	      }
	
	      Utils.Extend(AjaxAdapter, ArrayAdapter);
	
	      AjaxAdapter.prototype._applyDefaults = function (options) {
	        var defaults = {
	          data: function data(params) {
	            return $.extend({}, params, {
	              q: params.term
	            });
	          },
	          transport: function transport(params, success, failure) {
	            var $request = $.ajax(params);
	
	            $request.then(success);
	            $request.fail(failure);
	
	            return $request;
	          }
	        };
	
	        return $.extend({}, defaults, options, true);
	      };
	
	      AjaxAdapter.prototype.processResults = function (results) {
	        return results;
	      };
	
	      AjaxAdapter.prototype.query = function (params, callback) {
	        var matches = [];
	        var self = this;
	
	        if (this._request != null) {
	          // JSONP requests cannot always be aborted
	          if ($.isFunction(this._request.abort)) {
	            this._request.abort();
	          }
	
	          this._request = null;
	        }
	
	        var options = $.extend({
	          type: 'GET'
	        }, this.ajaxOptions);
	
	        if (typeof options.url === 'function') {
	          options.url = options.url.call(this.$element, params);
	        }
	
	        if (typeof options.data === 'function') {
	          options.data = options.data.call(this.$element, params);
	        }
	
	        function request() {
	          var $request = options.transport(options, function (data) {
	            var results = self.processResults(data, params);
	
	            if (self.options.get('debug') && window.console && console.error) {
	              // Check to make sure that the response included a `results` key.
	              if (!results || !results.results || !$.isArray(results.results)) {
	                console.error('Select2: The AJAX results did not return an array in the ' + '`results` key of the response.');
	              }
	            }
	
	            callback(results);
	          }, function () {
	            // Attempt to detect if a request was aborted
	            // Only works if the transport exposes a status property
	            if ('status' in $request && ($request.status === 0 || $request.status === '0')) {
	              return;
	            }
	
	            self.trigger('results:message', {
	              message: 'errorLoading'
	            });
	          });
	
	          self._request = $request;
	        }
	
	        if (this.ajaxOptions.delay && params.term != null) {
	          if (this._queryTimeout) {
	            window.clearTimeout(this._queryTimeout);
	          }
	
	          this._queryTimeout = window.setTimeout(request, this.ajaxOptions.delay);
	        } else {
	          request();
	        }
	      };
	
	      return AjaxAdapter;
	    });
	
	    S2.define('select2/data/tags', ['jquery'], function ($) {
	      function Tags(decorated, $element, options) {
	        var tags = options.get('tags');
	
	        var createTag = options.get('createTag');
	
	        if (createTag !== undefined) {
	          this.createTag = createTag;
	        }
	
	        var insertTag = options.get('insertTag');
	
	        if (insertTag !== undefined) {
	          this.insertTag = insertTag;
	        }
	
	        decorated.call(this, $element, options);
	
	        if ($.isArray(tags)) {
	          for (var t = 0; t < tags.length; t++) {
	            var tag = tags[t];
	            var item = this._normalizeItem(tag);
	
	            var $option = this.option(item);
	
	            this.$element.append($option);
	          }
	        }
	      }
	
	      Tags.prototype.query = function (decorated, params, callback) {
	        var self = this;
	
	        this._removeOldTags();
	
	        if (params.term == null || params.page != null) {
	          decorated.call(this, params, callback);
	          return;
	        }
	
	        function wrapper(obj, child) {
	          var data = obj.results;
	
	          for (var i = 0; i < data.length; i++) {
	            var option = data[i];
	
	            var checkChildren = option.children != null && !wrapper({
	              results: option.children
	            }, true);
	
	            var optionText = (option.text || '').toUpperCase();
	            var paramsTerm = (params.term || '').toUpperCase();
	
	            var checkText = optionText === paramsTerm;
	
	            if (checkText || checkChildren) {
	              if (child) {
	                return false;
	              }
	
	              obj.data = data;
	              callback(obj);
	
	              return;
	            }
	          }
	
	          if (child) {
	            return true;
	          }
	
	          var tag = self.createTag(params);
	
	          if (tag != null) {
	            var $option = self.option(tag);
	            $option.attr('data-select2-tag', true);
	
	            self.addOptions([$option]);
	
	            self.insertTag(data, tag);
	          }
	
	          obj.results = data;
	
	          callback(obj);
	        }
	
	        decorated.call(this, params, wrapper);
	      };
	
	      Tags.prototype.createTag = function (decorated, params) {
	        var term = $.trim(params.term);
	
	        if (term === '') {
	          return null;
	        }
	
	        return {
	          id: term,
	          text: term
	        };
	      };
	
	      Tags.prototype.insertTag = function (_, data, tag) {
	        data.unshift(tag);
	      };
	
	      Tags.prototype._removeOldTags = function (_) {
	        var tag = this._lastTag;
	
	        var $options = this.$element.find('option[data-select2-tag]');
	
	        $options.each(function () {
	          if (this.selected) {
	            return;
	          }
	
	          $(this).remove();
	        });
	      };
	
	      return Tags;
	    });
	
	    S2.define('select2/data/tokenizer', ['jquery'], function ($) {
	      function Tokenizer(decorated, $element, options) {
	        var tokenizer = options.get('tokenizer');
	
	        if (tokenizer !== undefined) {
	          this.tokenizer = tokenizer;
	        }
	
	        decorated.call(this, $element, options);
	      }
	
	      Tokenizer.prototype.bind = function (decorated, container, $container) {
	        decorated.call(this, container, $container);
	
	        this.$search = container.dropdown.$search || container.selection.$search || $container.find('.select2-search__field');
	      };
	
	      Tokenizer.prototype.query = function (decorated, params, callback) {
	        var self = this;
	
	        function createAndSelect(data) {
	          // Normalize the data object so we can use it for checks
	          var item = self._normalizeItem(data);
	
	          // Check if the data object already exists as a tag
	          // Select it if it doesn't
	          var $existingOptions = self.$element.find('option').filter(function () {
	            return $(this).val() === item.id;
	          });
	
	          // If an existing option wasn't found for it, create the option
	          if (!$existingOptions.length) {
	            var $option = self.option(item);
	            $option.attr('data-select2-tag', true);
	
	            self._removeOldTags();
	            self.addOptions([$option]);
	          }
	
	          // Select the item, now that we know there is an option for it
	          select(item);
	        }
	
	        function select(data) {
	          self.trigger('select', {
	            data: data
	          });
	        }
	
	        params.term = params.term || '';
	
	        var tokenData = this.tokenizer(params, this.options, createAndSelect);
	
	        if (tokenData.term !== params.term) {
	          // Replace the search term if we have the search box
	          if (this.$search.length) {
	            this.$search.val(tokenData.term);
	            this.$search.focus();
	          }
	
	          params.term = tokenData.term;
	        }
	
	        decorated.call(this, params, callback);
	      };
	
	      Tokenizer.prototype.tokenizer = function (_, params, options, callback) {
	        var separators = options.get('tokenSeparators') || [];
	        var term = params.term;
	        var i = 0;
	
	        var createTag = this.createTag || function (params) {
	          return {
	            id: params.term,
	            text: params.term
	          };
	        };
	
	        while (i < term.length) {
	          var termChar = term[i];
	
	          if ($.inArray(termChar, separators) === -1) {
	            i++;
	
	            continue;
	          }
	
	          var part = term.substr(0, i);
	          var partParams = $.extend({}, params, {
	            term: part
	          });
	
	          var data = createTag(partParams);
	
	          if (data == null) {
	            i++;
	            continue;
	          }
	
	          callback(data);
	
	          // Reset the term to not include the tokenized portion
	          term = term.substr(i + 1) || '';
	          i = 0;
	        }
	
	        return {
	          term: term
	        };
	      };
	
	      return Tokenizer;
	    });
	
	    S2.define('select2/data/minimumInputLength', [], function () {
	      function MinimumInputLength(decorated, $e, options) {
	        this.minimumInputLength = options.get('minimumInputLength');
	
	        decorated.call(this, $e, options);
	      }
	
	      MinimumInputLength.prototype.query = function (decorated, params, callback) {
	        params.term = params.term || '';
	
	        if (params.term.length < this.minimumInputLength) {
	          this.trigger('results:message', {
	            message: 'inputTooShort',
	            args: {
	              minimum: this.minimumInputLength,
	              input: params.term,
	              params: params
	            }
	          });
	
	          return;
	        }
	
	        decorated.call(this, params, callback);
	      };
	
	      return MinimumInputLength;
	    });
	
	    S2.define('select2/data/maximumInputLength', [], function () {
	      function MaximumInputLength(decorated, $e, options) {
	        this.maximumInputLength = options.get('maximumInputLength');
	
	        decorated.call(this, $e, options);
	      }
	
	      MaximumInputLength.prototype.query = function (decorated, params, callback) {
	        params.term = params.term || '';
	
	        if (this.maximumInputLength > 0 && params.term.length > this.maximumInputLength) {
	          this.trigger('results:message', {
	            message: 'inputTooLong',
	            args: {
	              maximum: this.maximumInputLength,
	              input: params.term,
	              params: params
	            }
	          });
	
	          return;
	        }
	
	        decorated.call(this, params, callback);
	      };
	
	      return MaximumInputLength;
	    });
	
	    S2.define('select2/data/maximumSelectionLength', [], function () {
	      function MaximumSelectionLength(decorated, $e, options) {
	        this.maximumSelectionLength = options.get('maximumSelectionLength');
	
	        decorated.call(this, $e, options);
	      }
	
	      MaximumSelectionLength.prototype.query = function (decorated, params, callback) {
	        var self = this;
	
	        this.current(function (currentData) {
	          var count = currentData != null ? currentData.length : 0;
	          if (self.maximumSelectionLength > 0 && count >= self.maximumSelectionLength) {
	            self.trigger('results:message', {
	              message: 'maximumSelected',
	              args: {
	                maximum: self.maximumSelectionLength
	              }
	            });
	            return;
	          }
	          decorated.call(self, params, callback);
	        });
	      };
	
	      return MaximumSelectionLength;
	    });
	
	    S2.define('select2/dropdown', ['jquery', './utils'], function ($, Utils) {
	      function Dropdown($element, options) {
	        this.$element = $element;
	        this.options = options;
	
	        Dropdown.__super__.constructor.call(this);
	      }
	
	      Utils.Extend(Dropdown, Utils.Observable);
	
	      Dropdown.prototype.render = function () {
	        var $dropdown = $('<span class="select2-dropdown">' + '<span class="select2-results"></span>' + '</span>');
	
	        $dropdown.attr('dir', this.options.get('dir'));
	
	        this.$dropdown = $dropdown;
	
	        return $dropdown;
	      };
	
	      Dropdown.prototype.bind = function () {
	        // Should be implemented in subclasses
	      };
	
	      Dropdown.prototype.position = function ($dropdown, $container) {
	        // Should be implmented in subclasses
	      };
	
	      Dropdown.prototype.destroy = function () {
	        // Remove the dropdown from the DOM
	        this.$dropdown.remove();
	      };
	
	      return Dropdown;
	    });
	
	    S2.define('select2/dropdown/search', ['jquery', '../utils'], function ($, Utils) {
	      function Search() {}
	
	      Search.prototype.render = function (decorated) {
	        var $rendered = decorated.call(this);
	
	        var $search = $('<span class="select2-search select2-search--dropdown">' + '<input class="select2-search__field" type="search" tabindex="-1"' + ' autocomplete="off" autocorrect="off" autocapitalize="none"' + ' spellcheck="false" role="textbox" />' + '</span>');
	
	        this.$searchContainer = $search;
	        this.$search = $search.find('input');
	
	        $rendered.prepend($search);
	
	        return $rendered;
	      };
	
	      Search.prototype.bind = function (decorated, container, $container) {
	        var self = this;
	
	        decorated.call(this, container, $container);
	
	        this.$search.on('keydown', function (evt) {
	          self.trigger('keypress', evt);
	
	          self._keyUpPrevented = evt.isDefaultPrevented();
	        });
	
	        // Workaround for browsers which do not support the `input` event
	        // This will prevent double-triggering of events for browsers which support
	        // both the `keyup` and `input` events.
	        this.$search.on('input', function (evt) {
	          // Unbind the duplicated `keyup` event
	          $(this).off('keyup');
	        });
	
	        this.$search.on('keyup input', function (evt) {
	          self.handleSearch(evt);
	        });
	
	        container.on('open', function () {
	          self.$search.attr('tabindex', 0);
	
	          self.$search.focus();
	
	          window.setTimeout(function () {
	            self.$search.focus();
	          }, 0);
	        });
	
	        container.on('close', function () {
	          self.$search.attr('tabindex', -1);
	
	          self.$search.val('');
	          self.$search.blur();
	        });
	
	        container.on('focus', function () {
	          if (!container.isOpen()) {
	            self.$search.focus();
	          }
	        });
	
	        container.on('results:all', function (params) {
	          if (params.query.term == null || params.query.term === '') {
	            var showSearch = self.showSearch(params);
	
	            if (showSearch) {
	              self.$searchContainer.removeClass('select2-search--hide');
	            } else {
	              self.$searchContainer.addClass('select2-search--hide');
	            }
	          }
	        });
	      };
	
	      Search.prototype.handleSearch = function (evt) {
	        if (!this._keyUpPrevented) {
	          var input = this.$search.val();
	
	          this.trigger('query', {
	            term: input
	          });
	        }
	
	        this._keyUpPrevented = false;
	      };
	
	      Search.prototype.showSearch = function (_, params) {
	        return true;
	      };
	
	      return Search;
	    });
	
	    S2.define('select2/dropdown/hidePlaceholder', [], function () {
	      function HidePlaceholder(decorated, $element, options, dataAdapter) {
	        this.placeholder = this.normalizePlaceholder(options.get('placeholder'));
	
	        decorated.call(this, $element, options, dataAdapter);
	      }
	
	      HidePlaceholder.prototype.append = function (decorated, data) {
	        data.results = this.removePlaceholder(data.results);
	
	        decorated.call(this, data);
	      };
	
	      HidePlaceholder.prototype.normalizePlaceholder = function (_, placeholder) {
	        if (typeof placeholder === 'string') {
	          placeholder = {
	            id: '',
	            text: placeholder
	          };
	        }
	
	        return placeholder;
	      };
	
	      HidePlaceholder.prototype.removePlaceholder = function (_, data) {
	        var modifiedData = data.slice(0);
	
	        for (var d = data.length - 1; d >= 0; d--) {
	          var item = data[d];
	
	          if (this.placeholder.id === item.id) {
	            modifiedData.splice(d, 1);
	          }
	        }
	
	        return modifiedData;
	      };
	
	      return HidePlaceholder;
	    });
	
	    S2.define('select2/dropdown/infiniteScroll', ['jquery'], function ($) {
	      function InfiniteScroll(decorated, $element, options, dataAdapter) {
	        this.lastParams = {};
	
	        decorated.call(this, $element, options, dataAdapter);
	
	        this.$loadingMore = this.createLoadingMore();
	        this.loading = false;
	      }
	
	      InfiniteScroll.prototype.append = function (decorated, data) {
	        this.$loadingMore.remove();
	        this.loading = false;
	
	        decorated.call(this, data);
	
	        if (this.showLoadingMore(data)) {
	          this.$results.append(this.$loadingMore);
	        }
	      };
	
	      InfiniteScroll.prototype.bind = function (decorated, container, $container) {
	        var self = this;
	
	        decorated.call(this, container, $container);
	
	        container.on('query', function (params) {
	          self.lastParams = params;
	          self.loading = true;
	        });
	
	        container.on('query:append', function (params) {
	          self.lastParams = params;
	          self.loading = true;
	        });
	
	        this.$results.on('scroll', function () {
	          var isLoadMoreVisible = $.contains(document.documentElement, self.$loadingMore[0]);
	
	          if (self.loading || !isLoadMoreVisible) {
	            return;
	          }
	
	          var currentOffset = self.$results.offset().top + self.$results.outerHeight(false);
	          var loadingMoreOffset = self.$loadingMore.offset().top + self.$loadingMore.outerHeight(false);
	
	          if (currentOffset + 50 >= loadingMoreOffset) {
	            self.loadMore();
	          }
	        });
	      };
	
	      InfiniteScroll.prototype.loadMore = function () {
	        this.loading = true;
	
	        var params = $.extend({}, { page: 1 }, this.lastParams);
	
	        params.page++;
	
	        this.trigger('query:append', params);
	      };
	
	      InfiniteScroll.prototype.showLoadingMore = function (_, data) {
	        return data.pagination && data.pagination.more;
	      };
	
	      InfiniteScroll.prototype.createLoadingMore = function () {
	        var $option = $('<li ' + 'class="select2-results__option select2-results__option--load-more"' + 'role="treeitem" aria-disabled="true"></li>');
	
	        var message = this.options.get('translations').get('loadingMore');
	
	        $option.html(message(this.lastParams));
	
	        return $option;
	      };
	
	      return InfiniteScroll;
	    });
	
	    S2.define('select2/dropdown/attachBody', ['jquery', '../utils'], function ($, Utils) {
	      function AttachBody(decorated, $element, options) {
	        this.$dropdownParent = options.get('dropdownParent') || $(document.body);
	
	        decorated.call(this, $element, options);
	      }
	
	      AttachBody.prototype.bind = function (decorated, container, $container) {
	        var self = this;
	
	        var setupResultsEvents = false;
	
	        decorated.call(this, container, $container);
	
	        container.on('open', function () {
	          self._showDropdown();
	          self._attachPositioningHandler(container);
	
	          if (!setupResultsEvents) {
	            setupResultsEvents = true;
	
	            container.on('results:all', function () {
	              self._positionDropdown();
	              self._resizeDropdown();
	            });
	
	            container.on('results:append', function () {
	              self._positionDropdown();
	              self._resizeDropdown();
	            });
	          }
	        });
	
	        container.on('close', function () {
	          self._hideDropdown();
	          self._detachPositioningHandler(container);
	        });
	
	        this.$dropdownContainer.on('mousedown', function (evt) {
	          evt.stopPropagation();
	        });
	      };
	
	      AttachBody.prototype.destroy = function (decorated) {
	        decorated.call(this);
	
	        this.$dropdownContainer.remove();
	      };
	
	      AttachBody.prototype.position = function (decorated, $dropdown, $container) {
	        // Clone all of the container classes
	        $dropdown.attr('class', $container.attr('class'));
	
	        $dropdown.removeClass('select2');
	        $dropdown.addClass('select2-container--open');
	
	        $dropdown.css({
	          position: 'absolute',
	          top: -999999
	        });
	
	        this.$container = $container;
	      };
	
	      AttachBody.prototype.render = function (decorated) {
	        var $container = $('<span></span>');
	
	        var $dropdown = decorated.call(this);
	        $container.append($dropdown);
	
	        this.$dropdownContainer = $container;
	
	        return $container;
	      };
	
	      AttachBody.prototype._hideDropdown = function (decorated) {
	        this.$dropdownContainer.detach();
	      };
	
	      AttachBody.prototype._attachPositioningHandler = function (decorated, container) {
	        var self = this;
	
	        var scrollEvent = 'scroll.select2.' + container.id;
	        var resizeEvent = 'resize.select2.' + container.id;
	        var orientationEvent = 'orientationchange.select2.' + container.id;
	
	        var $watchers = this.$container.parents().filter(Utils.hasScroll);
	        $watchers.each(function () {
	          Utils.StoreData(this, 'select2-scroll-position', {
	            x: $(this).scrollLeft(),
	            y: $(this).scrollTop()
	          });
	        });
	
	        $watchers.on(scrollEvent, function (ev) {
	          var position = Utils.GetData(this, 'select2-scroll-position');
	          $(this).scrollTop(position.y);
	        });
	
	        $(window).on(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent, function (e) {
	          self._positionDropdown();
	          self._resizeDropdown();
	        });
	      };
	
	      AttachBody.prototype._detachPositioningHandler = function (decorated, container) {
	        var scrollEvent = 'scroll.select2.' + container.id;
	        var resizeEvent = 'resize.select2.' + container.id;
	        var orientationEvent = 'orientationchange.select2.' + container.id;
	
	        var $watchers = this.$container.parents().filter(Utils.hasScroll);
	        $watchers.off(scrollEvent);
	
	        $(window).off(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent);
	      };
	
	      AttachBody.prototype._positionDropdown = function () {
	        var $window = $(window);
	
	        var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
	        var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');
	
	        var newDirection = null;
	
	        var offset = this.$container.offset();
	
	        offset.bottom = offset.top + this.$container.outerHeight(false);
	
	        var container = {
	          height: this.$container.outerHeight(false)
	        };
	
	        container.top = offset.top;
	        container.bottom = offset.top + container.height;
	
	        var dropdown = {
	          height: this.$dropdown.outerHeight(false)
	        };
	
	        var viewport = {
	          top: $window.scrollTop(),
	          bottom: $window.scrollTop() + $window.height()
	        };
	
	        var enoughRoomAbove = viewport.top < offset.top - dropdown.height;
	        var enoughRoomBelow = viewport.bottom > offset.bottom + dropdown.height;
	
	        var css = {
	          left: offset.left,
	          top: container.bottom
	        };
	
	        // Determine what the parent element is to use for calciulating the offset
	        var $offsetParent = this.$dropdownParent;
	
	        // For statically positoned elements, we need to get the element
	        // that is determining the offset
	        if ($offsetParent.css('position') === 'static') {
	          $offsetParent = $offsetParent.offsetParent();
	        }
	
	        var parentOffset = $offsetParent.offset();
	
	        css.top -= parentOffset.top;
	        css.left -= parentOffset.left;
	
	        if (!isCurrentlyAbove && !isCurrentlyBelow) {
	          newDirection = 'below';
	        }
	
	        if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
	          newDirection = 'above';
	        } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
	          newDirection = 'below';
	        }
	
	        if (newDirection == 'above' || isCurrentlyAbove && newDirection !== 'below') {
	          css.top = container.top - parentOffset.top - dropdown.height;
	        }
	
	        if (newDirection != null) {
	          this.$dropdown.removeClass('select2-dropdown--below select2-dropdown--above').addClass('select2-dropdown--' + newDirection);
	          this.$container.removeClass('select2-container--below select2-container--above').addClass('select2-container--' + newDirection);
	        }
	
	        this.$dropdownContainer.css(css);
	      };
	
	      AttachBody.prototype._resizeDropdown = function () {
	        var css = {
	          width: this.$container.outerWidth(false) + 'px'
	        };
	
	        if (this.options.get('dropdownAutoWidth')) {
	          css.minWidth = css.width;
	          css.position = 'relative';
	          css.width = 'auto';
	        }
	
	        this.$dropdown.css(css);
	      };
	
	      AttachBody.prototype._showDropdown = function (decorated) {
	        this.$dropdownContainer.appendTo(this.$dropdownParent);
	
	        this._positionDropdown();
	        this._resizeDropdown();
	      };
	
	      return AttachBody;
	    });
	
	    S2.define('select2/dropdown/minimumResultsForSearch', [], function () {
	      function countResults(data) {
	        var count = 0;
	
	        for (var d = 0; d < data.length; d++) {
	          var item = data[d];
	
	          if (item.children) {
	            count += countResults(item.children);
	          } else {
	            count++;
	          }
	        }
	
	        return count;
	      }
	
	      function MinimumResultsForSearch(decorated, $element, options, dataAdapter) {
	        this.minimumResultsForSearch = options.get('minimumResultsForSearch');
	
	        if (this.minimumResultsForSearch < 0) {
	          this.minimumResultsForSearch = Infinity;
	        }
	
	        decorated.call(this, $element, options, dataAdapter);
	      }
	
	      MinimumResultsForSearch.prototype.showSearch = function (decorated, params) {
	        if (countResults(params.data.results) < this.minimumResultsForSearch) {
	          return false;
	        }
	
	        return decorated.call(this, params);
	      };
	
	      return MinimumResultsForSearch;
	    });
	
	    S2.define('select2/dropdown/selectOnClose', ['../utils'], function (Utils) {
	      function SelectOnClose() {}
	
	      SelectOnClose.prototype.bind = function (decorated, container, $container) {
	        var self = this;
	
	        decorated.call(this, container, $container);
	
	        container.on('close', function (params) {
	          self._handleSelectOnClose(params);
	        });
	      };
	
	      SelectOnClose.prototype._handleSelectOnClose = function (_, params) {
	        if (params && params.originalSelect2Event != null) {
	          var event = params.originalSelect2Event;
	
	          // Don't select an item if the close event was triggered from a select or
	          // unselect event
	          if (event._type === 'select' || event._type === 'unselect') {
	            return;
	          }
	        }
	
	        var $highlightedResults = this.getHighlightedResults();
	
	        // Only select highlighted results
	        if ($highlightedResults.length < 1) {
	          return;
	        }
	
	        var data = Utils.GetData($highlightedResults[0], 'data');
	
	        // Don't re-select already selected resulte
	        if (data.element != null && data.element.selected || data.element == null && data.selected) {
	          return;
	        }
	
	        this.trigger('select', {
	          data: data
	        });
	      };
	
	      return SelectOnClose;
	    });
	
	    S2.define('select2/dropdown/closeOnSelect', [], function () {
	      function CloseOnSelect() {}
	
	      CloseOnSelect.prototype.bind = function (decorated, container, $container) {
	        var self = this;
	
	        decorated.call(this, container, $container);
	
	        container.on('select', function (evt) {
	          self._selectTriggered(evt);
	        });
	
	        container.on('unselect', function (evt) {
	          self._selectTriggered(evt);
	        });
	      };
	
	      CloseOnSelect.prototype._selectTriggered = function (_, evt) {
	        var originalEvent = evt.originalEvent;
	
	        // Don't close if the control key is being held
	        if (originalEvent && originalEvent.ctrlKey) {
	          return;
	        }
	
	        this.trigger('close', {
	          originalEvent: originalEvent,
	          originalSelect2Event: evt
	        });
	      };
	
	      return CloseOnSelect;
	    });
	
	    S2.define('select2/i18n/en', [], function () {
	      // English
	      return {
	        errorLoading: function errorLoading() {
	          return 'The results could not be loaded.';
	        },
	        inputTooLong: function inputTooLong(args) {
	          var overChars = args.input.length - args.maximum;
	
	          var message = 'Please delete ' + overChars + ' character';
	
	          if (overChars != 1) {
	            message += 's';
	          }
	
	          return message;
	        },
	        inputTooShort: function inputTooShort(args) {
	          var remainingChars = args.minimum - args.input.length;
	
	          var message = 'Please enter ' + remainingChars + ' or more characters';
	
	          return message;
	        },
	        loadingMore: function loadingMore() {
	          return 'Loading more results…';
	        },
	        maximumSelected: function maximumSelected(args) {
	          var message = 'You can only select ' + args.maximum + ' item';
	
	          if (args.maximum != 1) {
	            message += 's';
	          }
	
	          return message;
	        },
	        noResults: function noResults() {
	          return 'Nie znaleziono wyników';
	        },
	        searching: function searching() {
	          return 'Wyszukiwanie…';
	        }
	      };
	    });
	
	    S2.define('select2/defaults', ['jquery', 'require', './results', './selection/single', './selection/multiple', './selection/placeholder', './selection/allowClear', './selection/search', './selection/eventRelay', './utils', './translation', './diacritics', './data/select', './data/array', './data/ajax', './data/tags', './data/tokenizer', './data/minimumInputLength', './data/maximumInputLength', './data/maximumSelectionLength', './dropdown', './dropdown/search', './dropdown/hidePlaceholder', './dropdown/infiniteScroll', './dropdown/attachBody', './dropdown/minimumResultsForSearch', './dropdown/selectOnClose', './dropdown/closeOnSelect', './i18n/en'], function ($, require, ResultsList, SingleSelection, MultipleSelection, Placeholder, AllowClear, SelectionSearch, EventRelay, Utils, Translation, DIACRITICS, SelectData, ArrayData, AjaxData, Tags, Tokenizer, MinimumInputLength, MaximumInputLength, MaximumSelectionLength, Dropdown, DropdownSearch, HidePlaceholder, InfiniteScroll, AttachBody, MinimumResultsForSearch, SelectOnClose, CloseOnSelect, EnglishTranslation) {
	      function Defaults() {
	        this.reset();
	      }
	
	      Defaults.prototype.apply = function (options) {
	        options = $.extend(true, {}, this.defaults, options);
	
	        if (options.dataAdapter == null) {
	          if (options.ajax != null) {
	            options.dataAdapter = AjaxData;
	          } else if (options.data != null) {
	            options.dataAdapter = ArrayData;
	          } else {
	            options.dataAdapter = SelectData;
	          }
	
	          if (options.minimumInputLength > 0) {
	            options.dataAdapter = Utils.Decorate(options.dataAdapter, MinimumInputLength);
	          }
	
	          if (options.maximumInputLength > 0) {
	            options.dataAdapter = Utils.Decorate(options.dataAdapter, MaximumInputLength);
	          }
	
	          if (options.maximumSelectionLength > 0) {
	            options.dataAdapter = Utils.Decorate(options.dataAdapter, MaximumSelectionLength);
	          }
	
	          if (options.tags) {
	            options.dataAdapter = Utils.Decorate(options.dataAdapter, Tags);
	          }
	
	          if (options.tokenSeparators != null || options.tokenizer != null) {
	            options.dataAdapter = Utils.Decorate(options.dataAdapter, Tokenizer);
	          }
	
	          if (options.query != null) {
	            var Query = require(options.amdBase + 'compat/query');
	
	            options.dataAdapter = Utils.Decorate(options.dataAdapter, Query);
	          }
	
	          if (options.initSelection != null) {
	            var InitSelection = require(options.amdBase + 'compat/initSelection');
	
	            options.dataAdapter = Utils.Decorate(options.dataAdapter, InitSelection);
	          }
	        }
	
	        if (options.resultsAdapter == null) {
	          options.resultsAdapter = ResultsList;
	
	          if (options.ajax != null) {
	            options.resultsAdapter = Utils.Decorate(options.resultsAdapter, InfiniteScroll);
	          }
	
	          if (options.placeholder != null) {
	            options.resultsAdapter = Utils.Decorate(options.resultsAdapter, HidePlaceholder);
	          }
	
	          if (options.selectOnClose) {
	            options.resultsAdapter = Utils.Decorate(options.resultsAdapter, SelectOnClose);
	          }
	        }
	
	        if (options.dropdownAdapter == null) {
	          if (options.multiple) {
	            options.dropdownAdapter = Dropdown;
	          } else {
	            var SearchableDropdown = Utils.Decorate(Dropdown, DropdownSearch);
	
	            options.dropdownAdapter = SearchableDropdown;
	          }
	
	          if (options.minimumResultsForSearch !== 0) {
	            options.dropdownAdapter = Utils.Decorate(options.dropdownAdapter, MinimumResultsForSearch);
	          }
	
	          if (options.closeOnSelect) {
	            options.dropdownAdapter = Utils.Decorate(options.dropdownAdapter, CloseOnSelect);
	          }
	
	          if (options.dropdownCssClass != null || options.dropdownCss != null || options.adaptDropdownCssClass != null) {
	            var DropdownCSS = require(options.amdBase + 'compat/dropdownCss');
	
	            options.dropdownAdapter = Utils.Decorate(options.dropdownAdapter, DropdownCSS);
	          }
	
	          options.dropdownAdapter = Utils.Decorate(options.dropdownAdapter, AttachBody);
	        }
	
	        if (options.selectionAdapter == null) {
	          if (options.multiple) {
	            options.selectionAdapter = MultipleSelection;
	          } else {
	            options.selectionAdapter = SingleSelection;
	          }
	
	          // Add the placeholder mixin if a placeholder was specified
	          if (options.placeholder != null) {
	            options.selectionAdapter = Utils.Decorate(options.selectionAdapter, Placeholder);
	          }
	
	          if (options.allowClear) {
	            options.selectionAdapter = Utils.Decorate(options.selectionAdapter, AllowClear);
	          }
	
	          if (options.multiple) {
	            options.selectionAdapter = Utils.Decorate(options.selectionAdapter, SelectionSearch);
	          }
	
	          if (options.containerCssClass != null || options.containerCss != null || options.adaptContainerCssClass != null) {
	            var ContainerCSS = require(options.amdBase + 'compat/containerCss');
	
	            options.selectionAdapter = Utils.Decorate(options.selectionAdapter, ContainerCSS);
	          }
	
	          options.selectionAdapter = Utils.Decorate(options.selectionAdapter, EventRelay);
	        }
	
	        if (typeof options.language === 'string') {
	          // Check if the language is specified with a region
	          if (options.language.indexOf('-') > 0) {
	            // Extract the region information if it is included
	            var languageParts = options.language.split('-');
	            var baseLanguage = languageParts[0];
	
	            options.language = [options.language, baseLanguage];
	          } else {
	            options.language = [options.language];
	          }
	        }
	
	        if ($.isArray(options.language)) {
	          var languages = new Translation();
	          options.language.push('en');
	
	          var languageNames = options.language;
	
	          for (var l = 0; l < languageNames.length; l++) {
	            var name = languageNames[l];
	            var language = {};
	
	            try {
	              // Try to load it with the original name
	              language = Translation.loadPath(name);
	            } catch (e) {
	              try {
	                // If we couldn't load it, check if it wasn't the full path
	                name = this.defaults.amdLanguageBase + name;
	                language = Translation.loadPath(name);
	              } catch (ex) {
	                // The translation could not be loaded at all. Sometimes this is
	                // because of a configuration problem, other times this can be
	                // because of how Select2 helps load all possible translation files.
	                if (options.debug && window.console && console.warn) {
	                  console.warn('Select2: The language file for "' + name + '" could not be ' + 'automatically loaded. A fallback will be used instead.');
	                }
	
	                continue;
	              }
	            }
	
	            languages.extend(language);
	          }
	
	          options.translations = languages;
	        } else {
	          var baseTranslation = Translation.loadPath(this.defaults.amdLanguageBase + 'en');
	          var customTranslation = new Translation(options.language);
	
	          customTranslation.extend(baseTranslation);
	
	          options.translations = customTranslation;
	        }
	
	        return options;
	      };
	
	      Defaults.prototype.reset = function () {
	        function stripDiacritics(text) {
	          // Used 'uni range + named function' from http://jsperf.com/diacritics/18
	          function match(a) {
	            return DIACRITICS[a] || a;
	          }
	
	          return text.replace(/[^\u0000-\u007E]/g, match);
	        }
	
	        function matcher(params, data) {
	          // Always return the object if there is nothing to compare
	          if ($.trim(params.term) === '') {
	            return data;
	          }
	
	          //   if ($(data.element).data('test').toString().indexOf(params.term) > -1) {
	          //     return data;
	          // }
	          var dataAttr = String(data.element.getAttribute('data-country-name'));
	          var termP = stripDiacritics(params.term).toUpperCase();
	          var org = stripDiacritics(dataAttr).toUpperCase();
	
	          // if(termP == org) {
	          //   // console.log(data.element.getAttribute('data-country-name'));
	          //   return data;
	          // }
	
	          if (org.indexOf(termP) > -1) {
	            return data;
	          }
	
	          // Do a recursive check for options with children
	          if (data.children && data.children.length > 0) {
	            // Clone the data object if there are children
	            // This is required as we modify the object to remove any non-matches
	            var match = $.extend(true, {}, data);
	
	            // Check each child of the option
	            for (var c = data.children.length - 1; c >= 0; c--) {
	              var child = data.children[c];
	
	              var matches = matcher(params, child);
	
	              // If there wasn't a match, remove the object in the array
	              if (matches == null) {
	                match.children.splice(c, 1);
	              }
	            }
	
	            // If any children matched, return the new object
	            if (match.children.length > 0) {
	              return match;
	            }
	
	            // If there were no matching children, check just the plain object
	            return matcher(params, match);
	          }
	
	          var original = stripDiacritics(data.text).toUpperCase();
	          var term = stripDiacritics(params.term).toUpperCase();
	
	          // Check if the text contains the term
	          if (original.indexOf(term) > -1) {
	            return data;
	          }
	
	          // If it doesn't contain the term, don't return anything
	          return null;
	        }
	
	        this.defaults = {
	          amdBase: './',
	          amdLanguageBase: './i18n/',
	          closeOnSelect: true,
	          debug: false,
	          dropdownAutoWidth: false,
	          escapeMarkup: Utils.escapeMarkup,
	          language: EnglishTranslation,
	          matcher: matcher,
	          minimumInputLength: 0,
	          maximumInputLength: 0,
	          maximumSelectionLength: 0,
	          minimumResultsForSearch: 0,
	          selectOnClose: false,
	          sorter: function sorter(data) {
	            return data;
	          },
	          templateResult: function templateResult(result) {
	            return result.text;
	          },
	          templateSelection: function templateSelection(selection) {
	            return selection.text;
	          },
	          theme: 'default',
	          width: 'resolve'
	        };
	      };
	
	      Defaults.prototype.set = function (key, value) {
	        var camelKey = $.camelCase(key);
	
	        var data = {};
	        data[camelKey] = value;
	
	        var convertedData = Utils._convertData(data);
	
	        $.extend(true, this.defaults, convertedData);
	      };
	
	      var defaults = new Defaults();
	
	      return defaults;
	    });
	
	    S2.define('select2/options', ['require', 'jquery', './defaults', './utils'], function (require, $, Defaults, Utils) {
	      function Options(options, $element) {
	        this.options = options;
	
	        if ($element != null) {
	          this.fromElement($element);
	        }
	
	        this.options = Defaults.apply(this.options);
	
	        if ($element && $element.is('input')) {
	          var InputCompat = require(this.get('amdBase') + 'compat/inputData');
	
	          this.options.dataAdapter = Utils.Decorate(this.options.dataAdapter, InputCompat);
	        }
	      }
	
	      Options.prototype.fromElement = function ($e) {
	        var excludedData = ['select2'];
	
	        if (this.options.multiple == null) {
	          this.options.multiple = $e.prop('multiple');
	        }
	
	        if (this.options.disabled == null) {
	          this.options.disabled = $e.prop('disabled');
	        }
	
	        if (this.options.language == null) {
	          if ($e.prop('lang')) {
	            this.options.language = $e.prop('lang').toLowerCase();
	          } else if ($e.closest('[lang]').prop('lang')) {
	            this.options.language = $e.closest('[lang]').prop('lang');
	          }
	        }
	
	        if (this.options.dir == null) {
	          if ($e.prop('dir')) {
	            this.options.dir = $e.prop('dir');
	          } else if ($e.closest('[dir]').prop('dir')) {
	            this.options.dir = $e.closest('[dir]').prop('dir');
	          } else {
	            this.options.dir = 'ltr';
	          }
	        }
	
	        $e.prop('disabled', this.options.disabled);
	        $e.prop('multiple', this.options.multiple);
	
	        if (Utils.GetData($e[0], 'select2Tags')) {
	          if (this.options.debug && window.console && console.warn) {
	            console.warn('Select2: The `data-select2-tags` attribute has been changed to ' + 'use the `data-data` and `data-tags="true"` attributes and will be ' + 'removed in future versions of Select2.');
	          }
	
	          Utils.StoreData($e[0], 'data', Utils.GetData($e[0], 'select2Tags'));
	          Utils.StoreData($e[0], 'tags', true);
	        }
	
	        if (Utils.GetData($e[0], 'ajaxUrl')) {
	          if (this.options.debug && window.console && console.warn) {
	            console.warn('Select2: The `data-ajax-url` attribute has been changed to ' + '`data-ajax--url` and support for the old attribute will be removed' + ' in future versions of Select2.');
	          }
	
	          $e.attr('ajax--url', Utils.GetData($e[0], 'ajaxUrl'));
	          Utils.StoreData($e[0], 'ajax-Url', Utils.GetData($e[0], 'ajaxUrl'));
	        }
	
	        var dataset = {};
	
	        // Prefer the element's `dataset` attribute if it exists
	        // jQuery 1.x does not correctly handle data attributes with multiple dashes
	        if ($.fn.jquery && $.fn.jquery.substr(0, 2) == '1.' && $e[0].dataset) {
	          dataset = $.extend(true, {}, $e[0].dataset, Utils.GetData($e[0]));
	        } else {
	          dataset = Utils.GetData($e[0]);
	        }
	
	        var data = $.extend(true, {}, dataset);
	
	        data = Utils._convertData(data);
	
	        for (var key in data) {
	          if ($.inArray(key, excludedData) > -1) {
	            continue;
	          }
	
	          if ($.isPlainObject(this.options[key])) {
	            $.extend(this.options[key], data[key]);
	          } else {
	            this.options[key] = data[key];
	          }
	        }
	
	        return this;
	      };
	
	      Options.prototype.get = function (key) {
	        return this.options[key];
	      };
	
	      Options.prototype.set = function (key, val) {
	        this.options[key] = val;
	      };
	
	      return Options;
	    });
	
	    S2.define('select2/core', ['jquery', './options', './utils', './keys'], function ($, Options, Utils, KEYS) {
	      var Select2 = function Select2($element, options) {
	        if (Utils.GetData($element[0], 'select2') != null) {
	          Utils.GetData($element[0], 'select2').destroy();
	        }
	
	        this.$element = $element;
	
	        this.id = this._generateId($element);
	
	        options = options || {};
	
	        this.options = new Options(options, $element);
	
	        Select2.__super__.constructor.call(this);
	
	        // Set up the tabindex
	
	        var tabindex = $element.attr('tabindex') || 0;
	        Utils.StoreData($element[0], 'old-tabindex', tabindex);
	        $element.attr('tabindex', '-1');
	
	        // Set up containers and adapters
	
	        var DataAdapter = this.options.get('dataAdapter');
	        this.dataAdapter = new DataAdapter($element, this.options);
	
	        var $container = this.render();
	
	        this._placeContainer($container);
	
	        var SelectionAdapter = this.options.get('selectionAdapter');
	        this.selection = new SelectionAdapter($element, this.options);
	        this.$selection = this.selection.render();
	
	        this.selection.position(this.$selection, $container);
	
	        var DropdownAdapter = this.options.get('dropdownAdapter');
	        this.dropdown = new DropdownAdapter($element, this.options);
	        this.$dropdown = this.dropdown.render();
	
	        this.dropdown.position(this.$dropdown, $container);
	
	        var ResultsAdapter = this.options.get('resultsAdapter');
	        this.results = new ResultsAdapter($element, this.options, this.dataAdapter);
	        this.$results = this.results.render();
	
	        this.results.position(this.$results, this.$dropdown);
	
	        // Bind events
	
	        var self = this;
	
	        // Bind the container to all of the adapters
	        this._bindAdapters();
	
	        // Register any DOM event handlers
	        this._registerDomEvents();
	
	        // Register any internal event handlers
	        this._registerDataEvents();
	        this._registerSelectionEvents();
	        this._registerDropdownEvents();
	        this._registerResultsEvents();
	        this._registerEvents();
	
	        // Set the initial state
	        this.dataAdapter.current(function (initialData) {
	          self.trigger('selection:update', {
	            data: initialData
	          });
	        });
	
	        // Hide the original select
	        $element.addClass('select2-hidden-accessible');
	        $element.attr('aria-hidden', 'true');
	
	        // Synchronize any monitored attributes
	        this._syncAttributes();
	
	        Utils.StoreData($element[0], 'select2', this);
	
	        // Ensure backwards compatibility with $element.data('select2').
	        $element.data('select2', this);
	      };
	
	      Utils.Extend(Select2, Utils.Observable);
	
	      Select2.prototype._generateId = function ($element) {
	        var id = '';
	
	        if ($element.attr('id') != null) {
	          id = $element.attr('id');
	        } else if ($element.attr('name') != null) {
	          id = $element.attr('name') + '-' + Utils.generateChars(2);
	        } else {
	          id = Utils.generateChars(4);
	        }
	
	        id = id.replace(/(:|\.|\[|\]|,)/g, '');
	        id = 'select2-' + id;
	
	        return id;
	      };
	
	      Select2.prototype._placeContainer = function ($container) {
	        $container.insertAfter(this.$element);
	
	        var width = this._resolveWidth(this.$element, this.options.get('width'));
	
	        if (width != null) {
	          $container.css('width', '100%');
	        }
	      };
	
	      Select2.prototype._resolveWidth = function ($element, method) {
	        var WIDTH = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
	
	        if (method == 'resolve') {
	          var styleWidth = this._resolveWidth($element, 'style');
	
	          if (styleWidth != null) {
	            return styleWidth;
	          }
	
	          return this._resolveWidth($element, 'element');
	        }
	
	        if (method == 'element') {
	          var elementWidth = $element.outerWidth(false);
	
	          if (elementWidth <= 0) {
	            return 'auto';
	          }
	
	          return elementWidth + 'px';
	        }
	
	        if (method == 'style') {
	          var style = $element.attr('style');
	
	          if (typeof style !== 'string') {
	            return null;
	          }
	
	          var attrs = style.split(';');
	
	          for (var i = 0, l = attrs.length; i < l; i = i + 1) {
	            var attr = attrs[i].replace(/\s/g, '');
	            var matches = attr.match(WIDTH);
	
	            if (matches !== null && matches.length >= 1) {
	              return matches[1];
	            }
	          }
	
	          return null;
	        }
	
	        return method;
	      };
	
	      Select2.prototype._bindAdapters = function () {
	        this.dataAdapter.bind(this, this.$container);
	        this.selection.bind(this, this.$container);
	
	        this.dropdown.bind(this, this.$container);
	        this.results.bind(this, this.$container);
	      };
	
	      Select2.prototype._registerDomEvents = function () {
	        var self = this;
	
	        this.$element.on('change.select2', function () {
	          self.dataAdapter.current(function (data) {
	            self.trigger('selection:update', {
	              data: data
	            });
	          });
	        });
	
	        this.$element.on('focus.select2', function (evt) {
	          self.trigger('focus', evt);
	        });
	
	        this._syncA = Utils.bind(this._syncAttributes, this);
	        this._syncS = Utils.bind(this._syncSubtree, this);
	
	        if (this.$element[0].attachEvent) {
	          this.$element[0].attachEvent('onpropertychange', this._syncA);
	        }
	
	        var observer = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	
	        if (observer != null) {
	          this._observer = new observer(function (mutations) {
	            $.each(mutations, self._syncA);
	            $.each(mutations, self._syncS);
	          });
	          this._observer.observe(this.$element[0], {
	            attributes: true,
	            childList: true,
	            subtree: false
	          });
	        } else if (this.$element[0].addEventListener) {
	          this.$element[0].addEventListener('DOMAttrModified', self._syncA, false);
	          this.$element[0].addEventListener('DOMNodeInserted', self._syncS, false);
	          this.$element[0].addEventListener('DOMNodeRemoved', self._syncS, false);
	        }
	      };
	
	      Select2.prototype._registerDataEvents = function () {
	        var self = this;
	
	        this.dataAdapter.on('*', function (name, params) {
	          self.trigger(name, params);
	        });
	      };
	
	      Select2.prototype._registerSelectionEvents = function () {
	        var self = this;
	        var nonRelayEvents = ['toggle', 'focus'];
	
	        this.selection.on('toggle', function () {
	          self.toggleDropdown();
	        });
	
	        this.selection.on('focus', function (params) {
	          self.focus(params);
	        });
	
	        this.selection.on('*', function (name, params) {
	          if ($.inArray(name, nonRelayEvents) !== -1) {
	            return;
	          }
	
	          self.trigger(name, params);
	        });
	      };
	
	      Select2.prototype._registerDropdownEvents = function () {
	        var self = this;
	
	        this.dropdown.on('*', function (name, params) {
	          self.trigger(name, params);
	        });
	      };
	
	      Select2.prototype._registerResultsEvents = function () {
	        var self = this;
	
	        this.results.on('*', function (name, params) {
	          self.trigger(name, params);
	        });
	      };
	
	      Select2.prototype._registerEvents = function () {
	        var self = this;
	
	        this.on('open', function () {
	          self.$container.addClass('select2-container--open');
	        });
	
	        this.on('close', function () {
	          self.$container.removeClass('select2-container--open');
	        });
	
	        this.on('enable', function () {
	          self.$container.removeClass('select2-container--disabled');
	        });
	
	        this.on('disable', function () {
	          self.$container.addClass('select2-container--disabled');
	        });
	
	        this.on('blur', function () {
	          self.$container.removeClass('select2-container--focus');
	        });
	
	        this.on('query', function (params) {
	          if (!self.isOpen()) {
	            self.trigger('open', {});
	          }
	
	          this.dataAdapter.query(params, function (data) {
	            self.trigger('results:all', {
	              data: data,
	              query: params
	            });
	          });
	        });
	
	        this.on('query:append', function (params) {
	          this.dataAdapter.query(params, function (data) {
	            self.trigger('results:append', {
	              data: data,
	              query: params
	            });
	          });
	        });
	
	        this.on('keypress', function (evt) {
	          var key = evt.which;
	
	          if (self.isOpen()) {
	            if (key === KEYS.ESC || key === KEYS.TAB || key === KEYS.UP && evt.altKey) {
	              self.close();
	
	              evt.preventDefault();
	            } else if (key === KEYS.ENTER) {
	              self.trigger('results:select', {});
	
	              evt.preventDefault();
	            } else if (key === KEYS.SPACE && evt.ctrlKey) {
	              self.trigger('results:toggle', {});
	
	              evt.preventDefault();
	            } else if (key === KEYS.UP) {
	              self.trigger('results:previous', {});
	
	              evt.preventDefault();
	            } else if (key === KEYS.DOWN) {
	              self.trigger('results:next', {});
	
	              evt.preventDefault();
	            }
	          } else {
	            if (key === KEYS.ENTER || key === KEYS.SPACE || key === KEYS.DOWN && evt.altKey) {
	              self.open();
	
	              evt.preventDefault();
	            }
	          }
	        });
	      };
	
	      Select2.prototype._syncAttributes = function () {
	        this.options.set('disabled', this.$element.prop('disabled'));
	
	        if (this.options.get('disabled')) {
	          if (this.isOpen()) {
	            this.close();
	          }
	
	          this.trigger('disable', {});
	        } else {
	          this.trigger('enable', {});
	        }
	      };
	
	      Select2.prototype._syncSubtree = function (evt, mutations) {
	        var changed = false;
	        var self = this;
	
	        // Ignore any mutation events raised for elements that aren't options or
	        // optgroups. This handles the case when the select element is destroyed
	        if (evt && evt.target && evt.target.nodeName !== 'OPTION' && evt.target.nodeName !== 'OPTGROUP') {
	          return;
	        }
	
	        if (!mutations) {
	          // If mutation events aren't supported, then we can only assume that the
	          // change affected the selections
	          changed = true;
	        } else if (mutations.addedNodes && mutations.addedNodes.length > 0) {
	          for (var n = 0; n < mutations.addedNodes.length; n++) {
	            var node = mutations.addedNodes[n];
	
	            if (node.selected) {
	              changed = true;
	            }
	          }
	        } else if (mutations.removedNodes && mutations.removedNodes.length > 0) {
	          changed = true;
	        }
	
	        // Only re-pull the data if we think there is a change
	        if (changed) {
	          this.dataAdapter.current(function (currentData) {
	            self.trigger('selection:update', {
	              data: currentData
	            });
	          });
	        }
	      };
	
	      /**
	       * Override the trigger method to automatically trigger pre-events when
	       * there are events that can be prevented.
	       */
	      Select2.prototype.trigger = function (name, args) {
	        var actualTrigger = Select2.__super__.trigger;
	        var preTriggerMap = {
	          'open': 'opening',
	          'close': 'closing',
	          'select': 'selecting',
	          'unselect': 'unselecting',
	          'clear': 'clearing'
	        };
	
	        if (args === undefined) {
	          args = {};
	        }
	
	        if (name in preTriggerMap) {
	          var preTriggerName = preTriggerMap[name];
	          var preTriggerArgs = {
	            prevented: false,
	            name: name,
	            args: args
	          };
	
	          actualTrigger.call(this, preTriggerName, preTriggerArgs);
	
	          if (preTriggerArgs.prevented) {
	            args.prevented = true;
	
	            return;
	          }
	        }
	
	        actualTrigger.call(this, name, args);
	      };
	
	      Select2.prototype.toggleDropdown = function () {
	        if (this.options.get('disabled')) {
	          return;
	        }
	
	        if (this.isOpen()) {
	          this.close();
	        } else {
	          this.open();
	        }
	      };
	
	      Select2.prototype.open = function () {
	        if (this.isOpen()) {
	          return;
	        }
	
	        this.trigger('query', {});
	      };
	
	      Select2.prototype.close = function () {
	        if (!this.isOpen()) {
	          return;
	        }
	
	        this.trigger('close', {});
	      };
	
	      Select2.prototype.isOpen = function () {
	        return this.$container.hasClass('select2-container--open');
	      };
	
	      Select2.prototype.hasFocus = function () {
	        return this.$container.hasClass('select2-container--focus');
	      };
	
	      Select2.prototype.focus = function (data) {
	        // No need to re-trigger focus events if we are already focused
	        if (this.hasFocus()) {
	          return;
	        }
	
	        this.$container.addClass('select2-container--focus');
	        this.trigger('focus', {});
	      };
	
	      Select2.prototype.enable = function (args) {
	        if (this.options.get('debug') && window.console && console.warn) {
	          console.warn('Select2: The `select2("enable")` method has been deprecated and will' + ' be removed in later Select2 versions. Use $element.prop("disabled")' + ' instead.');
	        }
	
	        if (args == null || args.length === 0) {
	          args = [true];
	        }
	
	        var disabled = !args[0];
	
	        this.$element.prop('disabled', disabled);
	      };
	
	      Select2.prototype.data = function () {
	        if (this.options.get('debug') && arguments.length > 0 && window.console && console.warn) {
	          console.warn('Select2: Data can no longer be set using `select2("data")`. You ' + 'should consider setting the value instead using `$element.val()`.');
	        }
	
	        var data = [];
	
	        this.dataAdapter.current(function (currentData) {
	          data = currentData;
	        });
	
	        return data;
	      };
	
	      Select2.prototype.val = function (args) {
	        if (this.options.get('debug') && window.console && console.warn) {
	          console.warn('Select2: The `select2("val")` method has been deprecated and will be' + ' removed in later Select2 versions. Use $element.val() instead.');
	        }
	
	        if (args == null || args.length === 0) {
	          return this.$element.val();
	        }
	
	        var newVal = args[0];
	
	        if ($.isArray(newVal)) {
	          newVal = $.map(newVal, function (obj) {
	            return obj.toString();
	          });
	        }
	
	        this.$element.val(newVal).trigger('change');
	      };
	
	      Select2.prototype.destroy = function () {
	        this.$container.remove();
	
	        if (this.$element[0].detachEvent) {
	          this.$element[0].detachEvent('onpropertychange', this._syncA);
	        }
	
	        if (this._observer != null) {
	          this._observer.disconnect();
	          this._observer = null;
	        } else if (this.$element[0].removeEventListener) {
	          this.$element[0].removeEventListener('DOMAttrModified', this._syncA, false);
	          this.$element[0].removeEventListener('DOMNodeInserted', this._syncS, false);
	          this.$element[0].removeEventListener('DOMNodeRemoved', this._syncS, false);
	        }
	
	        this._syncA = null;
	        this._syncS = null;
	
	        this.$element.off('.select2');
	        this.$element.attr('tabindex', Utils.GetData(this.$element[0], 'old-tabindex'));
	
	        this.$element.removeClass('select2-hidden-accessible');
	        this.$element.attr('aria-hidden', 'false');
	        Utils.RemoveData(this.$element[0]);
	        this.$element.removeData('select2');
	
	        this.dataAdapter.destroy();
	        this.selection.destroy();
	        this.dropdown.destroy();
	        this.results.destroy();
	
	        this.dataAdapter = null;
	        this.selection = null;
	        this.dropdown = null;
	        this.results = null;
	      };
	
	      Select2.prototype.render = function () {
	        var $container = $('<span class="select2 select2-container">' + '<span class="selection"></span>' + '<span class="dropdown-wrapper" aria-hidden="true"></span>' + '</span>');
	
	        $container.attr('dir', this.options.get('dir'));
	
	        this.$container = $container;
	
	        this.$container.addClass('select2-container--' + this.options.get('theme'));
	
	        Utils.StoreData($container[0], 'element', this.$element);
	
	        return $container;
	      };
	
	      return Select2;
	    });
	
	    S2.define('jquery-mousewheel', ['jquery'], function ($) {
	      // Used to shim jQuery.mousewheel for non-full builds.
	      return $;
	    });
	
	    S2.define('jquery.select2', ['jquery', 'jquery-mousewheel', './select2/core', './select2/defaults', './select2/utils'], function ($, _, Select2, Defaults, Utils) {
	      if ($.fn.select2 == null) {
	        // All methods that should return the element
	        var thisMethods = ['open', 'close', 'destroy'];
	
	        $.fn.select2 = function (options) {
	          options = options || {};
	
	          if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	            this.each(function () {
	              var instanceOptions = $.extend(true, {}, options);
	
	              var instance = new Select2($(this), instanceOptions);
	            });
	
	            return this;
	          } else if (typeof options === 'string') {
	            var ret;
	            var args = Array.prototype.slice.call(arguments, 1);
	
	            this.each(function () {
	              var instance = Utils.GetData(this, 'select2');
	
	              if (instance == null && window.console && console.error) {
	                console.error('The select2(\'' + options + '\') method was called on an ' + 'element that is not using Select2.');
	              }
	
	              ret = instance[options].apply(instance, args);
	            });
	
	            // Check if we should be returning `this`
	            if ($.inArray(options, thisMethods) > -1) {
	              return this;
	            }
	
	            return ret;
	          } else {
	            throw new Error('Invalid arguments for Select2: ' + options);
	          }
	        };
	      }
	
	      if ($.fn.select2.defaults == null) {
	        $.fn.select2.defaults = Defaults;
	      }
	
	      return Select2;
	    });
	
	    // Return the AMD loader configuration so it can be used outside of this file
	    return {
	      define: S2.define,
	      require: S2.require
	    };
	  }();
	
	  // Autoload the jQuery bindings
	  // We know that all of the modules exist above this, so we're safe
	  var select2 = S2.require('jquery.select2');
	
	  // Hold the AMD module references on the jQuery function that was just loaded
	  // This allows Select2 to use the internal loader outside of this file, such
	  // as in the language files.
	  jQuery.fn.select2.amd = S2;
	
	  // Return the Select2 instance for anyone who is importing it.
	  return select2;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	// Opera 8.0+
	var isOpera = !!window.opr && !!opr.addons || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
	
	// Firefox 1.0+
	var isFirefox = typeof InstallTrigger !== 'undefined';
	
	// Safari 3.0+ "[object HTMLElementConstructor]"
	var isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
	  return p.toString() === "[object SafariRemoteNotification]";
	}(!window['safari'] || safari.pushNotification);
	
	// Internet Explorer 6-11
	var isIE = /*@cc_on!@*/false || !!document.documentMode;
	
	// Edge 20+
	var isEdge = !isIE && !!window.StyleMedia;
	
	// Chrome 1+
	var isChrome = !!window.chrome && !!window.chrome.webstore;
	
	// Blink engine detection
	var isBlink = (isChrome || isOpera) && !!window.CSS;
	
	if (isChrome) {
	  $('body').addClass('chrome');
	} else if (isOpera) {
	  $('body').addClass('opera');
	} else if (isSafari) {
	  $('body').addClass('safari');
	} else if (isIE) {
	  $('body').addClass('ie');
	} else if (isEdge) {
	  $('body').addClass('edge');
	} else if (isFirefox) {
	  $('body').addClass('firefox');
	}
	// var output = 'Detecting browsers by ducktyping:<hr>';
	// output += 'isFirefox: ' + isFirefox + '<br>';
	// output += 'isChrome: ' + isChrome + '<br>';
	// output += 'isSafari: ' + isSafari + '<br>';
	// output += 'isOpera: ' + isOpera + '<br>';
	// output += 'isIE: ' + isIE + '<br>';
	// output += 'isEdge: ' + isEdge + '<br>';
	// output += 'isBlink: ' + isBlink + '<br>';
	// document.body.innerHTML = output;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	(function () {
	
	  var burger = document.querySelector('.burger');
	  var burgerScnd = document.querySelector('.burger-second');
	
	  if (burger) {
	
	    var Menu = function () {
	      var menu = document.querySelector('.menu--mobile');
	      var menuList = document.querySelector('.menu--mobile__list');
	      var brand = document.querySelector('.menu--mobile__brand');
	      var menuItems = document.querySelectorAll('.menu--mobile__item');
	      var header = $('header');
	
	      var active = false;
	
	      var toggleMenu = function toggleMenu() {
	        if (!active) {
	          menu.classList.add('menu--mobile--active');
	          menuList.classList.add('menu--mobile__list--active');
	          brand.classList.add('menu--mobile__brand--active');
	          burger.classList.add('burger--close');
	          burgerScnd.classList.add('burger--close');
	          header.addClass('activeTop');
	
	          for (var i = 0, ii = menuItems.length; i < ii; i++) {
	            menuItems[i].classList.add('menu--mobile__item--active');
	          }
	
	          active = true;
	          $('body').addClass('unscroll');
	        } else {
	          menu.classList.remove('menu--mobile--active');
	          menuList.classList.remove('menu--mobile__list--active');
	          brand.classList.remove('menu--mobile__brand--active');
	          burger.classList.remove('burger--close');
	          burgerScnd.classList.remove('burger--close');
	          header.removeClass('activeTop');
	          for (var i = 0, ii = menuItems.length; i < ii; i++) {
	            menuItems[i].classList.remove('menu--mobile__item--active');
	          }
	
	          active = false;
	          $('body').removeClass('unscroll');
	        }
	      };
	
	      var bindActions = function bindActions() {
	        if ($('.burger-second').length) {
	          burger.addEventListener('click', toggleMenu, false);
	        }
	
	        if ($('.burger-second').length) {
	          burgerScnd.addEventListener('click', toggleMenu, false);
	        }
	      };
	
	      var init = function init() {
	        bindActions();
	      };
	
	      return {
	        init: init
	      };
	    }();
	    if ($('.burger').length || $('.burger-second').length) {
	      Menu.init();
	    }
	  }
	})();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {"use strict";
	
	jQuery(document).ready(function ($) {
	
	    $('.popup-famicord-overlay').each(function (ind, el) {
	        var popupName = $(el).attr("id");
	        $(el).addClass("show");
	        $(el).find(".close-popup").click(function () {
	            $("#" + popupName).removeClass("show");
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main_1.0.1.js